// Debug: set  window.__svTrace = []  in the console BEFORE load to collect pipeline traces.
  (function(){
  /* Build stamp. There was no version marker in this file, so "is the fix live or is my browser
     serving a cached copy?" was unanswerable, and we burned review cycles judging stale builds.
     BUMP THIS ON EVERY PUSH. It prints on load and is readable as window.SV_BUILD, so the answer
     is one glance in the console.
     3.94.1 (owner, phone) A carried-forward connector colour now also sets the PREVIEW image
            (createOptionBasedDropdowns re-resolved the variant but left currentStrapURL on
            the first variant's kit photo); a kit photo's two arms share ONE scale (the two
            adapter feet are photographed at different widths - Acetate Bangle 68 vs 55 px -
            so per-arm end sizing drew the bottom band 10% wider than the top); out-of-stock
            colours get a struck-through swatch; option labels show on the compact buy card.
     3.94.0 EMBED MODE (?embed=1&strap=<handle>): the product page's try-on is now this
            engine in an iframe - one compositor, no hand-port to drift. Strap-first fetch
            of the page's product + its fitting twins, watch membership from the products'
            own collections, rail/header/footer hidden, px-sized preview, and a postMessage
            bridge for height / fullscreen modals / add-to-cart (see EMBED MODE section).
     3.67.0 (owner) Desktop buy card: variant fields TWO-UP (Colour beside Strap Width; a
            third field starts the next row, left-justified). Template CSS only - the
            #strapColourPicker / form / #optionDropdownsContainer wrappers are hoisted with
            display:contents so every .sv-variant-field is a flex item of the card. No JS
            change beyond this stamp. Same day, data only: 8 silver metal-bracelet cutouts
            re-toned (Magnetic Steel, Milanese, Milanese with Clasp, Jubilee x3, Zirconia x2).
     3.66.4 (owner) The buy card comes BACK as soon as any of the preview scrolls into the
            viewport (was: the pill's 72px "useful amount" threshold), and only hides for a
            peek fade-OUT, not the fade-in.
     3.66.3 (owner) The mobile BUY CARD fades away with the render (body.sv-card-hidden from
            sync(): preview off-screen or fading out -> card opacity 0, pill drops to the
            bottom edge; back when the render is on screen again). And an (x) CLEAR button
            in both search boxes (svAddSearchClear; clears by dispatching 'input').
     3.66.2 (owner) The zoom SURVIVES a strap/colour/watch change: combineImages calls
            svKeepInlineZoom (first render seeds the resting default, later renders keep the
            scale + pan, re-clamped to the new canvas) instead of resetInlineZoom. And the
            mobile PEEK fades in/out (body.sv-peek-hidden = opacity 0 via a transition; the
            teardown waits PEEK_FADE_MS; a pick mid-fade cancels the fade-out).
     3.66.1 Mobile preview BIGGER and MORE ZOOMED by default (owner, after trying 3.66.0):
            flow resting height 38vh -> 46vh (svPhBigPx + the --sv-ph rule in SVO_FLOW_CSS
            and the template), resting zoom 1.8 -> 2.0 (inlineZoomDefault). The stored drag
            height key moved so_svPhBig -> so_svPhBig2 so the new default wins once.
     3.66.0 (a) APPLE RENDER SHARPNESS on high-DPI screens. The Apple compositor drew into a
            fixed 868x1100 canvas from a 900px strap and a 612px face; a phone shows that
            canvas at ~540 CSS px tall x DPR 3 = 1620 device px, so it was upscaled ~1.5x
            and read soft (the normal compositor's canvas is 4000+ px tall and was never
            the problem). On DPR > 1.25 the canvas is now 2x (1736x2200) and, once they
            land, the arms and face are drawn from 1800px / 1224px sources; the first paint
            still comes from the 900/612 images so nothing gets slower to appear, and realign
            drags repaint at 1x with the sharp copy back on release. All MEASUREMENTS stay on
            the 900px image - only the draw sources changed. `?svhidpi=1` forces it on 1x.
            (b) MOBILE PEEK (owner): picking a strap no longer scrolls the page to the top.
            The preview is FIXED over the list at the current scroll position (body.sv-peek;
            #svPeekPad keeps its grid cell and scrollY is pinned, so nothing shifts), and the
            customer's next scroll GESTURE (finger >24px outside the preview, or a wheel tick;
            never a scroll event, the engine scrolls the page itself after a pick) drops it.
            The "See it on your watch" pill peeks too. SV_PEEK=false restores 3.65.0.
     3.65.1 BLURRY THUMBNAILS. The template's `.loaded` keyframe animation (fadeInScale) opened
            on `filter: blur(4px)` + `scale(0.9)`. A CSS animation only advances while the page
            is painted, so a thumbnail that finished loading while the page was not being
            rendered (background tab, app switch mid-load, in-app browser, a row parked inside
            content-visibility:auto) was pinned on that blurred first frame - "sometimes the
            images load blurry". Verified live in a hidden tab: every thumbnail at blur(4px),
            all clearing the instant the tab was shown. The template now fades by opacity
            TRANSITION only (a transition that cannot paint lands on its end value), and
            SVO_CSS carries a `filter:none !important` guard so a cached page cannot regress.
     3.65.0 LIGHTING + MOBILE FLOW LAYOUT.
            Lighting (SV_LIGHT, both compositors + the PDP try-on): the strap's exposure is
            lifted toward a white highlight (metal especially - warehouse shots read as dull
            grey card), the arms get cylinder shading with a specular band (narrow and bright
            on metal, faint on leather/silicone), a contact shadow where the arm runs under
            the case, and a soft drop shadow under the whole assembly. Measurements untouched.
            Mobile (SV_MOBILE_FLOW): the preview is IN FLOW, not fixed - scrolling the straps
            scrolls it away and the whole screen is straps; picking a strap scrolls the render
            back; a pill jumps either way. At rest the old layout showed ONE row on a 390x664
            phone. Also: the divider handle no longer renders on desktop (its hide rule was
            nested inside the mobile media query), and the build badge is off the buy button.
     3.64.0 Trail Loop forced to the colour DROPDOWN (owner). REVERSES 3.62.0's call that the
            9 silicone/nylon two-tones keep discs - Trail Loop is now the exception. Ids added
            for the Quick Release, Apple and QuickFit rows; an id not in a feed is inert.
     3.63.0 a STYLE suffix no longer reads as a colourway (owner: "hex link incorrectly linked
            on steel bracelet"). "Steel Bracelet - Hex Link with Safety Deployant Clasp" and
            "- Beads of Rice" were collapsing into ONE "Steel Bracelet" row offering two
            different bracelets as colours. The FKM-only special case is generalised to
            SV_STYLE_SUFFIX_RE (clasp/link/beads of rice/bracelet/buckle/deployant/size), and
            the list AND the details colour picker now share ONE key via svGroupKeyOf - only
            the list had the guard before, so the panel kept offering the sibling as a colour.
            Swept all 255 feed suffixes: matches 8, splits 4 groups, no colourway touched.
     3.62.0 19 metal/material-composite rows forced to the colour DROPDOWN (SVO_DD_PRODUCT_IDS):
            Ceramic Bracelet x5, Jubilee x3, Steel Deployant Clasp x9, Zirconia Shimmer and
            Sparkle Hybrid. "Silver / White" is metal + ceramic, which one disc cannot say.
            Swept the whole feed: strap_type, NOT the slash, is what separates these from the
            55 Militex/ElastoFlex and 9 silicone/nylon two-tones that keep discs (owner call).
            A rail group is one control, so Jubilee and Steel Deployant flip whole.
     3.60.4 SVO_DISC_BY_PRODUCT: per-product disc exceptions. The Titanium Featherlight
            Milanese keeps its original PALE rose gold photo, so the shop-wide #BA9181 chip
            was deeper than its own strap; that row's chip is now #F8C5AC, the image's median.
     3.60.3 rose gold disc retuned #C9906F -> #BA9181 (owner supplied a reference finish: a
            MUTED BRUSHED rose gold, not the orange-copper the old hex read as). Matches the
            re-toned Link Bracelet flat-lay and the QuickFit Link / Steel rose gold photos,
            which measure rgb(212,163,139) and rgb(193,148,127).
     3.60.2 ...and 3.60.1's word-boundary regex shipped with literal BACKSPACE bytes where
            the two word-boundary escapes should have been (a heredoc ate the backslashes), so the metal
            test still matched nothing. Verified live this time.
     3.60.1 3.60.0's metal-row test read the title from allStrapProducts, which came back
            undefined for the sibling-group rows - the flag was never set on ANY row and the
            new palette did nothing live. Reads the thumbnail's data-title instead.
     3.60.0 metal FINISH swatch overrides (SVO_METAL_FINISH): the 3.39.0 named map only
            covered Gold / Rose Gold / Silver, so on a metal bracelet every OTHER finish
            still sampled the photo - and a brushed metal's modal bin is its cool shadow,
            which the display remap then LIFTS. Measured on the live feed: QR Titanium
            Bracelet 2's "Black" disc came out rgb(59,64,100) (a navy) and its "Dark Gun
            Metal Grey" rgb(85,89,120); EasyFit Bracelet 2's "Black" rgb(16,56,86).
            Fixed hexes for the grey/black/starlight/champagne finishes, applied ONLY on a
            metal row (svoIsMetalRow) because those same labels are used by leather and
            silicone rows where sampling is correct.
     3.59.0 svc follow-ups (owner): silhouette lugs are VERTICAL and shorter (were diagonal
            flares); the review ghost overlay no longer sits ON the cut-out - it's a small
            reference silhouette beside the "lugs up and down" note instead; photo-button
            icon flows INLINE with the text so wrapped lines centre truly (flex row kept the
            text block offset right of centre); all svc buttons get explicit text-align:center.
     3.58.0 mobile: the FIXED buy card was covering the last strap row at the bottom of the
            rail (owner report, Weaved Elastic Loop). The card's real height is now published
            as --sv-buy-h (dock() + a ResizeObserver) and the strap grid gets that much
            bottom padding, so the last row scrolls clear of the card.
     3.57.0 custom-watch (svc) overhaul: camera guide is a WATCH silhouette (no outer square)
            that turns green when level + framed; NO auto-upright rotation after background
            removal (it was tilting shots ~30deg off a bad axis guess); review step gains a
            1-degree Straighten slider + a ghost watch overlay showing lugs-up; saved custom
            watches get a delete button on their row; photo-button text centre-aligned.
            Template: #svPhHandle long-dash ::before removed (chevrons only).
     3.56.0 MOBILE watch picker = the desktop MODAL (chip "Change" and first visit both open
            #svWatchModal as a full-screen sheet; the old full-page step swap is retired on
            mobile - it was the source of the buggy in-between layout states). Mobile strap
            rows enlarged: 64x92 thumbs, bigger title/swatches (CSS in the template mobile
            block + SVO_CSS copy).
     3.40.0 the MOBILE collapsed buy card keeps the variant dropdowns VISIBLE (compact: no
            labels, mini selects in one wrapping row) instead of hiding every variant control
            behind the chevron - the card offered Add to Cart with no visible variant at all.
            Chevron still expands to the full labelled layout. Desktop untouched.
     3.39.0 named METAL swatch overrides (SVO_METAL_DISC): exact-label Gold / Rose Gold /
            Silver discs use fixed hexes instead of image sampling - sampling reads a
            metal's shadows (or a watch PHOTO when the colour's image is not a cutout)
            and Gold came out grey-brown. Applies to every swatch strip.
     3.38.0 NO-ALPHA GUARD: a flat-lay >97% opaque (an ordinary photo, not a cutout) now shows
            the preview notice instead of compositing a giant photo rectangle. Hit on QR Link
            Bracelet Black/Silver (colours not yet shot fall back to gallery image 0).
     3.37.0 the strap feed now REQUIRES tag:visualiser on top of collection membership - the
            smart collection's index held 240 members with no tag (44 of them un-evictable by
            any reindex trigger; corrupt rows on Shopify's side). The tag is the collection's
            only rule, so it is the source of truth. Cache v14 -> v15.
     3.36.0 the canvas-cap backstop no longer calls showStrapLoadError() - that wiped the whole
            strap rail and mislabelled a RENDER failure as a FETCH failure ("Couldn't load the
            strap list" on tapping QR Ceramic Bracelet, 2026-08-21). It now shows a message in
            the PREVIEW viewport only (svShowPreviewError) and the rail stays usable; every new
            performCombination() attempt hides the message again.
     3.35.0 (snippets/strap-try-on.liquid, no change in this file beyond the version) the PDP
            try-on aligned with this engine's methodology: inner-lug-gap sizing + SV_ARM_TRIM,
            lug-root/connector-depth overlap + SV_OV_TRIM, collapse guard, rotate_180, and
            visualiser_adjust (incl. staff sv_adj_<pid> drafts). Keep the constants in sync.
     3.34.0 the APPLE strap feed now carries strapScale / singleDiagonal / adjust (it read only
            visualiser_image_url before); apple cache key v2 -> v3. ⚠ performAppleCombination
            does NOT consume these fields yet - it anchors the case on the lug ADAPTER and lets
            band width fall at the product's real band/adapter ratio (by design). The Acetate
            Bangle's band is ~1/4 of its Apple plate, so it draws slim on Apple watches; making
            it read strapScale is future work in performAppleCombination, not the feed.
     3.33.0 Vintage Tapered Bracelet forced to a colour DROPDOWN ("Silver / Rose Gold" metal
            composite) and its diagonal flat-lay stood upright via the single_diagonal metafield.
     3.32.0 Acetate Bangle rows keep the colour DROPDOWN instead of swatch discs (owner call:
            "White Pearl / Rose Gold" is a colour+hardware composite a disc can't express).
            SVO_DD_PRODUCT_IDS now also matches sibling-product group rows via option values.
     3.25.0 per-strap custom.visualiser_strap_scale width correction; cache v13 for the new field
     3.24.0 usage telemetry (section 14) ported from the 2.15.0 live line + the hidden
            properties[_Visualiser] cart property, so publishing this theme does not lose them
     3.23.0 dd-mode colour dropdowns are PLAIN again: the disc inside the dropdown and the
            colour-tinted options both removed (owner call). Strip swatches are unaffected.
     2.14.0 the composite keeps a 2.5% margin, so the strap ends never touch the canvas edge
     2.13.0 "Loading straps…" instead of "No matching straps found" while the list is still loading
     2.12.0 single-piece diagonal flat-lays (Steel Bracelet with Deployant Clasp) stand upright;
            cache v11 for the new visualiser_strap_single_diagonal flag
     2.11.1 the row dropdown hides/rebuilds when a sibling colour lacks that option
     2.11.0 a look-changing option (Stitching) survives a colour change, both dropdowns agree,
            and every row dropdown is labelled (colour-as-variant rows had none)
     2.10.0 cache v10: the 52 Sailcloth variants whose fallback resolved to the WRONG image
     2.9.0  all 9 currentStrapURL reset sites honour the variant override (Stitching now renders)
     2.8.0  strap rows get a second, labelled dropdown for the look-changing option (Stitching)
     2.7.0  the on-page #svVersionTag badge now shows the REAL build (was hardcoded v1.0.0)
     2.6.0  cache v9 for King Sailcloth per-stitching variant image positions (data-only change)
     2.5.0  speck pruning always uses the downsampled mask; it was a NO-OP when specks vanished
     2.4.0  arm-order/rotation flag, speck pruning, balanced canvas framing
     2.3.0  composite framing: canvas was 4066px of blank below and 137px above, strap clipped
     2.2.0  per-product visualiser_strap_rotate_180 + cropToMainComponent speck pruning
     2.1.0  collapsed arm measurement guard + 16384 canvas backstop + CORS retry in loadImage
     2.0.0  repointed to the Online Store storefront token (the old one was a different channel) */
  const SV_BUILD = '3.94.5';
  /* 3.77.0: (a) svLugMm - the watch lug width is the FIRST "<n>mm" in the feed cell, not every
     digit glued together ("22mm, Quick Release 22mm" read as 2222). (b) The watch feed is fetched
     without a cache-buster and with `no-cache`, so the CRM's new ETag (v1.650.0) can answer 304. */
  /* 3.76.7: CACHE KEY BUMP ONLY (sv_straps_v18 -> v19). 50 [QuickFit] straps (Vintage Knotted,
     Crazy Horse, Prairie/King FKM, Daytona leather, ...) carried custom.watch_type
     ["Quick Release"] while their title, tags, variants and "Garmin Watch" option were QuickFit:
     hidden from every Garmin QuickFit watch, offered to a customer's own 20/22mm watch as if
     they fitted. Metafields corrected 2026-09-12; the bump publishes it on the next page view. */
  /* 3.76.0: THE 33 NO-STRAP WATCHES SHOW THE WATCH ITSELF. 3.75.0 stopped them offering the whole
     catalogue, which was the important half, but it left the preview an empty white panel next to
     the "No straps for this watch yet" notice - honest, and it reads as a broken page. The
     compositor needs a strap, so there is now a watch-only draw (svDrawWatchOnly) for exactly this
     state. */
  /* 3.75.0: A WATCH WE HAVE NOTHING FOR NO LONGER SHOWS THE WHOLE CATALOGUE. 33 TAG Heuer rows in
     the feed (2026-09-09) carry a BLANK collection_link and the sentence "We don't have anything
     available unfortunately" where the lug width belongs. Blank collection_link means "no
     restriction" and a blank watch type defaults to Quick Release, so picking one of those showed
     hundreds of Quick Release straps in every width, with a working Add to Cart, for a watch we
     cannot dress. They now get an honest empty state. See svWatchHasNoStraps. */
  /* 3.74.0: EVERY CATALOGUE-TEXT COMPARISON IS NOW CASE-INSENSITIVE, not just the brand list that
     3.73.0 fixed. The same bug shape was sitting in the category, sub-category and colour
     dropdowns (built from `new Set()` of raw metafield text, so one differently-cased value
     becomes a second menu entry that hides the other's straps) and in the watch-type
     compatibility check (`"Quick Release" === "quick release"` was false, which would hide every
     strap for that watch). All of it folds through svFold() now: menus are keyed on the folded
     value and labelled with the spelling the catalogue uses most, and every comparison folds both
     sides. ⚠ Image URLs, handles and SKUs are deliberately NOT folded - those are identifiers,
     and on a CDN they really are case-sensitive. */
  /* 3.73.0: ONE ENTRY PER BRAND, WHATEVER THE FEED'S CAPITALISATION. The brand dropdown was keyed
     on the raw `brand` string from the CRM watch feed, which carries both "TAG Heuer" and "Tag
     Heuer" - so the list showed the brand twice AND, worse than the cosmetics, picking either one
     hid the other spelling's watches, because the filter compared with !==. Brands are now folded
     on a trimmed lower-case key, labelled with the spelling the feed uses most, and compared
     folded. The feed itself is still inconsistent; this makes the page immune to it. */
  /* 3.72.1: APPLE_CACHE_KEY v4 -> v5 and the per-watch collection sets _v2 -> _v3, by hand, so
     catalogue edits to the Apple range and to collection membership go live immediately instead
     of on each customer's second page view - the companion to the 3.71.1 SV_STRAPS_KEY bump. No
     code change beyond the keys and their cleanup. */
  /* 3.72.0: NAMES WRAP INSTEAD OF ELLIPSISING, and their rows grow to fit. Every list and card
     name was `white-space:nowrap` + `text-overflow:ellipsis`, so "American Classic Intra-Matic
     Aut..." and "20mm Riven-O2 Titanium Straight End Quick Release Watc..." hid the part that
     tells two products apart. Both copies of the CSS are updated - the template (source of
     truth) and the guard below (which also covers a stale cached page HTML). Chrome that must
     stay on one line is deliberately left alone: filter chips, the width pill, Change, View
     Product, the jump pill, and every <select>, which cannot wrap at all. */
  /* 3.71.1: SV_STRAPS_KEY v17 -> v18 by hand, to make catalogue edits live immediately
     rather than on each customer's second page view. No code change. */
  /* 3.71.0: (a) WHAT IS ON SCREEN REFINES FIRST. The refine queue was strict FIFO, so scrolling
     to the bottom of 700+ watches left the rows in front of you behind a backlog of every row you
     had scrolled PAST - they filled in sequentially from the top. Each scroll pass now promotes
     the rows actually in view to the head of the queue; the rest still follow.
     (b) DOUBLE-CLICK TO SELECT TEXT IN THE WATCH MODAL NO LONGER FLASHES AND CLEARS. svoSyncWm
     polls every 400ms and reassigned textContent unconditionally, which replaces the text node
     and destroys any selection inside it. It now writes only on an actual change. */
  /* 3.70.0: WATCH THUMBNAILS THAT ONLY APPEARED ON CLICK. loadImage has no timeout, so a watch
     image that neither loads nor errors leaves its promise pending forever and never releases its
     refine slot; REFINE_CONCURRENCY of those wedge the queue for the whole session. Every watch
     after the eager first twelve then sat on a placeholder - except a clicked one, because
     displayWatchDetails calls refineWatch() DIRECTLY and bypasses the queue. Reported 2026-09-09
     on a Hamilton search: "the other hamilton watches dont seem to be loading. only after its
     clicked, it shows the thumbnail". Refines now time out and release the slot, a scroll pass
     backs up the IntersectionObserver, and the re-render in svRevalidateWatchCSV re-arms it. */
  /* 3.69.0: A PENDING COLLECTION IS A STATE, NOT "NO RESTRICTION". The per-watch collection that
     decides which straps fit is fetched asynchronously and used to fail open WHILE IT LOADED, so
     for the seconds the fetch took the grid showed every strap - 20mm straps on a 22mm Amazfit
     Balance - and the auto-select put one in the buy card, priced and add-to-cartable, before
     they all vanished. Reported 2026-09-09: "it still shows 20mm straps and then they disappear a
     few seconds later". Rows now stay behind the strap spinner until the set lands; a FAILED
     fetch still fails open. The sets are also cached persistently, so this is usually instant. */
  /* 3.68.0: LOAD SPEED ON A RESUME. The strap and watch feeds moved from sessionStorage (5-minute
     TTL, dies with the tab) to a persistent stale-while-revalidate cache, the Apple range is
     prefetched alongside the main fetch instead of after it, and the strap grid paints each
     GraphQL page as it lands. Measured before, on the live page 2026-09-09: 4 serial strap pages
     1.0s -> 5.0s, then 4 Apple pages 7.7s -> 8.7s. That is ~8.7s to data-ready on a fast desktop
     and ~15s on a phone, paid again in full on every new tab.
     See svCacheRead / svApplePrefetch / svRenderStrapsPartial. */
  /* 3.65.1: thumbnails must never be blurred or scaled by CSS. The template's old load-in
     keyframes opened on blur(4px)/scale(0.9) and parked there whenever the page was not being
     painted (see the build note above). The template is fixed; this !important guard makes
     the fix hold even while a stale page HTML (~20 min cache) still ships the old keyframes.
     Injected here, unconditionally, at boot - NOT in SVO_CSS, which only lands on a document
     whose template lacks the one-screen markup. */
  try {
    if (!document.getElementById('sv-noblur-css')) {
      const _svNb = document.createElement('style');
      _svNb.id = 'sv-noblur-css';
      _svNb.textContent =
        '.watches-grid img,.straps-grid img{filter:none !important;}' +
        '.watches-grid img.loaded,.straps-grid img.loaded{animation:none !important;transform:none !important;opacity:1 !important;}' +
        '.watches-grid img.error,.straps-grid img.error{filter:grayscale(100%) !important;}';
      (document.head || document.documentElement).appendChild(_svNb);
    }
  } catch (e) {}
  /* 3.72.0: WRAP, DON'T TRUNCATE. Injected unconditionally at boot for the same reason as the
     blur guard above - the template carries this too, but a cached page HTML (~20 min) still
     ships the old nowrap/ellipsis rules, and a half-applied fix would truncate on exactly the
     pages people are already on.
     ⚠ `overflow-wrap:anywhere` is what makes an unbroken model number (H32451141) fold rather
     than force the row wider than its column.
     ⚠ `content-visibility:auto` with a ONE-LINE `contain-intrinsic-size` CLIPS a row that now
     needs two lines - the same trap the one-screen CSS already worked around for swatch rows
     ("pinned them and clipped row 2"). Multi-line rows are the norm now, so the containment
     comes off both grids. */
  try {
    if (!document.getElementById('sv-wrap-css')) {
      const _svWrap = document.createElement('style');
      _svWrap.id = 'sv-wrap-css';
      _svWrap.textContent =
        '.watch-list-brand,.watch-list-model,.watch-list-lug,' +
        '.strap-list-category,.strap-list-title,.strap-list-price,' +
        '#svWatchBar .sv-wb-name,#svWatchModal .sv-wm-name,#svWmName,' +
        '#strapTitle,#watchTitle{' +
          /* Each of these is its own line. They are block-level already inside the desktop
             flex column, but they are inline spans on the phone layout, where a wrapped name
             otherwise flows around the category eyebrow instead of sitting under it. */
          'display:block;' +
          'white-space:normal !important;overflow:visible !important;text-overflow:clip !important;' +
          'overflow-wrap:anywhere;word-break:break-word;max-width:100% !important;' +
        '}' +
        // The row and its text column have to be free to grow, or the extra lines are painted
        // outside a box that is still one line tall.
        '.watch-list-item,.strap-list-item{height:auto !important;}' +
        '.watch-list-info,.strap-list-info{min-width:0;overflow:visible !important;}' +
        '.watches-grid .watch-list-item,.straps-grid .strap-list-item{' +
          'content-visibility:visible !important;contain:none !important;' +
          'contain-intrinsic-size:auto !important;' +
        '}' +
        /* ⚠ 3.76.4: HIDING THE BUY CARD WITH AN INLINE display:none DOES NOT WORK ON A PHONE.
           The one-screen mobile CSS sets the sticky card's display with !important, which beats
           an inline style - so a watch we stock nothing for kept a live "Add to Cart - $150.00"
           bar from the PREVIOUS watch under its "No straps for this watch yet" notice. A body
           class is the only hide the mobile rules cannot out-rank. */
        /* ⚠ The id is doubled ON PURPOSE. The mobile rule that owns this card is
           `body.sv-onescreen #strapDetails:not(.sv-buy-open)` at specificity (0,3,1) with
           `display:flex !important`; a plain `body.sv-nostraps #strapDetails` is (0,2,1) and
           LOSES, !important or not. Repeating the id makes it (0,2,2) - id count decides. */
        'body.sv-nostraps #strapDetails#strapDetails{display:none !important;}' +
        'body.sv-nostraps #svJumpPill#svJumpPill{display:none !important;}' +
        /* ⚠ THE ROW BOX GROWING IS NOT ENOUGH - THE GRID TRACK HAS TO GROW WITH IT. These lists
           are CSS grids, and their default `auto` tracks kept sizing to the old one-line height,
           so a wrapped row simply overflowed its 53px track and printed on top of the row below
           (measured: row box 86px, track still 53px). `max-content` sizes each track to the row
           it holds - the fix for "make the containers expand in tandem". */
        '#strapsGrid,#watchesGrid,.straps-grid,.watches-grid{grid-auto-rows:max-content !important;}' +
        /* Apple family dividers (3.80.0). grid-column:1/-1 so the label spans the whole row in
           grid view instead of sitting in one card-width column. */
        '#watchesGrid .watch-group-header{grid-column:1/-1;display:flex;align-items:center;gap:8px;' +
          'width:100%;margin:6px 0 0;padding:12px 14px;font:inherit;font-weight:700;font-size:13px;' +
          'letter-spacing:.04em;color:#2b2b2b;background:#f5f4f1;border:1px solid #e3e0da;' +
          'border-radius:10px;cursor:pointer;text-align:left;}' +
        '#watchesGrid .watch-group-header:hover{background:#efece6;}' +
        '#watchesGrid .watch-group-header .wgh-title{flex:1 1 auto;}' +
        '#watchesGrid .watch-group-header .wgh-count{flex:0 0 auto;font-weight:600;font-size:12px;' +
          'color:#6b6b6b;background:#fff;border:1px solid #e3e0da;border-radius:999px;padding:1px 8px;}' +
        '#watchesGrid .watch-group-header .wgh-chev{flex:0 0 auto;color:#8a8a8a;}';
      (document.head || document.documentElement).appendChild(_svWrap);
    }
  } catch (e) {}
  /* 3.66.3 (owner): an (x) that clears a search box. Wraps the input's .search-container,
     shows only while there is text, and CLEARS BY DISPATCHING 'input' so the existing filter
     listeners (watch: immediate, strap: debounced 150ms) run exactly as if the customer had
     deleted the text. Applied to both the strap and the watch search. */
  function svAddSearchClear(input) {
    try {
      if (!input || input._svClear) return;
      const wrap = input.parentElement;
      if (!wrap) return;
      if (!document.getElementById('sv-search-clear-css')) {
        const st = document.createElement('style');
        st.id = 'sv-search-clear-css';
        st.textContent =
          '.sv-clear-wrap{position:relative;}' +
          '.sv-clear-wrap input{padding-right:36px !important;}' +
          '.sv-search-clear{position:absolute;right:7px;top:50%;transform:translateY(-50%);width:26px;height:26px;border:0;border-radius:50%;background:#e3ded4;color:#1d1d1d;font:700 16px/1 -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;display:none;align-items:center;justify-content:center;cursor:pointer;padding:0 0 1px;z-index:2;}' +
          '.sv-search-clear:active{background:#d2cbbd;}' +
          '.sv-clear-wrap.sv-has-text .sv-search-clear{display:flex;}';
        (document.head || document.documentElement).appendChild(st);
      }
      wrap.classList.add('sv-clear-wrap');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sv-search-clear';
      btn.setAttribute('aria-label', 'Clear search');
      btn.textContent = '×';
      wrap.appendChild(btn);
      const syncBtn = () => wrap.classList.toggle('sv-has-text', !!input.value);
      input.addEventListener('input', syncBtn);
      btn.addEventListener('click', () => {
        input.value = '';
        syncBtn();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });
      syncBtn();
      input._svClear = btn;
    } catch (e) {}
  }
  try {
    window.SV_BUILD = SV_BUILD;
    console.info('[strap-visualiser] build ' + SV_BUILD);
    /* The on-page badge (#svVersionTag) was a HARDCODED string in page.StrapVisualiser.liquid -
       "v1.0.0 - 2026-08-12" - that no deploy ever touched. It is the thing people actually look
       at, so it was quietly asserting a version that had not been true for days and made
       "is my browser cached?" impossible to answer from the screen. Drive it from the real build.
       Runs on DOMContentLoaded because this script is in <head> and the badge is in <body>. */
    var svStampBadge = function () {
      var el = document.getElementById('svVersionTag');
      if (el) el.textContent = 'v' + SV_BUILD;
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', svStampBadge);
    } else {
      svStampBadge();
    }
  } catch (e) {}
  /* Whole engine is scope-isolated. The theme's header "Find your watch" selector section
     defines its own global parseCSV/watchList/loadWatchCSV; sharing the global scope made the
     two scripts overwrite each other and double-parse the CSV (738 rows instead of 369). */
  /************************************************************************
   * GLOBALS
   ************************************************************************/
  let currentWatchData = null;    // Holds the currently selected watch object
  let svUserInteracted = false;   // true once the user taps a watch/strap - stops the delayed
                                  // URL-restore / first-watch auto-select from overriding their pick
  let currentStrapURL = "";
  // Storage key for a watch the customer photographed themselves (section 12). It has to be
  // declared HERE rather than beside the rest of that section at the bottom of this IIFE:
  // parseCSV re-injects the saved watch, and when the watch feed is already in sessionStorage
  // parseCSV runs synchronously at script-parse time - before a const at the bottom of the
  // file has left its temporal dead zone. Declaring it up here is what makes that safe.
  const SVC_KEY = 'sv_custom_watch_v1';
  let allStrapProducts = [];      // Will store all straps fetched
  /* Watches render at ~40% of the boot sequence and the 792 straps land seconds later, so a watch
     picked in that window filtered an EMPTY grid and the page said "No matching straps found" for
     3-5 seconds - a wrong answer, not a slow one. True only once rows are actually on screen. */
  let _strapsRendered = false;
  let selectedStrapProduct = null; // The currently selected strap's product data
  let watchList = [];             // Array of watch objects from CSV
  let currentWatchSearchQuery = ""; // Current watch search query
  let currentStrapSearchQuery = ""; // Current strap search query
  let currentWatchViewMode = 'list'; // Track watch view mode: 'grid' or 'list' (default: list)

  /************************************************************************
   * STRAP CATEGORY STRUCTURE
   ************************************************************************/
  let categoryStructure = {}; // Will hold main categories and their sub-categories
  let allStrapCategories = []; // Will store all category combinations
  let currentStrapViewMode = 'list'; // Track strap view mode: 'grid' or 'list' (default list, mirrors watches)
  let suppressStrapAutoSelect = false; // Flag to prevent auto-select during view switches

  /************************************************************************
   * PERFORMANCE OPTIMIZATION GLOBALS - BEAST MODE
   ************************************************************************/
  let intersectionObserver = null;
  let rafId = null;
  
  /************************************************************************
   * URL STATE MANAGEMENT
   * Allows sharing links with specific watch + strap combinations
   * URL format: ?watch=<model>&strap=<handle>&variant=<id>
   ************************************************************************/
  
  /**
   * Get URL parameters for current selection state
   */
  /* 3.91.0: the ?watch=/?strap= INTENT is read once, at script start, and used until init has
     finished. updateURLState() rewrites the URL from the CURRENT selection - and during a cold
     load the first strap page painted and auto-selected a strap while no watch was chosen yet, so
     the URL became "?strap=..." with no watch, and autoSelectFirstWatchAndStrap() then found no
     watch to restore and picked the first catalogue row (Lange 1). Reported 18 Sep as "it tries to
     load what I selected, then clears itself and chooses the Lange 1". The rewrite is also held
     back until init is done, so the address bar cannot lose the link before it has been used. */
  const SV_INITIAL_PARAMS = new URLSearchParams(window.location.search);
  /* 3.94.0: EMBED MODE - see the EMBED MODE section. Read once, here, because the very first
     fetch (fetchAllStraps at parse time) already depends on it. */
  const SV_EMBED = SV_INITIAL_PARAMS.get('embed') === '1';
  const SV_EMBED_STRAP = SV_EMBED ? String(SV_INITIAL_PARAMS.get('strap') || '').trim() : '';
  window.SV_EMBED = SV_EMBED;
  let _svEmbedFamilyPromise = null;   // resolves to the strap family (fetchAllStraps in embed mode)
  let _svEmbedCollSets = null;        // collection handle -> Set of family handles that are in it
  const _svEmbedNoneSet = new Set(['__sv_embed_none__']);   // non-empty on purpose: an EMPTY set reads as unrestricted
  /* 3.94.0: the product field selection, shared by the catalogue fetch and the embed's family
     fetch so the two can never read different shapes. */
  const SV_STRAP_NODE_FIELDS = `
                  id
                  title
                  handle
                  tags
                  options {
                    name
                    values
                  }
                  images(first: 150) {
                    edges {
                      node {
                        src
                      }
                    }
                  }
                  variants(first: 250) {
                    edges {
                      node {
                        id
                        title
                        price {
                          amount
                          currencyCode
                        }
                        availableForSale
                        image {
                          src
                        }
                        metafields(identifiers: [
                          {namespace: "custom", key: "visualiser_image_position"}
                          {namespace: "custom", key: "visualiser_image_url"}
                        ]) {
                          value
                          key
                          namespace
                        }
                      }
                    }
                  }
                  metafields(identifiers: [
                    {namespace: "custom", key: "strap_type"}
                    {namespace: "custom", key: "watch_type"}
                    {namespace: "custom", key: "visualiser_image_position"}
                    {namespace: "custom", key: "visualiser_image_url"}
                    {namespace: "custom", key: "visualiser_product_sub_category"}
                    {namespace: "custom", key: "visualiser_strap_rotate_180"}
                    {namespace: "custom", key: "visualiser_strap_single_diagonal"}
                    {namespace: "custom", key: "visualiser_strap_scale"}
                    {namespace: "custom", key: "visualiser_adjust"}
                    {namespace: "custom", key: "strap_colour"}
                  ]) {
                    value
                    key
                    namespace
                  }`;
  /* The page that frames us. Shopify sends frame-ancestors 'none' on every Online Store page, so
     this document is served by the CRM (crm.strapify.com.au/visualiser/embed) and the product page
     is a DIFFERENT origin: the parent names itself in ?origin= (checked against the store's own
     hosts - anything else gets no messages at all), and the customer's remembered watch comes in
     ?selwatch= because localStorage is not shared across origins. */
  const SV_EMBED_ORIGIN = (function () {
    if (!SV_EMBED) return '';
    const ok = /^https:\/\/(www\.strapify\.com\.au|strapify\.com\.au|strapifyau\.myshopify\.com)$/;
    let o = String(SV_INITIAL_PARAMS.get('origin') || '').trim();
    if (!ok.test(o)) { try { o = new URL(document.referrer).origin; } catch (e) { o = ''; } }
    return ok.test(o) ? o : '';
  })();
  function svEmbedPost(msg) {
    if (!SV_EMBED || !SV_EMBED_ORIGIN || window.parent === window) return;
    try { window.parent.postMessage(Object.assign({ svEmbed: 1 }, msg), SV_EMBED_ORIGIN); } catch (e) {}
  }
  if (SV_EMBED) {
    try { document.documentElement.classList.add('sv-embed'); document.body.classList.add('sv-embed'); } catch (e) {}
    try {
      const sw = SV_INITIAL_PARAMS.get('selwatch');
      if (sw) { const parsed = JSON.parse(sw); if (parsed && typeof parsed === 'object') localStorage.setItem('selectedWatch', JSON.stringify(parsed)); }
    } catch (e) {}
    svEmbedInjectCSS();
  }
  let _svInitDone = false;
  function getURLParams() {
    return _svInitDone ? new URLSearchParams(window.location.search) : SV_INITIAL_PARAMS;
  }

  /**
   * Update URL with current watch and strap selection (without page reload)
   */
  function updateURLState() {
    if (!_svInitDone) return;   // 3.91.0: never overwrite the incoming link mid-load
    /* 3.94.0: never in the embed. The CRM-served document carries <base href="https://www.strapify.com.au/">
       so a RELATIVE replaceState resolves to the store's origin and throws a SecurityError that killed
       the selection flow; and the iframe's own URL (origin=, selwatch=) must stay as the parent set it. */
    if (SV_EMBED) return;
    const params = new URLSearchParams();
    if (SV_EMBED) params.set('embed', '1');   // 3.94.0: never drop the mode on a rewrite
    
    // Add watch parameter (use model name as identifier)
    const selectedWatch = document.querySelector('#watchesGrid img.selected');
    if (selectedWatch && selectedWatch.dataset.model) {
      params.set('watch', selectedWatch.dataset.model);
    }
    
    // Add strap parameter (use handle as identifier)
    if (selectedStrapProduct && selectedStrapProduct.handle) {
      params.set('strap', selectedStrapProduct.handle);
    }
    
    // Add selected variant ID if available
    const variantInput = document.getElementById('selectedVariantId');
    if (variantInput && variantInput.value) {
      params.set('variant', variantInput.value);
    }
    
    // Build new URL
    const newURL = params.toString() 
      ? `${window.location.pathname}?${params.toString()}`
      : window.location.pathname;
    
    // Update URL without reload
    window.history.replaceState({}, '', newURL);
    
  }

  /**
   * Restore selection state from URL parameters
   * Returns true if URL params were found and processed
   */
  /* ---- Reveal a programmatically-selected row ----
     A shared link selects a watch and a strap that nobody scrolled to: measured on a real link, the
     chosen watch row sat 4725px and the strap row 457px down lists whose scrollTop was still 0, so
     both panels looked untouched even though the selection, the details panel and the preview were
     all correct.
     ⚠ NOT element.scrollIntoView(): that walks every scrollable ancestor, so on a fresh page load it
     scrolls the PAGE as well and drops the visitor past the header. Only the list's own scrollTop is
     touched here. */
  function svScrollerFor(el) {
    let p = el && el.parentElement;
    while (p && p !== document.body) {
      const s = getComputedStyle(p);
      if (/(auto|scroll|overlay)/.test(s.overflowY) && p.scrollHeight > p.clientHeight + 4) return p;
      p = p.parentElement;
    }
    return null;
  }
  function svRevealRow(img) {
    if (!img) return;
    const row = img.closest('.watch-list-item') || img.closest('.strap-list-item') || img;
    const sc = svScrollerFor(row);
    if (!sc) return;
    const r = row.getBoundingClientRect(), c = sc.getBoundingClientRect();
    if (r.top >= c.top && r.bottom <= c.bottom) return;   // already visible - leave the scroll alone
    sc.scrollTop += (r.top - c.top) - Math.max(0, (c.height - r.height) / 2);
  }

  function restoreFromURLState() {
    const params = getURLParams();
    const watchModel = params.get('watch');
    const strapHandle = params.get('strap');
    const variantId = params.get('variant');
    
    if (!watchModel && !strapHandle) {
      return false;
    }
    
    
    // Schedule the restoration after DOM is ready
    setTimeout(() => {
      // If the user already started picking, don't yank their selection back to the URL/first watch.
      if (svUserInteracted) return;
      let watchFound = false;
      let strapFound = false;
      
      // Find and select the watch by model name
      if (watchModel) {
        const watchGrid = document.getElementById('watchesGrid');
        const watchImages = watchGrid.querySelectorAll('img[data-model]');
        
        // An Apple series is one row carrying both case sizes now (mergeAppleCaseSizes), so a link
        // to the size that is not currently showing has no row of its own to match. Switch that
        // row over to the requested size first, then let the normal match below find it.
        if (![...watchImages].some(i => i.dataset.model === watchModel)) {
          for (const img of watchImages) {
            const w = img._svWatch;
            const variant = w && w.sizeVariants && w.sizeVariants.find(v => v.row.model === watchModel);
            if (!variant) continue;
            const sel = img.closest('.watch-list-item')?.querySelector('.watch-size-select');
            if (sel) { sel.value = variant.label; sel.dispatchEvent(new Event('change', { bubbles: true })); }
            break;
          }
        }

        for (const img of watchImages) {
          if (img.dataset.model === watchModel) {
            if (currentWatchData && img.classList.contains('selected')) { watchFound = true; break; }   // 3.92.0: chosen early
            // Clear previous selection
            watchGrid.querySelectorAll('img').forEach(i => i.classList.remove('selected'));
            watchGrid.querySelectorAll('.watch-list-item').forEach(item => item.classList.remove('selected'));
            
            // Select this watch
            img.classList.add('selected');
            const listItem = img.closest('.watch-list-item');
            if (listItem) listItem.classList.add('selected');
            
            // Display watch details
            displayWatchDetails(img);
            svRaf(() => svRevealRow(img));   // the row is hundreds of rows down - show it
            watchFound = true;
            break;
          }
        }
        
        if (!watchFound) {
        }
      }
      
      // Find and select the strap by handle
      const restoreStrap = (attempt) => setTimeout(() => {
        if (svUserInteracted) return; // user took over in the meantime - don't override their strap
        if (strapHandle) {
          const strapsGrid = document.getElementById('strapsGrid');
          const strapImages = strapsGrid.querySelectorAll('img[data-id]');

          // Find product by handle
          const product = allStrapProducts.find(p => p.handle === strapHandle);

          // ⚠ Apple straps are LAZY-LOADED (and the normal list is cached, not instant), so on a
          // cold session the list can still be in flight when this window opens. Without a wait the
          // fallback below would quietly select the first visible strap instead of the linked one.
          // Only waits while something is actually loading, so a genuinely unknown handle still
          // falls through immediately.
          if (!product && attempt < 24 && (window.__applesLoading || !strapImages.length)) {
            restoreStrap(attempt + 1);
            return;
          }

          if (product) {
            // Find the corresponding image
            for (const img of strapImages) {
              if (String(img.dataset.id) === String(product.id)) {
                // Check if strap is visible (compatible with selected watch)
                if (isStrapImgShown(img)) {
                  // Clear previous selection
                  strapsGrid.querySelectorAll('img').forEach(i => i.classList.remove('selected'));
                  strapsGrid.querySelectorAll('.strap-list-item').forEach(item => item.classList.remove('selected'));
                  
                  // Select this strap
                  img.classList.add('selected');
                  const listItem = img.closest('.strap-list-item');
                  if (listItem) listItem.classList.add('selected');
                  
                  // Set up strap data
                  selectedStrapProduct = product;
                  currentStrapURL = svStrapUrl(product);
                  showStrapDetails(product);
                  strapFound = true;
                  
                  // If variant ID was specified, try to select it
                  if (variantId) {
                    setTimeout(() => {
                      if (SV_EMBED) svEmbedApplyVariant(variantId); else selectVariantById(variantId);
                    }, 100);
                  }
                  
                  svRaf(() => svRevealRow(img));

                  // Combine images
                  setTimeout(() => {
                    if (currentWatchData && currentStrapURL) {
                      combineImages();
                    }
                    // Again after everything has settled: a late Apple lazy-load re-render would
                    // rebuild the rows and put the list back to the top. No-op if already in view.
                    svRevealRow(document.querySelector('#strapsGrid img.selected'));
                    svRevealRow(document.querySelector('#watchesGrid img.selected'));
                  }, 200);
                } else {
                }
                break;
              }
            }
          }
          
          if (!strapFound && strapHandle) {
          }
        }
        
        // If no strap was specified or found, select first visible strap
        if (!strapFound && watchFound) {
          const strapsGrid = document.getElementById('strapsGrid');
          const firstVisibleStrap = Array.from(strapsGrid.querySelectorAll('img[data-id]')).find(isStrapImgShown);
          if (firstVisibleStrap) {
            firstVisibleStrap.click();
          }
        }
      }, attempt === 0 ? 300 : 250);
      restoreStrap(0);
      
      // If no watch was found from URL, select first watch
      /* 3.94.0: ...unless one is ALREADY chosen. A ?strap= link with no ?watch= (the PDP embed,
         or a shared strap link) reached here after svEarlySelectWatch had put the customer's own
         watch (header selector) in the chip, and clicked the first catalogue row over it. */
      if (!watchFound && !watchModel && !currentWatchData && !SV_EMBED) {   // embed: offer the picker instead (svEmbedState 'ready')
        const watchGrid = document.getElementById('watchesGrid');
        const firstWatch = watchGrid.querySelector('img[data-raw-link]');
        if (firstWatch) {
          firstWatch.click();
        }
      }
      
    }, 1200); // Wait for DOM to be fully ready
    
    return true;
  }

  /**
   * Select a specific variant by ID (for URL restoration)
   */
  function selectVariantById(variantId) {
    if (!selectedStrapProduct || !variantId) return;
    
    const variant = selectedStrapProduct.variants.find(v => String(v.id) === String(variantId));
    if (variant) {
      // Update dropdowns to match this variant
      const options = selectedStrapProduct.options || [];
      const parts = parseVariantOptionValues(variant.title, options);
      
      options.forEach((option, index) => {
        const select = document.getElementById(`optionSelect_${index}`);
        if (select && parts[index]) {
          select.value = parts[index];
          currentOptionSelections[index] = parts[index];
        }
      });
      
      // Update variant state
      updateSelectedVariant(variant);
      updateVisualizerImage(variant);
    }
  }

  /************************************************************************
   * HIGH-PERFORMANCE FILTER & SEARCH SYSTEM
   ************************************************************************/
  
  // Memoization cache for search results
  const searchCache = new Map();
  
  // RAF-based update queue
  let updateQueue = [];
  let isUpdating = false;
  
  // Performance-optimized filter state
  let filterState = {
    watches: {
      brand: '',
      search: '',
      results: new Set(),
      lastQuery: null
    },
    straps: {
      category: '',
      subCategory: '',
      color: '',
      search: '',
      results: new Set(),
      lastQuery: null
    }
  };
  
  // Fast string matching with memoization
  function fastStringMatch(text, query, cacheKey) {
    if (!query) return true;
    
    if (searchCache.has(cacheKey)) {
      return searchCache.get(cacheKey);
    }
    
    const result = text.toLowerCase().includes(query.toLowerCase());
    searchCache.set(cacheKey, result);
    
    // Limit cache size to prevent memory leaks
    if (searchCache.size > 1000) {
      const firstKey = searchCache.keys().next().value;
      searchCache.delete(firstKey);
    }
    
    return result;
  }
  
  // Batch DOM updates using RAF
  function queueDOMUpdate(updateFn) {
    updateQueue.push(updateFn);
    
    if (!isUpdating) {
      isUpdating = true;
      svRaf(() => {
        // Process all updates in single frame
        const updates = updateQueue.splice(0);
        updates.forEach(fn => fn());
        isUpdating = false;
      });
    }
  }
  
  // RAF-based throttle for search inputs
  function rafThrottle(callback) {
    let rafId = null;
    let lastArgs = null;
    
    return function(...args) {
      lastArgs = args;
      
      if (!rafId) {
        rafId = requestAnimationFrame(() => {
          callback.apply(this, lastArgs);
          rafId = null;
        });
      }
    };
  }
  
  // Loading overlay fully removed - these are no-ops kept so existing call sites stay valid.
  function updateLoadingProgress() {}
  function hideLoadingOverlay() { if (SV_EMBED) svEmbedRendered(); }   // 3.94.0: embed placeholder off

  /************************************************************************
   * PERSISTENT DATA CACHE (3.68.0)
   * The strap and watch feeds used to be cached in sessionStorage with a 5-minute TTL, so a
   * "resume" - a NEW TAB, or any return after 5 minutes - threw the lot away and paid the whole
   * cold load again. Measured on the live page 2026-09-09: 4 serial GraphQL pages for the straps
   * (1.0s -> 5.0s; the FIRST page alone is ~3s) and then 4 more for the Apple range
   * (7.7s -> 8.7s). ~8.7s to data-ready on a fast desktop, ~15s on a phone.
   * These read from localStorage, so a resume renders from the cache immediately. Anything older
   * than SV_CACHE_FRESH_MS is still SERVED, then revalidated in the background and swapped in
   * only if the catalogue actually changed. The old staleness trap is gone in both directions:
   * nothing is served for more than one page view without a network check, and nothing WAITS on
   * that check.
   * (a) localStorage survives the tab - never cache anything customer-specific here.
   * (b) A stale payload is READ, not rejected, so still bump the key on any SHAPE change.
   * (c) ⚠ These helpers, and every piece of state they touch, must stay ABOVE the parse-time
   *     loadWatchCSV()/fetchAllStraps() calls below. Those run synchronously on their line, and a
   *     `const`/`let` declared further down the file is in its temporal dead zone until then.
   ************************************************************************/
  const SV_CACHE_FRESH_MS  = 5 * 60 * 1000;            // younger than this: no revalidation at all
  const SV_CACHE_MAX_MS    = 7 * 24 * 60 * 60 * 1000;  // older than this: ignored, treated as absent
  const SV_CACHE_MAX_CHARS = 4000000;                  // one entry must not hog the whole quota
  /* 3.91.0: THE STRAP LIST NO LONGER FITS localStorage. 2,449 products (1,635 adapter bundles
     joined on 18 Sep) with tags, images and variants stringify past SV_CACHE_MAX_CHARS, so
     svCacheWrite refused it and EVERY visit was a cold fetch: ten Storefront pages, one after
     another, 26 seconds before a watch could even be chosen. IndexedDB has no such cap, so the
     list goes there when it is too big for localStorage (which keeps serving the small keys and
     older browsers). One store, one entry: a write clears whatever key came before it, so a
     bumped SV_STRAPS_KEY never leaves a dead payload behind. */
  function svIdb() {
    return new Promise((res) => {
      try {
        const r = indexedDB.open('sv_cache', 1);
        r.onupgradeneeded = () => { try { r.result.createObjectStore('kv'); } catch (e) {} };
        r.onsuccess = () => res(r.result);
        r.onerror = () => res(null);
        r.onblocked = () => res(null);
      } catch (e) { res(null); }
    });
  }
  async function svIdbCacheRead(key) {
    const db = await svIdb();
    if (!db) return null;
    return new Promise((res) => {
      try {
        const rq = db.transaction('kv', 'readonly').objectStore('kv').get(key);
        rq.onsuccess = () => {
          const raw = rq.result; db.close();
          if (!raw) return res(null);
          try {
            const wrap = JSON.parse(raw);
            if (!wrap || typeof wrap.t !== 'number' || !('data' in wrap)) return res(null);
            const age = Date.now() - wrap.t;
            if (age > SV_CACHE_MAX_MS) return res(null);
            res({ data: wrap.data, age: age, fresh: age < SV_CACHE_FRESH_MS });
          } catch (e) { res(null); }
        };
        rq.onerror = () => { db.close(); res(null); };
      } catch (e) { res(null); }
    });
  }
  async function svIdbCacheWrite(key, json) {
    const db = await svIdb();
    if (!db) return false;
    return new Promise((res) => {
      try {
        const tx = db.transaction('kv', 'readwrite');
        const st = tx.objectStore('kv');
        st.clear();
        st.put(json, key);
        tx.oncomplete = () => { db.close(); res(true); };
        tx.onerror = () => { db.close(); res(false); };
      } catch (e) { res(false); }
    });
  }
  // localStorage when it fits (fast, synchronous read), IndexedDB when it does not.
  function svCacheWriteBig(key, data, replacer) {
    if (svCacheWrite(key, data, replacer)) return;
    let json;
    try { json = JSON.stringify({ t: Date.now(), data: data }, replacer); } catch (e) { return; }
    svIdbCacheWrite(key, json);
  }
  /* v18 (2026-09-09): bumped by hand to push catalogue edits out IMMEDIATELY. A key bump is the
     only way to skip the serve-then-revalidate step - v17 payloads are simply never read again,
     so the next page view fetches fresh instead of showing the cached list first. The cost is one
     cold load (~5s, 4 serial GraphQL pages) for every visitor whose cache this invalidates, so
     bump it for a change that must be live now, not as routine hygiene. */
  /* v20: 2026-09-18 (3.90.0). The cached strap payload now carries `tags`, which the
     proprietary-lug check reads - a v19 payload has none, so every Pixel/Galaxy row would
     fall back to bundles only until the cache aged out. See the standing rule: a shape
     change is invisible until the key moves. */
  const SV_STRAPS_KEY   = 'sv_straps_v24';   // v24: 19 Sep - payload carries visUrlSet   // v23: 19 Sep - 549 Galaxy bundles' kit photos rebuilt (old media deleted)   // v22: 18 Sep - 76 Pixel bracelet bundles' kit photos rebuilt (old media deleted)
  var   APPLE_CACHE_KEY = 'sv_apple_straps_v6';   // v6:  2026-09-16 - 3.79.0 changed how the image
                                                  //      POSITIONS in this payload are computed (colour-only
                                                  //      key -> appearanceKey). A v5 entry holds the OLD
                                                  //      mapping and is served before any revalidation, so
                                                  //      Floral Silicone/Vogue would keep drawing the wrong
                                                  //      design for up to 7 days. A key bump is the only way
                                                  //      to publish a SHAPE change immediately.
  const SV_WATCHCSV_KEY = 'sv_watchcsv_v9';       // v9:  2026-09-18 - 8 Pixel rows typed Google, 4 blank
                                                 //      Galaxy 8/9/Ultra rows typed Galaxy Watch Ultra.
                                                 // v8:  2026-09-17 - Google Pixel 5 41mm/45mm added with
                                                 //      faces (Polished Silver / Satin Pyrite / Matte
                                                 //      Black); first Pixel rows ever to carry one.
                                                 // v7:  2026-09-16 - Series 12 rows gained their missing
                                                 //      `watch type: Apple` (a blank one reads as Quick
                                                 //      Release, so they never merged into one sized row);
                                                 //      a v6 payload still holds the blank. v6:  Series 12 +
                                                 //      8 finishes) + Ultra 4 49mm added to the catalogue;
                                                 //      bumped so the new watches show on the NEXT view
                                                 //      instead of after a background revalidation.

  // Private mode / disabled storage can throw on ACCESS, not just on write.
  function svLS() { try { return window.localStorage; } catch (e) { return null; } }
  function svSS() { try { return window.sessionStorage; } catch (e) { return null; } }

  // The sessionStorage-era keys. Left behind they are dead weight in a quota we now care about.
  ['sv_straps_v11', 'sv_straps_v12', 'sv_straps_v13', 'sv_straps_v14', 'sv_straps_v15',
   'sv_straps_v16', 'sv_straps_v17', 'sv_straps_v19', 'sv_straps_v20', 'sv_straps_v21', 'sv_straps_v22', 'sv_straps_v23', 'sv_watchcsv_v3', 'sv_watchcsv_v4', 'sv_watchcsv_v8',
   'sv_apple_straps_v3', 'sv_apple_straps_v4', 'sv_apple_straps_v5',
   'sv_watchcsv_v5', 'sv_watchcsv_v6', 'sv_watchcsv_v7'].forEach(k => {
    const ss = svSS(), ls = svLS();
    if (ss) { try { ss.removeItem(k); } catch (e) {} }
    if (ls) { try { ls.removeItem(k); } catch (e) {} }
  });

  /* The collection sets are keyed per watch collection handle (`sv_coll_<handle>_v3`), so a dead
     version cannot be listed by name - sweep anything that is not the current suffix. Bumping
     that suffix is what publishes a membership change immediately, and this is what stops the
     superseded copies sitting in the quota forever. */
  const SV_COLL_SUFFIX = '_v3';
  [svLS(), svSS()].forEach(store => {
    if (!store) return;
    try {
      for (let i = store.length - 1; i >= 0; i--) {
        const k = store.key(i);
        if (k && k.indexOf('sv_coll_') === 0 && k.slice(-SV_COLL_SUFFIX.length) !== SV_COLL_SUFFIX) {
          store.removeItem(k);
        }
      }
    } catch (e) {}
  });

  function svCacheRead(key) {
    const stores = [svLS(), svSS()];
    for (let i = 0; i < stores.length; i++) {
      const store = stores[i];
      if (!store) continue;
      try {
        const raw = store.getItem(key);
        if (!raw) continue;
        const wrap = JSON.parse(raw);
        if (!wrap || typeof wrap.t !== 'number' || !('data' in wrap)) continue;
        const age = Date.now() - wrap.t;
        if (age > SV_CACHE_MAX_MS) { try { store.removeItem(key); } catch (e) {} continue; }
        return { data: wrap.data, age: age, fresh: age < SV_CACHE_FRESH_MS };
      } catch (e) {}
    }
    return null;
  }

  // Writes to localStorage so the entry outlives the tab, and falls back to sessionStorage when
  // the quota says no: a full localStorage must never cost us the same-session cache we had before.
  function svCacheWrite(key, data, replacer) {
    let json;
    try { json = JSON.stringify({ t: Date.now(), data: data }, replacer); } catch (e) { return false; }
    if (!json || json.length > SV_CACHE_MAX_CHARS) return false;
    const ls = svLS();
    if (ls) {
      try { ls.setItem(key, json); return true; }
      catch (e) { try { ls.removeItem(key); } catch (e2) {} }   // quota: never leave a half-entry
    }
    const ss = svSS();
    if (ss) { try { ss.setItem(key, json); return true; } catch (e) {} }
    return false;
  }

  /* ---- strap list: serve, then revalidate ------------------------------------------------ */
  let _svServedStrapSig     = '';     // fingerprint of the list currently on screen
  let _svRevalidatingStraps = false;
  let _svPendingFreshStraps = null;   // arrived before init had finished rendering
  let _svStrapUiReady       = false;  // grid listeners wired: safe to paint rows
  let _svFinalStrapRender   = false;  // init has rendered the complete list; partials stop here

  /* 3.93.0: WATCH-FIRST LOADING. A cold visit used to pull the whole strap catalogue - eleven
     serial Storefront pages, ~2,550 products, 34 s measured - before a customer who arrived with
     a watch already chosen (?watch= link, the header selector) saw a single strap; the Galaxy
     straps sat on pages 9-10, so the grid stayed empty for 26 s under "1,979 straps so far".
     Now, when the watch is known before the straps are, the FIRST fetch is that watch's own
     collection (one page for every watch in the catalogue today) and the grid is complete for
     that watch in a few seconds. The full catalogue then loads in the background for a change of
     watch and is swapped in through the same path a revalidation uses (svApplyFreshStraps), and
     it - never the partial list - is what gets cached. While the background fetch runs, a
     DIFFERENT watch shows the loading panel rather than "No matching straps". */
  let _svEarlyWatchResolve = null;
  const _svEarlyWatchHandle = new Promise(r => { _svEarlyWatchResolve = r; });
  function svEarlyWatchSettle() {
    if (!_svEarlyWatchResolve) return;
    const w = currentWatchData;
    const h = (w && !w.isApple && !w.isCustom && !w.noStraps && w.collectionHandle) || '';
    _svEarlyWatchResolve(h); _svEarlyWatchResolve = null;
  }
  let _svWatchFirst = null;          // { handle } once a watch-first list is on screen
  let _svFullStrapsPending = false;  // the background full-catalogue fetch is still running
  function svRegisterCollectionSet(handle, handles) {
    try {
      if (!handle || !handles || !handles.length) return;
      _watchCollCache[handle] = new Set(handles);
      svCacheWrite('sv_coll_' + handle + SV_COLL_SUFFIX, handles);
      if (currentWatchData && currentWatchData.collectionHandle === handle) {
        currentWatchData.collectionSet = _watchCollCache[handle];
        currentWatchData.collectionPending = false;
      }
    } catch (e) {}
  }
  // A ?strap= that was not in the watch-first list (a link pairing a watch with a strap from
  // another collection) gets one more chance once the whole catalogue is in.
  function svRetryInitialStrap() {
    try {
      const want = SV_INITIAL_PARAMS.get('strap');
      if (!want || selectedStrapProduct || svUserInteracted) return;
      const p = (allStrapProducts || []).find(x => x && x.handle === want);
      if (!p) return;
      const img = document.querySelector('#strapsGrid img[data-id="' + String(p.id) + '"]');
      if (img && isStrapImgShown(img)) img.click();
    } catch (e) {}
  }

  // Cheap fingerprint: enough to tell "the catalogue changed" from "identical payload", so an
  // unchanged revalidation never rebuilds the grid under the customer.
  function svStrapsSignature(list) {
    if (!Array.isArray(list)) return '';
    return list.length + '|' + list.map(p => p && (p.id + ':' + ((p.variants && p.variants.length) || 0) +
      ':' + ((p.visualiserImage && p.visualiserImage.src) || ''))).join(',');
  }

  function svRevalidateStraps() {
    if (_svRevalidatingStraps) return;
    _svRevalidatingStraps = true;
    svFetchStrapsNetwork().then(fresh => {
      if (!fresh || !fresh.length) return;                         // a failed refresh keeps the cache
      if (svStrapsSignature(fresh) === _svServedStrapSig) return;   // unchanged: leave the DOM alone
      _svServedStrapSig = svStrapsSignature(fresh);
      if (!_svFinalStrapRender) { _svPendingFreshStraps = fresh; return; }
      svApplyFreshStraps(fresh);
    }).catch(e => console.warn('Strap revalidation failed', e))
      .finally(() => { _svRevalidatingStraps = false; });
  }

  // Swap a changed catalogue in without losing the Apple straps appended to the list at runtime,
  // or the customer's current selection.
  function svApplyFreshStraps(fresh) {
    try {
      const apples = (allStrapProducts || []).filter(p => p && p.__svApple);
      allStrapProducts = fresh.concat(apples);
      if (selectedStrapProduct) {
        const still = allStrapProducts.find(p => String(p.id) === String(selectedStrapProduct.id));
        if (still) selectedStrapProduct = still;
      }
      setupCategoryDropdowns();
      renderStraps(allStrapProducts);
      filterStrapsByAllCategories(true);   // straight after a render: never defer the hide
      svReapplySelectedStrap();
    } catch (e) { console.warn('Strap swap-in failed', e); }
  }

  // renderStraps() rebuilds the grid from scratch, so the .selected highlight has to be put back.
  function svReapplySelectedStrap() {
    if (!selectedStrapProduct) return;
    const grid = document.getElementById('strapsGrid');
    if (!grid) return;
    const img = grid.querySelector('img[data-id="' + String(selectedStrapProduct.id) + '"]');
    if (!img) return;
    img.classList.add('selected');
    const li = img.closest('.strap-list-item');
    if (li) li.classList.add('selected');
  }

  /* Paint what we have as each GraphQL page lands instead of only after the last one. Shopify's
     first response is the slow one (~3s) and the rest are ~300ms, so the grid fills from about
     half way through the fetch. Gated on _svStrapUiReady: rows painted before init wires the
     grid's delegated click/search listeners would be rows nothing is listening to. */
  function svRenderStrapsPartial(list) {
    try {
      // Readable from the console, like __svStrapsRendered: how many pages were painted early.
      try { window.__svPartialPaints = (window.__svPartialPaints || 0) + 1; } catch (e) {}
      allStrapProducts = list;
      setupCategoryDropdowns();
      renderStraps(list);
      filterStrapsByAllCategories(true);
      svReapplySelectedStrap();
    } catch (e) { console.warn('Partial strap render failed', e); }
  }

  /* ---- Apple range: prefetched, not lazy -------------------------------------------------- */
  /* The Apple straps live in a different collection and used to be fetched only when an Apple
     watch was first picked - 4 more serial pages that began at ~7.7s because they queued behind
     the main fetch AND its render. This starts them as soon as the main fetch has its first page
     (or instantly, on a cached resume). Same data, same cache, just off the critical path. */
  let _appleDataPromise    = null;
  let _svRevalidatingApple = false;
  function svApplePrefetch() {
    if (_appleDataPromise) return _appleDataPromise;
    _appleDataPromise = (async () => {
      const cached = svCacheRead(APPLE_CACHE_KEY);
      if (cached && Array.isArray(cached.data) && cached.data.length) {
        cached.data.forEach(s => { if (s.variants) s.variants.forEach(v => { v.parentImages = s.images; }); });
        if (!cached.fresh) svRevalidateApple();
        return cached.data;
      }
      const apple = await fetchAppleStraps();
      if (apple && apple.length) {
        svCacheWrite(APPLE_CACHE_KEY, apple, (k, v) => k === 'parentImages' ? undefined : v);
      }
      return apple;
    })();
    _appleDataPromise.catch(() => { _appleDataPromise = null; });   // a failure must not stick
    return _appleDataPromise;
  }
  // Fire-and-forget form: the prefetch call sites have no consumer, and an unhandled rejection
  // from a background warm-up would surface as a console error on every flaky connection.
  function svApplePrefetchQuiet() { try { svApplePrefetch().catch(() => {}); } catch (e) {} }

  function svRevalidateApple() {
    if (_svRevalidatingApple) return;
    _svRevalidatingApple = true;
    fetchAppleStraps().then(fresh => {
      if (!fresh || !fresh.length) return;
      svCacheWrite(APPLE_CACHE_KEY, fresh, (k, v) => k === 'parentImages' ? undefined : v);
      if (!_appleStrapsReady) return;   // not on screen yet - refreshing the cache is enough
      const cur = (allStrapProducts || []).filter(p => p && p.__svApple);
      if (svStrapsSignature(fresh) === svStrapsSignature(cur)) return;
      fresh.forEach(s => {
        s.__svApple = true;
        if (s.variants) s.variants.forEach(v => { v.parentImages = s.images; });
      });
      _appleDataPromise = Promise.resolve(fresh);
      allStrapProducts = (allStrapProducts || []).filter(p => !(p && p.__svApple)).concat(fresh);
      setupCategoryDropdowns();
      renderStraps(allStrapProducts);
      filterStrapsByAllCategories(true);
      svReapplySelectedStrap();
    }).catch(() => {}).finally(() => { _svRevalidatingApple = false; });
  }

  /* ---- watch feed ------------------------------------------------------------------------- */
  let _svCsvRevalidating = false;
  async function svRevalidateWatchCSV() {
    if (_svCsvRevalidating) return;
    _svCsvRevalidating = true;
    try {
      const prev = svCacheRead(SV_WATCHCSV_KEY);
      // 3.77.0: no cache-buster, `no-cache` not `no-store` - see loadWatchCSV.
      const r = await fetch('https://crm.strapify.com.au/visualiser-watches.json',
                            { cache: 'no-cache', referrerPolicy: 'no-referrer' });
      if (!r.ok) return;
      const t = await r.text();
      if (!t) return;
      svCacheWrite(SV_WATCHCSV_KEY, t);
      /* Re-parsing rebuilds the watch list, so a changed feed only takes effect immediately while
         nobody has chosen a watch yet. Otherwise the refreshed copy is simply cached and lands on
         the next page view - the feed changes far less often than a session lasts. */
      if (prev && prev.data !== t && !currentWatchData && !svUserInteracted) {
        parseCSV(t);
        renderWatches();
        // ⚠ renderWatches() REPLACES every row, which orphans the refine observer's targets.
        // Every other renderWatches() call site is paired with this one; leaving it out here
        // meant a refreshed feed silently cost the whole grid its lazy thumbnails.
        refineWatchesBatched();
      }
    } catch (e) { console.warn('Watch feed revalidation failed', e); }
    finally { _svCsvRevalidating = false; }
  }

  /************************************************************************
   * ON DOM CONTENT LOADED
   ************************************************************************/
  // Kick both data fetches off at script-parse time (this script sits at the end of <body>,
  // so the DOM already exists; waiting for DOMContentLoaded just delayed the network).
  const svCsvPromise = loadWatchCSV();
  const svStrapsPromise = fetchAllStraps();

  document.addEventListener("DOMContentLoaded", async function() {
    updateLoadingProgress(0, 'INITIALIZING...');
    if (SV_EMBED) svEmbedInit();

    try {
      // PHASE 1: Critical path rendering
      updateLoadingProgress(10, 'SETTING UP...');

      // 1) Setup observers first for immediate responsiveness
      setupIntersectionObserver();
      updateLoadingProgress(15, 'LOADING WATCHES...');

      // 2+3) Data fetches were started at parse time (above)
      const csvPromise = svCsvPromise;
      const strapPromise = svStrapsPromise;
      updateLoadingProgress(20, 'LOADING WATCHES...');

      // 4) Wait for CSV to complete before rendering watches
      await csvPromise;
      updateLoadingProgress(40, 'RENDERING WATCHES...');

      
      // 5) Render watches immediately with placeholders
      renderWatches();
      /* 3.92.0: the customer's watch is known NOW (a ?watch= link or the header selector) - choose
         it before the straps arrive, so the list filters as its pages land and the chip reads the
         right watch from the first paint. Before, the watch waited on the whole strap fetch:
         the chip said "Your watch", an unfiltered quick-release list painted with a strap
         selected, then "Loading straps...", then the real list (owner: "it takes so many steps
         for the straps to appear"). */
      try { svEarlySelectWatch(); } catch (e) {}
      svEarlyWatchSettle();   // 3.93.0: the strap fetch is waiting to hear which collection to load first
      setupBrandFilter();
      setupWatchSearch();
      watchSelectionSetup();
      svcSetupButton();      // "use a photo of your own watch" entry point
      setupViewToggle();
      updateLoadingProgress(50, 'LOADING STRAPS...');

      // PHASE 2: Background processing
      

      // 6) Start watch processing in background (non-blocking for faster load)
      refineWatchesBatched(); // Don't await - let it run in background

      /* 3.68.0: wire the grid's listeners BEFORE waiting on the straps. They are safe with no
         products (already the reason they ran before the render), and having them up front is
         what lets svFetchStrapsNetwork paint each page as it lands - rows painted with nothing
         listening to them would be worse than an empty grid. */
      setupStrapSearch();
      strapSelectionSetup();
      setupStrapViewToggle();
      _svStrapUiReady = true;

      // 7) Wait for straps and setup categories
      allStrapProducts = await strapPromise;
      updateLoadingProgress(75, 'SETTING UP STRAPS...');

      // Fetch failed / returned nothing: say so and offer a retry (never a silent empty page).
      if (!allStrapProducts || allStrapProducts.length === 0) {
        if (SV_EMBED) svEmbedState('error'); else showStrapLoadError();
        return;
      }

      setupCategoryDropdowns();

      // Add small delay to ensure DOM is stable before rendering
      await new Promise(resolve => setTimeout(resolve, 50));

      renderStraps(allStrapProducts);
      /* ⚠ HIDE STRAIGHT AFTER THE RENDER - the other two renderStraps() sites already do this
         and this one was the odd one out. renderStraps paints every row VISIBLE, and the
         autoSelectFirstWatchAndStrap() below returns immediately when `svUserInteracted` is
         set. So a customer who picks a watch DURING the ~4.5s cold strap fetch filtered an
         empty grid, then got all 130 rows painted with nothing left to re-filter them:
         QuickFit straps sat in the list of a Quick Release watch (reported on an Amazfit
         Active 2) until they happened to touch a filter or the search box. The watch chip
         looked correct throughout because it syncs off #watchDetails via MutationObserver,
         independently of the filter. Harmless when no watch is chosen yet - with no
         currentWatchData the compat check is skipped and everything stays visible. */
      filterStrapsByAllCategories(true);

      // The complete list is on screen: partial page renders stop here, and a background
      // revalidation that finished during init is applied now rather than dropped.
      _svFinalStrapRender = true;
      // 3.92.4: the final filter pass ran a moment BEFORE this flag flipped, so it kept the
      // "Loading straps…" panel (3.92.3 judges loading by this flag) - hide it now that the
      // complete list is on screen, then let the filter decide the empty state from here on.
      showStrapsLoading(false);
      if (currentWatchData && !currentWatchData.collectionPending) filterStrapsByAllCategories(true);
      if (_svPendingFreshStraps) {
        const _fresh = _svPendingFreshStraps;
        _svPendingFreshStraps = null;
        svApplyFreshStraps(_fresh);
      }

      updateLoadingProgress(85, 'FINALIZING...');
      
      // 9) Auto-select first items
      autoSelectFirstWatchAndStrap();
      if (SV_EMBED) svEmbedState('ready');
      updateLoadingProgress(95, 'ALMOST READY...');
      
      // Enforce grid view on mobile
      enforceGridViewOnMobile();
      
      // Initial action buttons centering setup
      setTimeout(() => {
        centerActionButtons();
      }, 100);
      
      updateLoadingProgress(100, 'READY!');
      _svInitDone = true;   // 3.91.0: from here the URL follows the selection
      
    } catch(err) {
      console.error('Visualiser init failed:', err);
    } finally {
      // No artificial minimum: the overlay is hidden the instant the first preview renders
      // (performCombination -> hideLoadingOverlay). This is only a safety net so it can't get
      // stuck if no preview ever renders (e.g. no data).
      setTimeout(hideLoadingOverlay, 3500);
    }
  });
  
  /************************************************************************
   * EMBED MODE (3.94.0) - this engine inside the product page
   *
   * The product page's "Try It On Your Watch" used to be a hand-port of performCombination in
   * snippets/strap-try-on.liquid, and it drifted from this file every time placement changed
   * (owner, 19 Sep 2026: "make sure the product page try-on is always in sync since I have to
   * keep saying the same thing"). The snippet is now an <iframe> of this page with
   * ?embed=1&strap=<handle>&variant=<id>, so there is ONE compositor:
   *  - the page's own product plus its fitting twins (adapter bundles / [Quick Release] /
   *    [QuickFit] of the SAME stripped title) is the whole strap list - a strap-first fetch of
   *    a handful of products, never the 800-strap catalogue (svFetchStrapFamily);
   *  - the watch's collection membership is read from those products' OWN `collections`,
   *    not the watch collection's 700 handles (ensureWatchCollection short-circuit);
   *  - header, footer, rail, filters and the mobile flow layout are off; the preview is a
   *    fixed px height (no vh - the iframe is sized to its content, vh would feed back);
   *  - the parent is told the content height, asked for the full viewport while the watch
   *    picker / own-photo modal is open, and handed a successful add-to-cart for its drawer.
   * Nothing here runs unless SV_EMBED is true - the standalone page is untouched.
   ************************************************************************/
  let _svEmbedMain = null;
  let _svEmbedState = 'loading';
  let _svEmbedFs = false;
  let _svEmbedLastH = 0;
  let _svEmbedHeightTimer = null;

  function svStripFittingPrefix(t) { return String(t || '').replace(/^\[[^\]]+\]\s*/, '').trim(); }

  function svEmbedInjectCSS() {
    if (document.getElementById('sv-embed-css')) return;
    const st = document.createElement('style');
    st.id = 'sv-embed-css';
    st.textContent = [
      /* chrome that belongs to the product page, not the try-on */
      'html.sv-embed .shopify-section-group-header-group,html.sv-embed .shopify-section--header,html.sv-embed store-header,',
      'html.sv-embed #shopify-section-watch-selector-final,html.sv-embed .watch-selector-bar,html.sv-embed .shopify-section-group-footer-group,',
      'html.sv-embed .shopify-section--footer,html.sv-embed .shopify-section-group-overlay-group,html.sv-embed .header-countdown-bar,',
      'html.sv-embed cart-notification-drawer,html.sv-embed #scw-launcher,html.sv-embed .scw-launcher,html.sv-embed [class*="kl-private-reset"],',
      'html.sv-embed .sv-header,html.sv-embed .sv-stepper,html.sv-embed #svVersionTag,html.sv-embed #svJumpPill,html.sv-embed .sv-flip,',
      'html.sv-embed #productPageLink,html.sv-embed #changeWatchBtn,html.sv-embed .straps-container,html.sv-embed #downloadBtn,',
      'html.sv-embed #svBuyToggle,html.sv-embed #svPeekPad,html.sv-embed body #strapDetails #productPageLink#productPageLink{display:none !important;}',
      'html.sv-embed,html.sv-embed body{background:#fff !important;padding:0 !important;margin:0 !important;overflow-x:hidden !important;}',
      'html.sv-embed body.sv-onescreen{--sv-embed-ph:560px;--sv-ph:var(--sv-embed-ph);--sv-canvas-h:calc(var(--sv-embed-ph) - 6px);}',
      '@media (max-width:768px){html.sv-embed body.sv-onescreen{--sv-embed-ph:440px;}',
      /* the phone layout keeps the buy card as a floating bar under the rail - here it is a plain card under the preview */
      'html.sv-embed .final-image-container #strapDetails{display:block !important;position:static !important;border:1px solid #e3ded4 !important;border-radius:10px !important;padding:10px 12px !important;background:#fff !important;box-shadow:none !important;}',
      'html.sv-embed #svPhHandle{display:none !important;}}',
      'html.sv-embed body.sv-embed-nowatch #strapDetails#strapDetails{display:none !important;}',
      /* fullscreen (a modal is open): the parent fixes the iframe over its viewport; keep this document the same size */
      'html.sv-embed.sv-embed-fs,html.sv-embed.sv-embed-fs body{height:100% !important;overflow:hidden !important;}',
      'html.sv-embed #mainContainer{margin:0 !important;padding:0 !important;}',
      'html.sv-embed body.sv-onescreen .container.sv-step-strap{display:block !important;padding:0 !important;margin:0 !important;gap:0 !important;}',
      'html.sv-embed body.sv-onescreen .container.sv-step-strap .final-image-container{position:static !important;top:auto !important;left:auto !important;right:auto !important;',
      'z-index:auto !important;height:auto !important;max-height:none !important;margin:0 !important;padding:0 !important;width:100% !important;max-width:none !important;',
      'box-shadow:none !important;border:0 !important;border-radius:0 !important;background:#fff !important;display:flex !important;flex-direction:column !important;',
      'align-items:stretch !important;justify-content:flex-start !important;transition:none !important;transform:none !important;}',
      'html.sv-embed body.sv-onescreen .container.sv-step-strap .preview-viewport{position:relative !important;height:var(--sv-embed-ph) !important;max-height:none !important;',
      'min-height:0 !important;flex:0 0 auto !important;width:100% !important;display:flex !important;align-items:center !important;justify-content:center !important;overflow:hidden !important;}',
      'html.sv-embed body.sv-onescreen .container.sv-step-strap #finalCanvas{max-height:100% !important;max-width:100% !important;height:auto !important;width:auto !important;margin:0 !important;}',
      'html.sv-embed .final-image-container #svWatchBar{display:flex !important;margin:0 0 8px !important;width:100% !important;box-sizing:border-box;}',
      'html.sv-embed .final-image-container .strap-details,html.sv-embed .final-image-container #strapDetails{max-height:none !important;overflow:visible !important;',
      'margin:10px 0 0 !important;width:100% !important;max-width:none !important;box-sizing:border-box;}',
      'html.sv-embed body.sv-onescreen .container.sv-step-strap .action-buttons-container{position:absolute !important;right:8px !important;bottom:8px !important;top:auto !important;left:auto !important;',
      'width:auto !important;margin:0 !important;padding:0 !important;background:none !important;border:0 !important;box-shadow:none !important;z-index:6 !important;display:block !important;}',
      'html.sv-embed #zoomBtn{display:inline-flex !important;align-items:center !important;justify-content:center !important;width:auto !important;min-width:0 !important;margin:0 !important;',
      'padding:7px 13px !important;min-height:34px !important;font-size:12px !important;font-weight:700 !important;border-radius:999px !important;background:rgba(255,255,255,.93) !important;',
      'color:#8a7244 !important;border:1px solid rgba(178,149,95,.55) !important;box-shadow:0 1px 6px rgba(0,0,0,.15) !important;}',
      /* placeholder + "does not fit" notice live INSIDE the preview box */
      '#svEmbedPh,#svEmbedNoFit{position:absolute;inset:0;z-index:5;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;text-align:center;',
      'padding:18px;background:#fff;color:#555;font:14px/1.45 -apple-system,BlinkMacSystemFont,"Segoe UI",Poppins,sans-serif;}',
      '#svEmbedPh[hidden],#svEmbedNoFit[hidden]{display:none !important;}',
      '#svEmbedPh strong,#svEmbedNoFit strong{color:#1d1d1d;font-weight:600;}',
      '.sv-embed-btn{display:inline-block;padding:10px 20px;border:1px solid #b2955f;border-radius:999px;background:#b2955f;color:#fff;font-size:14px;font-weight:600;cursor:pointer;text-decoration:none;}',
      '.sv-embed-btn:hover{background:#fff;color:#b2955f;}',
      '.sv-embed-spin{width:30px;height:30px;border:3px solid #eee;border-top-color:#b2955f;border-radius:50%;animation:svspin .8s linear infinite;}',
      '@keyframes svspin{to{transform:rotate(360deg)}}'
    ].join('');
    (document.head || document.documentElement).appendChild(st);
  }

  /* The whole strap list for an embedded page: the product itself, then every visualiser-tagged
     product whose title minus its "[Fitting]" prefix is the same strap - its adapter bundles, its
     [Quick Release] and [QuickFit] versions. The engine's normal filters then choose the one that
     fits the chosen watch (a Galaxy gets the Galaxy bundle, a spring-bar watch the Quick Release
     twin, a Garmin the QuickFit), exactly as the standalone would from the full catalogue. */
  async function svFetchStrapFamily(handle) {
    const apiUrl = "https://strapifyau.myshopify.com/api/2024-01/graphql.json";
    const headers = { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': '25c76973f9450c7f447913861a934097' };
    const gql = async (query, variables) => {
      const r = await fetch(apiUrl, { method: 'POST', headers, body: JSON.stringify({ query, variables: variables || {} }) });
      const d = await r.json();
      if (d.errors) throw new Error(JSON.stringify(d.errors).slice(0, 300));
      return d.data;
    };
    const COLLS = 'collections(first: 250) { pageInfo { hasNextPage endCursor } edges { node { handle } } }';
    const main = await gql(`query($h: String!) { product(handle: $h) { ${SV_STRAP_NODE_FIELDS} ${COLLS} } }`, { h: handle });
    const node = main && main.product;
    if (!node) return [];
    const base = svStripFittingPrefix(node.title);
    const baseKey = svFold(base);
    const handles = [];
    try {
      // Phase 1: titles + handles only (the search is a relevance search, so it over-returns;
      // the exact stripped-title match is decided here, not by the query).
      const words = base.replace(/[^\w\s]/g, ' ').replace(/\s+/g, ' ').trim();
      if (words) {
        const res = await gql(`query($q: String!) { products(first: 100, query: $q) { edges { node { title handle tags } } } }`, { q: words });
        for (const e of ((res && res.products && res.products.edges) || [])) {
          const n = e && e.node;
          if (!n || n.handle === node.handle) continue;
          if (svFold(svStripFittingPrefix(n.title)) !== baseKey) continue;
          if (!(n.tags || []).some(t => svFold(t) === 'visualiser')) continue;
          if (handles.indexOf(n.handle) < 0) handles.push(n.handle);
          if (handles.length >= 12) break;
        }
      }
    } catch (e) { console.warn('Strap family lookup failed', e); }
    const nodes = [node];
    if (handles.length) {
      try {
        // Phase 2: the full nodes, one request, aliased.
        const q = 'query { ' + handles.map((h, i) => `p${i}: product(handle: ${JSON.stringify(h)}) { ${SV_STRAP_NODE_FIELDS} ${COLLS} }`).join(' ') + ' }';
        const res = await gql(q);
        handles.forEach((h, i) => { const n = res && res['p' + i]; if (n) nodes.push(n); });
      } catch (e) { console.warn('Strap family fetch failed', e); }
    }
    // A quick-release strap sits in hundreds of watch collections - page through the rest.
    const sets = {};
    for (const n of nodes) {
      let page = n.collections, guard = 0;
      while (page) {
        (page.edges || []).forEach(c => {
          const ch = c && c.node && c.node.handle; if (!ch) return;
          (sets[ch] = sets[ch] || new Set()).add(n.handle);
        });
        if (!(page.pageInfo && page.pageInfo.hasNextPage) || ++guard > 8) break;
        try {
          const more = await gql(`query($h: String!, $a: String!) { product(handle: $h) { collections(first: 250, after: $a) { pageInfo { hasNextPage endCursor } edges { node { handle } } } } }`,
                                 { h: n.handle, a: page.pageInfo.endCursor });
          page = more && more.product && more.product.collections;
        } catch (e) { console.warn('Collection page failed', e); page = null; }
      }
    }
    _svEmbedCollSets = sets;
    const list = nodes.map(n => svShapeStrapNode(n));
    _svEmbedMain = list[0] || null;
    window.__svTrace && window.__svTrace.push('embed:family:' + list.map(p => p.handle).join(','));
    return list;
  }

  if (window.__svDebugOn) { try { window.__svFetchStrapFamily = svFetchStrapFamily; } catch (e) {} }   // harness only
  if (window.__svDebugOn) { try { window.__svCurrentStrapURL = () => currentStrapURL; } catch (e) {} }   // harness only
  async function svEmbedFetchStraps() {
    if (!SV_EMBED_STRAP) return [];
    _svEmbedFamilyPromise = svFetchStrapFamily(SV_EMBED_STRAP);
    try { return await _svEmbedFamilyPromise; } catch (e) { console.warn('Embed strap fetch failed', e); return []; }
  }

  /* ---- bridge to the parent page ------------------------------------------------------- */
  function svEmbedMeasure() {
    const mc = document.getElementById('mainContainer');
    if (!mc) return 0;
    const r = mc.getBoundingClientRect();
    return Math.max(0, Math.ceil(r.bottom + (window.scrollY || 0))) + 2;
  }
  function svEmbedPostHeight(force) {
    if (!SV_EMBED || _svEmbedFs) return;
    clearTimeout(_svEmbedHeightTimer);
    _svEmbedHeightTimer = setTimeout(() => {
      const h = svEmbedMeasure();
      if (!h) return;
      if (!force && Math.abs(h - _svEmbedLastH) < 2) return;
      _svEmbedLastH = h;
      svEmbedPost({ sv: 'height', h: h });
    }, 40);
  }
  function svEmbedFullscreen(on) {
    if (!SV_EMBED) return;
    _svEmbedFs = !!on;
    try { document.documentElement.classList.toggle('sv-embed-fs', !!on); } catch (e) {}
    svEmbedPost({ sv: 'fullscreen', on: !!on });
    if (!on) svEmbedPostHeight(true);
  }

  /* ---- placeholder / states ------------------------------------------------------------ */
  function svEmbedPh() {
    let el = document.getElementById('svEmbedPh');
    if (el) return el;
    const vp = document.querySelector('.preview-viewport');
    if (!vp) return null;
    el = document.createElement('div');
    el.id = 'svEmbedPh';
    vp.appendChild(el);
    return el;
  }
  function svEmbedSyncNoWatch() {
    // No watch = no buy card (a bundle's hidden model option would otherwise sell an arbitrary model).
    try { document.body.classList.toggle('sv-embed-nowatch', !currentWatchData); } catch (e) {}
  }
  function svEmbedState(s) {
    if (!SV_EMBED) return;
    svEmbedSyncNoWatch();   // on EVERY transition - an early return below must never leave it stale
    const el = svEmbedPh();
    if (s === 'watch' && _svEmbedState === 'rendered') return;
    if (s === 'ready' && currentWatchData && _svEmbedState === 'rendered') return;
    if (s === 'ready' && currentWatchData) { _svEmbedState = 'waiting'; svEmbedPost({ sv: 'ready' }); svEmbedPostHeight(true); return; }
    if (s === 'watch') { if (_svEmbedState === 'pick') _svEmbedState = 'waiting'; else if (_svEmbedState === 'loading') return; }
    if (s === 'ready') { _svEmbedState = 'pick'; svEmbedPost({ sv: 'ready' }); }
    if (s === 'error') _svEmbedState = 'error';
    if (!el) return;
    if (_svEmbedState === 'pick') {
      el.hidden = false;
      el.innerHTML = '<span>See <strong>' + svEmbedStrapName() + '</strong> on your own watch.</span>' +
        '<button type="button" class="sv-embed-btn" id="svEmbedPickBtn">Choose your watch</button>';
      const b = document.getElementById('svEmbedPickBtn');
      if (b) b.addEventListener('click', () => { const c = document.getElementById('svWatchChip'); if (c) c.click(); });
    } else if (_svEmbedState === 'error') {
      el.hidden = false;
      el.innerHTML = '<span>Couldn\'t load the preview. Please refresh the page.</span>';
    } else if (_svEmbedState === 'loading' || _svEmbedState === 'waiting') {
      el.hidden = false;
      el.innerHTML = '<div class="sv-embed-spin"></div><span>Loading your preview…</span>';
    }
    svEmbedPostHeight();
  }
  function svEmbedStrapName() {
    const p = _svEmbedMain;
    const t = p ? (typeof svStrapDisplayName === 'function' ? svStrapDisplayName(p) : svStripFittingPrefix(p.title)) : 'this strap';
    return String(t).replace(/</g, '&lt;');
  }
  function svEmbedRendered() {
    if (!SV_EMBED) return;
    svEmbedSyncNoWatch();
    if (!currentWatchData) return;   // nothing was drawn: keep the "choose your watch" placeholder
    _svEmbedState = 'rendered';
    const el = document.getElementById('svEmbedPh');
    if (el) el.hidden = true;
    // (the no-fit notice is NOT cleared here: init's 3.5 s overlay safety net lands here too, and it
    //  must not wipe a verdict the filter pass has just given; a real render clears it via the pass)
    svEmbedPostHeight();
  }
  /* The rail is hidden, so "No matching straps found" in it says nothing to the customer. When
     the family has no member that fits the chosen watch the preview box says so and points at
     the watch's own collection; the engine has already dropped the buy card (filter pass). */
  function svEmbedNoFit(show) {
    if (!SV_EMBED) return;
    let el = document.getElementById('svEmbedNoFit');
    if (!show) { if (el) el.hidden = true; return; }
    // (no loading guard here: showNoResultsMessage already withholds the verdict until the final render)
    const vp = document.querySelector('.preview-viewport');
    if (!vp) return;
    if (!el) { el = document.createElement('div'); el.id = 'svEmbedNoFit'; vp.appendChild(el); }
    const w = currentWatchData || {};
    const wname = String(((w.brand || '') + ' ' + watchDisplayModel({ model: w.model || '' })).trim()).replace(/</g, '&lt;');
    const sel = document.querySelector('#watchesGrid img.selected');
    const link = (sel && sel.dataset.collectionLink) || '';
    if (w.noStraps) {
      el.innerHTML = '<span>We don\'t stock a strap for the <strong>' + wname + '</strong> yet.</span>' +
        '<a class="sv-embed-btn" href="/pages/contact" target="_top">Get in touch</a>';
    } else {
      el.innerHTML = '<span><strong>' + svEmbedStrapName() + '</strong> isn\'t made for the <strong>' + wname + '</strong>.</span>' +
        (link ? '<a class="sv-embed-btn" href="' + link.replace(/"/g, '&quot;') + '" target="_top">See straps that fit it</a>' : '') +
        '<button type="button" class="sv-embed-btn" style="background:#fff;color:#b2955f;" id="svEmbedNoFitPick">Choose a different watch</button>';
      const b = document.getElementById('svEmbedNoFitPick');
      if (b) b.addEventListener('click', () => { const c = document.getElementById('svWatchChip'); if (c) c.click(); });
    }
    el.hidden = false;
    const ph = document.getElementById('svEmbedPh');
    if (ph) ph.hidden = true;
    svEmbedPostHeight();
  }

  /* The product page's variant is the customer's colour choice; its WIDTH is usually just the
     page's default, so after taking the variant the strap width is matched to the chosen watch
     the same way a fresh selection is (checkSizeMismatch with auto-correct), keeping the colour. */
  function svEmbedApplyVariant(variantId) {
    selectVariantById(variantId);
    try {
      const p = selectedStrapProduct;
      const v = p && p.variants && p.variants.find(x => String(x.id) === String(variantId));
      if (!v || !currentWatchData) return;
      const watchSize = extractNumericSize(currentWatchData.lugWidth || '');
      const variantSize = extractSizeFromVariantTitle(v.title);
      if (watchSize && variantSize && watchSize !== variantSize) checkSizeMismatch(v, p, true);
    } catch (e) {}
  }

  let _svEmbedAddReply = null;
  function svEmbedAddToCart(formData, btn, originalText) {
    const item = { id: formData.get('id'), quantity: 1, properties: {} };
    formData.forEach((v, k) => { const m = /^properties\[(.+)\]$/.exec(k); if (m) item.properties[m[1]] = v; });
    const done = ok => {
      _svEmbedAddReply = null;
      btn.textContent = ok ? 'Added!' : 'Error - Try Again';
      btn.classList.add(ok ? 'atc-added' : 'atc-err');
      setTimeout(() => {
        btn.textContent = originalText; btn.disabled = false; btn.style.opacity = '1';
        btn.classList.remove('atc-added', 'atc-err');
      }, ok ? 2000 : 3000);
    };
    if (!item.id || !SV_EMBED_ORIGIN) { done(false); return; }
    const timer = setTimeout(() => done(false), 15000);
    _svEmbedAddReply = d => { clearTimeout(timer); done(d.sv === 'added'); };
    svEmbedPost({ sv: 'add', item: item });
  }

  function svEmbedInit() {
    if (!SV_EMBED) return;
    svEmbedInjectCSS();
    // Order attribution: this add-to-cart came from the product page's try-on, not the page.
    const attr = document.querySelector('#addToCartForm input[name="properties[_Visualiser]"]');
    if (attr) attr.value = 'pdp';
    svEmbedState('loading');
    // Content height -> parent (the iframe is sized to fit; no scrolling inside it).
    try {
      const ro = new ResizeObserver(() => svEmbedPostHeight());
      ro.observe(document.body);
      const mc = document.getElementById('mainContainer');
      if (mc) ro.observe(mc);
    } catch (e) {}
    window.addEventListener('load', () => svEmbedPostHeight(true));
    setInterval(() => svEmbedPostHeight(), 1500);   // belt and braces: fonts, late images, hidden-tab layouts
    // Parent -> engine: the product page's own variant picker changed.
    window.addEventListener('message', e => {
      if (!SV_EMBED_ORIGIN || e.origin !== SV_EMBED_ORIGIN || !e.data || e.data.svEmbed !== 1) return;
      const d = e.data;
      try {
        if (d.sv === 'added' || d.sv === 'add-failed') { if (_svEmbedAddReply) _svEmbedAddReply(d); }
        else if (d.sv === 'variant' && d.id) svEmbedApplyVariant(String(d.id));
        else if (d.sv === 'open-watch') { const c = document.getElementById('svWatchChip'); if (c) c.click(); }
        else if (d.sv === 'measure') svEmbedPostHeight(true);
      } catch (err) {}
    });
    svEmbedPost({ sv: 'hello', build: SV_BUILD });
  }

  /************************************************************************
   * 1) LOAD & PARSE WATCH DATA (JSON from the CRM - was a Google Sheet CSV)
   ************************************************************************/
  async function loadWatchCSV() {
    // Per-session cache. The watch data fetch is ~1.2s and was being hit multiple times per load;
    // reuse it within the browser-tab session so re-loads are instant. Bumped to v3 (was v2) since
    // the cached payload is now JSON text, not CSV text - an old cached v2 CSV string would crash
    // JSON.parse below.
    /* ⚠⚠ THIS CACHE HAD NO EXPIRY AND sessionStorage IS NOT "CACHE" IN ANY BROWSER'S CLEAR-CACHE
       UI - it lives until the TAB is closed. So a tab opened before a catalogue edit replayed the
       OLD feed through every reload, including a hard refresh: staff updated a watch image, saw
       the old one forever, and every diagnosis pointed at Shopify's CDN instead. v4 stores
       {t, json} and re-fetches once the payload is older than SV_CSV_TTL_MS. That keeps the point
       of the cache (the fetch is ~1.2s and used to run several times per load) while making a
       stale tab self-heal. The key had to move v3 -> v4: a v3 payload is bare JSON TEXT, which
       still JSON.parses here, so reading it as the new wrapper would silently yield undefined. */
    const cached = svCacheRead(SV_WATCHCSV_KEY);
    if (cached && typeof cached.data === 'string' && cached.data) {
      parseCSV(cached.data);
      if (!cached.fresh) svRevalidateWatchCSV();   // background; only swaps in a CHANGED feed
      return;
    }

    /* 3.77.0: LET THE FEED REVALIDATE INSTEAD OF REBUILDING. The CRM now serves this endpoint
       with an ETag and `Cache-Control: no-cache` (CRM v1.650.0) - the same treatment the
       watch-selector's /watch-catalog.json already had - so an unchanged catalogue answers 304
       with no body, and the CRM serves the cached body instead of re-serialising 755 rows
       (~1.1s of TTFB on every cold load). Both halves of the old code defeated that: the random
       query string made every request a different URL, and `no-store` told the browser never
       to send If-None-Match. `no-cache` = "always revalidate", which keeps the freshness we had. */
    const url = "https://crm.strapify.com.au/visualiser-watches.json";

    /* 3.87.0: a COLD load (nothing in localStorage) is the only path that dies when the CRM is
       down - a returning visitor renders from the 7-day cache above and never notices. So this
       fetch gets a timeout, and on failure falls back to the copy the CRM keeps on Shopify's CDN
       (window.STRAPIFY_FEED_FALLBACK from theme.liquid; base url + a 15-minute cache bucket of
       our own, because the CDN caches every url variant for a year and an unseen key is a miss
       to origin). The fallback copy is cached under the same key as a live one - it is the same
       feed, at most 15 minutes older - so the NEXT load is instant and revalidates against the
       CRM as usual. 17 Sep 2026: the CRM was down 2h40m. */
    const fetchTimed = (u, ms) => {
      const ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
      const timer = ctrl ? setTimeout(() => ctrl.abort(), ms) : null;
      return fetch(u, { cache: 'no-cache', referrerPolicy: 'no-referrer', ...(ctrl ? { signal: ctrl.signal } : {}) })
        .finally(() => { if (timer) clearTimeout(timer); });
    };
    let response;
    try {
      response = await fetchTimed(url, 4000);
      if (!response.ok) throw new Error("HTTP " + response.status);
    } catch (err) {
      const fb = window.STRAPIFY_FEED_FALLBACK;
      if (!fb || !fb.visualiser) throw new Error("Failed to fetch watch data");
      const bucket = Math.floor(Date.now() / (fb.bucketMs || 900000));
      try { console.warn('watch feed: CRM unavailable, using CDN copy', err && err.message); } catch (e) {}
      /* 3.90.7: the key MUST be ?v=. Shopify's CDN (Cloudflare) keys its cache on the path plus
         `v` only - any other query string is stripped, so '?t=<bucket>' was a HIT on the first
         copy ever cached (Age 79,506s, a 30-hour-old feed with blank Pixel rows) and the mirror's
         own '?verify=' read-back failed for the same reason. An unseen ?v= is a MISS to origin. */
      response = await fetchTimed(fb.visualiser + '?v=' + bucket, 8000);
      if (!response.ok) throw new Error("Failed to fetch watch data");
    }
    const jsonText = await response.text();
    svCacheWrite(SV_WATCHCSV_KEY, jsonText);
    parseCSV(jsonText);
  }

  /* ⚠ THE ONLY CACHE KEY SHOPIFY'S IMAGE CDN RESPECTS HERE IS THE WIDTH.
     Re-uploading a file in place keeps its URL, and the CDN keeps serving the derivative it
     already built from the OLD master: ?width=600 stayed stale indefinitely, and adding a cache-
     busting parameter of our own (?fv=..., ?zz=random) changed nothing because the derivative is
     keyed on the size, not the query string. Verified in-browser against one re-cut face:
       ?width=600            -> old image        ?v=<shopify version>&width=600 -> new
       ?fv=...&width=600     -> old image        ?width=601                     -> new
     So Apple faces are requested at a width that has never been generated from a stale master.
     ⚠ BUMP THIS WHENEVER AN APPLE FACE IMAGE IS RE-CUT - it is what makes the new cut visible. */
  const SV_APPLE_FACE_W = 612;
  /* 3.66.0: high-DPI Apple render. K scales the Apple compositor's canvas (1.5 on phones and
     retina desktops, 1 elsewhere); the draw sources are fetched at these widths once the first
     paint is up. Measurements never use them. The face width is 2x SV_APPLE_FACE_W so it is
     also a derivative no stale master ever produced (see the note above). */
  // `?svhidpi=1` forces the sharp path on a 1x screen (verification only, same spirit as __svTrace).
  // 2, not more: the static Apple canvas becomes 1736x2200 (3.8MP), cropped tight afterwards; a
  // DPR-3 phone at the 1.8x resting zoom still upscales it ~1.4x, but 3x would be 8.6MP per strap
  // change. Realign drags repaint at 1x and the sharp copy returns on release (svAppBindDrag).
  const SV_APP_HIDPI = ((window.devicePixelRatio || 1) > 1.25 || /[?&]svhidpi=1\b/.test(location.search)) ? 2 : 1;
  const SV_APP_STRAP_HI_W = 1800;
  const SV_APP_FACE_HI_W = SV_APPLE_FACE_W * 2;

  // Name kept as parseCSV (not renamed) so nothing downstream that reads watchList entries needs
  // to change - the CRM's JSON endpoint keys each object with the SAME header names the old CSV
  // used ("lug width", "scaling factor", "watch type", ...), so this just JSON.parses instead of
  // splitting CSV text on commas; the resulting watchList shape is identical either way.
  function parseCSV(jsonText) {
  watchList.length = 0; // idempotent: a re-parse can never double the list again
  let rows;
  try { rows = JSON.parse(jsonText); } catch (e) { rows = []; }
  if (!Array.isArray(rows)) rows = [];

  for (const raw of rows) {
    let obj = {};
    Object.keys(raw).forEach(colName => {
      obj[colName.trim().toLowerCase()] = (raw[colName] == null ? "" : String(raw[colName])).trim();
    });

    // Skip empty rows
    if (!obj.brand && !obj.link) continue;

    // Keep 'lug width' as original string (e.g., "22mm QuickFit", "20mm") - do not parse or modify it

    if (obj["scaling factor"]) {
      obj["scaling factor"] = parseFloat(obj["scaling factor"]) || 0.8;
    }

    // Store collection_link for "View all straps" feature
    if (obj["collection_link"]) {
      obj["collection_link"] = obj["collection_link"].trim();
    }

    // "colour images" is an optional JSON object {label: face image url} letting ONE catalogue row
    // offer several case colours (e.g. Apple Watch Series 7 in 8 colours) - the row then gets a
    // colour dropdown that swaps the face. Blank, malformed, or single-entry = ordinary one-face
    // watch, exactly as before.
    obj.colourImages = null;
    if (obj["colour images"]) {
      // (parsed below, then revved together with `link` once colourImages exists)
      try {
        const parsed = JSON.parse(obj["colour images"]);
        if (parsed && typeof parsed === "object" && !Array.isArray(parsed)
            && Object.keys(parsed).length > 1) {
          obj.colourImages = parsed;
        }
      } catch (e) { /* not valid JSON - treat as a single-colour watch */ }
    }

    // ⚠ THE DEFAULT FACE MUST BE ONE OF THE COLOUR FACES, OR THE DROPDOWN LABEL LIES.
    // buildWatchColourSelect pre-selects the option whose URL === watch.link. When `link` is a
    // file that appears in no colour entry - e.g. the same photo re-uploaded separately, so the
    // URLs differ character-for-character - NO option gets `selected`, the browser falls back to
    // highlighting the FIRST option, and the canvas still draws `link`: the row then shows one
    // colour's name over another colour's watch, and it silently swaps around as the catalogue is
    // edited. Adopting the first colour's image as the default keeps label and face in step. Done
    // here (not in buildWatchColourSelect) because nothing has refined or cached a thumbnail off
    // `link` yet, so there is no stale render to invalidate.
    if (obj.colourImages) {
      // Trim the map's values in place: they come straight out of the catalogue's JSON blob and
      // are NOT run through the header-level trim above, so a stray space would defeat both this
      // check and the === in buildWatchColourSelect.
      Object.keys(obj.colourImages).forEach(k => {
        obj.colourImages[k] = String(obj.colourImages[k] == null ? "" : obj.colourImages[k]).trim();
      });
      const faces = Object.values(obj.colourImages);
      if (faces.indexOf(obj.link) === -1) obj.link = faces[0];
    }

    watchList.push(obj);
  }
  // Apple used to be a single hardcoded entry here, because the catalogue carried no Apple row with
  // a face image. It now carries one per series AND case size, each with its own set of case
  // colours, so the real rows are used instead. The synthetic entry survives only as a fallback for
  // the case where the catalogue somehow comes back with no Apple face at all - without it,
  // selecting an Apple Watch (and therefore the whole Apple strap range) would vanish from the
  // visualiser entirely.
  if (!watchList.some(w => /apple/i.test(w["watch type"] || "") && w.link)) {
    watchList.push({
      brand: "Apple", model: "Apple Watch",
      "lug width": "", "watch type": "Apple", "scaling factor": 0.8,
      link: "https://cdn.shopify.com/s/files/1/1794/4993/files/Apple_Watch_Series_9_face_silver.png?v=1770949733",
      "collection_link": "/collections/apple"
    });
  }

  try { mergeAppleCaseSizes(); } catch (e) { /* a merge failure must never empty the catalogue */ }
  try { svSortAppleFamilies(); } catch (e) { /* ordering is cosmetic - never lose the catalogue over it */ }

  // A watch the customer photographed themselves lives in localStorage, not the catalogue
  // feed, so it has to be re-added on every (re)parse - parseCSV resets watchList above.
  // Guarded: a bad stored value must never stop the real catalogue from loading.
  try { svcInjectCustomWatch(); } catch (e) {}
}

  // The catalogue carries one Apple row per series AND case size ("Series 7:Case Size:41mm" and
  // "Series 7:Case Size:45mm"), which puts every series in the list twice for what is, to a
  // customer, one watch. Collapse each series to a SINGLE row carrying its sizes as variants; the
  // row then offers a case-size dropdown (see buildWatchSizeSelect) exactly like the case-colour
  // one. The sizes are not cosmetic - each has its own face image AND its own collection_link,
  // which is what restricts the strap grid - so switching size swaps the whole underlying row.
  // The regex is a literal INSIDE the function on purpose: with a warm sv_watchcsv_v3 cache
  // parseCSV runs synchronously at script-parse time, so a `const` declared down here would still
  // be in its temporal dead zone and the merge would throw (silently - it is called in a
  // try/catch, so the symptom is just that the sizes never merge on a warm tab).
  /* APPLE FAMILY GROUPING (3.80.0, owner's call). The Apple range is 20 rows - long enough that
     a flat list makes a customer read every one to find their watch. Once the brand filter is
     Apple the list is split into four labelled families, in THIS order (owner's, not newest-group
     first), and NEWEST FIRST inside each: Series 12 above 11, Ultra 4 above Ultra 3, SE 3rd above
     SE 1st.
     ⚠ The sort mutates watchList and must run BEFORE the pass that assigns watch.index - the grid
     finds a row by `img[data-index]`, so reordering afterwards would paint refined thumbnails onto
     the wrong watches. It runs next to mergeAppleCaseSizes for exactly that reason. */
  /* Which families are expanded. Everything starts CLOSED: picking Apple should show four
     buttons, not 19 rows. A live search force-opens every family that still has a match,
     otherwise typing a model name would look like it found nothing. */
  const svAppleFamilyOpen = Object.create(null);
  const SV_APPLE_FAMILIES = [
    { key: 'series-1-10',  title: 'Series 1-10',  match: f => f.kind === 'series' && f.num <= 10 },
    { key: 'series-11-12', title: 'Series 11-12', match: f => f.kind === 'series' && f.num >= 11 },
    { key: 'se',           title: 'SE',           match: f => f.kind === 'se' },
    { key: 'ultra',        title: 'Ultra',        match: f => f.kind === 'ultra' },
  ];

  function svAppleFamily(watch) {
    if (!watch || !/apple/i.test(watch['watch type'] || '')) return null;
    // A merged row's model still carries one size ("Series 7:Case Size:41mm"); _series is the
    // series on its own. Ultra rows never merge, so fall back to the model.
    const name = String(watch._series || watch.model || '');
    let m = /^\s*Series\s+(\d+)/i.exec(name);
    let f = null;
    if (m) f = { kind: 'series', num: parseInt(m[1], 10) };
    else if ((m = /^\s*SE\s*(\d+)?/i.exec(name))) f = { kind: 'se', num: parseInt(m[1] || '1', 10) };
    // "Ultra: 49mm" is the first one and carries no number - it ranks below "Ultra 2".
    // ⚠ \s* not \D*: \D* would swallow the colon in "Ultra: 49mm" and read 49 as the generation.
    else if ((m = /^\s*Ultra\s*(\d+)?/i.exec(name))) f = { kind: 'ultra', num: parseInt(m[1] || '1', 10) };
    if (!f) return null;
    const idx = SV_APPLE_FAMILIES.findIndex(g => g.match(f));
    if (idx < 0) return null;
    return { idx: idx, key: SV_APPLE_FAMILIES[idx].key, title: SV_APPLE_FAMILIES[idx].title, num: f.num };
  }

  function svSortAppleFamilies() {
    const apple = [];
    for (const w of watchList) {
      const fam = svAppleFamily(w);
      if (fam) { w._appleFamily = fam; apple.push(w); }
    }
    if (apple.length < 2) return;
    apple.sort((a, b) => (a._appleFamily.idx - b._appleFamily.idx) ||
                         (b._appleFamily.num - a._appleFamily.num));
    // Drop the sorted block back in where the Apple rows already sat, so no other brand moves.
    const out = [];
    let placed = false;
    for (const w of watchList) {
      if (w._appleFamily) { if (!placed) { out.push(...apple); placed = true; } continue; }
      out.push(w);
    }
    if (!placed) return;
    watchList.length = 0;
    watchList.push(...out);
  }

  function mergeAppleCaseSizes() {
    const groups = new Map();
    for (const w of watchList) {
      if (!/apple/i.test(w["watch type"] || "")) continue;
      const m = /^(.*?)\s*:\s*Case Size\s*:\s*(.+)$/i.exec(String(w.model || ""));
      if (!m) continue;                       // Ultra rows ("Ultra 2: 49mm") have no size axis
      const key = (w.brand || "") + "|" + m[1];
      w._series = m[1];
      w._sizeLabel = m[2];
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(w);
    }

    const drop = new Set();
    groups.forEach(rows => {
      if (rows.length < 2) return;
      // Smallest case first: it is both the sensible default and the order the sizes read in.
      rows.sort((a, b) => (parseFloat(a._sizeLabel) || 0) - (parseFloat(b._sizeLabel) || 0));
      const keep = rows[0];
      keep.sizeVariants = rows.map(r => ({ label: r._sizeLabel, row: r }));
      for (let i = 1; i < rows.length; i++) drop.add(rows[i]);
    });

    if (drop.size) {
      const kept = watchList.filter(w => !drop.has(w));
      watchList.length = 0;
      watchList.push(...kept);
    }
  }

  // Copy a size variant's catalogue fields onto the merged row. Everything the rest of the page
  // reads about a watch comes from these fields (or the dataset mirrored off them), so this is the
  // whole of "switch to the 45mm".
  function applyWatchSizeVariant(watch, variant) {
    const r = variant.row;
    watch.model = r.model;
    watch.link = r.link;
    watch.colourImages = r.colourImages;
    watch["lug width"] = r["lug width"];
    watch["collection_link"] = r["collection_link"];
    watch["scaling factor"] = r["scaling factor"];
    watch._sizeLabel = variant.label;
  }


  /************************************************************************
   * 2) BEAST MODE PERFORMANCE OPTIMIZATION FUNCTIONS
   ************************************************************************/
  
  function setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '100px', // Increased for better prefetching
      threshold: 0.1
    };

    intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          // Skip if already processed (e.g., normalized watch thumbnails)
          if (img.dataset.processed === 'true') {
            intersectionObserver.unobserve(img);
            return;
          }
          if (img.dataset.src && img.src !== img.dataset.src) {
            img.onload = () => { img.classList.remove('loading'); img.classList.add('loaded'); };
            img.onerror = () => { img.classList.remove('loading'); img.classList.add('error'); };
            img.src = img.dataset.src;
            intersectionObserver.unobserve(img);
          }
        }
      });
    }, options);
    

  }
  
  // rAF that still fires in hidden/background tabs (Chrome freezes requestAnimationFrame
  // there, which used to stall thumbnails/filtering/auto-select if the page was opened in a
  // background tab or the user switched apps mid-load). Visible tabs keep real rAF timing.
  function svRaf(cb) {
    if (document.visibilityState === 'hidden') { setTimeout(cb, 32); return; }
    requestAnimationFrame(cb);
  }

  /* ---- Lazy watch refinement ----
     Watches are refined (downloaded at CDN ?width=600 -> cropped -> lug-normalised 300px
     thumbnail) ON DEMAND: the first EAGER_REFINE up-front, the rest as their rows scroll
     into view, and a tapped/auto-selected watch at top priority. Replaces the old eager
     loop that fetched + canvas-processed ALL ~366 full-res images on every load and kept
     a never-used full-res dataURL per watch (~430MB of strings). Thumbnails are blob URLs,
     not base64, so nothing big is retained. */
  const EAGER_REFINE = 12;
  const REFINE_CONCURRENCY = 4;
  /* ⚠ A REFINE THAT NEVER SETTLES WEDGES THE WHOLE GRID. loadImage resolves on load and rejects
     on error, but a request that does neither (a stalled connection, a CDN that accepts and never
     answers) leaves it pending, so refineActive never comes back down; four of those and no watch
     is ever refined again. The symptom is not "some images missing" - it is EVERY watch stuck on
     a placeholder while a CLICKED one still works, because displayWatchDetails calls refineWatch
     directly rather than through the queue. */
  const REFINE_TIMEOUT_MS = 20000;
  function svRefineLoad(url) {
    let t = null;
    return Promise.race([
      loadImage(url),
      new Promise((_, rej) => { t = setTimeout(() => rej(new Error('SV_REFINE_TIMEOUT')), REFINE_TIMEOUT_MS); })
    ]).finally(() => { if (t) clearTimeout(t); });
  }
  const refineQueue = [];
  let refineActive = 0;
  let refineObserver = null;

  function refineWatch(watch) {
    if (!watch) return Promise.resolve(null);
    if (watch._refinePromise) return watch._refinePromise;
    window.__svTrace && window.__svTrace.push('refine:start:' + watch.model);
    watch._refinePromise = (async () => {
      try {
        // Apple faces are fetched at SV_APPLE_FACE_W, not 600 - see the comment on that constant.
        const _isAppleFace = /apple/i.test(watch["watch type"] || "");
        const img = await svRefineLoad(cdnSized(watch.link, _isAppleFace ? SV_APPLE_FACE_W : 600));
        const cropped = cropToContent(drawToCanvas(img));
        let normalized;
        // 300px is plenty for a catalogue row (there are 800+ of them and every refined one
        // holds a blob), but it is also what the COMPOSITE draws from - so a watch the customer
        // photographed themselves was being thrown away at 300px and looked soft next to the
        // strap. There is only ever one custom watch, so it can afford a far bigger canvas.
        // 900, not larger: the composite canvas is built at the watch's resolution, so 1100
        // produced a 1089x3818 (4MP) canvas that a phone has to redraw on every strap change.
        // 900 still reads sharp at the preview's maximum zoom and keeps that well under control.
        const _target = watch._custom ? 900 : 300;
        // Apple faces have no LUGS - the strap slots straight into the case - so the lug-distance
        // normalisation below has nothing real to measure and returns a different scale for each
        // face, which is why the Apple icons came out at wildly different sizes in the grid. Fit
        // those to the case instead, so every Apple watch is drawn at one consistent size.
        const _fitContent = _isAppleFace;
        try { normalized = normalizeWatchThumbnail(cropped, _target, 0.15, _fitContent); }
        catch (e) { normalized = cropped; }
        watch.thumbnailImageData = await new Promise((resolve) => {
          try { normalized.toBlob(b => resolve(b ? URL.createObjectURL(b) : normalized.toDataURL('image/png')), 'image/png'); }
          catch (e) { resolve(normalized.toDataURL('image/png')); }
        });
        watch._refined = true;
        window.__svTrace && window.__svTrace.push('refine:done:' + watch.model);
        updateWatchInGrid(watch);
      } catch (err) {
        /* A timeout says something about the NETWORK, not about this watch: clear the memoised
           promise so a later scroll or click can try again, and never set `ignore` - that would
           drop the row from the grid for the rest of the session over one slow request. */
        if (String(err && err.message) === 'SV_REFINE_TIMEOUT') watch._refinePromise = null;
        else watch.ignore = true;
        window.__svTrace && window.__svTrace.push('refine:ERR:' + watch.model + ':' + String(err && err.message || err).slice(0, 120));
      }
      return watch;
    })();
    return watch._refinePromise;
  }

  function pumpRefineQueue() {
    while (refineActive < REFINE_CONCURRENCY && refineQueue.length) {
      const w = refineQueue.shift();
      if (!w || w._refined || w._refinePromise) continue;
      refineActive++;
      refineWatch(w).then(() => { refineActive--; pumpRefineQueue(); });
    }
  }
  function queueRefine(watch, priority) {
    if (!watch || watch._refined || watch._refinePromise) return;
    if (priority) refineQueue.unshift(watch); else refineQueue.push(watch);
    pumpRefineQueue();
  }

  /**
   * Normalize watch thumbnail based on lug-to-lug distance for consistent sizing
   * Centers based on the functional watch center (lug midpoints), not canvas dimensions
   * @param {Canvas} croppedCanvas - The cropped watch canvas
   * @param {number} targetSize - Target size for normalized thumbnail (default 300x300)
   * @param {number} padding - Padding percentage (default 0.15 = 15%)
   * @param {boolean} fitContent - Scale to FIT the whole (already cropped) watch instead of to its
   *        lug span. For watches with no lugs to measure - Apple - where lug detection returns a
   *        different answer per image and the icons come out at inconsistent sizes.
   * @returns {Canvas} - Normalized canvas with watch centered based on lug positions
   */
  /* The SELECTED watch, re-refined big enough to composite sharply.

     refineWatch normalises catalogue watches to 300px because there are 800+ of them and every
     refined one holds a blob - but that same 300px thumbnail is what the compositor draws, so the
     watch in the preview was a 300px image blown up to fill a ~1000px-tall canvas. The custom
     ("photograph your own watch") path already got 900 for exactly this reason; catalogue
     watches - which is what customers actually use - never did.

     Only ONE watch is composited at a time, so this runs on selection and is cached per watch.
     900 and not larger is the tuned figure: the composite canvas is built at the watch's
     resolution, and 1100 produced a 4MP canvas that a phone redraws on every strap change.
     Source is fetched at SV_HIRES_SRC_W so there is real detail to normalise DOWN from - asking
     for 900 out of a 600px fetch would just upscale the same softness. */
  const SV_HIRES_TARGET = 900;
  const SV_HIRES_SRC_W = 1600;

  function refineWatchHiRes(watch) {
    if (!watch) return Promise.resolve(null);
    /* ⚠⚠ THE CACHE IS KEYED ON `watch.link`, NOT ON THE WATCH OBJECT. A row is MUTATED in place
       when the customer changes its case colour or (Apple) its case size - same object, new
       `link`. Caching on the object alone meant the FIRST colour's sharp image was handed back
       for every later colour, and svUpgradeWatchImage then overwrote the correct thumbnail with
       it: the dropdown, the row thumbnail and rawLink all followed the new colour while the
       composite silently kept the old face forever. The two change handlers each clear
       _refined/_refinePromise/thumbnailImageData; keying here means they cannot forget this one
       too, and neither can any future caller. */
    if (watch.hiResImageData && watch._hiResLink === watch.link) {
      return Promise.resolve(watch.hiResImageData);
    }
    if (watch._hiResPromise && watch._hiResPending === watch.link) return watch._hiResPromise;
    // A customer photo is already normalised at 900 and has no CDN source to re-fetch.
    if (watch._custom) return Promise.resolve(watch.thumbnailImageData || null);
    const hiResLink = watch.link;   // an in-flight fetch belongs to the link that started it
    watch._hiResPending = hiResLink;
    watch._hiResPromise = (async () => {
      try {
        const _isAppleFace = /apple/i.test(watch["watch type"] || "");
        // 3.93.1: raced against a timeout like refineWatch is - a 1600px PNG that never answers
        // on a phone connection used to leave this pending forever, and the composite on 300px.
        const img = await svRefineLoad(cdnSized(hiResLink, SV_HIRES_SRC_W));
        const cropped = cropToContent(drawToCanvas(img));
        let normalized;
        try { normalized = normalizeWatchThumbnail(cropped, SV_HIRES_TARGET, 0.15, _isAppleFace); }
        catch (e) { normalized = cropped; }
        const out = await new Promise((resolve) => {
          try { normalized.toBlob(b => resolve(b ? URL.createObjectURL(b) : normalized.toDataURL('image/png')), 'image/png'); }
          catch (e) { resolve(normalized.toDataURL('image/png')); }
        });
        // Only cache it if the row still points where this fetch started - the customer can change
        // colour mid-flight, and caching under the CURRENT link would re-create the stale-face bug
        // in the opposite direction. The caller's own guard drops the value in that case.
        if (watch.link === hiResLink) {
          watch.hiResImageData = out;
          watch._hiResLink = hiResLink;
        }
        window.__svTrace && window.__svTrace.push('hires:done:' + watch.model);
        return out;
      } catch (err) {
        // Never fail the preview over this - the 300px thumbnail still composites, just softer.
        window.__svTrace && window.__svTrace.push('hires:ERR:' + watch.model);
        return null;
      } finally {
        if (watch._hiResPending === hiResLink) {
          watch._hiResPromise = null;
          watch._hiResPending = null;
        }
      }
    })();
    return watch._hiResPromise;
  }

  /* Swap the composite onto the sharp copy once it lands. Guarded on the watch STILL being the
     selected one - the fetch is async and the customer can move on mid-flight, and painting a
     stale watch would be worse than a soft one. */
  /* 3.93.1: "SOMETIMES THE IMAGES LOAD ALL BLURRY" (owner, several times; screenshot of a Galaxy
     Watch 8 on a phone, watch pixelated, strap soft). The composite canvas is built at the WATCH
     bitmap's resolution, and until the sharp 900px copy lands that bitmap is the 300px catalogue
     thumbnail - so the whole render is a 300px image blown up 2-3x. The sharp fetch ran ONCE per
     selection with no timeout and no retry: a failed or stalled 1600px PNG (phone connection,
     the strap pages and four thumbnail refines all in flight at the same moment, a CORS-less CDN
     edge copy) left the thumbnail as the composite base for the rest of the session. Now: the
     fetch is timed out (above), retried three times with backoff while the watch stays selected,
     and every composite paint re-checks that the watch it drew was the sharp one (see
     svEnsureSharpWatch) - so any path that resets finalImageData to the thumbnail (colour swap,
     size swap, refine-on-demand) heals itself on the next paint. */
  const SV_HIRES_RETRY_MS = [1500, 5000, 12000];
  function svUpgradeWatchImage(watch, attempt) {
    if (!watch || !currentWatchData) return;
    const upgradeLink = watch.link;   // the colour/size can change while the fetch is in flight
    const n = attempt || 0;
    refineWatchHiRes(watch).then((src) => {
      if (watch.link !== upgradeLink) return;   // this sharp copy is a face the row has moved off
      // ⚠ Identity is rawLink, NOT model: currentWatchData carries no model field, so a model
      // comparison is always undefined !== "..." and the upgrade would silently never apply.
      // rawLink is set from watch.link and is the same test updateWatchInGrid uses.
      if (!currentWatchData || currentWatchData.rawLink !== watch.link) return;
      if (!src) {
        if (n < SV_HIRES_RETRY_MS.length) {
          window.__svTrace && window.__svTrace.push('hires:retry:' + (n + 1) + ':' + watch.model);
          setTimeout(() => {
            if (currentWatchData && currentWatchData.rawLink === watch.link && watch.link === upgradeLink) svUpgradeWatchImage(watch, n + 1);
          }, SV_HIRES_RETRY_MS[n]);
        }
        return;
      }
      if (currentWatchData.finalImageData === src) return;
      currentWatchData.finalImageData = src;
      if (typeof currentStrapURL !== 'undefined' && currentStrapURL) combineImages();
      else if (currentWatchData.noStraps && typeof svDrawWatchOnly === 'function') svDrawWatchOnly();
    });
  }
  // Called after every composite paint: if the watch just drawn was not its sharp copy, fetch
  // (or re-fetch) it. Cheap when already sharp - one string compare.
  function svEnsureSharpWatch() {
    try {
      const wd = currentWatchData, w = wd && wd.watchObj;
      if (!wd || !w || wd.isApple || wd.isCustom || w._custom) return;
      if (w.hiResImageData && w._hiResLink === w.link && wd.finalImageData === w.hiResImageData) return;
      if (w._hiResPromise) return;   // already on its way; the .then above will repaint
      svUpgradeWatchImage(w);
    } catch (e) {}
  }
  // A phone that was backgrounded mid-load (iOS suspends the page) comes back to whatever was
  // painted last; re-check the sharp copy as soon as the page is visible again.
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') svEnsureSharpWatch(); });

  function normalizeWatchThumbnail(croppedCanvas, targetSize = 300, padding = 0.15, fitContent = false) {
    const paddingPixels = Math.floor(targetSize * padding);
    const availableSize = targetSize - (paddingPixels * 2);

    if (fitContent) {
      // "Contain" the watch in the padded box so every such watch fills the same box regardless of
      // how its source image was framed. ⚠ Measured at alpha > 24, NOT taken from croppedCanvas:
      // cropToContent trims at alpha > 0, so a few near-invisible dust pixels (some faces carry
      // them at alpha 9-24) leave a crop far bigger than the watch, and the fit then draws that
      // watch noticeably smaller than its neighbours. This is exactly what made the Apple icons
      // uneven in the first place.
      let bx0 = croppedCanvas.width, by0 = croppedCanvas.height, bx1 = -1, by1 = -1;
      try {
        const cd = croppedCanvas.getContext('2d').getImageData(0, 0, croppedCanvas.width, croppedCanvas.height).data;
        for (let y = 0; y < croppedCanvas.height; y++) {
          for (let x = 0; x < croppedCanvas.width; x++) {
            if (cd[(y * croppedCanvas.width + x) * 4 + 3] > 24) {
              if (x < bx0) bx0 = x; if (x > bx1) bx1 = x;
              if (y < by0) by0 = y; if (y > by1) by1 = y;
            }
          }
        }
      } catch (e) { /* tainted canvas: fall back to the full crop below */ }
      if (bx1 < bx0 || by1 < by0) { bx0 = 0; by0 = 0; bx1 = croppedCanvas.width - 1; by1 = croppedCanvas.height - 1; }
      const bw = bx1 - bx0 + 1, bh = by1 - by0 + 1;
      const s = Math.min(availableSize / bw, availableSize / bh);
      const w = Math.max(1, Math.round(bw * s)), h = Math.max(1, Math.round(bh * s));
      const c = document.createElement('canvas');
      c.width = targetSize; c.height = targetSize;
      c.getContext('2d').drawImage(croppedCanvas, bx0, by0, bw, bh,
        Math.round((targetSize - w) / 2), Math.round((targetSize - h) / 2), w, h);
      return c;
    }

    // Find watch lugs (connection points)
    const lugs = findWatchLugs(croppedCanvas);
    
    // Calculate lug-to-lug distances
    const topLugDistance = distance(lugs.topLeft, lugs.topRight);
    const bottomLugDistance = distance(lugs.bottomLeft, lugs.bottomRight);
    
    // Use the larger lug distance as reference (more consistent)
    const lugDistance = Math.max(topLugDistance, bottomLugDistance);
    
    // Target lug distance in the normalized thumbnail (70% of available size)
    const targetLugDistance = availableSize * 0.7;
    
    // Calculate scale based on lug distance, not overall dimensions
    const scale = targetLugDistance / lugDistance;
    
    const scaledWidth = Math.floor(croppedCanvas.width * scale);
    const scaledHeight = Math.floor(croppedCanvas.height * scale);
    
    // Calculate the CENTER of the watch based on lug positions (functional center)
    const lugCenterX = (lugs.topLeft.x + lugs.topRight.x + lugs.bottomLeft.x + lugs.bottomRight.x) / 4;
    const lugCenterY = (lugs.topLeft.y + lugs.topRight.y + lugs.bottomLeft.y + lugs.bottomRight.y) / 4;
    
    // Scale the lug center position
    const scaledLugCenterX = lugCenterX * scale;
    const scaledLugCenterY = lugCenterY * scale;
    
    // Create normalized canvas
    const normalizedCanvas = document.createElement('canvas');
    normalizedCanvas.width = targetSize;
    normalizedCanvas.height = targetSize;
    const ctx = normalizedCanvas.getContext('2d');
    
    // Calculate offset to center the WATCH (based on lug center), not the canvas
    // We want the lug center to be at the center of our target canvas
    const targetCenter = targetSize / 2;
    const offsetX = Math.floor(targetCenter - scaledLugCenterX);
    const offsetY = Math.floor(targetCenter - scaledLugCenterY);
    
    // Draw scaled watch centered on the functional watch center (lugs)
    ctx.drawImage(croppedCanvas, offsetX, offsetY, scaledWidth, scaledHeight);
    
    return normalizedCanvas;
  }

  /* Belt and braces for the IntersectionObserver, which is a single point of failure for the
     entire grid: if it is ever orphaned by a re-render, or simply never delivers, every row sits
     on a placeholder until it is individually clicked. This pass queues whatever is in (or near)
     view on scroll, is throttled to one pass per 200ms, and skips anything already refined or
     queued - so once the list is warm it costs a single rect pass and nothing else. */
  let _svRefineScrollAt = 0;
  function svRefineVisibleWatchRows() {
    const grid = document.getElementById('watchesGrid');
    if (!grid) return;
    const gr = grid.getBoundingClientRect();
    const top = gr.top - 300, bot = gr.bottom + 300;
    const onScreen = new Set();
    grid.querySelectorAll('img[data-raw-link]').forEach(img => {
      const w = img._svWatch;
      if (!w || w._refined || w._refinePromise || w.ignore) return;
      const row = img.closest('.watch-list-item') || img;
      const r = row.getBoundingClientRect();
      if (!r.height && !r.width) return;          // hidden by the brand/search filter
      if (r.bottom < top || r.top > bot) return;
      onScreen.add(w);
      queueRefine(w);
    });
    /* ⚠ A STRICT FIFO QUEUE MAKES A LONG SCROLL LOOK BROKEN. Every row scrolled PAST is already
       queued, so jumping to the bottom of 700+ watches left the rows in front of the customer
       waiting behind hundreds of rows they had left behind - the faces then filled in from the
       top, sequentially, exactly as reported. Promote what is on screen to the head of the queue
       on every pass; everything else keeps its order and still loads afterwards. */
    if (onScreen.size && refineQueue.length > 1) {
      const front = [], back = [];
      refineQueue.forEach(w => (onScreen.has(w) ? front : back).push(w));
      refineQueue.length = 0;
      refineQueue.push.apply(refineQueue, front.concat(back));
    }
  }
  function svRefineOnScroll() {
    const now = Date.now();
    if (now - _svRefineScrollAt < 200) return;
    _svRefineScrollAt = now;
    svRefineVisibleWatchRows();
  }

  function refineWatchesBatched() {
    // Adding a custom watch re-renders the grid and calls this again; the previous observer
    // still points at DOM nodes that no longer exist, so drop it before building a new one.
    if (refineObserver) { try { refineObserver.disconnect(); } catch (e) {} refineObserver = null; }
    const validWatches = watchList.filter(watch => {
      if (!watch.link) {
        watch.ignore = true;
        return false;
      }
      if (watch._custom) return true;   // customer photo: a data: URL, no file extension to test
      const linkLower = watch.link.toLowerCase();
      if (!(linkLower.includes(".png") || linkLower.includes(".webp"))) {
        watch.ignore = true;
        return false;
      }
      return true;
    });

    // Assign indices to all valid watches (critical for watches sharing same image URL)
    validWatches.forEach((watch, idx) => {
      watch.index = idx;
    });

    // First screenful up-front; the rest refine as their rows approach the viewport.
    validWatches.slice(0, EAGER_REFINE).forEach(w => queueRefine(w));

    if ('IntersectionObserver' in window) {
      refineObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          refineObserver.unobserve(entry.target);
          if (entry.target._svWatch) queueRefine(entry.target._svWatch);
        });
      }, { root: null, rootMargin: '300px', threshold: 0.01 });
      const grid = document.getElementById('watchesGrid');
      if (grid) grid.querySelectorAll('img[data-raw-link]').forEach(img => refineObserver.observe(img));
    } else {
      validWatches.forEach(w => queueRefine(w));
    }
    // The list is its own scroll container, so this listener belongs on the grid, not the window.
    const grid = document.getElementById('watchesGrid');
    if (grid && !grid._svRefineScrollBound) {
      grid._svRefineScrollBound = true;
      grid.addEventListener('scroll', svRefineOnScroll, { passive: true });
    }
  }

  function updateWatchInGrid(watch, retryCount = 0) {
    const watchGrid = document.getElementById("watchesGrid");
    if (!watchGrid) {
      return;
    }
    
    // CRITICAL: Use index to find image, not link (some watches share the same image URL!)
    // First try by index (most reliable for watches with shared images)
    let img = watchGrid.querySelector(`img[data-index="${watch.index}"]`);
    
    // Fallback: try by model (more specific than link)
    if (!img) {
      img = watchGrid.querySelector(`img[data-model="${watch.model}"][data-brand="${watch.brand}"]`);
    }
    
    // Last resort: try by link (but this can match multiple watches)
    if (!img) {
      const allImages = watchGrid.querySelectorAll('img[data-raw-link]');
      img = Array.from(allImages).find(el => 
        el.dataset.rawLink === watch.link && 
        el.dataset.model === watch.model &&
        el.dataset.brand === watch.brand
      );
    }
    
    window.__svTrace && window.__svTrace.push('grid:upd:' + watch.model + ':img=' + !!img + ':thumb=' + !!watch.thumbnailImageData);
    if (img && watch.thumbnailImageData) {
      // svRaf: still applies in hidden/background tabs (plain rAF freezes there)
      svRaf(() => {
        // Force immediate update - remove old src first
        img.removeAttribute('src');
        
        // Force browser to recognize the change
        void img.offsetHeight; // Force reflow
        
        // Set new thumbnail
        img.setAttribute('src', watch.thumbnailImageData);
        img.src = watch.thumbnailImageData; // Set both ways for reliability
        
        img.classList.remove('loading');
        img.classList.add('loaded');
        
        // Mark as processed to prevent any observers from overriding
        img.dataset.processed = 'true';
        
        // Remove dataset.src if it exists to prevent lazy loading override
        delete img.dataset.src;
        
        // Force the image to reload if it hasn't loaded yet
        if (!img.complete || img.naturalHeight === 0) {
          img.onerror = null;
          img.onload = () => {
            img.classList.remove('loading');
            img.classList.add('loaded');
          };
        }
        
        
      });
    } else if (!img && retryCount < 3) {
      // Retry after a short delay (DOM might not be ready)
      setTimeout(() => {
        updateWatchInGrid(watch, retryCount + 1);
      }, 500 * (retryCount + 1)); // Exponential backoff: 500ms, 1000ms, 1500ms
    } else if (!img) {
    } else if (!watch.thumbnailImageData) {
    }
  }

  /************************************************************************
   * 3) RENDER WATCHES - UNIFIED STRUCTURE FOR CSS-ONLY VIEW TOGGLE
   ************************************************************************/
  function renderWatches() {
    const watchGrid = document.getElementById("watchesGrid");
    watchGrid.innerHTML = "";

    // Filter valid watches first
    const validWatches = watchList.filter(watch => {
      if (!watch.link) return false;
      if (watch._custom) return true;   // customer photo: a data: URL, no file extension to test
      const linkLower = watch.link.toLowerCase();
      return linkLower.includes(".png") || linkLower.includes(".webp");
    });

    // Use optimized placeholder
    const optimizedPlaceholder = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cmFkaWFsR3JhZGllbnQgaWQ9InIiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNmOGY4ZjgiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNlZGVkZWQiLz48L3JhZGlhbEdyYWRpZW50PjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0idXJsKCNyKSIvPjxjaXJjbGUgY3g9IjUwIiBjeT0iNTAiIHI9IjE1IiBmaWxsPSIjZGRkIiBvcGFjaXR5PSIwLjUiLz48L3N2Zz4=';

    // Set initial view mode class
    const isMobile = window.innerWidth <= 768;
    if (currentWatchViewMode === 'list') {
      watchGrid.classList.add('list-view');
    } else {
      watchGrid.classList.remove('list-view');
    }

    // Always render unified structure - CSS handles view switching
    renderWatchesUnified(validWatches, watchGrid, optimizedPlaceholder);
  }
  
  // Unified render - creates list items that CSS can display as grid or list
  function renderWatchesUnified(validWatches, watchGrid, placeholder) {
    const fragment = document.createDocumentFragment();

    let lastFamily = null;
    validWatches.forEach((watch, index) => {
      // One labelled divider per Apple family (3.80.0). Rendered for every view, SHOWN only while
      // the brand filter is Apple - see filterWatches, which also hides a family the search has
      // emptied. Headers are a different class so every `.watch-list-item` query is unaffected.
      const fam = watch._appleFamily || null;
      if (fam && (!lastFamily || lastFamily.key !== fam.key)) {
        const head = document.createElement('button');
        head.type = 'button';                      // inside no form, but never submit one either
        head.className = 'watch-group-header';
        head.dataset.appleGroup = fam.key;
        head.setAttribute('aria-expanded', 'false');
        head.innerHTML = '<span class="wgh-title"></span><span class="wgh-count"></span>' +
                         '<span class="wgh-chev" aria-hidden="true">▾</span>';
        head.querySelector('.wgh-title').textContent = fam.title;
        head.style.display = 'none';
        head.addEventListener('click', () => {
          svAppleFamilyOpen[fam.key] = !svAppleFamilyOpen[fam.key];
          // The filter pass owns every row's display, so re-run it rather than toggling rows here.
          filterState.watches.lastQuery = null;
          performOptimizedWatchFilter();
        });
        fragment.appendChild(head);
      }
      lastFamily = fam;

      const listItem = document.createElement('div');
      listItem.className = 'watch-list-item';
      
      const img = createOptimizedWatchImage(watch, placeholder, index);
      
      const info = document.createElement('div');
      info.className = 'watch-list-info';
      
      const brand = document.createElement('div');
      brand.className = 'watch-list-brand';
      brand.textContent = watch.brand || '';
      
      const model = document.createElement('div');
      model.className = 'watch-list-model';
      model.textContent = watchDisplayModel(watch);

      const lug = document.createElement('div');
      lug.className = 'watch-list-lug';
      lug.textContent = watchDisplayLug(watch);

      info.appendChild(brand);
      info.appendChild(model);
      info.appendChild(lug);

      // Several case sizes / colours for this watch? Offer them as dropdowns on the row. A watch
      // with both (every merged Apple series) puts them side by side so the row stays one line
      // taller, not two.
      if (watch.sizeVariants) {
        const vrow = document.createElement('div');
        vrow.className = 'watch-variant-row';
        vrow.appendChild(buildWatchSizeSelect(watch, img, vrow));
        if (watch.colourImages) vrow.appendChild(buildWatchColourSelect(watch, img));
        info.appendChild(vrow);
      } else if (watch.colourImages) {
        info.appendChild(buildWatchColourSelect(watch, img));
      }

      listItem.appendChild(img);
      listItem.appendChild(info);

      // 3.57.0: a saved custom watch can be removed again. stopPropagation keeps the tap
      // from also selecting the row (the grid handlers are delegated on the ancestor).
      if (watch._custom) {
        const del = document.createElement('button');
        del.type = 'button';
        del.className = 'svc-del';
        del.setAttribute('aria-label', 'Delete this watch');
        del.textContent = '×';
        del.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          if (window.confirm('Remove "' + (watch.model || 'My watch') + '" from your watch list?')) {
            svcDeleteWatch();
          }
        });
        listItem.appendChild(del);
      }

      fragment.appendChild(listItem);
    });

    watchGrid.appendChild(fragment);
  }
  
  // The catalogue's Apple rows encode the case size into the model ("Series 7:Case Size:41mm") for
  // the storefront watch-selector bar, and put a "pick the size printed on the back" sentence in
  // the sizes column. Both read badly in this list, so tidy the model and drop the sentence - the
  // strap-width line is meaningless for Apple anyway (Apple straps fit by case size, not lug mm).
  function watchDisplayModel(watch) {
    // A row that offers its case sizes as a dropdown shouldn't also repeat one of them in the
    // title - the series name IS the watch as far as the customer is concerned.
    if (watch && watch.sizeVariants) return String(watch._series || watch.model || '');
    return String(watch.model || '').replace(/\s*:\s*Case Size\s*:\s*/i, ' · ');
  }

  /* ⚠ TWO CONDITIONS, BOTH REQUIRED: no collection AND no real width. A row that merely FORGOT
     its collection_link still carries a width like "20mm", and keeps the old fail-open behaviour -
     losing a watch's straps silently would be its own bug. Measured against the live feed
     2026-09-09: this matches exactly the 33 TAG Heuer no-stock rows and nothing else (the only
     other non-"<n>mm" lug values are 31 Apple "pick smaller/larger size" rows, which carry
     collections and are handled by the Apple branch below). */
  function svWatchHasNoStraps(lugWidth, collectionLink) {
    if (String(collectionLink || '').trim()) return false;
    return !/\d\s*mm/i.test(String(lugWidth || ''));
  }

  function watchDisplayLug(watch) {
    const lug = String(watch['lug width'] || '').trim();
    if (!lug || /apple/i.test(watch['watch type'] || '')) return '';
    // "We don't have anything available unfortunately" is not a strap width; the grid says it
    // properly instead of squeezing a sentence into a width pill (3.75.0).
    if (svWatchHasNoStraps(lug, watch['collection_link'])) return '';
    return 'Strap Width: ' + lug;
  }

  // Case-colour dropdown for a watch that ships more than one face image (see "colour images" in
  // the catalogue). Changing it re-refines this row's thumbnail and, when the row is the currently
  // selected watch, recomposites the strap onto the newly chosen face.
  function buildWatchColourSelect(watch, img) {
    const sel = document.createElement('select');
    sel.className = 'watch-colour-select';
    sel.setAttribute('aria-label', 'Watch case colour');

    Object.keys(watch.colourImages).forEach(label => {
      const opt = document.createElement('option');
      opt.value = label;
      opt.textContent = label;
      if (watch.colourImages[label] === watch.link) opt.selected = true;
      sel.appendChild(opt);
    });

    // Same guards the strap list's colour dropdown uses, so opening/changing the dropdown doesn't
    // also fire the row's select-this-watch click handler.
    sel.addEventListener('click', (e) => e.stopPropagation());
    sel.addEventListener('change', (e) => {
      e.stopPropagation();
      const url = watch.colourImages[sel.value];
      if (!url || url === watch.link) return;

      watch.link = url;
      img.dataset.rawLink = url;
      // Drop the cached thumbnail + refine promise: they belong to the PREVIOUS colour, and
      // refineWatch short-circuits on _refinePromise, so without this the face never changes.
      watch._refined = false;
      watch._refinePromise = null;
      watch.thumbnailImageData = null;
      watch.ignore = false;

      const wasSelected = img.classList.contains('selected');
      refineWatch(watch).then(() => {
        if (!wasSelected || !img.classList.contains('selected') || !currentWatchData) return;
        currentWatchData.rawLink = url;
        if (watch.thumbnailImageData) currentWatchData.finalImageData = watch.thumbnailImageData;
        svUpgradeWatchImage(watch);
        if (currentStrapURL) combineImages();
      });
    });

    return sel;
  }

  // Case-size dropdown for a merged Apple series row (see mergeAppleCaseSizes). Each size is a
  // different catalogue row - its own face image, its own colours, its own collection - so
  // changing it swaps those onto the row and, when this row is the selected watch, re-runs the
  // normal watch-selected path so the strap grid re-restricts and the composite is redrawn.
  function buildWatchSizeSelect(watch, img, host) {   // host = the row's dropdown container
    const sel = document.createElement('select');
    sel.className = 'watch-colour-select watch-size-select';
    sel.setAttribute('aria-label', 'Apple Watch case size');

    watch.sizeVariants.forEach(v => {
      const opt = document.createElement('option');
      opt.value = v.label;
      opt.textContent = v.label;
      if (v.label === watch._sizeLabel) opt.selected = true;
      sel.appendChild(opt);
    });

    sel.addEventListener('click', (e) => e.stopPropagation());
    sel.addEventListener('change', (e) => {
      e.stopPropagation();
      const variant = watch.sizeVariants.find(v => v.label === sel.value);
      if (!variant || variant.label === watch._sizeLabel) return;

      applyWatchSizeVariant(watch, variant);

      // Mirror onto the dataset the rest of the page reads the watch through.
      img.alt = watch.model || '';
      img.dataset.model = watch.model || '';
      img.dataset.rawLink = watch.link;
      img.dataset.lugWidth = watch['lug width'] || '';
      img.dataset.collectionLink = watch['collection_link'] || '';
      img.dataset.scale = watch['scaling factor'] || '0.8';

      // The cached thumbnail belongs to the PREVIOUS size, and refineWatch short-circuits on
      // _refinePromise - without this the face never changes.
      watch._refined = false;
      watch._refinePromise = null;
      watch.thumbnailImageData = null;
      watch.ignore = false;

      // The colour list is per size, so its dropdown has to be rebuilt against the new row.
      const oldColour = host.querySelector('.watch-colour-select:not(.watch-size-select)');
      if (oldColour) oldColour.remove();
      if (watch.colourImages) host.appendChild(buildWatchColourSelect(watch, img));

      const wasSelected = img.classList.contains('selected');
      refineWatch(watch).then(() => {
        if (!wasSelected || !img.classList.contains('selected')) return;
        // Full re-select: the collection restriction, the "view all straps" link and the face all
        // belong to the size that was just chosen.
        displayWatchDetails(img);
        if (watch.thumbnailImageData && currentWatchData) {
          currentWatchData.finalImageData = watch.thumbnailImageData;
          svUpgradeWatchImage(watch);
        }
        // The strap's "Apple Watch Size" variant follows the case size that was just picked.
        syncAppleSizeSelection();
        if (currentStrapURL) combineImages();
      });
    });

    return sel;
  }

  function createOptimizedWatchImage(watch, placeholder, index) {
    const img = document.createElement("img");

    // Start with placeholder - refined thumbnail will replace it
    // Don't load raw watch images directly; let the refinement process handle it
    img.src = placeholder;
    img.classList.add('loading');
    
    if (!watch.link) {
      // No image available – keep placeholder and mark as error
      img.classList.remove('loading');
      img.classList.add('error');
    }

    // Common dataset/meta
    img._svWatch = watch; // direct ref for the lazy-refine observer + priority refine on tap
    img.alt = watch.model || "";
    img.dataset.brand = watch.brand || "";
    img.dataset.model = watch.model || "";
    img.dataset.lugWidth = watch["lug width"] || "";
    img.dataset.scale = watch["scaling factor"] || "0.8";
    img.dataset.rawLink = watch.link;
    img.dataset.collectionLink = watch["collection_link"] || "";
    img.dataset.watchType = watch["watch type"] || "";
    img.dataset.ovTop = watch["overlap top"] || "";      // per-watch overlap % overrides
    img.dataset.ovBot = watch["overlap bottom"] || "";
    img.dataset.scaleTop = watch["scale top"] || "";     // per-watch width multiplier overrides
    img.dataset.scaleBot = watch["scale bottom"] || "";
    img.dataset.custom = watch._custom ? "1" : "";
    img.dataset.sizes = watch.sizeVariants ? watch.sizeVariants.map(v => v.label).join(" ") : "";
    img.dataset.index = index;

    // Always hint browser we intend to lazy-load if possible
    img.loading = img.loading || 'lazy';

    return img;
  }
  
  /* ⚠ CATALOGUE TEXT IS FREE TEXT AND ITS CAPITALISATION IS NOT CONSISTENT - the watch feed
     carries both "TAG Heuer" and "Tag Heuer" (2026-09-09), and the strap metafields are typed by
     hand too. Fold EVERY comparison of such a value through svFold, and key every menu built from
     one on the folded value, or a second spelling becomes a second category that hides the
     first's products.
     ⚠ Do NOT fold identifiers - product handles, image URLs, SKUs. Those are addresses, and the
     image CDN really is case-sensitive. */
  function svFold(v) { return String(v == null ? '' : v).trim().toLowerCase(); }
  const svBrandKey = svFold;   // the 3.73.0 name, kept so brand call sites still read clearly

  /* Pick the label for a folded group: the spelling the catalogue uses most often, ties broken
     alphabetically so the menu does not reword itself between loads. */
  function svPickLabel(counts) {
    return [...counts.entries()].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))[0][0];
  }
  function svCountInto(map, raw) {
    const label = String(raw == null ? '' : raw).trim();
    if (!label) return;
    const k = svFold(label);
    const counts = map.get(k) || new Map();
    counts.set(label, (counts.get(label) || 0) + 1);
    map.set(k, counts);
  }

  function setupBrandFilter() {
  const brandSelect = document.getElementById("brandFilterSelect");

  // One option per brand, keyed case-insensitively, labelled with the spelling the feed uses
  // most often (ties resolve alphabetically so the label does not flip between loads).
  const byKey = new Map();
  watchList.forEach(w => {
    const raw = String(w && w.brand || '').trim();
    if (!raw) return;
    const k = svBrandKey(raw);
    const counts = byKey.get(k) || new Map();
    counts.set(raw, (counts.get(raw) || 0) + 1);
    byKey.set(k, counts);
  });
  const brands = [...byKey.values()].map(svPickLabel).sort((a, b) => a.localeCompare(b));

  brands.forEach(brand => {
    const opt = document.createElement("option");
    opt.value = brand;
    opt.textContent = brand;
    brandSelect.appendChild(opt);
  });

  brandSelect.addEventListener("change", rafThrottle((e) => {
    filterState.watches.brand = e.target.value;
    performOptimizedWatchFilter();
  }));
}

function setupWatchSearch() {
  const watchSearchInput = document.getElementById("watchSearchInput");
  
  if (!watchSearchInput) {
    return;
  }
  
  // Use RAF-based throttle for instant response
  const throttledSearch = rafThrottle((query) => {
    filterState.watches.search = query;
    currentWatchSearchQuery = query;
    performOptimizedWatchFilter();
  });
  
  watchSearchInput.addEventListener("input", (e) => {
    throttledSearch(e.target.value);
  });
  svAddSearchClear(watchSearchInput);   // 3.66.3
}

// High-performance watch filtering with memoization
function performOptimizedWatchFilter() {
  const { brand, search } = filterState.watches;
  const queryKey = `${brand}|${search}`;
  
  // Check if we already computed this filter
  if (filterState.watches.lastQuery === queryKey) {
    return;
  }
  
  filterState.watches.lastQuery = queryKey;
  filterState.watches.results = new Set();
  
  const watchGrid = document.getElementById("watchesGrid");
  const isListView = watchGrid.classList.contains('list-view');
  
  queueDOMUpdate(() => {
    // Always query list items since we use unified structure
    const listItems = watchGrid.querySelectorAll('.watch-list-item');
    
    let visibleCount = 0;
    
    listItems.forEach((listItem) => {
      const img = listItem.querySelector('img');
      if (!img) return;
      
      const watchData = {
        brand: img.dataset.brand,
        model: img.dataset.model,
        lugWidth: img.dataset.lugWidth
      };
      
      const cacheKey = `${watchData.brand}-${watchData.model}-${queryKey}`;
      let shouldShow = true;
      
      // Fast brand filter - folded, so "TAG Heuer" and "Tag Heuer" are one brand
      if (brand && svBrandKey(watchData.brand) !== svBrandKey(brand)) {
        shouldShow = false;
      }
      
      // Fast search with memoization
      if (shouldShow && search) {
        // sizes: a merged Apple row's model only names the size currently showing, so without this
        // searching "44mm" would lose the row that offers 44mm in its dropdown.
        const searchableText =
          `${watchData.brand} ${watchData.model} ${watchData.lugWidth} ${img.dataset.sizes || ''}`.toLowerCase();
        shouldShow = fastStringMatch(searchableText, search, cacheKey);
      }
      
      // Update visibility on the list item
      listItem.style.display = shouldShow ? '' : 'none';
      
      if (shouldShow) {
        filterState.watches.results.add(img.dataset.index);
        visibleCount++;
      }
    });
    
    /* Family buttons: Apple only. Each header owns the rows that follow it until the next header,
       so one ordered walk both counts a family's matches and collapses it. A family is drawn only
       while it still HAS a match (so a search cannot leave an empty button behind), and its rows
       are hidden unless it is open - or unless a search is running, which force-opens the lot. */
    const applePicked = svBrandKey(brand || '') === 'apple';
    const searching = !!search;
    let currentHead = null, headRows = [], headMatches = 0;
    const closeHead = () => {
      if (!currentHead) return;
      const key = currentHead.dataset.appleGroup;
      const open = searching || !!svAppleFamilyOpen[key];
      const shown = applePicked && headMatches > 0;
      currentHead.style.display = shown ? '' : 'none';
      currentHead.setAttribute('aria-expanded', String(shown && open));
      const c = currentHead.querySelector('.wgh-count');
      if (c) c.textContent = headMatches ? String(headMatches) : '';
      const chev = currentHead.querySelector('.wgh-chev');
      if (chev) chev.textContent = open ? '▴' : '▾';
      // Collapsed (or Apple not picked, where the header is hidden anyway) -> rows stay hidden.
      if (applePicked && !open) headRows.forEach(r => { r.style.display = 'none'; });
    };
    [...watchGrid.children].forEach(el => {
      if (el.classList.contains('watch-group-header')) {
        closeHead(); currentHead = el; headRows = []; headMatches = 0; return;
      }
      if (!currentHead || !el.classList.contains('watch-list-item')) return;
      headRows.push(el);
      if (el.style.display !== 'none') headMatches++;
    });
    closeHead();

    // Show "no results" message if needed
    showNoResultsMessage('watchesGrid', visibleCount === 0, 'watches');

    // Filtering changes which rows are on screen without any scroll happening, and the rows a
    // search brings into view are exactly the ones the customer is waiting to see.
    svRefineVisibleWatchRows();
    
    // Auto-select first visible if filter changed
    if (search || brand) {
      autoSelectFirstVisibleWatch();
    }
  });
}

// Auto-select first visible watch (optimized)
function autoSelectFirstVisibleWatch() {
  svRaf(() => {
    const watchGrid = document.getElementById("watchesGrid");
    
    // Always use list items since we have unified structure
    const visibleItems = watchGrid.querySelectorAll('.watch-list-item:not([style*="none"])');
    if (visibleItems.length > 0) {
      const firstVisible = visibleItems[0].querySelector('img');
      if (firstVisible) {
        firstVisible.click();
      }
    }
  });
}

function setupStrapSearch() {
  const strapSearchInput = document.getElementById("strapSearchInput");
  
  if (!strapSearchInput) {
    return;
  }
  
  strapSearchInput.addEventListener("input", debounce((e) => {
    currentStrapSearchQuery = e.target.value;
    // Use unified filtering instead of separate search function
    filterStrapsByAllCategories();
  }, 150)); // Reduced from 300ms for snappier response
  svAddSearchClear(strapSearchInput);   // 3.66.3
  
  
}

  /************************************************************************
   * VIEW TOGGLE LOGIC
   ************************************************************************/
  // Mobile detection utility (<= 768 matches the CSS breakpoint everywhere else)
  function isMobileView() {
    return window.innerWidth <= 768;
  }

  // Force grid view on mobile
  function enforceGridViewOnMobile() {
    // Mobile now uses the same list view as desktop (stacked). We no longer force
    // grid view here - just hide the view-toggle buttons on mobile.
    const onMobile = isMobileView();
    const disp = onMobile ? 'none' : '';
    document.querySelectorAll('#gridViewBtn, #listViewBtn, #strapGridViewBtn, #strapListViewBtn')
      .forEach(btn => { btn.style.display = disp; });
  }

  /**
   * Restores the previously selected strap after a view switch re-render + filter.
   * Waits for filterStrapsByAllCategories RAF chain to complete, then either:
   * 1) Re-selects the previously selected strap if it's still visible
   * 2) Keeps whatever the filter auto-selected if the previous strap is gone
   */
  function restoreStrapSelectionAfterFilter(savedStrapId, savedStrapURL) {
    if (!savedStrapId) {
      suppressStrapAutoSelect = false;
      return;
    }
    
    // filterStrapsByAllCategories uses RAF for filtering.
    // We wait for that to complete, then restore selection.
    svRaf(() => {
      svRaf(() => {
        svRaf(() => {
          const strapsGrid = document.getElementById('strapsGrid');
          
          // Find the previously selected strap in the new DOM
          const savedImg = strapsGrid.querySelector(`img[data-id="${savedStrapId}"]`);
          
          if (savedImg && savedImg.style.display !== 'none') {
            // Previous strap is still visible - restore selection
            strapsGrid.querySelectorAll('img').forEach(i => i.classList.remove('selected'));
            strapsGrid.querySelectorAll('.strap-list-item').forEach(item => item.classList.remove('selected'));
            
            savedImg.classList.add('selected');
            const listItem = savedImg.closest('.strap-list-item');
            if (listItem) listItem.classList.add('selected');
            
            // Restore the product reference and URL
            selectedStrapProduct = allStrapProducts.find(p => String(p.id) === savedStrapId);
            if (selectedStrapProduct) {
              currentStrapURL = savedStrapURL || svStrapUrl(selectedStrapProduct);
              showStrapDetails(selectedStrapProduct);
              if (currentWatchData) {
                combineImages();
              }
            }
          } else {
            // Previous strap is not visible (incompatible) - auto-select first visible
            const allImgs = strapsGrid.querySelectorAll('img[data-id]');
            const firstVisible = Array.from(allImgs).find(isStrapImgShown);
            
            if (firstVisible) {
              strapsGrid.querySelectorAll('img').forEach(i => i.classList.remove('selected'));
              strapsGrid.querySelectorAll('.strap-list-item').forEach(item => item.classList.remove('selected'));
              
              firstVisible.classList.add('selected');
              const listItem = firstVisible.closest('.strap-list-item');
              if (listItem) listItem.classList.add('selected');
              
              const chosenId = firstVisible.dataset.id;
              selectedStrapProduct = allStrapProducts.find(p => String(p.id) === String(chosenId));
              if (selectedStrapProduct) {
                currentStrapURL = svStrapUrl(selectedStrapProduct);
                showStrapDetails(selectedStrapProduct);
                if (currentWatchData) combineImages();
              }
            }
          }
          
          // Clear the suppress flag - view switch is complete
          suppressStrapAutoSelect = false;
        });
      });
    });
  }

  function setupViewToggle() {
    const gridViewBtn = document.getElementById('gridViewBtn');
    const listViewBtn = document.getElementById('listViewBtn');
    
    if (!gridViewBtn || !listViewBtn) {
      return;
    }
    
    // Grid view button click (optimized - no DOM rebuild)
    gridViewBtn.addEventListener('click', () => {
      if (currentWatchViewMode !== 'grid') {
        currentWatchViewMode = 'grid';
        switchToGridView();
      }
    });
    
    // List view button click (optimized - no DOM rebuild)
    listViewBtn.addEventListener('click', () => {
      if (isMobileView()) {
        return; // Prevent list view on mobile
      }
      if (currentWatchViewMode !== 'list') {
        currentWatchViewMode = 'list';
        switchToListView();
      }
    });

    // "Select watch face" back button (mobile two-step flow)
    const changeWatchBtn = document.getElementById('changeWatchBtn');
    if (changeWatchBtn) changeWatchBtn.addEventListener('click', goToWatchStep);
  }
  
  // Optimized view switching - CSS-only, no DOM rebuilds
  function switchToGridView() {
    const gridViewBtn = document.getElementById('gridViewBtn');
    const listViewBtn = document.getElementById('listViewBtn');
    const watchGrid = document.getElementById('watchesGrid');
    
    // Update button states
    gridViewBtn.classList.add('active');
    listViewBtn.classList.remove('active');
    
    // Switch to grid layout via CSS only - no re-rendering
    watchGrid.classList.remove('list-view');
    
    // Reapply filters if needed
    if (filterState.watches.search || filterState.watches.brand) {
      performOptimizedWatchFilter();
    }
  }
  
  function switchToListView() {
    const gridViewBtn = document.getElementById('gridViewBtn');
    const listViewBtn = document.getElementById('listViewBtn');
    const watchGrid = document.getElementById('watchesGrid');
    
    // Update button states  
    listViewBtn.classList.add('active');
    gridViewBtn.classList.remove('active');
    
    // Switch to list layout via CSS only - no re-rendering
    watchGrid.classList.add('list-view');
    
    // Reapply filters if needed
    if (filterState.watches.search || filterState.watches.brand) {
      performOptimizedWatchFilter();
    }
  }
  
  // Strap view toggle setup
  function setupStrapViewToggle() {
    const strapGridViewBtn = document.getElementById('strapGridViewBtn');
    const strapListViewBtn = document.getElementById('strapListViewBtn');
    
    if (!strapGridViewBtn || !strapListViewBtn) {
      return;
    }
    
    // Grid view button click
    strapGridViewBtn.addEventListener('click', () => {
      if (currentStrapViewMode !== 'grid') {
        currentStrapViewMode = 'grid';
        switchStrapToGridView();
      }
    });
    
    // List view button click
    strapListViewBtn.addEventListener('click', () => {
      if (isMobileView()) {
        return; // Prevent list view on mobile
      }
      if (currentStrapViewMode !== 'list') {
        currentStrapViewMode = 'list';
        switchStrapToListView();
      }
    });
  }
  
  function switchStrapToGridView() {
    const strapGridViewBtn = document.getElementById('strapGridViewBtn');
    const strapListViewBtn = document.getElementById('strapListViewBtn');
    const strapsGrid = document.getElementById('strapsGrid');
    
    // Remember current selection before re-render wipes the DOM
    const savedStrapId = selectedStrapProduct ? String(selectedStrapProduct.id) : null;
    const savedStrapURL = currentStrapURL;
    
    queueDOMUpdate(() => {
      // Suppress auto-select during view switch - we'll restore selection ourselves
      suppressStrapAutoSelect = true;
      
      // Update button states
      strapGridViewBtn.classList.add('active');
      strapListViewBtn.classList.remove('active');
      
      // Switch to grid layout via CSS
      strapsGrid.classList.remove('list-view');
      
      // Re-render straps in grid view
      if (currentStrapProducts && currentStrapProducts.length > 0) {
        renderStraps(currentStrapProducts);
      }
      
      // Synchronous: renderStraps above rebuilt every row visible, so a deferred pass would
      // leave incompatible straps on screen until the next frame (and rapid clicking cancels
      // that frame's pass over and over).
      filterStrapsByAllCategories(true);
      restoreStrapSelectionAfterFilter(savedStrapId, savedStrapURL);
    });
  }
  
  function switchStrapToListView() {
    const strapGridViewBtn = document.getElementById('strapGridViewBtn');
    const strapListViewBtn = document.getElementById('strapListViewBtn');
    const strapsGrid = document.getElementById('strapsGrid');
    
    // Remember current selection before re-render wipes the DOM
    const savedStrapId = selectedStrapProduct ? String(selectedStrapProduct.id) : null;
    const savedStrapURL = currentStrapURL;
    
    queueDOMUpdate(() => {
      // Suppress auto-select during view switch - we'll restore selection ourselves
      suppressStrapAutoSelect = true;
      
      // Update button states  
      strapListViewBtn.classList.add('active');
      strapGridViewBtn.classList.remove('active');
      
      // Switch to list layout via CSS
      strapsGrid.classList.add('list-view');
      
      // Re-render straps in list view
      if (currentStrapProducts && currentStrapProducts.length > 0) {
        renderStraps(currentStrapProducts);
      }
      
      // Synchronous: renderStraps above rebuilt every row visible, so a deferred pass would
      // leave incompatible straps on screen until the next frame (and rapid clicking cancels
      // that frame's pass over and over).
      filterStrapsByAllCategories(true);
      restoreStrapSelectionAfterFilter(savedStrapId, savedStrapURL);
    });
  }

  /************************************************************************
   * 4) WATCH SELECTION LOGIC
   ************************************************************************/
  function watchSelectionSetup() {
    const watchGrid = document.getElementById("watchesGrid");
    watchGrid.addEventListener("click", (e) => {
      if (e.isTrusted) svUserInteracted = true; // real tap - block any pending auto-select/restore
      // Check if clicked element is an image or if clicked on a list item containing an image
      let targetImg = null;
      
      if (e.target && e.target.tagName === "IMG") {
        targetImg = e.target;
      } else if (e.target && e.target.classList.contains('watch-list-item')) {
        // Clicked on the list item itself - find the image inside
        targetImg = e.target.querySelector('img');
      } else if (e.target && e.target.closest('.watch-list-item')) {
        // Clicked on something inside the list item (like text) - find the image
        targetImg = e.target.closest('.watch-list-item').querySelector('img');
      }
      
      if (targetImg) {
        // Clear previous .selected from both grid images and list items
        watchGrid.querySelectorAll("img").forEach(img => {
          img.classList.remove("selected");
        });
        watchGrid.querySelectorAll(".watch-list-item").forEach(item => {
          item.classList.remove("selected");
        });
        
        // Mark newly clicked watch as selected
        targetImg.classList.add("selected");
        
        // If in list view, also mark the list item as selected
        const listItem = targetImg.closest('.watch-list-item');
        if (listItem) {
          listItem.classList.add("selected");
        }

        // Show watch details
        displayWatchDetails(targetImg);

        // Re-match variant if strap is already selected (so variant updates with new watch lug width)
        if (selectedStrapProduct) {
          showStrapDetails(selectedStrapProduct);
        }

        // Combine if strap is already selected
        combineImages();

        // Mobile: advance to step 2 (pick a strap) - only on a real user tap,
        // not the programmatic .click() used to auto-select the default watch.
        if (e.isTrusted) goToStrapStep();
      }
    });
  }

  /* ---- Mobile two-step flow: 1) pick a watch  2) pick a strap ---- */
  function goToStrapStep() {
    if (window.innerWidth > 768) return; // matches the mobile @media breakpoint
    const container = document.querySelector('.container');
    if (!container || container.classList.contains('sv-step-strap')) return;
    const watches = document.querySelector('.watches-container');
    if (watches) {
      watches.style.transition = 'opacity .28s ease';
      watches.style.opacity = '0';
      setTimeout(() => {
        container.classList.add('sv-step-strap');
        watches.style.opacity = '';
        try { document.getElementById('mainContainer')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
      }, 280);
    } else {
      container.classList.add('sv-step-strap');
    }
  }
  function goToWatchStep() {
    const container = document.querySelector('.container');
    if (!container) return;
    container.classList.remove('sv-step-strap');
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
  }

  function displayWatchDetails(watchImgEl) {
    svAppResetNudge(false);   // see showStrapDetails
    if (SV_EMBED) svEmbedState('watch');

    // Show watch details below the grid
    const watchDetailsEl = document.getElementById("watchDetails");
    
    // Set brand name (show only if brand exists)
    const brandElement = document.getElementById("watchBrand");
    const brandName = watchImgEl.dataset.brand || '';
    if (brandName.trim()) {
      brandElement.textContent = brandName;
      brandElement.parentElement.style.display = 'block';
    } else {
      brandElement.parentElement.style.display = 'none';
    }
    
    // dataset.model stays the raw catalogue string (deep links + grid lookups match on it); only
    // what's shown to the customer gets tidied.
    document.getElementById("watchTitle").textContent =
      watchDisplayModel({ model: watchImgEl.dataset.model });

    // Display lug width exactly as it appears in CSV
    const lugEl = document.getElementById("watchLugWidth");
    lugEl.textContent =
      watchDisplayLug({ 'lug width': watchImgEl.dataset.lugWidth,
                        'watch type': watchImgEl.dataset.watchType,
                        'collection_link': watchImgEl.dataset.collectionLink })
        ? watchImgEl.dataset.lugWidth : '';
    // Apple watches have no lug width to show, and a bare "Strap Width:" label with nothing after
    // it reads as a bug.
    if (lugEl.parentElement) lugEl.parentElement.style.display = lugEl.textContent ? '' : 'none';

    // The two case sizes of an Apple series share ONE face image in the catalogue, so the picture
    // is identical either way. Say so, rather than leaving someone toggling the size dropdown
    // waiting for the preview to change.
    {
      const merged = watchImgEl._svWatch && watchImgEl._svWatch.sizeVariants;
      let note = document.getElementById('watchSizeNote');
      if (merged && !note) {
        note = document.createElement('p');
        note.id = 'watchSizeNote';
        note.style.cssText = 'color:#777;font-size:.85rem;margin:4px 0 0;';
        note.textContent = 'Both case sizes are shown the same way here.';
        (lugEl.parentElement || document.getElementById('watchTitle').parentElement)
          .insertAdjacentElement('afterend', note);
      }
      if (note) note.style.display = merged ? '' : 'none';
    }

    // Update "View all straps" link with collection_link from CSV
    const viewAllStrapsLink = document.getElementById("viewAllStrapsLink");
    const collectionLink = watchImgEl.dataset.collectionLink;
    if (collectionLink && collectionLink.trim() !== '') {
      viewAllStrapsLink.href = collectionLink;
      viewAllStrapsLink.style.display = 'inline-flex';
      
    } else {
      // Hide the link if no collection_link is available
      viewAllStrapsLink.style.display = 'none';
    }

    watchDetailsEl.style.display = "block";

    // Store the selected watch info globally
    // Use the current src (which might be processed or original)
    const imageSrc = watchImgEl.src;
    
    
    currentWatchData = {
      finalImageData: imageSrc,
      watchObj: watchImgEl._svWatch || null,   // 3.93.1: for svEnsureSharpWatch
      scale: parseFloat(watchImgEl.dataset.scale) || 0.8,
      rawLink: watchImgEl.dataset.rawLink, // Keep reference to original
      watchType: watchImgEl.dataset.watchType || "", // Store watch type for filtering
      brand: watchImgEl.dataset.brand || "",
      model: watchImgEl.dataset.model || "",
      lugWidth: watchImgEl.dataset.lugWidth || "", // Store lug width for variant matching
      ovTop: watchImgEl.dataset.ovTop || "",       // per-watch overlap/scale overrides
      ovBot: watchImgEl.dataset.ovBot || "",
      scaleTop: watchImgEl.dataset.scaleTop || "",
      scaleBot: watchImgEl.dataset.scaleBot || "",
      isApple: /apple/i.test(watchImgEl.dataset.watchType || ""),
      isCustom: watchImgEl.dataset.custom === "1",   // watch the customer photographed themselves
      // Restrict the strap grid to the products in this watch's catalogue collection.
      collectionHandle: collectionHandleFromLink(watchImgEl.dataset.collectionLink),
      collectionSet: null,
      // The feed says we stock nothing for this watch - show that, not the whole catalogue.
      noStraps: svWatchHasNoStraps(watchImgEl.dataset.lugWidth, watchImgEl.dataset.collectionLink)
    };
    // THE MAIN SELECTION PATH. The three other svUpgradeWatchImage calls are secondary (colour
    // swap, size switch, refine-on-demand for a row that was never scrolled into view) - this is
    // the one that runs when someone simply picks a watch, and leaving it out meant the sharp
    // copy was never fetched for the ordinary case, which is every case.
    svUpgradeWatchImage(watchImgEl._svWatch);
    // Already-cached collection applies on this very pass; otherwise fetch then re-filter.
    {
      const _wd = currentWatchData, _ch = _wd.collectionHandle;
      const _cached = _ch ? _watchCollCache[_ch] : null;
      if (_cached && _cached !== 'failed') {
        _wd.collectionSet = _cached;
      } else if (_ch) {
        /* ⚠ PENDING IS NOT "UNRESTRICTED". This fetch used to leave collectionSet null while it
           ran, and a null set means no restriction - so every strap in the catalogue showed for a
           second or three, including the wrong widths, and the auto-select below happily put one
           in the buy card. Hiding the rows until we know is the only honest state; a failed fetch
           still fails OPEN (see ensureWatchCollection). */
        _wd.collectionPending = true;
        ensureWatchCollection(_ch).then(set => {
          if (currentWatchData !== _wd) return;   // user moved on
          _wd.collectionPending = false;
          if (set) _wd.collectionSet = set;       // no set = fetch failed = stay unrestricted
          filterStrapsByAllCategories(true);      // straight after a state change: never defer
        });
      }
    }

    // Not refined yet (row was never scrolled into view)? Refine at top priority and
    // swap the composite over to the proper lug-normalised thumbnail when it lands.
    const wobj = watchImgEl._svWatch;
    if (wobj && !wobj._refined) {
      refineWatch(wobj).then(() => {
        if (!watchImgEl.classList.contains('selected')) return; // user moved on
        if (wobj.thumbnailImageData && currentWatchData) {
          currentWatchData.finalImageData = wobj.thumbnailImageData;
          // A no-strap watch has no composite to refresh, but its own picture just got sharper.
          if (!currentStrapURL && currentWatchData.noStraps) svDrawWatchOnly();
          if (currentStrapURL) combineImages();
          svUpgradeWatchImage(wobj);
        }
      });
    }

    // Update URL state with new watch selection
    updateURLState();
    
    /* ⚠ 3.76.3: DROP THE PREVIOUS STRAP SYNCHRONOUSLY for a watch we stock nothing for. The
       filter pass does clear it, but its auto-select branch runs inside svRaf - so between the
       click and the next animation frame the sticky buy bar still showed the LAST watch's strap
       with a live "Add to Cart - $150.00" under a "No straps for this watch yet" notice. Anything
       that decides whether a customer can buy has to be immediate, not a frame away. */
    if (currentWatchData.noStraps) {
      selectedStrapProduct = null;
      currentStrapURL = "";
      const _sd = document.getElementById('strapDetails');
      if (_sd) _sd.style.display = 'none';
      try { document.body.classList.add('sv-nostraps'); } catch (e) {}
      const _sg = document.getElementById('strapsGrid');
      if (_sg) _sg.querySelectorAll('img.selected, .strap-list-item.selected')
                  .forEach(el => el.classList.remove('selected'));
      const _fc0 = document.getElementById('finalCanvas');
      if (_fc0) { const _x0 = _fc0.getContext('2d'); if (_x0) _x0.clearRect(0, 0, _fc0.width, _fc0.height); }
      svDrawWatchOnly();
    }

    // Apply unified filtering (includes watch type compatibility + category filters). Apple straps
    // aren't in the normal collection, so lazy-load them the first time an Apple watch is picked;
    // show a loading spinner (not "no straps") and drop the stale composite while they arrive.
    if (currentWatchData.isApple) {
      // Gate on whether the straps are READY, not on whether a fetch was once started: a fetch
      // that failed leaves "started" true-then-false and used to drop through to the empty state.
      if (!_appleStrapsReady) {
        currentStrapURL = "";
        const _fc = document.getElementById('finalCanvas');   // wipe the previous (non-Apple) composite now
        if (_fc) { const _x = _fc.getContext('2d'); if (_x) _x.clearRect(0, 0, _fc.width, _fc.height); }
        hideAppleStrapsError();
        showApplesLoading(true);
      }
      ensureAppleStraps().then(() => {
        if (_appleStrapsReady) showApplesLoading(false);   // on failure the error box takes over
        filterStrapsByAllCategories(true);
        syncAppleSizeSelection();
      });
    } else {
      hideAppleStrapsError();
      showApplesLoading(false);
    }
    // Synchronous: picking a watch changes which straps are COMPATIBLE, and deferring that to
    // the next frame leaves the previous watch's straps on screen - visibly so while someone
    // taps between watches quickly, because each call cancels the pending pass. The pass is a
    // loop over the strap rows and costs well under a frame.
    filterStrapsByAllCategories(true);
  }

  /************************************************************************
   * 5) SETUP STRAP CATEGORY DROPDOWNS
   ************************************************************************/
  function setupCategoryDropdowns() {
    // Build category structure from all products
    buildCategoryStructure();
    
    // Setup main category dropdown
    setupMainCategoryDropdown();
    
    // Setup sub category dropdown
    setupSubCategoryDropdown();
    
    // Setup color filter dropdown
    setupColorFilterDropdown();
    
    // Add event listeners
    setupCategoryEventListeners();
  }

  function buildCategoryStructure() {
    categoryStructure = {};
    allStrapCategories = [];

    /* Keyed on the FOLDED value (see svFold): "Leather" and "leather" are one category, listed
       once, under the spelling the catalogue uses most. Before this, each spelling was its own
       menu entry and picking one hid the other's straps. */
    const mainCounts = new Map();                  // folded main -> spelling counts
    const subCounts = new Map();                   // folded main -> (folded sub -> spelling counts)
    const allCatCounts = new Map();

    allStrapProducts.forEach(product => {
      if (product.mainCategory && product.subCategory) {
        svCountInto(mainCounts, product.mainCategory);
        const mk = svFold(product.mainCategory);
        if (!subCounts.has(mk)) subCounts.set(mk, new Map());
        svCountInto(subCounts.get(mk), product.subCategory);
        svCountInto(allCatCounts, product.productSubCategory);
      }
    });

    mainCounts.forEach((counts, mk) => {
      const label = svPickLabel(counts);
      const subs = subCounts.get(mk) || new Map();
      categoryStructure[label] = [...subs.values()].map(svPickLabel).sort();
    });
    allStrapCategories = [...allCatCounts.values()].map(svPickLabel);
  }
  function setupMainCategoryDropdown() {
    const mainCategorySelect = document.getElementById("mainCategorySelect");
    
    // Clear existing options except the first one
    mainCategorySelect.innerHTML = "";
    
    // Add the default option
    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = "Materials";
    mainCategorySelect.appendChild(defaultOption);
    
    // Get sorted main categories
    const mainCategories = Object.keys(categoryStructure).sort();
    
    // Create dropdown options
    const fragment = document.createDocumentFragment();
    mainCategories.forEach(mainCat => {
      const option = document.createElement("option");
      option.value = mainCat;
      option.textContent = mainCat;
      fragment.appendChild(option);
    });
    mainCategorySelect.appendChild(fragment);
  }

  function setupSubCategoryDropdown() {
    const subCategorySelect = document.getElementById("subCategorySelect");
    
    // Clear existing options
    subCategorySelect.innerHTML = "";
    
    // Add the default option
    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = "Styles";
    subCategorySelect.appendChild(defaultOption);
    
    // Get all unique subcategories from all products
    const allSubCategories = [...new Set(allStrapProducts
      .map(p => p.subCategory)
      .filter(subCat => subCat && subCat.trim() !== "")
    )].sort();
    
    // Create dropdown options for all styles
    const fragment = document.createDocumentFragment();
    allSubCategories.forEach(subCat => {
      const option = document.createElement("option");
      option.value = subCat;
      option.textContent = subCat;
      fragment.appendChild(option);
    });
    subCategorySelect.appendChild(fragment);
  }

  function setupColorFilterDropdown() {
    const colorFilterSelect = document.getElementById("colorFilterSelect");
    
    // Clear existing options
    colorFilterSelect.innerHTML = "";
    
    // Add the default option
    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = "Colours";
    colorFilterSelect.appendChild(defaultOption);
    
    // Extract individual colors from JSON arrays, folded so "Black" and "black" are one option
    // (see svFold) and listed under the spelling the catalogue uses most.
    const colorCounts = new Map();

    allStrapProducts.forEach(product => {
      if (product.strapColor && product.strapColor.trim() !== "") {
        try {
          // Try to parse as JSON array
          const colorArray = JSON.parse(product.strapColor);
          if (Array.isArray(colorArray)) {
            colorArray.forEach(color => {
              if (color && typeof color === 'string') svCountInto(colorCounts, color);
            });
          }
        } catch (e) {
          // If not JSON, treat as single color
          svCountInto(colorCounts, product.strapColor);
        }
      }
    });

    // Convert to sorted array
    const colors = [...colorCounts.values()].map(svPickLabel).sort((a, b) => a.localeCompare(b));
    
    // Create dropdown options
    const fragment = document.createDocumentFragment();
    colors.forEach(color => {
      const option = document.createElement("option");
      option.value = color;
      option.textContent = color;
      fragment.appendChild(option);
    });
    colorFilterSelect.appendChild(fragment);
  }

  function updateSubCategoryDropdown(selectedMainCategory) {
    const subCategorySelect = document.getElementById("subCategorySelect");
    
    // Clear existing options
    subCategorySelect.innerHTML = "";
    
    // Add the default option
    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = "Styles";
    subCategorySelect.appendChild(defaultOption);
    
    if (selectedMainCategory && categoryStructure[selectedMainCategory]) {
      // Show subcategories for selected main category
      const fragment = document.createDocumentFragment();
      categoryStructure[selectedMainCategory].forEach(subCat => {
        const option = document.createElement("option");
        option.value = subCat;
        option.textContent = subCat;
        fragment.appendChild(option);
      });
      subCategorySelect.appendChild(fragment);
    } else {
      // Show all subcategories when no main category is selected
      const allSubCategories = [...new Set(allStrapProducts
        .map(p => p.subCategory)
        .filter(subCat => subCat && subCat.trim() !== "")
      )].sort();
      
      const fragment = document.createDocumentFragment();
      allSubCategories.forEach(subCat => {
        const option = document.createElement("option");
        option.value = subCat;
        option.textContent = subCat;
        fragment.appendChild(option);
      });
      subCategorySelect.appendChild(fragment);
    }
  }

  function setupCategoryEventListeners() {
    const mainCategorySelect = document.getElementById("mainCategorySelect");
    const subCategorySelect = document.getElementById("subCategorySelect");
    const colorFilterSelect = document.getElementById("colorFilterSelect");
    
    mainCategorySelect.addEventListener("change", debounce(() => {
      const selectedMainCategory = mainCategorySelect.value;
      // Update subcategory options based on selected main category
      updateSubCategoryDropdown(selectedMainCategory);
      
      // Reset sub category selection when main category changes
      subCategorySelect.value = "";
      
      // Filter straps based on all selected filters
      filterStrapsByAllCategories();
    }, 100));
    
    subCategorySelect.addEventListener("change", debounce(() => {
      // Filter straps based on all selected filters
      filterStrapsByAllCategories();
    }, 100));
    
    colorFilterSelect.addEventListener("change", debounce(() => {
      // Filter straps based on all selected filters
      filterStrapsByAllCategories();
    }, 100));
    
  }

  // Helper function to check if product has selected color
  function productHasColor(product, selectedColor) {
    if (!product.strapColor || !selectedColor) return false;
    
    try {
      // Try to parse as JSON array
      const colorArray = JSON.parse(product.strapColor);
      if (Array.isArray(colorArray)) {
        return colorArray.some(color => 
          color && typeof color === 'string' && svFold(color) === svFold(selectedColor)
        );
      }
    } catch (e) {
      // If not JSON, treat as single color
      return svFold(product.strapColor) === svFold(selectedColor);
    }
    
    return false;
  }



  /**
   * UNIFIED STRAP FILTERING SYSTEM
   * This single function handles ALL strap filtering to prevent conflicts:
   * 1. Search query matching
   * 2. Watch type compatibility (when a watch is selected)
   * 3. Main category filter
   * 4. Sub category filter
   * 5. Color filter
   * 
   * All filter sources (dropdowns, search, watch selection) call this function.
   */
  /* `immediate === true` runs the pass synchronously instead of on the next animation frame.
     Required after any renderStraps(), because that rebuilds every row VISIBLE: deferring the
     hide leaves the unfiltered list on screen until the next frame, and since each call also
     cancels the pending one, rapid clicking postpones it indefinitely. That is how QuickFit
     straps stayed on screen for a Quick Release watch while the view buttons were tapped
     quickly. Compared with `=== true` on purpose - this is also used as an event handler in
     places, and an Event object would otherwise read as truthy. */
  function filterStrapsByAllCategories(immediate) {
    const mainCategorySelect = document.getElementById("mainCategorySelect");
    const subCategorySelect = document.getElementById("subCategorySelect");
    const colorFilterSelect = document.getElementById("colorFilterSelect");
    
    const mainCategory = mainCategorySelect.value;
    const subCategory = subCategorySelect.value;
    const selectedColor = colorFilterSelect.value;
    
    // Get current watch type for compatibility check.
    // Standard watches with no explicit "watch type" take Quick Release straps,
    // so default to "Quick Release" (otherwise the compat check is skipped and
    // incompatible straps like QuickFit show through).
    let selectedWatchType = currentWatchData?.watchType || null;
    if (currentWatchData && (!selectedWatchType || !String(selectedWatchType).trim())) {
      selectedWatchType = "Quick Release";
    }

    // Straps are limited to the products in the selected watch's catalogue collection
    // (null until it loads, or when the watch has no collection_link -> unrestricted).
    const watchCollSet = (currentWatchData?.collectionSet && currentWatchData.collectionSet.size)
      ? currentWatchData.collectionSet : null;

    // ... and until that set arrives, show NOTHING rather than everything: an unrestricted grid
    // at this moment is a WRONG grid, not a permissive one. showNoResultsMessage puts the strap
    // spinner up in its place instead of "no matching straps".
    const collPending = !!(currentWatchData && currentWatchData.collectionPending);
    // ... and this watch has nothing at all, which is a different message again (3.75.0).
    const noStraps = !!(currentWatchData && currentWatchData.noStraps);

  
    
    // Cancel any pending filter operation
    if (rafId) {
      cancelAnimationFrame(rafId);
    }

    const svFilterPass = () => {
      // Show/hide existing DOM elements based on filters
      const strapsGrid = document.getElementById("strapsGrid");
      const strapImgs = strapsGrid.querySelectorAll("img");
      
      // Also handle list view items
      const listItems = strapsGrid.querySelectorAll(".strap-list-item");
      
      // Batch DOM updates for better performance
      const updates = [];
      
      // In list view, iterate through list items; in grid view, iterate through images
      const isListView = currentStrapViewMode === 'list';
      const elements = isListView ? listItems : strapImgs;
        
      elements.forEach(element => {
        const img = isListView ? element.querySelector('img') : element;
        if (!img) return;
        
        const productId = img.dataset.id;
        let product = currentStrapProducts.find(p => String(p.id) === String(productId));
        if (!product) {
          product = allStrapProducts.find(p => String(p.id) === String(productId));
        }

        // Grouped list rows: switch to the colour-member matching the active colour/search filter.
        let groupNoMatch = false;
        if (isListView && element._members && element._members.length > 1) {
          // Only offer colour members that are in the selected watch's collection.
          const members = (watchCollSet
            ? element._members.filter(m => watchCollSet.has(m.handle))
            : element._members).filter(svFitsProprietaryLug).filter(svBundleUsable);   // 3.92.3
          // ⚠ A customer's explicit colour pick outranks the filter. Changing the WATCH re-filters
          // the strap list, which re-ran pickStrapGroupMember for every row - and with no colour
          // filter active that returns the group's FIRST member, so choosing White Pearl and then
          // switching watch silently snapped the selection, the card and the render back to Blue
          // Pearl. Only the row that IS the current selection is protected, and only while that
          // member survives the new watch's collection filter; every other row still follows the
          // colour filter exactly as before.
          let chosenMember = null;
          if (img.classList.contains('selected') && selectedStrapProduct) {
            chosenMember = members.find(m => String(m.id) === String(selectedStrapProduct.id)) || null;
          }
          if (!chosenMember) {
            chosenMember = members.length ? pickStrapGroupMember(members, selectedColor, currentStrapSearchQuery) : null;
          }
          if (chosenMember) {
            if (String(chosenMember.id) !== String(img.dataset.id)) {
              setStrapGroupActive(element, img, chosenMember);
              // If this row is the currently-selected strap, keep the details panel + preview
              // in sync with the colour the filter just switched the row to.
              if (img.classList.contains('selected') && selectedStrapProduct && String(selectedStrapProduct.id) !== String(chosenMember.id)) {
                selectedStrapProduct = chosenMember;
                currentStrapURL = svStrapUrl(chosenMember);
                showStrapDetails(chosenMember);
                if (currentWatchData) combineImages();
              }
            }
            product = chosenMember;
          } else {
            groupNoMatch = true;
          }
        }

        let shouldShow = !groupNoMatch && !collPending && !noStraps;

        if (shouldShow && product) {
          // 0. Watch collection restriction - only straps sold for this watch
          if (watchCollSet && !watchCollSet.has(product.handle)) {
            shouldShow = false;
          }

          // 1. Check search match first
          const matchesSearch = strapMatchesSearch(product, currentStrapSearchQuery);
          if (!matchesSearch) {
            shouldShow = false;
          }
          
          // 2. Check watch type compatibility (CRITICAL - always apply if watch is selected)
          if (shouldShow && selectedWatchType) {
            const strapWatchType = product.watchType;
            let isCompatible = false;
            
            /* ⚠ Folded: this is the check that decides whether a strap fits the chosen watch,
               so a "quick release" typed into one metafield against the feed's "Quick Release"
               would have hidden every strap for that watch with no error anywhere. */
            const wantType = svFold(selectedWatchType);
            if (strapWatchType) {
              if (Array.isArray(strapWatchType)) {
                isCompatible = strapWatchType.some(t => svFold(t) === wantType);
              } else if (typeof strapWatchType === 'string') {
                isCompatible = svFold(strapWatchType) === wantType;
              }
            } else {
              isCompatible = true; // Backward compatibility
            }
            
            if (!isCompatible) {
              shouldShow = false;
            }
          }
          
          // 2b) A proprietary lug takes only straps made for it - see svFitsProprietaryLug.
          if (shouldShow && !svFitsProprietaryLug(product)) shouldShow = false;
          if (shouldShow && !svBundleUsable(product)) shouldShow = false;   // 3.92.3

          // 3. Check main category filter
          if (shouldShow && mainCategory && svFold(product.mainCategory) !== svFold(mainCategory)) {
            shouldShow = false;
          }
          
          // 4. Check sub category filter
          if (shouldShow && subCategory && svFold(product.subCategory) !== svFold(subCategory)) {
            shouldShow = false;
          }
          
          // 5. Check color filter
          if (shouldShow && selectedColor && !productHasColor(product, selectedColor)) {
            shouldShow = false;
          }

          // 6. QuickFit size match via variant titles
          if (shouldShow && currentWatchData && currentWatchData.lugWidth && /QuickFit/i.test((product.title || ''))) {
            const targetSizeNum = svLugMm(currentWatchData.lugWidth);   // 3.77.0: first "<n>mm", not every digit
            if (!isNaN(targetSizeNum)) {
              let hasMatchingVariant = false;
              if (product.variants && Array.isArray(product.variants)) {
                for (const variant of product.variants) {
                  const vSize = extractSizeFromVariantTitle(variant.title);
                  if (vSize && Number(vSize) === Number(targetSizeNum)) {
                    hasMatchingVariant = true;
                    break;
                  }
                }
              }
              if (!hasMatchingVariant) {
                shouldShow = false;
              }
            }
          }

          // 7. Customer's own watch with a stated strap width: hide straps that DO come in
          // sizes but not in theirs. Fails OPEN - a strap whose variants encode no size at all
          // stays visible, same rule the QuickFit check above uses. When they answered
          // "not sure", lugWidth is blank and every standard strap shows.
          if (shouldShow && currentWatchData && currentWatchData.isCustom && currentWatchData.lugWidth) {
            const wantW = svLugMm(currentWatchData.lugWidth);   // 3.77.0: first "<n>mm", not every digit
            if (!isNaN(wantW) && product.variants && Array.isArray(product.variants)) {
              let sawSize = false, sizeMatch = false;
              for (const variant of product.variants) {
                const vSize = extractSizeFromVariantTitle(variant.title);
                if (vSize) {
                  sawSize = true;
                  if (Number(vSize) === wantW) { sizeMatch = true; break; }
                }
              }
              if (sawSize && !sizeMatch) shouldShow = false;
            }
          }
        } else {
          shouldShow = false;
        }
        
        updates.push({ element, img, shouldShow });
      });

      // Apply all updates at once
      updates.forEach(({ element, img, shouldShow }) => {
        element.style.display = shouldShow ? (isListView ? "flex" : "block") : "none";
      });
        
        
        
        // Count visible straps
        const visibleCount = updates.filter(u => u.shouldShow).length;
        
        // Show/hide "no results" message
        showNoResultsMessage('strapsGrid', visibleCount === 0, 'straps');
        window.__svTrace && window.__svTrace.push('filter:done:visible:' + visibleCount);
        
        // Auto-select first visible strap if current selection is now hidden
        // Skip if suppressed (during view switches - selection is restored separately)
        if (suppressStrapAutoSelect) {
          return;
        }

        svRaf(() => {
          const strapsGrid = document.getElementById("strapsGrid");
          const currentSelectedStrap = strapsGrid.querySelector('img.selected');
          
          // Check if current selected strap is hidden or doesn't exist. Must go through
          // isStrapImgShown: in LIST view the filter hides the ROW, not the <img>, so testing
          // the image's own display said "still visible" and the stale selection survived.
          // That is why going from an Apple watch back to a normal one left the preview blank -
          // the Apple strap stayed selected on a hidden row, and the Apple/non-Apple guard in
          // performCombination cleared the canvas with nothing to replace it.
          if (!currentSelectedStrap || !isStrapImgShown(currentSelectedStrap)) {
            
            // Find first visible strap
            const firstVisibleStrap = Array.from(strapImgs).find(isStrapImgShown);
            
            if (firstVisibleStrap) {
              // Clear previous selection
              strapImgs.forEach(img => img.classList.remove('selected'));
              
              // Select first visible strap
              firstVisibleStrap.classList.add('selected');
              
              // Update strap details
              const chosenId = firstVisibleStrap.dataset.id;
              selectedStrapProduct = allStrapProducts.find(p => String(p.id) === String(chosenId));
              
              if (selectedStrapProduct) {
                currentStrapURL = svStrapUrl(selectedStrapProduct);
                showStrapDetails(selectedStrapProduct);
                
                // Combine with current watch if one is selected
                if (currentWatchData) {
                  combineImages();
                }
                
              }
            } else {
              // Clear strap selection + WIPE the stale composite (e.g. while Apple straps lazy-load,
              // or any filter that yields nothing) so a previously-composited strap doesn't linger.
              selectedStrapProduct = null;
              currentStrapURL = "";
              document.getElementById('strapDetails').style.display = 'none';
              const _fc = document.getElementById('finalCanvas');
              if (_fc) { const _x = _fc.getContext('2d'); if (_x) _x.clearRect(0, 0, _fc.width, _fc.height); }
              /* 3.76.0: for a watch we stock nothing for, the empty box next to "No straps for
                 this watch yet" read as a broken page - show the watch itself. Every OTHER
                 strapless moment here (a lazy-loading Apple range, a filter that matches nothing)
                 is transient and still clears, because a bare watch flashing mid-load would be
                 worse than a blank beat. */
              if (currentWatchData && currentWatchData.noStraps) svDrawWatchOnly();
            }
          } else {
            /* ⚠ 3.75.0: THE WIPE ABOVE IS ONE-WAY AND ONLY showStrapDetails() UNDOES IT. When the
               selection comes back into view after a window where nothing was visible - a pending
               collection, an Apple lazy-load, or (new) a watch we stock nothing for - the branch
               above is skipped because the selection is fine, so the inline display:none set by
               that wipe stayed on the buy card: a strap plainly selected, composited, and no card
               or Add to Cart under it. Reported by testing the no-straps watches, but the hole
               pre-dates them. */
            const _sd = document.getElementById('strapDetails');
            if (_sd && _sd.style.display === 'none' && currentSelectedStrap) {
              /* ⚠ The wipe nulls selectedStrapProduct but leaves the row's `.selected` class, so
                 by the time the row is visible again the product has to be recovered FROM THE ROW -
                 keying off selectedStrapProduct alone silently did nothing. */
              if (!selectedStrapProduct) {
                const _id = currentSelectedStrap.dataset.id;
                selectedStrapProduct = allStrapProducts.find(p => String(p.id) === String(_id)) || null;
              }
              if (selectedStrapProduct) {
                currentStrapURL = svStrapUrl(selectedStrapProduct);
                showStrapDetails(selectedStrapProduct);
                if (currentWatchData) combineImages();
              }
            }
          }
        });

    };
    // Hidden tabs freeze rAF; run the pass via timeout there so background loads still filter.
    if (immediate === true) { svFilterPass(); }
    else if (document.visibilityState === 'hidden') { setTimeout(svFilterPass, 32); }
    else { rafId = requestAnimationFrame(svFilterPass); }
  }

  /************************************************************************
   * 6) FETCH STRAPS
   ************************************************************************/
  // variants[].parentImages is a per-variant reference to the product's image array. It is
  // stripped before caching (JSON.stringify would otherwise duplicate the whole array once
  // PER VARIANT, ~10x cache bloat) and re-linked here after parse.
  /* STABLE IMAGE IDENTITY (3.61.0).
     `custom.visualiser_image_url` names the flat-lay by its CDN FILE instead of its gallery
     INDEX. An index is only valid for one particular gallery order, so uploading a new hero,
     reordering, or deleting any earlier media silently re-points every colour at its neighbour's
     photo - exactly how rose gold and black ended up showing each other (2026-08-23), and why a
     single-image swap has always meant rewriting every position on the product.
     The Apple path (custom.visualiser_image_url, per variant) has never had this problem; this
     brings the normal-watch path onto the same identifier.
     WARNING: POSITION IS STILL READ AS A FALLBACK and must stay that way until every product is
     backfilled - and permanently for the four QuickFit products whose variants have no image
     links to derive a URL from. URL first, index second, product default last. */
  function svImgKey(u) {
    if (!u) return '';
    // Last path segment only: it carries Shopify's uniqueness hash. Drop the query string, which
    // holds ?v= cache-busters and the ?width= that cdnSized appends.
    const s = String(u).split('?')[0].split('#')[0];
    const i = s.lastIndexOf('/');
    return (i >= 0 ? s.slice(i + 1) : s).toLowerCase();
  }

  /* Resolve a stored URL against the product's OWN media. Returns the gallery entry when the file
     is in the gallery, so everything downstream keeps operating on the same image objects.
     A URL that is not in the gallery is still honoured verbatim rather than dropped: a valid CDN
     file that simply is not attached to this product is a deliberate choice, not an error. */
  function svResolveImageUrl(images, url) {
    if (!url) return null;
    const k = svImgKey(url);
    if (!k) return null;
    const hit = (images || []).find(im => im && svImgKey(im.src) === k);
    return hit || { src: String(url) };
  }

  function relinkParentImages(products) {
    products.forEach(p => { if (p && Array.isArray(p.variants)) p.variants.forEach(v => { v.parentImages = p.images; }); });
  }

  /* Serve the cached list, then revalidate. On a resume that is the whole cold load gone.
     ⚠ The old v16 note said the key had to be BUMPED whenever straps were added to
     `visualiser-normal-watches`, because a warm cache never checked again (hit 2026-08-13 after
     167 straps were added: the API returned them and they still did not appear). That is no
     longer true - every page view revalidates a cache older than SV_CACHE_FRESH_MS and
     re-renders when the list differs. Still bump SV_STRAPS_KEY for a SHAPE change: a stale
     payload is read, not rejected. */
  async function fetchAllStraps() {
    if (SV_EMBED) return svEmbedFetchStraps();   // 3.94.0: the page's strap family, never the catalogue
    let cached = svCacheRead(SV_STRAPS_KEY);
    if (!cached) cached = await svIdbCacheRead(SV_STRAPS_KEY);   // 3.91.0: the big-list store
    if (cached && Array.isArray(cached.data) && cached.data.length) {
      relinkParentImages(cached.data);
      _svServedStrapSig = svStrapsSignature(cached.data);
      svApplePrefetchQuiet();               // nothing left to wait for: warm the Apple range now
      if (!cached.fresh) svRevalidateStraps();
      return cached.data;
    }
    /* 3.93.0: cold, and the watch is (about to be) known - fetch its own collection first. The
       early selection runs as soon as the watch feed has rendered (svEarlySelectWatch); if that
       takes longer than 5 s, or there is no watch, fall through to the full catalogue as before. */
    let handle = '';
    try {
      handle = await Promise.race([_svEarlyWatchHandle, new Promise(r => setTimeout(() => r(''), 5000))]);
    } catch (e) { handle = ''; }
    if (handle && handle !== 'visualiser-normal-watches') {
      _svStrapsLoadMode = 'watch';
      let first = null;
      try { first = await svFetchStrapsNetwork({ handle: handle }); } catch (e) { first = null; }
      _svStrapsLoadMode = '';
      if (first && first.length) {
        _svWatchFirst = { handle: handle };
        svRegisterCollectionSet(handle, first.map(p => p.handle));
        _svFullStrapsPending = true;
        window.__svTrace && window.__svTrace.push('straps:watch-first:' + handle + ':' + first.length);
        svFetchStrapsNetwork({ background: true }).then(full => {
          if (!full || !full.length) return;
          _svServedStrapSig = svStrapsSignature(full);
          if (!_svFinalStrapRender) { _svPendingFreshStraps = full; return; }
          svApplyFreshStraps(full);
          svRetryInitialStrap();
        }).catch(e => console.warn('Full strap fetch failed', e))
          .finally(() => {
            _svFullStrapsPending = false;
            // Re-judge the empty state: a watch waiting on the full list may now have its straps
            // (or, on a failure, must stop showing the spinner).
            try { if (_svFinalStrapRender) filterStrapsByAllCategories(true); } catch (e) {}
          });
        return first;
      }
    }
    return svFetchStrapsNetwork();
  }

  /* 3.94.0: ONE Storefront product node -> the engine's strap record. Lifted out of the page loop
     so the embed's family fetch shapes its products through exactly the same code. */
  function svShapeStrapNode(product) {
          
          const strapTypeMetafield = product.metafields?.find(
            metafield => metafield && metafield.namespace === "custom" && metafield.key === "strap_type"
          );
          
          const watchTypeMetafield = product.metafields?.find(
            metafield => metafield && metafield.namespace === "custom" && metafield.key === "watch_type"
          );
          
          const visualiserImagePositionMetafield = product.metafields?.find(
            metafield => metafield && metafield.namespace === "custom" && metafield.key === "visualiser_image_position"
          );

          const visualiserImageUrlMetafield = product.metafields?.find(
            metafield => metafield && metafield.namespace === "custom" && metafield.key === "visualiser_image_url"
          );

          const subCategoryMetafield = product.metafields?.find(
            metafield => metafield && metafield.namespace === "custom" && metafield.key === "visualiser_product_sub_category"
          );

          const colorMetafield = product.metafields?.find(
            metafield => metafield && metafield.namespace === "custom" && metafield.key === "strap_colour"
          );
          
          let strapTypes = [];
          if (strapTypeMetafield && strapTypeMetafield.value) {
            try {
              strapTypes = JSON.parse(strapTypeMetafield.value);
            } catch (e) {
            }
          }

          // Parse watch type information
          let watchType = null;
          if (watchTypeMetafield && watchTypeMetafield.value) {
            const rawValue = watchTypeMetafield.value.trim();
            try {
              // Try to parse as JSON array first
              const parsedArray = JSON.parse(rawValue);
              if (Array.isArray(parsedArray) && parsedArray.length > 0) {
                watchType = parsedArray; // Store as array for flexible matching
              } else {
                watchType = rawValue; // Fallback to string
              }
            } catch (e) {
              // If JSON parsing fails, treat as plain string
              watchType = rawValue;
            }
          } else {
            // Default to "Quick Release" if watch_type metafield is empty or missing
            watchType = ["Quick Release"];
          }

          // Parse sub-category information
          let productSubCategory = null;
          let mainCategory = null;
          let subCategory = null;
          if (subCategoryMetafield && subCategoryMetafield.value) {
            productSubCategory = subCategoryMetafield.value.trim();
            const parts = productSubCategory.split(' - ');
            if (parts.length >= 2) {
              mainCategory = parts[0].trim();
              subCategory = parts[1].trim();
            } else if (parts.length === 1 && productSubCategory) {
              // If there's no " - " separator, try other common separators
              const altParts = productSubCategory.split(/[-– - ]/); // Try different dash types
              if (altParts.length >= 2) {
                mainCategory = altParts[0].trim();
                subCategory = altParts[1].trim();
              } else {
                // If no separator at all, treat the whole value as both main and sub category
                // This ensures the product still appears in the dropdown
                mainCategory = productSubCategory;
                subCategory = productSubCategory;
              }
            }
          }

          // Parse color information
          let strapColor = null;
          if (colorMetafield && colorMetafield.value) {
            strapColor = colorMetafield.value.trim();
          }

          // Determine which image to use based on visualiser_image_position metafield
          let visualiserImagePosition = 0;
          if (visualiserImagePositionMetafield && visualiserImagePositionMetafield.value) {
            const position = parseInt(visualiserImagePositionMetafield.value, 10);
            if (!isNaN(position) && position >= 0) {
              visualiserImagePosition = position;
            }
          }

          // Get all images
          const allImages = product.images.edges.map(img => ({ src: img.node.src }));
          
          // Process variants first to get their override images
          const processedVariants = product.variants.edges.map(variant => {
              // Check for variant-level visualiser_image_position metafield
              const variantVisualiserMetafield = variant.node.metafields?.find(
                mf => mf && mf.namespace === "custom" && mf.key === "visualiser_image_position"
              );
              
              let variantVisualiserImagePosition = null;
              if (variantVisualiserMetafield && variantVisualiserMetafield.value) {
                const position = parseInt(variantVisualiserMetafield.value, 10);
                if (!isNaN(position) && position >= 0) {
                  variantVisualiserImagePosition = position;
                }
              }

              // Stable identifier; wins over the position when present (see svResolveImageUrl).
              const variantVisualiserUrlMf = variant.node.metafields?.find(
                mf => mf && mf.namespace === "custom" && mf.key === "visualiser_image_url"
              );
              const variantVisualiserImageUrl =
                (variantVisualiserUrlMf && variantVisualiserUrlMf.value) || null;

              return {
                id: variant.node.id.split('/').pop(),
                title: variant.node.title,
                price: variant.node.price.amount,
                availableForSale: variant.node.availableForSale,
                image: variant.node.image?.src || "",
                visualiserImagePosition: variantVisualiserImagePosition,
                visualiserImageUrl: variantVisualiserImageUrl,
                parentImages: allImages // Store reference to parent product images
              };
            });

          /* Product thumbnail, in descending order of trust. The variant tiers come before the
             product tiers because that is the order this has always resolved in; only the URL
             steps are new, and they are no-ops for a product that has not been backfilled. */
          let productVisualiserImage = null;
          const firstVariant = processedVariants[0];
          if (firstVariant) {
            // 1. first variant's stable URL
            productVisualiserImage = svResolveImageUrl(allImages, firstVariant.visualiserImageUrl);
            // 2. first variant's gallery index
            if (!productVisualiserImage && firstVariant.visualiserImagePosition !== null) {
              productVisualiserImage = allImages[firstVariant.visualiserImagePosition] || allImages[0];
            }
          }
          // 3. product-level stable URL
          if (!productVisualiserImage) {
            productVisualiserImage = svResolveImageUrl(allImages, visualiserImageUrlMetafield && visualiserImageUrlMetafield.value);
          }
          // 4. product-level gallery index, then image 0
          if (!productVisualiserImage) {
            productVisualiserImage = allImages[visualiserImagePosition] || allImages[0];
          }

          return {
            id: product.id.split('/').pop(),
            title: product.title,
            handle: product.handle,
            images: allImages,
            visualiserImage: productVisualiserImage,
            // 3.92.3: whether the product NAMES its visualiser picture. A bundle with no kit photo
            // and no named cut-out would otherwise draw images[0] - its adapter shot, or an
            // on-watch photo - as the strap ([Galaxy Watch 8-9/Ultra] Ultra Militex - Army Green,
            // Alpha Militex - Army Green: "some ultra militex are just the adapter").
            visUrlSet: !!(visualiserImageUrlMetafield && visualiserImageUrlMetafield.value),
            variants: processedVariants,
            strapTypes: strapTypes,
            watchType: watchType,
            visualiserImagePosition: visualiserImagePosition,
            productSubCategory: productSubCategory,
            mainCategory: mainCategory,
            subCategory: subCategory,
            strapColor: strapColor,
            // Per-product override: this flat-lay is laid out end-for-end relative to the rest of
            // the range, so rotate it before splitting. See svStrapRotate180 in performCombination.
            rotate180: (() => {
              const m = product.metafields?.find(x => x && x.namespace === "custom" &&
                                                      x.key === "visualiser_strap_rotate_180");
              const v = m && m.value;
              return v === "true" || v === "1";
            })(),
            /* Per-product override: this flat-lay is ONE continuous strap laid corner to corner
               (both arms joined by their clasp), not two arms side by side. Rendered by the
               normal rules it comes out diagonal. See svSingleDiagonalArms in performCombination. */
            singleDiagonal: (() => {
              const m = product.metafields?.find(x => x && x.namespace === "custom" &&
                                                      x.key === "visualiser_strap_single_diagonal");
              const v = m && m.value;
              return v === "true" || v === "1";
            })(),
            /* Per-product WIDTH correction, applied to both arm scales.
               The arm width is measured from the two extreme points of the arm's end, which is
               right for a strap of even width. It under-reads on a flat-lay whose end is a
               different width from its body - the Acetate Bangle has a wide end plate and a
               narrow band and rendered at 0.387 of the case where 0.476 is correct for a 20mm
               strap on a 42mm watch, while the Crystalised Acetate, even-width and shot the same
               way, measured 0.482 on the SAME watch.
               This is the strap-side twin of the per-watch "scale top"/"scale bottom" CSV
               overrides. 1 = no change; clamped to 0.3-2.5 like those, so a stray value cannot
               blow the canvas past the browser's 16384px cap. */
            strapScale: (() => {
              const m = product.metafields?.find(x => x && x.namespace === "custom" &&
                                                      x.key === "visualiser_strap_scale");
              const n = parseFloat(m && m.value);
              return isFinite(n) ? Math.max(0.3, Math.min(2.5, n)) : 1;
            })(),
            // Staff adjust-mode override (custom.visualiser_adjust, JSON). Bad JSON is ignored
            // rather than thrown, so a hand-edited metafield can never blank the visualiser.
            adjust: (() => {
              const m = product.metafields?.find(x => x && x.namespace === "custom" &&
                                                      x.key === "visualiser_adjust");
              if (!m || !m.value) return null;
              try { return JSON.parse(m.value); } catch (e) { return null; }
            })(),
            options: product.options || [], // Store variant options (e.g., [{name: "Colour", values: [...]}, {name: "Garmin Watch", values: [...]}])
            // 3.90.0: kept for the proprietary-lug check below. The feed already reads tags to
            // find the `visualiser` gate; this just stops throwing them away afterwards.
            tags: product.tags || []
          };
  }

  /* opts.handle: fetch ONE collection (watch-first) - not cached, not painted as "the catalogue",
     and filtered to `visualiser`-tagged products, which is the rule the visualiser-normal-watches
     smart collection applies for the full list. opts.background: accumulate silently - no partial
     paints - the caller swaps the finished list in. */
  async function svFetchStrapsNetwork(opts) {
    const collHandle = (opts && opts.handle) || 'visualiser-normal-watches';
    const watchFirst = !!(opts && opts.handle);
    const background = !!(opts && opts.background);
    // Fetch all products with pagination support
    let allProducts = [];
    let hasNextPage = true;
    let cursor = null;
    const apiUrl = "https://strapifyau.myshopify.com/api/2024-01/graphql.json";

    try {
      while (hasNextPage) {
        // Build query with optional cursor for pagination
        const afterParam = cursor ? `, after: "${cursor}"` : '';
        const query = `query {
          collection(handle: "${collHandle}") {
            products(first: 250${afterParam}) {
              edges {
                node {
                  ${SV_STRAP_NODE_FIELDS}
                }
              }
              pageInfo {
                hasNextPage
                endCursor
              }
            }
          }
        }`;

        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': '25c76973f9450c7f447913861a934097'
          },
          body: JSON.stringify({ query })
        });

        const data = await response.json();
        
        if (data.errors) {
          break;
        }
        
        if (!data.data?.collection) {
          break;
        }
        
        /* ⚠ TRUST THE TAG, NOT THE COLLECTION INDEX (2026-08-21). Shopify's smart-collection
           index for visualiser-normal-watches held 240 members whose `visualiser` tag was long
           gone, and 44 of them survived every reindex trigger (tag add/remove cycle, ruleSet
           touch, even a DRAFT->ACTIVE status cycle) - corrupt index rows on Shopify's side.
           The collection's ONE rule is TAG = visualiser, so the tag IS the intent; requiring it
           here makes the visualiser immune to the index lying. Products with the tag but not
           yet indexed into the collection still won't appear (we never see them) - that
           direction has always been reindex-lag and resolves itself. */
        const svTaggedEdges = data.data.collection.products.edges.filter(edge =>
          Array.isArray(edge.node && edge.node.tags) &&
          edge.node.tags.some(t => String(t).trim().toLowerCase() === 'visualiser'));
        const products = svTaggedEdges.map(edge => svShapeStrapNode(edge.node));

        // 3.93.0: a watch's own collection holds everything we sell for it; only the straps the
        // visualiser gate (the `visualiser` tag) admits belong in the list.
        allProducts = allProducts.concat(watchFirst
          ? products.filter(p => (p.tags || []).some(t => svFold(t) === 'visualiser'))
          : products);
        if (!watchFirst) svStrapsProgress(allProducts.length);   // 3.92.3

        // Paint this page now rather than waiting for the last one (see svRenderStrapsPartial).
        if (!background && _svStrapUiReady && !_svFinalStrapRender) svRenderStrapsPartial(allProducts);

        // Update pagination state
        const pageInfo = data.data.collection.products.pageInfo;
        hasNextPage = pageInfo.hasNextPage;
        cursor = pageInfo.endCursor;


      }

      // All pages fetched OK - cache the processed list. parentImages is stripped (a back-
      // reference rebuilt on read by relinkParentImages, and it doubles the payload).
      if (allProducts.length && !watchFirst) {
        try { localStorage.setItem('sv_straps_n', String(allProducts.length)); } catch (e) {}   // 3.92.3: next visit's progress total
        svCacheWriteBig(SV_STRAPS_KEY, allProducts, (k, v) => k === 'parentImages' ? undefined : v);
      }

      /* Warm the Apple range now - after the last page, before the render and long before any
         Apple watch is clicked.
         ⚠ DO NOT move this back inside the loop to overlap the two fetches. Measured on the
         preview theme 2026-09-09: run concurrently, Shopify's Storefront throttle slows BOTH
         (first page 3.0s -> 4.3s, later pages 0.3s -> 2.2s) and data-ready went 8.7s -> 13.2s.
         The two fetches share one token bucket, so parallelism here costs rather than pays. */
      if (!watchFirst) svApplePrefetchQuiet();   // 3.93.0: after the FULL list, never the watch-first page

    } catch (error) {
      console.error('Strap fetch failed:', error);
    }

    return allProducts;
  }

  // Visible failure + one-tap retry when the strap fetch returns nothing (e.g. a flaky
  // mobile connection). Anything beats a silently empty page.
  function showStrapLoadError() {
    const grid = document.getElementById('strapsGrid');
    if (!grid) return;
    grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:30px 12px;color:#666;font-size:.9rem;">Couldn\'t load the strap list.<br><button type="button" id="svStrapRetryBtn" style="margin-top:10px;padding:8px 18px;border:1px solid #b2955f;border-radius:8px;background:#fff;color:#563818;font-weight:600;cursor:pointer;">Try again</button></div>';
    const b = document.getElementById('svStrapRetryBtn');
    if (b) b.addEventListener('click', async () => {
      b.disabled = true; b.textContent = 'Loading…';
      allStrapProducts = await fetchAllStraps();
      if (allStrapProducts && allStrapProducts.length) {
        setupCategoryDropdowns();
        renderStraps(allStrapProducts);
        filterStrapsByAllCategories(true);   // straight after a render: never defer the hide
      } else {
        b.disabled = false; b.textContent = 'Try again';
      }
    });
  }



  /************************************************************************
   * APPLE STRAPS - fetched lazily (only when an Apple watch is picked). Apple straps live in the
   * "apple" collection (not visualiser-normal-watches) and their visualiser image is a Files URL
   * in the per-variant custom.visualiser_image_url metafield, not a gallery index. We keep only
   * the straps that actually have a published image and give them watch_type ["Apple"] so the
   * existing compatibility filter shows them ONLY for the Apple watch.
   ************************************************************************/
  let _appleStrapsLoaded = false;    // a fetch has been STARTED (re-entry guard)
  let _appleStrapsReady = false;     // the straps are actually in allStrapProducts
  let _appleFetchFailed = false;     // last attempt failed - show the retry box, not "no straps"
  async function fetchAppleStraps() {
    const apiUrl = "https://strapifyau.myshopify.com/api/2024-01/graphql.json";
    const out = [];
    let hasNext = true, cursor = null;
    while (hasNext) {
      const after = cursor ? `, after: "${cursor}"` : '';
      const query = `query { collection(handle: "apple") { products(first: 250${after}) { edges { node {
        id title handle options { name values }
        metafields(identifiers: [
          {namespace:"custom",key:"visualiser_product_sub_category"},
          {namespace:"custom",key:"strap_type"},
          {namespace:"custom",key:"strap_colour"},
          {namespace:"custom",key:"visualiser_strap_scale"},
          {namespace:"custom",key:"visualiser_strap_single_diagonal"},
          {namespace:"custom",key:"visualiser_adjust"}
        ]) { value key namespace }
        variants(first: 100) { edges { node { id title price { amount currencyCode } availableForSale image { src }
          selectedOptions { name value }
          metafields(identifiers: [{namespace:"custom",key:"visualiser_image_url"}]) { value key namespace } } } }
      } } pageInfo { hasNextPage endCursor } } } }`;
      const res = await fetch(apiUrl, { method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': '25c76973f9450c7f447913861a934097' },
        body: JSON.stringify({ query }) });
      const data = await res.json();
      const coll = data && data.data && data.data.collection;
      if (!coll) break;
      for (const edge of coll.products.edges) {
        const p = edge.node;
        const vUrl = v => { const m = (v.metafields || []).find(mf => mf && mf.key === 'visualiser_image_url'); return (m && m.value) || null; };
        const variantsRaw = p.variants.edges.map(e => e.node);
        let url = null;
        for (const v of variantsRaw) { const u = vUrl(v); if (u) { url = u; break; } }
        if (!url) continue;   // only Apple straps that actually have a published visualiser image

        // PER-COLOUR PREVIEWS. Every distinct visualiser_image_url on the product is kept, and each
        // variant points at the image for ITS OWN colour - so the Strap Colour dropdown actually
        // changes the picture. (It used to give every variant the first image found, which is why a
        // 25-colour Sports Loop previewed as one colour and the graded Armour colourways never drew.)
        // Keyed on EVERY APPEARANCE OPTION, not the variant: the size axis is excluded (both sizes
        // must show the same photo, and size variants are inconsistently tagged), everything else
        // is part of the key.
        // ⚠ 3.79.0: this used to key on the COLOUR option alone, on the audited assumption that
        // "all variants sharing a colour carry the same url". A THIRD axis breaks that, because the
        // colour values repeat under every value of it, so the first one read claimed the colour and
        // the rest silently drew its image: [Apple Watch] Floral Silicone (Design = Wildflower /
        // Sunflower / Butterfly x 8 colours) showed Wildflower for all 24 combos, and Vogue Leather
        // Link (Hardware Colour = Gold / Silver) showed Gold for both. Both carry a correct, distinct
        // image on every variant - the data was never the problem. Don't narrow this back to colour.
        // ⚠ index 0 stays the product-level image, because product.visualiserImage and every
        // non-Apple code path assume the position is an index into this same array.
        const SV_SIZE_OPT = /size|model/i;
        const appearanceKey = v => {
          const opts = (v.selectedOptions || []).filter(o => o && !SV_SIZE_OPT.test(o.name || ''));
          // No non-size option at all (single-colour products) -> one key for the whole product.
          return opts.map(o => String(o.name) + '=' + String(o.value)).join('|');
        };
        const urlByColour = new Map();
        for (const v of variantsRaw) {
          const u = vUrl(v), k = appearanceKey(v);
          if (u && !urlByColour.has(k)) urlByColour.set(k, u);
        }
        const allImages = [{ src: url }];
        const _imgPos = new Map([[url, 0]]);
        // Colours with no image of their own (6 products in the collection) fall back to the
        // product image rather than dropping out of the preview entirely.
        const imagePosFor = v => {
          const u = urlByColour.get(appearanceKey(v)) || url;
          if (!_imgPos.has(u)) { _imgPos.set(u, allImages.length); allImages.push({ src: u }); }
          return _imgPos.get(u);
        };
        const mf = k => { const m = (p.metafields || []).find(x => x && x.key === k); return (m && m.value) || null; };
        let mainCategory = null, subCategory = null; const sub = mf('visualiser_product_sub_category');
        if (sub) { const parts = sub.split(' - '); mainCategory = (parts[0] || sub).trim(); subCategory = (parts[1] || parts[0] || sub).trim(); }
        let strapTypes = []; try { strapTypes = JSON.parse(mf('strap_type') || '[]'); } catch (e) {}
        const variants = variantsRaw.map(v => ({
          id: v.id.split('/').pop(), title: v.title, price: v.price.amount,
          availableForSale: v.availableForSale, image: (v.image && v.image.src) || "",
          visualiserImagePosition: imagePosFor(v), parentImages: allImages
        }));
        out.push({
          id: p.id.split('/').pop(), title: p.title, handle: p.handle,
          images: allImages, visualiserImage: { src: url }, variants,
          strapTypes: strapTypes, watchType: ["Apple"], visualiserImagePosition: 0,
          productSubCategory: sub, mainCategory, subCategory, strapColor: mf('strap_colour'),
          // Same per-product render fields the non-Apple feed carries (3.34.0). Without them
          // every Apple strap rendered at scale 1 with no adjust - the Acetate Bangle's body
          // is ~1/3 of its Apple plate, so it drew as a 0.22-case-width thread.
          singleDiagonal: (() => { const v = mf('visualiser_strap_single_diagonal'); return v === 'true' || v === '1'; })(),
          strapScale: (() => { const n = parseFloat(mf('visualiser_strap_scale')); return isFinite(n) ? Math.max(0.3, Math.min(2.5, n)) : 1; })(),
          adjust: (() => { const v = mf('visualiser_adjust'); if (!v) return null; try { return JSON.parse(v); } catch (e) { return null; } })(),
          options: p.options || [], isApple: true
        });
      }
      hasNext = coll.products.pageInfo.hasNextPage; cursor = coll.products.pageInfo.endCursor;
    }
    return out;
  }
  /************************************************************************
   * WATCH COLLECTION RESTRICTION - each watch row in the CRM watch catalogue carries a
   * collection_link (the "View all straps" collection for that watch). The strap grid is
   * restricted to the products in THAT collection, so a watch only ever offers straps that
   * are actually sold for it. Fetches just the handles (cheap), cached per collection.
   * Fails OPEN: if the collection can't be loaded or is empty, no restriction is applied.
   ************************************************************************/
  const _watchCollCache = {};   // collection handle -> Set(product handle) | 'failed'

  function collectionHandleFromLink(link) {
    if (!link) return "";
    const m = String(link).match(/\/collections\/([^\/?#]+)/i);
    return m ? decodeURIComponent(m[1]).trim().toLowerCase() : "";
  }

  async function fetchCollectionProductHandles(handle) {
    const apiUrl = "https://strapifyau.myshopify.com/api/2024-01/graphql.json";
    const handles = [];
    let hasNext = true, cursor = null;
    while (hasNext) {
      const after = cursor ? `, after: "${cursor}"` : '';
      const query = `query { collection(handle: "${handle}") { products(first: 250${after}) {
        edges { node { handle } } pageInfo { hasNextPage endCursor } } } }`;
      const res = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': '25c76973f9450c7f447913861a934097' },
        body: JSON.stringify({ query })
      });
      const data = await res.json();
      const coll = data?.data?.collection;
      if (!coll) break;                       // unknown handle -> no restriction
      coll.products.edges.forEach(e => { if (e.node?.handle) handles.push(e.node.handle); });
      hasNext = coll.products.pageInfo.hasNextPage;
      cursor = coll.products.pageInfo.endCursor;
    }
    return handles;
  }

  async function ensureWatchCollection(handle) {
    if (!handle) return null;
    if (SV_EMBED) {
      /* 3.94.0: the rail holds one strap family, so "is this strap in the watch's collection" is
         answered by the family products' own `collections` (svFetchStrapFamily) - not by paging
         the collection's 700 handles. A collection none of them is in gets a NON-EMPTY sentinel
         set: the filter treats an empty set as "unrestricted", which would show the strap. */
      try { await _svEmbedFamilyPromise; } catch (e) {}
      return (_svEmbedCollSets && _svEmbedCollSets[handle]) || _svEmbedNoneSet;
    }
    const cached = _watchCollCache[handle];
    if (cached) return cached === 'failed' ? null : cached;

    // Persistent (3.69.0) - this set gates what the customer can see, so paying 1-2 GraphQL
    // round trips for it on every visit is exactly the wait we are trying to remove.
    // ⚠ Bump SV_COLL_SUFFIX (not this line) to invalidate every collection set at once; the
    // sweep at the top of the file clears whatever the previous suffix left behind.
    const CK = 'sv_coll_' + handle + SV_COLL_SUFFIX;
    const cachedArr = svCacheRead(CK);
    if (cachedArr && Array.isArray(cachedArr.data) && cachedArr.data.length) {
      _watchCollCache[handle] = new Set(cachedArr.data);
      if (!cachedArr.fresh) {
        // Serve now, refresh for next time. A membership change is a catalogue edit, not
        // something to make this customer wait on.
        fetchCollectionProductHandles(handle).then(arr => {
          if (arr && arr.length) {
            svCacheWrite(CK, arr);
            _watchCollCache[handle] = new Set(arr);
          }
        }).catch(() => {});
      }
      return _watchCollCache[handle];
    }

    try {
      const arr = await fetchCollectionProductHandles(handle);
      if (arr.length) {
        _watchCollCache[handle] = new Set(arr);
        svCacheWrite(CK, arr);
        return _watchCollCache[handle];
      }
    } catch (e) {
      console.warn('Watch collection fetch failed:', handle, e);
    }
    _watchCollCache[handle] = 'failed';   // fail open, don't retry every click
    return null;
  }

  // APPLE_CACHE_KEY and the prefetch live in the persistent-cache block at the top of the file:
  // they are read by fetchAllStraps, which runs at parse time, long before this line executes.
  // Loading spinner in the strap grid while the (first-time) Apple fetch runs, instead of the
  // "no matching straps" empty state + a lingering non-Apple composite.
  function showApplesLoading(on) {
    window.__applesLoading = !!on;
    const grid = document.getElementById('strapsGrid');
    if (!grid) return;
    if (on && !document.getElementById('sv-apple-spin-style')) {
      const st = document.createElement('style'); st.id = 'sv-apple-spin-style';
      st.textContent = '@keyframes svspin{to{transform:rotate(360deg)}}'; document.head.appendChild(st);
    }
    let el = document.getElementById('strapsGrid-apples-loading');
    if (on) {
      if (!el) {
        el = document.createElement('div');
        el.id = 'strapsGrid-apples-loading';
        el.style.cssText = 'grid-column:1/-1;width:100%;display:flex;justify-content:center;align-items:center;min-height:200px;';
        el.innerHTML = '<div style="text-align:center;padding:40px 20px;color:#666;"><div style="width:34px;height:34px;border:3px solid #eee;border-top-color:#b2955f;border-radius:50%;margin:0 auto 14px;animation:svspin .8s linear infinite;"></div><h3 style="margin:0 0 6px;color:#333;font-size:1.05rem;">Loading Apple Watch straps…</h3><p style="margin:0;font-size:.9rem;">One moment</p></div>';
        grid.appendChild(el);
      }
      el.style.display = 'flex';
      showNoResultsMessage('strapsGrid', false, 'straps');
    } else if (el) { el.style.display = 'none'; }
  }
  async function ensureAppleStraps() {
    if (SV_EMBED) return;   // 3.94.0: the family IS the list - an Apple watch on a spring-bar strap page gets the no-fit notice
    if (_appleStrapsLoaded) return;
    _appleStrapsLoaded = true;
    try {
      // Usually already resolved: prefetched during the main strap fetch (svApplePrefetch).
      const apple = await svApplePrefetch();
      if (apple && apple.length) {
        // Tagged so a background catalogue swap can keep them (see svApplyFreshStraps).
        apple.forEach(s => { s.__svApple = true; });
        allStrapProducts = (allStrapProducts || []).concat(apple);
        _appleStrapsReady = true;
        _appleFetchFailed = false;
        setupCategoryDropdowns();
        renderStraps(allStrapProducts);
        // The caller filters too, but that is a promise tick away - hide the freshly rendered
        // (and initially all-visible) rows now so the newly added straps can't flash through.
        filterStrapsByAllCategories(true);
      } else {
        // Reached the endpoint but got nothing back: treat it as a failure, not as "this watch
        // genuinely has no straps" - every Apple watch has straps.
        throw new Error('Apple strap fetch returned nothing');
      }
    } catch (e) {
      _appleStrapsLoaded = false;   // let the next Apple selection retry
      _appleDataPromise = null;     // ... including the prefetched promise
      _appleFetchFailed = true;
      console.error('Apple strap fetch failed', e);
      showAppleStrapsError();
    }
  }

  // Shown instead of "No matching straps found" when the Apple range could not be fetched: that
  // message blames the customer's filters for what is actually a failed request, and leaves them
  // with nothing to do about it.
  function showAppleStrapsError() {
    const grid = document.getElementById('strapsGrid');
    if (!grid) return;
    showApplesLoading(false);
    let el = document.getElementById('strapsGrid-apples-error');
    if (!el) {
      el = document.createElement('div');
      el.id = 'strapsGrid-apples-error';
      el.style.cssText = 'grid-column:1/-1;width:100%;display:flex;justify-content:center;align-items:center;min-height:200px;';
      el.innerHTML = '<div style="text-align:center;padding:40px 20px;color:#666;">' +
        '<h3 style="margin:0 0 8px;color:#333;font-size:1.05rem;">Couldn\'t load the Apple Watch straps</h3>' +
        '<p style="margin:0 0 14px;font-size:.9rem;">Check your connection and try again.</p>' +
        '<button type="button" id="svAppleRetry" style="padding:8px 18px;border:1px solid #b2955f;border-radius:8px;' +
        'background:#b2955f;color:#fff;font-size:.9rem;cursor:pointer;">Retry</button></div>';
      grid.appendChild(el);
      el.querySelector('#svAppleRetry').addEventListener('click', () => {
        hideAppleStrapsError();
        _appleFetchFailed = false;
        showApplesLoading(true);
        ensureAppleStraps().then(() => { showApplesLoading(false); filterStrapsByAllCategories(true); });
      });
    }
    el.style.display = 'flex';
  }
  /* Honest empty state for a watch the catalogue has nothing for (see svWatchHasNoStraps).
     Deliberately offers the two things that are actually useful: tell us, or try the customer's
     own photo, which is not restricted to a collection. */
  function svShowNoStrapsNotice(on) {
    // The class both hides the buy card (see the guard CSS) and marks the state for anything else.
    try { document.body.classList.toggle('sv-nostraps', !!on); } catch (e) {}
    const grid = document.getElementById('strapsGrid');
    if (!grid) return;
    let el = document.getElementById('strapsGrid-nostraps');
    if (!on) { if (el) el.style.display = 'none'; return; }
    if (!el) {
      el = document.createElement('div');
      el.id = 'strapsGrid-nostraps';
      el.style.cssText = 'grid-column:1/-1;width:100%;display:flex;justify-content:center;align-items:center;min-height:200px;';
      el.innerHTML = '<div style="text-align:center;padding:36px 20px;color:#666;max-width:340px;">' +
        '<h3 style="margin:0 0 8px;color:#333;font-size:1.05rem;">No straps for this watch yet</h3>' +
        '<p style="margin:0 0 14px;font-size:.9rem;line-height:1.45;">We don\'t stock a strap that fits this model at the moment. Tell us which one you have and we\'ll let you know when we do.</p>' +
        '<a href="/pages/contact" style="display:inline-block;padding:9px 18px;border:1px solid #b2955f;border-radius:8px;background:#b2955f;color:#fff;font-size:.9rem;font-weight:600;text-decoration:none;">Get in touch</a>' +
        '</div>';
      grid.appendChild(el);
    }
    el.style.display = 'flex';
  }

  function hideAppleStrapsError() {
    const el = document.getElementById('strapsGrid-apples-error');
    if (el) el.style.display = 'none';
  }

  /************************************************************************
   * 8) RENDER STRAPS - BEAST MODE OPTIMIZED
   ************************************************************************/
  // Global variables for current rendering state
  let currentStrapProducts = [];
  let optimizedPlaceholder = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImciIHgxPSIwJSIgeTE9IjAlIiB4Mj0iMTAwJSIgeTI9IjEwMCUiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNmNWY1ZjUiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNlZWVlZWUiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0idXJsKCNnKSIvPjwvc3ZnPg==';

  // Pulled from the visualiser at the owner's request (imagery not ready, 2026-08-16):
  // [Quick Release] Steel Bracelet (Gold / Rose Gold / Silver) - Deployment Clasp 3.
  // Their `visualiser` tag is already gone; this covers Shopify's collection-index lag.
  const SV_EXCLUDED_PRODUCT_IDS = new Set(['4782398865482', '4782383595594', '4553600204874']);

  function renderStraps(products) {
    // Prevent race condition - ensure we have complete product data
    if (!products || products.length === 0) {
      return;
    }
    products = products.filter(p => !SV_EXCLUDED_PRODUCT_IDS.has(String(p.id)));
    
    // Additional safety check - ensure products are fully loaded
    if (!allStrapProducts || allStrapProducts.length === 0) {
      setTimeout(() => renderStraps(products), 100);
      return;
    }
    
    const strapsGrid = document.getElementById("strapsGrid");
    strapsGrid.innerHTML = "";
    _strapsRendered = true;   // rows exist now, so an empty result really is "no match"
    try { window.__svStrapsRendered = true; } catch (e) {}   // readable from the console

    // Pre-filter and optimize products
    const validProducts = products.filter(product => {
      
      if (!product.visualiserImage) {
        return false;
      }
      
      const linkLower = product.visualiserImage.src.toLowerCase();
      const isValidFormat = linkLower.includes(".png") || linkLower.includes(".webp") || linkLower.includes(".jpg") || linkLower.includes(".jpeg");
      
      if (!isValidFormat) {
        return false;
      }
      
      return true;
    });

    // Sort products alphabetically (removing bracket prefixes for sorting)
    const sortedProducts = sortProductsAlphabetically([...validProducts]);

    // Store current products for filtering
    currentStrapProducts = sortedProducts;

    // Remove list-view class initially
    strapsGrid.classList.remove('list-view');

    // Render based on current view mode (Note: On mobile, view toggle is hidden, so always grid)
    const isMobile = window.innerWidth <= 768;
    if (currentStrapViewMode === 'list') {
      strapsGrid.classList.add('list-view');
      renderStrapsList(sortedProducts, strapsGrid, optimizedPlaceholder);
    } else {
      renderStrapsRegular(sortedProducts, strapsGrid, optimizedPlaceholder);
    }
  }
  
  function renderStrapsRegular(validProducts, strapsGrid, placeholder) {
    const fragment = document.createDocumentFragment();

    validProducts.forEach((product, index) => {
      const img = createOptimizedImage(product, placeholder, index);
      fragment.appendChild(img);
    });

    strapsGrid.appendChild(fragment);
  }
  
  // Connector/type label for a strap, from the custom.watch_type metafield
  // (e.g. "Quick Release", "Apple", "QuickFit"). Used as the strap list's top label.
  function getStrapTypeLabel(product) {
    /* 3.90.6: an adapter bundle is labelled by the family in its own title ("[Pixel Watch 3-5
       45mm]", "[Galaxy Watch 8-9/Ultra]"), not by the watch_type choice it is gated on. Until 18 Sep
       every Pixel bundle was typed "Quick Release" and the Pixel rows were blank (= Quick Release):
       the straps shown were right by accident and every row said QUICK RELEASE. The bundles are now
       typed "Google" and the rows "Google" - an existing choice, because the definition's choice
       list cannot be edited while a smart collection rules on the field - and the label comes from
       the title, which says exactly which watches the bundle is for. */
    if (product && svBundleOptName(product)) {
      const m = /^\s*\[([^\]]+)\]/.exec(product.title || '');
      if (m) return m[1].trim();
    }
    let t = product && product.watchType;
    if (Array.isArray(t)) t = t.filter(Boolean).join(' · ');
    return (t == null ? '' : String(t)).trim();
  }

  // True only if a strap <img> is actually visible. In list view the display
  // toggle lives on the .strap-list-item row, NOT on the <img> (which stays
  // display:block), so we must check the row - otherwise "first visible strap"
  // grabs the first DOM img even when its row is hidden (e.g. an incompatible
  // QuickFit strap), instead of the first compatible one.
  function isStrapImgShown(img) {
    if (!img) return false;
    const li = img.closest('.strap-list-item');
    if (li) return li.style.display !== 'none';
    return img.style.display !== 'none';
  }

  // Select a strap from its <img> (same effect as the delegated grid click, but
  // without dispatching a DOM click - safe to call from row/swatch handlers).
  function selectStrapByImg(img) {
    if (!img) return;
    const strapsGrid = document.getElementById("strapsGrid");
    strapsGrid.querySelectorAll("img").forEach(i => i.classList.remove("selected"));
    strapsGrid.querySelectorAll(".strap-list-item").forEach(item => item.classList.remove("selected"));
    img.classList.add("selected");
    const li = img.closest('.strap-list-item');
    if (li) li.classList.add("selected");
    const chosenId = img.dataset.id;
    selectedStrapProduct = allStrapProducts.find(p => String(p.id) === String(chosenId));
    if (selectedStrapProduct) {
      currentStrapURL = svStrapUrl(selectedStrapProduct);
      showStrapDetails(selectedStrapProduct);
      if (currentWatchData) combineImages();
    }
  }

  // Colour = the text after the last " - " in the title (connector prefix stripped first).
  function getStrapColourName(product) {
    const t = (product && product.title ? product.title : '').replace(/^\s*\[[^\]]*\]\s*/, '').trim();
    const parts = t.split(/\s+[-– - ]\s+/);
    return parts.length > 1 ? parts[parts.length - 1].trim() : '';
  }

  /* 3.91.1: ONE display name for the list row and the details panel. A style suffix is part of
     the product's identity ("Steel Bracelet - Beads of Rice", "- Hex Link with Safety Deployant
     Clasp"): the row already kept it, the panel under the preview dropped it and read plain
     "Steel Bracelet" for both. */
  function svStrapDisplayName(product) {
    let name = getStrapBaseName(product) || (product && product.title || '').replace(/^\s*\[[^\]]*\]\s*/, '');
    if (svStyleNotColour(product)) name += ' - ' + getStrapColourName(product);
    return name;
  }

  // Base name = everything before that last " - ".
  function getStrapBaseName(product) {
    const t = (product && product.title ? product.title : '').replace(/^\s*\[[^\]]*\]\s*/, '').trim();
    const parts = t.split(/\s+[-– - ]\s+/);
    if (parts.length > 1) { parts.pop(); return parts.join(' - ').trim(); }
    return t;
  }

  // A title's leading "[...]" tag (e.g. "[QuickFit]", "[QuickFit 20mm]") is a FIT/size marker,
  // not decoration - "[QuickFit] Sports Silicone 2" and "[QuickFit 20mm] Sports Silicone 2" are
  // two different-fit products that happen to share a base name. getStrapBaseName strips it for
  // DISPLAY (the row shouldn't show the bracket), so the group key has to capture it separately
  // or two incompatible-fit products get merged into one "colour" dropdown that's actually
  // offering a fit choice mislabelled as a colour (hit 2026-08-12, Sports Silicone 2 QuickFit vs
  // QuickFit 20mm merged together).
  function getStrapBracketTag(product) {
    const t = (product && product.title ? product.title : '');
    const m = t.match(/^\s*\[([^\]]*)\]/);
    return m ? m[1].trim().toLowerCase() : '';
  }

  // Group key - same connector type + fit tag + base name + material/style = same strap, colour
  // aside.
  function getStrapGroupKey(product) {
    return [
      getStrapTypeLabel(product),
      getStrapBracketTag(product),
      getStrapBaseName(product).toLowerCase(),
      (product && product.mainCategory) || '',
      (product && product.subCategory) || ''
    ].join('||');
  }

  /* A title suffix that names HARDWARE, a LINK STYLE or a SIZE is not a colourway, and
     grouping on it merges genuinely different products into one row whose dropdown then
     offers a clasp or a size mislabelled as a colour.

     This has now bitten three times, each patched narrowly:
       2026-08-16  "FKM Rubber - AeroMax / Pilot / Two Tone"          (3 products -> 1 row)
       2026-08-30  "Steel Bracelet - Hex Link with Safety Deployant Clasp" vs "- Beads of Rice"
                   (owner report: "hex link incorrectly linked on steel bracelet")
     so the FKM special case is generalised here instead of being extended again.

     ⚠ This is deliberately a BLOCKLIST of style words, NOT an allowlist of colour words.
     The feed carries 255 distinct suffixes including Bordeaux, Wheat, Bond, Brandy, Bourbon
     and Mauve - a positive "is this a colour?" test rejects those and would SHATTER real
     colour families. A style blocklist can only ever SPLIT a group, never merge one.

     Swept against all 255 suffixes 2026-08-30: matches 8, splitting exactly 4 wrongly-merged
     groups (Steel Bracelet, Steel Bracelet (Silver), Steel Bracelet (Black), Sports Loop
     (Velcro) - 18mm) and touching no legitimate colourway. */
  const SV_STYLE_SUFFIX_RE =
    /(^|\s)(clasp|link|links|beads of rice|bracelet|buckle|deployant|deployment|end ?links?)(\s|$)|^\d{1,2}(\.\d)?mm$/i;

  function svStyleNotColour(product) {
    const c = getStrapColourName(product);
    if (!c) return false;
    if (SV_STYLE_SUFFIX_RE.test(c)) return true;
    // The original 2026-08-16 case: bare style names carrying no style KEYWORD at all.
    return /fkm rubber$/i.test(getStrapBaseName(product)) && /^(aeromax|pilot|two tone)$/i.test(c);
  }

  /* THE grouping key. Colour-sibling products collapse into one row; a product whose suffix
     is absent or is a STYLE gets a standalone key built from its full title so it can never
     be folded into a colour family. Both the strap LIST and the details-panel colour picker
     must use this same function - when only the list applied the guard, the row split
     correctly but the details panel still offered the other product as a "colour". */
  function svGroupKeyOf(product) {
    const base = getStrapGroupKey(product);
    const hasColourSuffix = !!getStrapColourName(product) && !svStyleNotColour(product);
    return hasColourSuffix
      ? base
      : base + '||standalone||' + ((product && (product.title || product.id)) || '');
  }

  function formatStrapPrice(product) {
    if (product && product.priceRange && product.priceRange.minVariantPrice) {
      const priceValue = parseFloat(product.priceRange.minVariantPrice.amount);
      const currency = product.priceRange.minVariantPrice.currencyCode || 'USD';
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(priceValue);
    }
    if (product && Array.isArray(product.variants) && product.variants.length) {
      const nums = product.variants.map(v => parseFloat(v.price)).filter(n => !isNaN(n));
      if (nums.length) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'AUD' }).format(Math.min(...nums));
      }
    }
    return '';
  }

  // Switch which colour-member a grouped list row is currently showing.
  function setStrapGroupActive(listItem, img, member) {
    if (!member || !member.visualiserImage) return;
    const newSrc = cdnSized(svProductImageSrc(member), 240);
    img.src = newSrc;
    if (img.dataset.src) img.dataset.src = newSrc;
    img.classList.remove('error');
    img.dataset.id = member.id;
    img.dataset.title = member.title;
    img.alt = member.title;
    const sel = listItem.querySelector('.strap-colour-select');
    if (sel && String(sel.value) !== String(member.id)) sel.value = String(member.id);
    const priceEl = listItem.querySelector('.strap-list-price');
    if (priceEl) priceEl.textContent = formatStrapPrice(member);
  }

  // Pick the group member that matches the active colour + search filters.
  function pickStrapGroupMember(members, selectedColor, searchQuery) {
    const ok = m =>
      (!selectedColor || productHasColor(m, selectedColor)) &&
      (!searchQuery || strapMatchesSearch(m, searchQuery));
    return members.find(ok) || null;
  }

  // Find the rendered list row whose colour group contains this product (if any).
  function findStrapListItemForProduct(product) {
    const grid = document.getElementById('strapsGrid');
    if (!grid || !product) return null;
    const items = grid.querySelectorAll('.strap-list-item');
    for (const li of items) {
      if (li._members && li._members.some(m => String(m.id) === String(product.id))) return li;
    }
    return null;
  }

  // Colour dropdown shown inside the strap details panel.
  function renderDetailsColourPicker(product) {
    const host = document.getElementById('strapColourPicker');
    if (!host) return;
    host.innerHTML = '';
    const key = svGroupKeyOf(product);
    const members = allStrapProducts
      .filter(p => svGroupKeyOf(p) === key)
      .sort((a, b) => getStrapColourName(a).localeCompare(getStrapColourName(b)));
    if (members.length <= 1) return; // single colour - nothing to choose

    const sel = document.createElement('select');
    sel.className = 'strap-colour-select';
    sel.id = 'strapColourGroupSelect';
    members.forEach(m => {
      const opt = document.createElement('option');
      opt.value = m.id;
      opt.textContent = getStrapColourName(m) || m.title;
      if (String(m.id) === String(product.id)) opt.selected = true;
      sel.appendChild(opt);
    });
    sel.addEventListener('change', () => {
      const chosen = members.find(m => String(m.id) === String(sel.value));
      if (!chosen) return;
      // Keep the list row, selection, details and preview all in sync.
      const li = findStrapListItemForProduct(chosen);
      if (li) {
        const img = li.querySelector('img');
        setStrapGroupActive(li, img, chosen);
        selectStrapByImg(img);
      } else {
        selectedStrapProduct = chosen;
        currentStrapURL = svStrapUrl(chosen);
        showStrapDetails(chosen);
        if (currentWatchData) combineImages();
      }
    });
    // Wrap with a "Colour" helper label so the colour-group picker matches the variant dropdowns.
    const field = document.createElement('div');
    field.className = 'sv-variant-field';
    const cLabel = document.createElement('label');
    cLabel.className = 'sv-variant-label';
    cLabel.setAttribute('for', sel.id);
    cLabel.textContent = 'Colour';
    field.appendChild(cLabel);
    field.appendChild(sel);
    host.appendChild(field);
  }

  // Shrink a list title's font until the product name fits on a single line.
  function fitStrapTitleOneLine(el) {
    if (!el) return;
    el.style.whiteSpace = 'nowrap';
    el.style.fontSize = ''; // reset to the CSS default before measuring
    if (el.clientWidth < 30) return; // not laid out yet
    let fs = parseFloat(getComputedStyle(el).fontSize) || 14;
    const min = 9;
    let guard = 0;
    while (el.scrollWidth > el.clientWidth + 1 && fs > min && guard < 60) {
      fs -= 0.5;
      el.style.fontSize = fs + 'px';
      guard++;
    }
  }

  function renderStrapsList(validProducts, strapsGrid, placeholder) {
    const fragment = document.createDocumentFragment();

    // Collapse colour-sibling products (same type + base name) into one row each. A product with
    // NO " - Colour" suffix in its title (getStrapColourName returns '') has no established
    // colour identity of its own - if its bare title happens to equal another family's base name
    // (e.g. a plain "[QuickFit] Flexi Silicone" product next to a real colour family "[QuickFit]
    // Flexi Silicone - Asymmetric/Digital Camo/Two Tone"), grouping purely by base name folds it
    // into that family as if it were just another colour, mislabelling a genuinely different
    // product (hit 2026-08-13). Give every colourless product its own one-off group key (its full
    // title) so it can never collide with a real colour family.
    // "FKM Rubber - AeroMax / Pilot / Two Tone" are three different PRODUCTS whose
    // suffix is a STYLE, not a colourway; grouping them as colours of one "FKM Rubber"
    // row merged three products into one (owner report, 2026-08-16). A style suffix
    // forces a standalone row that keeps the full name.
    // Style-vs-colour suffix handling now lives in svGroupKeyOf / svStyleNotColour, shared with
    // renderDetailsColourPicker - see the note there. The local FKM-only copy that used to sit
    // here was generalised 2026-08-30 after the same bug recurred on the Steel Bracelet rows.
    const groupsMap = new Map();
    const order = [];
    validProducts.forEach(p => {
      const k = svGroupKeyOf(p);
      if (!groupsMap.has(k)) { groupsMap.set(k, []); order.push(k); }
      groupsMap.get(k).push(p);
    });

    order.forEach((k, index) => {
      const members = groupsMap.get(k);
      members.sort((a, b) => getStrapColourName(a).localeCompare(getStrapColourName(b)));
      // Keep the currently-selected colour showing across re-renders; else default to the first.
      let active = members[0];
      if (selectedStrapProduct && members.some(m => String(m.id) === String(selectedStrapProduct.id))) {
        active = members.find(m => String(m.id) === String(selectedStrapProduct.id));
      }

      const listItem = document.createElement('div');
      listItem.className = 'strap-list-item';
      listItem.style.display = 'flex';
      listItem._members = members; // used by the filter to switch colours
      // 3.53.0: single-column flat-lay (loop / stacked pair). The row thumbnail is rebuilt
      // into the same two arms the compositor cuts, SIDE BY SIDE - see svThumbSideBySide.
      if (active && svStrapIsSingleDiagonal(active)) listItem.dataset.svSd = '1';

      const img = createOptimizedImage(active, placeholder, index);
      img.style.display = 'block';

      const info = document.createElement('div');
      info.className = 'strap-list-info';

      // Top label = connector type, mirroring the watch list's brand line.
      const category = document.createElement('div');
      category.className = 'strap-list-category';
      category.textContent = getStrapTypeLabel(active);

      // Product name (base, colour removed); wraps via CSS.
      const title = document.createElement('div');
      title.className = 'strap-list-title';
      title.textContent = svStrapDisplayName(active);

      info.appendChild(category);
      info.appendChild(title);

      const hasColours = members.length > 1;

      // Colour picker - a dropdown, only when the group has more than one colour.
      if (hasColours) {
        const sel = document.createElement('select');
        sel.className = 'strap-colour-select';
        members.forEach(m => {
          const opt = document.createElement('option');
          opt.value = m.id;
          opt.textContent = getStrapColourName(m) || m.title;
          if (m === active) opt.selected = true;
          sel.appendChild(opt);
        });
        sel.addEventListener('click', (e) => e.stopPropagation());
        sel.addEventListener('change', (e) => {
          e.stopPropagation();
          const chosen = members.find(mm => String(mm.id) === String(sel.value));
          if (chosen) { setStrapGroupActive(listItem, img, chosen); selectStrapByImg(img); }
        });
        // Labelled, so the row says WHAT is being picked rather than showing a bare dropdown.
        const cwrap = document.createElement('div');
        cwrap.className = 'strap-row-optwrap';
        const clab = document.createElement('label');
        clab.className = 'strap-row-optlabel';
        clab.textContent = 'Colour';
        cwrap.appendChild(clab);
        cwrap.appendChild(sel);
        info.appendChild(cwrap);
      } else {
        // Some straps' colours are VARIANTS of one product rather than separate products (every
        // Apple strap works this way, but so do others - e.g. Garmin QuickFit "Titanium
        // Featherlight Milanese" - so this used to be gated on `active.isApple` and any non-Apple
        // variant-coloured strap silently got no dropdown at all, just a bare row). Build the row
        // dropdown from the colour OPTION values whenever they exist, Apple or not, and drive the
        // details panel's own colour select on change so variant, price, preview image and row
        // thumbnail all follow the one existing path.
        const aOpts = active.options || [];
        const ci = aOpts.findIndex(o => o && /colou?r/i.test(o.name || ''));
        const vals = (ci >= 0 && aOpts[ci].values) ? aOpts[ci].values : [];
        if (vals.length > 1) {
          const sel = document.createElement('select');
          sel.className = 'strap-colour-select sv-apple-colour-select';
          sel.dataset.pid = active.id;
          sel.dataset.ci = ci;
          sel.dataset.optname = aOpts[ci].name || '';
          vals.forEach(v => {
            const opt = document.createElement('option');
            opt.value = v;
            opt.textContent = v;
            sel.appendChild(opt);
          });
          // Survive a re-render: reflect the live selection when this strap is the selected one.
          if (selectedStrapProduct && String(selectedStrapProduct.id) === String(active.id) &&
              currentOptionSelections && currentOptionSelections[ci]) {
            sel.value = currentOptionSelections[ci];
          }
          sel.addEventListener('click', (e) => e.stopPropagation());
          sel.addEventListener('change', (e) => {
            e.stopPropagation();
            const want = sel.value;
            if (!selectedStrapProduct || String(selectedStrapProduct.id) !== String(active.id)) {
              selectStrapByImg(img);   // builds the details dropdowns synchronously
            }
            const dsel = Array.prototype.slice.call(
              document.querySelectorAll('#optionDropdownsContainer select.option-select'))
              .find(s => /colou?r/i.test(s.dataset.optionName || ''));
            if (dsel && dsel.value !== want) {
              dsel.value = want;
              dsel.dispatchEvent(new Event('change'));
            }
          });
          /* Labelled like every other row dropdown. Colour-as-VARIANT rows (Apple's Vogue Leather
             Link, QuickFit Aero Silicone, ...) used to append this select bare, so the one row
             shape that most needs a label - a lone dropdown under the title - was the only one
             without one. */
          const awrap = document.createElement('div');
          awrap.className = 'strap-row-optwrap';
          const alab = document.createElement('label');
          alab.className = 'strap-row-optlabel';
          alab.textContent = getVariantFieldLabel(aOpts[ci].name || 'Colour');
          awrap.appendChild(alab);
          awrap.appendChild(sel);
          info.appendChild(awrap);
        }
      }

      /* Second row dropdown: the next option that actually changes how the strap LOOKS.
         Colour is already handled above (either as sibling products or as an option). Sizing
         options are deliberately excluded - width and length change the fit, not the picture, and
         putting them here would crowd the row with the one choice that does not alter the render.
         What is left is the look-changing option: Stitching on King Sailcloth, and the same slot
         serves anything similar (Material, Buckle Colour, ...) without another special case.
         Drives the details panel's own select so variant, price, preview and thumbnail all follow
         the single existing path, exactly as the colour row select above does. */
      const rowOpts = active.options || [];
      /* The old skip regex excluded ANY option containing "colour", which silently hid
         second colour-ish options like Vogue Leather Link's "Hardware Colour". Exclude
         only sizing options and the PRIMARY colour option (already handled above). */
      const svSizeOnlyRe = /width|length|size|garmin\s*watch|wrist|galaxy\s*watch\s*model|^watch\s*model$/i;   // 3.92.0: watch model is set by the watch
      const svPrimaryCi = rowOpts.findIndex(o => o && /colou?r/i.test(o.name || ''));
      const si = rowOpts.findIndex((o, oi) => o && o.name && oi !== svPrimaryCi &&
                                        !svSizeOnlyRe.test(o.name) &&
                                        (o.values || []).length > 1);
      if (si >= 0) {
        const wrap = document.createElement('div');
        wrap.className = 'strap-row-optwrap';
        const lab = document.createElement('label');
        lab.className = 'strap-row-optlabel';
        lab.textContent = getVariantFieldLabel(rowOpts[si].name);
        const ssel = document.createElement('select');
        ssel.className = 'strap-colour-select sv-row-opt-select';
        ssel.dataset.pid = active.id;
        ssel.dataset.ci = si;
        ssel.dataset.optname = rowOpts[si].name || '';
        rowOpts[si].values.forEach(v => {
          const o = document.createElement('option');
          o.value = v; o.textContent = v;
          ssel.appendChild(o);
        });
        if (selectedStrapProduct && String(selectedStrapProduct.id) === String(active.id) &&
            currentOptionSelections && currentOptionSelections[si]) {
          ssel.value = currentOptionSelections[si];
        }
        ssel.addEventListener('click', (e) => e.stopPropagation());
        ssel.addEventListener('change', (e) => {
          e.stopPropagation();
          const want = ssel.value;
          if (!selectedStrapProduct || String(selectedStrapProduct.id) !== String(active.id)) {
            selectStrapByImg(img);   // builds the details dropdowns synchronously
          }
          const want_name = rowOpts[si].name;
          const dsel = Array.prototype.slice.call(
            document.querySelectorAll('#optionDropdownsContainer select.option-select'))
            .find(s => (s.dataset.optionName || '') === want_name);
          if (dsel && dsel.value !== want) {
            dsel.value = want;
            dsel.dispatchEvent(new Event('change'));
          }
        });
        wrap.appendChild(lab);
        wrap.appendChild(ssel);
        info.appendChild(wrap);
      }

      listItem.appendChild(img);
      listItem.appendChild(info);

      // Clicking anywhere on the row selects the active colour.
      listItem.addEventListener('click', () => { selectStrapByImg(img); });

      fragment.appendChild(listItem);
    });

    strapsGrid.appendChild(fragment);

    // Shrink each strap name so it fits on one line.
    svRaf(() => {
      strapsGrid.querySelectorAll('.strap-list-title').forEach(fitStrapTitleOneLine);
    });
  }
  
  /* ---- Row thumbnail follows the chosen colour ----
     A normal strap's colours are separate PRODUCTS, so a grouped row just swaps member
     (setStrapGroupActive). An Apple strap's colours are VARIANTS of one product, so the row is a
     single product and its thumbnail has to follow the variant instead.
     ⚠ It also has to survive a re-render: renderStraps() rebuilds every row from the product image
     on a view switch, a filter pass or the Apple lazy-load, which would snap the thumbnail back to
     the first colour while the preview and the dropdown still show another. Hence the override is
     remembered and re-applied in createOptimizedImage, not just written onto the live <img>. */
  let _strapThumbOverride = null;   // { id, src } - at most one strap is selected at a time

  function syncStrapThumb(productId, src) {
    if (!src || productId == null) { _strapThumbOverride = null; return; }
    _strapThumbOverride = { id: productId, src };
    const grid = document.getElementById('strapsGrid');
    if (!grid) return;
    const sized = cdnSized(src, 240);
    grid.querySelectorAll('img[data-id="' + productId + '"]').forEach(img => {
      if (img.dataset.src) img.dataset.src = sized;   // keep a pending lazy load in step
      if (img.src === sized) return;
      img.classList.remove('error');
      img.src = sized;
    });
    // Keep an Apple row's variant-colour dropdown in step with the details panel (this runs on
    // every preview-image change, which is exactly when the colour selection moves).
    const rowSel = grid.querySelector('select.sv-apple-colour-select[data-pid="' + productId + '"]');
    if (rowSel && currentDropdownProduct && String(currentDropdownProduct.id) === String(productId)) {
      const ci = parseInt(rowSel.dataset.ci, 10);
      const v = currentOptionSelections && currentOptionSelections[ci];
      if (v && rowSel.value !== v) rowSel.value = v;
    }
  }

  // The image a given variant should show: its own visualiser position if it has one, else the
  // product's. Single definition, used by the preview and the thumbnail alike.
  /* The strap image for a product, HONOURING the live variant selection.
     ⚠⚠ There were nine places that set `currentStrapURL = <product>.visualiserImage?.src`, i.e.
     the product-level default. `updateVisualizerImage` sets the variant-specific image correctly,
     but any of those nine firing afterwards overwrote it with the product default, so choosing a
     different Stitching updated the variant, the price and the dropdown while the composited
     image silently stayed on the first image. That is why King Sailcloth's stitching colours
     never appeared even though all 117 variant positions were correct in Shopify.
     Every one of those sites now goes through here, so the variant override always wins and there
     is a single definition of "which image does this strap show". */
  // The option an adapter bundle carries; "" for every other strap.
  const SV_ADAPTER_OPT = /adapter colour|connector colour/i;
  function svBundleOptName(product) {
    const opts = (product && product.options) || [];
    for (const o of opts) if (o && SV_ADAPTER_OPT.test(o.name || '')) return o.name;
    return '';
  }

  /* A PROPRIETARY LUG TAKES ONLY STRAPS MADE FOR IT (3.90.0).
     The Pixel rows carry no watch type, and a blank type is read as Quick Release - so every
     ordinary 20mm quick-release strap passed the type check and showed up on a Pixel, which
     cannot wear one without an adapter. The collection cannot settle it either: the Pixel
     collection deliberately holds generic straps, because they are what you buy WITH an adapter.
     It only became visible once the bundles were tagged and the grid filled up.
     The honest test is what the strap IS: an adapter bundle (it carries an "Adapter Colour" /
     "Connector Colour" option), or a strap made for this watch (it carries the watch's own brand
     or family tag). Scoped to watches whose lug width reads "specific straps only" - ten rows,
     all Pixel and Galaxy - so no ordinary lug watch changes at all.
     ⚠ 3.90.1: this must ALSO filter grouped list rows. Display strips the "[Pixel Watch ...]"
     prefix, so the generic Cross Militex and the Pixel bundle of the same name land in ONE group;
     the row then passed on its bundle member while DISPLAYING the generic one. */
  function svFitsProprietaryLug(product) {
    if (!product || !currentWatchData) return true;
    if (!/specific\s+straps\s+only/i.test(currentWatchData.lugWidth || '')) return true;
    if (svBundleOptName(product)) return true;
    const toks = [];
    const b = svFold(currentWatchData.brand);
    const m = svFold(currentWatchData.model).split(/\s+/)[0];
    if (b) toks.push(b);
    if (m && m !== b) toks.push(m);
    if (!toks.length) return true;
    const tags = (product.tags || []).map(svFold);
    return toks.some(t => tags.some(tag => tag.indexOf(t) >= 0));
  }

  function svStrapUrl(product) {
    if (!product) return "";
    let v = null;
    try {
      if (currentDropdownProduct && String(currentDropdownProduct.id) === String(product.id)) {
        v = findMatchingVariant();
      }
    } catch (e) {}
    const s = v ? variantVisualiserSrc(product, v) : "";
    if (s) return s;
    /* ⚠ 3.90.3: A BUNDLE MUST NEVER FALL BACK TO THE BARE STRAP. The variant rule in
       variantVisualiserSrc only runs when this product is the one the dropdown is on - every other
       call (the rail thumbnails, and the preview before a variant resolves) dropped straight to the
       product-level flat-lay, which for an adapter bundle is the strap WITHOUT its adapter. The
       owner saw it immediately: "it's using the qr photo without the adapter ... should just use
       the bundle as if it's its own product." So the bundle's own photo is the product-level
       answer too. Single-diagonal one-piece straps keep their own flat-lay (see 3.90.2). */
    return svProductImageSrc(product);
  }

  /* THE PICTURE A PRODUCT SHOWS, bundle-aware. ⚠ ONE definition, because the preview and the three
     thumbnail call sites disagreeing is exactly what the owner saw: the rail thumbnail drew the
     bare quick-release strap and the preview drew the bundle, so clicking a strap "magically added
     the adapters on after". */
  function svProductImageSrc(product) {
    if (!product) return "";
    const kit = svBundleKitSrc(product);
    return kit || (product.visualiserImage && product.visualiserImage.src) || "";
  }

  /* The bundle's own fitted photo, or "" when this is not a bundle / has none.
     `singleDiagonal` is NOT consulted here: the kit photo is the picture either way, and the flag
     decides how it is CUT (svStrapIsSingleDiagonal), not which picture is drawn. */
  function svBundleKitSrc(product) {
    if (!product || !SV_ADAPTER_OPT.test(svBundleOptName(product))) return "";
    /* 3.93.0: only the bundle builder's own `bundle-kit_*` file counts. A variant carrying some
       other picture (Galaxy Alpha Militex Army Green: an on-black lifestyle PNG) is NOT a fitted
       photo, and drawing it composited a whole strap-on-wrist shot as "the strap". */
    const kit = (product.variants || []).find(x => x && x.image && /bundle-kit/i.test(String(x.image)));
    return (kit && kit.image) || "";
  }

  /* A one-piece flat-lay is cut ACROSS the middle. 3.90.8: the flag applies to a bundle's fitted
     photo TOO. 3.90.2 ignored it for bundles on the belief that the kit photo was a two-arm
     layout; it is not - the bundle build fits the adapter onto the base product's own flat-lay, so
     a one-piece bracelet (Ceramic, Riven-O2, Acetate Bangle, EasyFit...) stays one tall column
     with the adapter at one end. Split down the middle it drew as a 1-link-wide strip beside a
     tiny watch. The "enormous Riven-O2" that motivated 3.90.2 was the pre-3.90.5 global white
     test erasing the titanium, not the cut. Same rule as the Quick Release versions. */
  function svStrapIsSingleDiagonal(product) {
    return !!(product && product.singleDiagonal);
  }

  // 3.92.3: an adapter bundle is only shown when it has a picture that IS the strap - its kit
  // photo, or a cut-out it names. Anything else it carries is an adapter shot or a lifestyle
  // photo, and drawing that as the strap is worse than leaving the bundle out.
  function svBundleUsable(product) {
    if (!product || !svBundleOptName(product)) return true;
    return !!svBundleKitSrc(product) || !!product.visUrlSet;
  }

  function variantVisualiserSrc(product, variant) {
    if (variant) {
      // Stable URL first - immune to gallery order. Apple variants carry no visualiser_image_url
      // on the variant (their URL is resolved into images/position upstream), so they fall
      // straight through to the index branch and are unaffected by this.
      const byUrl = svResolveImageUrl(variant.parentImages || [], variant.visualiserImageUrl);
      if (byUrl && byUrl.src) return byUrl.src;

      if (variant.visualiserImagePosition !== null &&
          variant.visualiserImagePosition !== undefined &&
          variant.parentImages &&
          variant.parentImages.length > 0) {
        const override = variant.parentImages[variant.visualiserImagePosition];
        if (override && override.src) return override.src;
      }

      /* 3.89.0: AN ADAPTER BUNDLE ALREADY HAS ITS OWN PICTURE. The bundle build attaches a photo
         of the strap with that adapter colour fitted to each variant, which is exactly what the
         visualiser wants to draw - so use it rather than a flat-lay of the bare strap with no
         connector. ⚠ Gated on the product carrying an "Adapter Colour" / "Connector Colour"
         option, NOT applied to variants generally: an ordinary strap's variant image is often a
         lifestyle or on-watch shot, which is the exact wrong-image case the no-alpha guard was
         added for (Link Bracelet, 2026-08-22). */
      /* 3.90.8: the kit photo is used for one-piece products too - `singleDiagonal` cuts it across
         exactly as it cuts the base flat-lay (see svStrapIsSingleDiagonal). */
      if (variant.image && SV_ADAPTER_OPT.test(svBundleOptName(product))) {
        return variant.image;
      }
    }
    return (product && product.visualiserImage && product.visualiserImage.src) || '';
  }

  function createOptimizedImage(product, placeholder, index) {
    const img = document.createElement("img");
    const _thumbSrc = (_strapThumbOverride && String(_strapThumbOverride.id) === String(product.id) &&
                       _strapThumbOverride.src) || svProductImageSrc(product);

    // For first 20 images, load immediately for better UX
    if (index < 20) {
      img.src = cdnSized(_thumbSrc, 240);
      img.classList.add('loading');
      
      img.onload = () => {
        img.classList.remove('loading');
        img.classList.add('loaded');
      };
      img.onerror = () => {
        img.classList.remove('loading');
        img.classList.add('error');
        img.src = placeholder;
      };
    } else {
      // Use lazy loading for images beyond the first 20
      img.dataset.src = cdnSized(_thumbSrc, 240);
      img.src = placeholder;
      img.classList.add('loading');
      img.loading = 'lazy';
      
      // Setup observers for lazy loading
      if (intersectionObserver) {
        intersectionObserver.observe(img);
      }
    }
    
          img.alt = product.title;
          img.dataset.title = product.title;
    img.dataset.id = product.id;
    img.dataset.index = index;
    
    return img;
  }

  /************************************************************************
   * 8) STRAP CLICK SELECTION
   ************************************************************************/
  function strapSelectionSetup() {
    const strapsGrid = document.getElementById("strapsGrid");
    strapsGrid.addEventListener("click", e => {
      if (e.isTrusted) svUserInteracted = true; // real tap - block any pending auto-select/restore
      const img = e.target.closest('img');
      if (img) {
        // Clear previous .selected
        strapsGrid.querySelectorAll("img").forEach(i => i.classList.remove("selected"));
        strapsGrid.querySelectorAll(".strap-list-item").forEach(item => item.classList.remove("selected"));
        
        // Mark newly clicked strap as selected
        img.classList.add("selected");
        
        // If in list view, also mark the list item as selected
        const listItem = img.closest('.strap-list-item');
        if (listItem) {
          listItem.classList.add("selected");
        }
        
        const chosenId = img.dataset.id;
        selectedStrapProduct = allStrapProducts.find(p => String(p.id) === String(chosenId));
        
        if (selectedStrapProduct) {
          currentStrapURL = svStrapUrl(selectedStrapProduct);
          showStrapDetails(selectedStrapProduct);
          
          // Combine if watch is already selected
          if (currentWatchData) {
            combineImages();
          }
        }
      }
    });
  }





  /**
   * Parse a variant title into its option values using the product's options.
   * Shopify builds variant titles by joining option values with " / ",
   * but option values themselves can contain " / " (e.g. "Black / Red").
   * This function uses the known option values to correctly decompose the title.
   * 
   * @param {string} title - The variant title (e.g. "Black / Red / QuickFit 22mm")
   * @param {Array} options - The product's options array with {name, values}
   * @returns {string[]} - Array of option values matching each option index
   */
  function parseVariantOptionValues(title, options) {
    if (!title || !options || options.length === 0) {
      return title ? title.split(' / ') : [];
    }

    // Quick path: if only 1 option, the entire title is the value
    if (options.length === 1) {
      return [title];
    }

    // Try to greedily match known option values from left to right
    const result = [];
    let remaining = title;

    for (let i = 0; i < options.length; i++) {
      const isLast = (i === options.length - 1);

      if (isLast) {
        // Last option gets whatever is left
        result.push(remaining);
        break;
      }

      // Try to find which known value for this option matches the start of remaining
      let matched = false;
      // Sort values by length descending so longer matches win ("Black / Red" before "Black")
      const sortedValues = [...options[i].values].sort((a, b) => b.length - a.length);

      for (const value of sortedValues) {
        const prefix = value + ' / ';
        if (remaining.startsWith(prefix)) {
          result.push(value);
          remaining = remaining.substring(prefix.length);
          matched = true;
          break;
        }
      }

      if (!matched) {
        // Fallback: take everything up to the first " / " delimiter
        const delimIndex = remaining.indexOf(' / ');
        if (delimIndex !== -1) {
          result.push(remaining.substring(0, delimIndex));
          remaining = remaining.substring(delimIndex + 3);
        } else {
          result.push(remaining);
          remaining = '';
          break;
        }
      }
    }

    return result;
  }

  /**
   * Extract numeric size from variant title
   * Handles formats: "20mm", "20 mm", "20", "Size 20mm", etc.
   */
  function extractSizeFromVariantTitle(title) {
    if (!title) return null;
    
    // Try to find number followed by optional mm/MM
    const matches = title.match(/(\d+(?:\.\d+)?)\s*mm/i) || title.match(/(\d+(?:\.\d+)?)/);
    if (matches && matches[1]) {
      return parseFloat(matches[1]);
    }
    return null;
  }

  /* 3.77.0: THE WATCH'S LUG WIDTH IS THE FIRST "<n>mm" IN THE CELL, NOT EVERY DIGIT IN IT.
     The feed's `lug width` (CRM column `sizes`) is free text and may legitimately list more than
     one entry - "22mm, Quick Release 22mm" (14 TAG Monaco + Longines Evidenza), and the CRM's own
     rule builder accepts "20mm, QuickFit 22mm". The old parse stripped everything but digits, so
     "22mm, Quick Release 22mm" became 2222: no exact variant, and the closest-size fallback then
     picked the LARGEST size the strap had (24mm on a Milanese) until the buy card auto-corrected.
     Same helper for the QuickFit size gate and the own-watch width gate below. A bare number
     with no "mm" still counts, so a hand-typed "20" keeps working. */
  function svLugMm(lugWidth) {
    if (typeof lugWidth === 'number') return lugWidth;
    const s = String(lugWidth == null ? '' : lugWidth);
    const m = s.match(/(\d+(?:\.\d+)?)\s*mm/i) || s.match(/(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : NaN;
  }

  /**
   * Find best matching variant based on watch lug width
   * Returns variant index or -1 if no match
   */
  function findMatchingVariantIndex(variants, lugWidth) {
    if (!lugWidth || !variants || variants.length === 0) return -1;
    
    // Parse lug width - first "<n>mm" in the cell (see svLugMm)
    const targetSize = svLugMm(lugWidth);
    
    if (isNaN(targetSize)) return -1;
    
    
    // Try to find exact match first (available variants only)
    for (let i = 0; i < variants.length; i++) {
      const variant = variants[i];
      const variantSize = extractSizeFromVariantTitle(variant.title);
      
      if (variantSize === targetSize && variant.availableForSale) {
        return i;
      }
    }
    
    // If no available match, try exact match with any variant
    for (let i = 0; i < variants.length; i++) {
      const variant = variants[i];
      const variantSize = extractSizeFromVariantTitle(variant.title);
      
      if (variantSize === targetSize) {
        return i;
      }
    }
    
    // If no exact match, find closest size (prefer available)
    let closestIndex = -1;
    let smallestDiff = Infinity;
    
    for (let i = 0; i < variants.length; i++) {
      const variant = variants[i];
      const variantSize = extractSizeFromVariantTitle(variant.title);
      
      if (variantSize !== null) {
        const diff = Math.abs(variantSize - targetSize);
        const isAvailable = variant.availableForSale;
        
        // Prefer available variants (give them priority by reducing their diff)
        const adjustedDiff = isAvailable ? diff : diff + 1000;
        
        if (adjustedDiff < smallestDiff) {
          smallestDiff = adjustedDiff;
          closestIndex = i;
        }
      }
    }
    
    if (closestIndex !== -1) {
      const closestVariant = variants[closestIndex];
      const closestSize = extractSizeFromVariantTitle(closestVariant.title);
    }
    
    return closestIndex;
  }

  function showStrapDetails(product) {
    // A manual strap nudge is measured against one particular strap on one particular watch, so it
    // means nothing once either changes.
    svAppResetNudge(false);
    const strapDetailsEl = document.getElementById("strapDetails");
    const strapTitleEl = document.getElementById("strapTitle");
    const strapPriceEl = document.getElementById("strapPrice");
    const productPageLink = document.getElementById("productPageLink");

    // 3.67.0: clear the inline value instead of forcing "block", so the stylesheet decides the
    // card's display (desktop two-up card is display:flex; mobile is grid/flex via !important).
    // The clear-selection path still sets display:none inline, and this undoes exactly that.
    strapDetailsEl.style.display = "";

    // Title: connector type on line 1, base product name on line 2.
    strapTitleEl.innerHTML = '';
    const sdType = document.createElement('span');
    sdType.className = 'sd-type';
    sdType.textContent = getStrapTypeLabel(product);
    const sdName = document.createElement('span');
    sdName.className = 'sd-name';
    sdName.textContent = svStrapDisplayName(product);   // 3.91.1: same name as the list row
    strapTitleEl.appendChild(sdType);
    strapTitleEl.appendChild(sdName);

    // Colour dropdown for the selected strap's colour group
    renderDetailsColourPicker(product);

    // Set up product page links
    const productUrl = `https://strapifyau.myshopify.com/products/${product.handle}`;
    productPageLink.href = productUrl;
    
    // Make title clickable too
    strapTitleEl.onclick = () => {
      window.open(productUrl, '_blank');
    };

    // First variant by default - except a sticky look-changing choice (Stitching, ...) carries
    // over from the colour the customer just came from, when this colour offers it.
    const selectedVariant = svPreferredVariant(product);

    if (selectedVariant) {
      strapPriceEl.textContent = `Price: $${parseFloat(selectedVariant.price)}`;
    } else {
      strapPriceEl.textContent = "Price: N/A";
    }

    // Update add to cart button based on selected variant availability
    updateAddToCartButton(selectedVariant);

    // Set the hidden variant ID for form submission
    const selectedVariantIdInput = document.getElementById('selectedVariantId');
    if (selectedVariantIdInput && selectedVariant) {
      selectedVariantIdInput.value = selectedVariant.id;
    }

    /* The preview follows the variant we actually opened on. It used to fill currentStrapURL only
       when empty, so a sticky Stitching pick would select the right variant and price while the
       canvas kept the previous colour's product-level image. */
    const _openSrc = variantVisualiserSrc(product, selectedVariant);
    if (_openSrc) currentStrapURL = _openSrc;

    // Selecting a strap starts from its first variant, so drop any colour the row's thumbnail was
    // left showing from a previous visit. handleOptionChange re-applies one as soon as a colour is
    // picked (and the size sync fires immediately below, which counts).
    syncStrapThumb(product.id, variantVisualiserSrc(product, selectedVariant));

    // Create option-based dropdowns using product.options from Shopify API
    createOptionBasedDropdowns(product, selectedVariant);

    // The row keeps its old dropdown values across a colour swap (it is not re-rendered), so push
    // the selections the panel just built back onto it.
    syncRowOptionSelects(product);

    // Update URL state with new strap selection
    updateURLState();
  }

  function updateAddToCartButton(variant) {
    const addToCartBtn = document.querySelector('.add-to-cart-btn');
    if (!addToCartBtn) return;
    addToCartBtn.classList.remove('atc-oos', 'atc-added', 'atc-err');
    addToCartBtn.style.opacity = "";

    if (!variant || !variant.availableForSale) {
      // Out of stock
      addToCartBtn.textContent = "Out of Stock";
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('atc-oos');
    } else {
      // In stock. On MOBILE show the price on the button (e.g. "Add to Cart - $59.95") since the
      // separate price line is hidden in the floating bar; desktop keeps its price line + plain button.
      var _p = (variant && variant.price != null) ? parseFloat(variant.price) : NaN;
      var _mob = window.innerWidth <= 768;
      addToCartBtn.textContent = (_mob && isFinite(_p)) ? ("Add to Cart - $" + _p.toFixed(2)) : "Add to Cart";
      addToCartBtn.disabled = false;
    }
  }

  /************************************************************************
   * OPTION-BASED VARIANT SELECTION SYSTEM
   * Uses product.options from Shopify API to create proper dropdowns
   * Based on actual product structures:
   * - Single option (size-only): [QuickFit] Milanese, Leather, Titanium
   * - Single option (colour-only): King FKM Rubber (connector colour)
   * - Two options (colour + size): Flexi Silicone, Sports Silicone, Floral
   * - Two options (size + colour): Alligator Leather Hybrid
   * - Two options (size + wrist): Milanese with wrist sizes
   ************************************************************************/

  // Store current product for dropdown interactions
  let currentDropdownProduct = null;
  let currentOptionSelections = {};

  /**
   * Determines if an option is a "size" type option (watch size, strap width, etc.)
   */
  function isSizeOption(optionName) {
    const sizePatterns = [
      /garmin\s*watch/i,
      /watch\s*size/i,
      /strap\s*width/i,
      /wrist\s*size/i,
      /quickfit\s*\d+/i,
      /\d+mm/i,
      /^size$/i,
    ];
    return sizePatterns.some(pattern => pattern.test(optionName));
  }

  /**
   * Determines if an option value is a size value (QuickFit 20mm, 18mm, etc.)
   */
  function isSizeValue(value) {
    const sizePatterns = [
      /quickfit\s*\d+/i,
      /^\d+mm$/i,
      /^\d+\s*mm$/i,
      /small.*medium/i,
      /medium.*large/i,
      /x-small|small|medium|large|x-large/i,
    ];
    return sizePatterns.some(pattern => pattern.test(value));
  }

  /**
   * Extracts the numeric size from a value like "QuickFit 20mm" or "20mm"
   */
  function extractNumericSize(value) {
    const match = value.match(/(\d+)\s*mm/i);
    return match ? parseInt(match[1], 10) : null;
  }

  /**
   * Checks if the currently selected variant size matches the watch lug width.
   * Shows/hides a mismatch warning and can auto-correct.
   * @param {Object} variant - The currently selected variant
   * @param {Object} product - The current product
   * @param {boolean} autoCorrect - Whether to auto-select the correct size
   */
  function checkSizeMismatch(variant, product, autoCorrect = false) {
    const disclaimer = document.getElementById('lugWidthDisclaimer');
    if (!disclaimer) return;

    const lugWidth = currentWatchData?.lugWidth || "";
    if (!lugWidth) {
      // No watch selected - hide warning
      disclaimer.style.display = 'none';
      return;
    }

    // Parse the watch lug width (e.g. "20mm", "22mm QuickFit" → 20, 22)
    const watchSize = extractNumericSize(lugWidth);
    if (!watchSize) {
      disclaimer.style.display = 'none';
      return;
    }

    // Check if this product even has size options
    const options = product?.options || [];
    const variants = product?.variants || [];
    
    // Find which option index is the size option
    let sizeOptionIndex = -1;
    for (let i = 0; i < options.length; i++) {
      // Check if option name or any of its values indicate a size
      const hasSize = options[i].values.some(v => isSizeValue(v));
      if (isSizeOption(options[i].name) || hasSize) {
        sizeOptionIndex = i;
        break;
      }
    }

    // If no size option, nothing to check
    if (sizeOptionIndex === -1 || variants.length <= 1) {
      disclaimer.style.display = 'none';
      return;
    }

    // Get the selected size from the variant
    if (!variant) {
      disclaimer.style.display = 'none';
      return;
    }

    const variantParts = parseVariantOptionValues(variant.title, options);
    const selectedSizeValue = variantParts[sizeOptionIndex] || '';
    const selectedSize = extractNumericSize(selectedSizeValue);

    if (selectedSize === null) {
      disclaimer.style.display = 'none';
      return;
    }

    // Determine the watch type for context
    const watchType = currentWatchData?.watchType || '';
    const isQuickFit = /quickfit/i.test(watchType) || /quickfit/i.test(lugWidth);

    if (selectedSize === watchSize) {
      // Correct size - no banner needed; the dropdown already labels the right option "(Correct fit)".
      disclaimer.style.display = 'none';
    } else {
      // MISMATCH - show warning
      disclaimer.style.display = 'block';
      disclaimer.style.backgroundColor = '#fff3cd';
      disclaimer.style.borderColor = '#ffc107';
      disclaimer.style.border = '1px solid #ffc107';
      disclaimer.style.color = '#856404';
      disclaimer.style.whiteSpace = 'normal';

      const correctLabel = isQuickFit ? `QuickFit ${watchSize}mm` : `${watchSize}mm`;
      disclaimer.innerHTML = `<strong>⚠️ Size mismatch:</strong> Your watch requires <strong>${correctLabel}</strong>, but <strong>${selectedSizeValue}</strong> is selected. ` +
        `<a href="#" id="autoCorrectSizeLink" style="color: #563818; font-weight: bold; text-decoration: underline; cursor: pointer;">Click to auto-correct →</a>`;

      // Add auto-correct click handler
      const autoCorrectLink = document.getElementById('autoCorrectSizeLink');
      if (autoCorrectLink) {
        autoCorrectLink.addEventListener('click', (e) => {
          e.preventDefault();
          autoCorrectSizeSelection(product, sizeOptionIndex, watchSize);
        });
      }

      if (autoCorrect) {
        autoCorrectSizeSelection(product, sizeOptionIndex, watchSize);
      }
    }
  }

  /**
   * Auto-corrects the size dropdown to match the watch lug width
   */
  function autoCorrectSizeSelection(product, sizeOptionIndex, targetSize) {
    const options = product?.options || [];
    if (sizeOptionIndex < 0 || sizeOptionIndex >= options.length) return;

    const sizeValues = options[sizeOptionIndex].values;
    
    // Find the value that matches the target size
    const matchingValue = sizeValues.find(v => {
      const numSize = extractNumericSize(v);
      return numSize === targetSize;
    });

    if (matchingValue) {
      // Update the dropdown
      const selectEl = document.getElementById(`optionSelect_${sizeOptionIndex}`);
      if (selectEl) {
        selectEl.value = matchingValue;
        // Trigger the change handler
        handleOptionChange(sizeOptionIndex, matchingValue);
      }
    } else {
      // No matching size value exists for this product
      const disclaimer = document.getElementById('lugWidthDisclaimer');
      if (disclaimer) {
        disclaimer.style.display = 'block';
        disclaimer.style.backgroundColor = '#f8d7da';
        disclaimer.style.borderColor = '#f5c6cb';
        disclaimer.style.border = '1px solid #f5c6cb';
        disclaimer.style.color = '#721c24';
        disclaimer.innerHTML = `<strong>❌ No matching size:</strong> This strap does not have a ${targetSize}mm option available for your watch.`;
      }
    }
  }

  /**
   * Creates option-based dropdowns using product.options from Shopify API
   */
  /* 3.92.0: the connector colour a customer picked once follows them across bundles - it is the
     same physical adapter whichever strap they look at next. And a bundle's "Galaxy Watch Model"
     option (Ultra vs Watch 8 & 9) is decided by the watch they chose, so it is set from the
     catalogue row and never shown. Both are the same rule for Pixel and Galaxy. */
  const SV_CONNECTOR_OPT = /adapter\s*colou?r|connector\s*colou?r|model\s*\/\s*colou?r/i;
  const SV_WATCHMODEL_OPT = /galaxy\s*watch\s*model|^watch\s*model$/i;
  let svRememberedConnector = null;
  function svWatchModelValueFor(values) {
    const model = String((currentWatchData && currentWatchData.model) || '');
    if (!model || !values || !values.length) return null;
    const ultra = /ultra/i.test(model);
    return values.find(v => /ultra/i.test(v) === ultra) || null;
  }

  function createOptionBasedDropdowns(product, preSelectedVariant) {
    const container = document.getElementById('optionDropdownsContainer');
    if (!container) {
      return;
    }

    // Clear existing dropdowns
    container.innerHTML = '';
    
    // Store product reference for event handlers
    currentDropdownProduct = product;
    currentOptionSelections = {};

    const options = product.options || [];
    const variants = product.variants || [];

    // If only one variant or no options, create a simple hidden input
    if (variants.length <= 1 || options.length === 0) {
      const variant = variants[0];
      if (variant) {
        updateSelectedVariant(variant);
      }
      // Hide mismatch warning for single-variant products
      const disclaimer = document.getElementById('lugWidthDisclaimer');
      if (disclaimer) disclaimer.style.display = 'none';
      return;
    }

    // Get the lug width from selected watch for smart pre-selection
    const lugWidth = currentWatchData?.lugWidth || "";
    const targetSize = extractNumericSize(lugWidth);

    // Create a dropdown for each option (collected first, then appended colour-first / width-last)
    const fields = [];
    options.forEach((option, optionIndex) => {
      const select = document.createElement('select');
      select.id = `optionSelect_${optionIndex}`;
      select.className = 'option-select';
      select.dataset.optionIndex = optionIndex;
      select.dataset.optionName = option.name;

      // Create default "Select..." option with proper label
      const defaultOpt = document.createElement('option');
      defaultOpt.value = '';
      defaultOpt.textContent = formatOptionLabel(option.name);
      select.appendChild(defaultOpt);

      // Add option values
      option.values.forEach(value => {
        const opt = document.createElement('option');
        opt.value = value;
        opt.textContent = value;

        // Mark the size that fits the selected watch's lug width right in the dropdown,
        // e.g. "20mm (Correct fit)" - replaces the old standalone green banner.
        if (targetSize && isSizeValue(value) && extractNumericSize(value) === targetSize) {
          opt.textContent += ' (Correct fit)';
        }

        // Check if this value has any available variants
        const hasAvailable = variants.some(v => {
          const parts = parseVariantOptionValues(v.title, options);
          return parts[optionIndex] === value && v.availableForSale;
        });
        
        if (!hasAvailable) {
          opt.textContent += ' (Out of Stock)';
          // Don't disable - user might still want to see it
        }
        
        select.appendChild(opt);
      });

      // Pre-select based on the matched variant
      if (preSelectedVariant) {
        const parts = parseVariantOptionValues(preSelectedVariant.title, options);
        if (parts[optionIndex]) {
          currentOptionSelections[optionIndex] = parts[optionIndex];
          select.value = parts[optionIndex];
        }
      }

      // Add change event listener
      select.addEventListener('change', () => {
        handleOptionChange(optionIndex, select.value);
      });

      // Wrap each dropdown with a helper label ("Colour", "Strap Width", "Stitching", …) so people
      // know what they're picking. The ORIGINAL optionIndex stays on the <select>, so the reorder
      // below does NOT affect variant matching.
      const field = document.createElement('div');
      field.className = 'sv-variant-field';
      const fLabel = document.createElement('label');
      fLabel.className = 'sv-variant-label';
      fLabel.setAttribute('for', select.id);
      fLabel.textContent = getVariantFieldLabel(option.name);
      field.appendChild(fLabel);
      field.appendChild(select);

      const _nm = (option.name || '').toLowerCase();
      const _isColour = /colou?r/.test(_nm);
      const _isSize = isSizeOption(option.name) || (option.values || []).some(v => isSizeValue(v));
      // colour first (0), strap width / size last (2), everything else in between (1)
      fields.push({ field, order: _isColour ? 0 : (_isSize ? 2 : 1), idx: optionIndex });
    });

    // Append colour-first, strap-width-last (stable within a group).
    fields.sort((a, b) => (a.order - b.order) || (a.idx - b.idx));
    fields.forEach(f => container.appendChild(f.field));

    // 3.92.0: hide the watch-model option and set it from the chosen watch; carry the remembered
    // connector colour forward. The matching variant is then re-resolved from the selections.
    let _forced = false;
    options.forEach((option, optionIndex) => {
      const sel = document.getElementById(`optionSelect_${optionIndex}`);
      if (!sel) return;
      if (SV_WATCHMODEL_OPT.test(option.name || '')) {
        const want = svWatchModelValueFor(option.values || []);
        const field = sel.closest('.sv-variant-field');
        if (field) field.style.display = 'none';
        if (want && sel.value !== want) { sel.value = want; currentOptionSelections[optionIndex] = want; _forced = true; }
      } else if (SV_CONNECTOR_OPT.test(option.name || '') && svRememberedConnector &&
                 (option.values || []).indexOf(svRememberedConnector) >= 0 && sel.value !== svRememberedConnector) {
        sel.value = svRememberedConnector; currentOptionSelections[optionIndex] = svRememberedConnector; _forced = true;
      }
    });
    if (_forced) {
      const mv = findMatchingVariant();
      if (mv) {
        preSelectedVariant = mv;
        const _fsrc = variantVisualiserSrc(product, mv);
        syncStrapThumb(product.id, _fsrc);
        /* 3.94.1: the preview must follow too. Callers set currentStrapURL from svStrapUrl() BEFORE
           these dropdowns exist (= the first variant's kit photo), then composite AFTER this
           returns - so a remembered Rose Gold connector showed in the dropdown while the render
           still wore Black (owner, Pixel 5 45mm). Only when this is the strap being drawn. */
        if (_fsrc && selectedStrapProduct && String(selectedStrapProduct.id) === String(product.id)) currentStrapURL = _fsrc;
      }
    }

    // Update hidden input with the pre-selected variant
    if (preSelectedVariant) {
      updateSelectedVariant(preSelectedVariant);
      
      // Check if first variant's size matches the watch size
      // If it does, show it as-is (even if OOS)
      // If it doesn't match, auto-correct to find a matching size
      const watchLugWidth = currentWatchData?.lugWidth || "";
      const watchSize = extractNumericSize(watchLugWidth);
      const variantSize = extractSizeFromVariantTitle(preSelectedVariant.title);
      
      // Only auto-correct if sizes don't match
      const shouldAutoCorrect = (watchSize && variantSize && watchSize !== variantSize);
      checkSizeMismatch(preSelectedVariant, product, shouldAutoCorrect);
    }

    // Apple sizing is a named range, not a lug measurement, so the numeric auto-correct above
    // can't reach it - match it explicitly to the case size chosen on the watch.
    syncAppleSizeSelection();

    options.forEach((opt, i) => {
    });
  }

  /* ---- Apple case size -> the strap's "Apple Watch Size" variant ----
     An Apple strap has ONE size option with two values, each covering a range of cases:
       "Series 1-9: 38-41mm & Series 10-11: 42mm"  and  "Series 1-9: 42-49mm Ultra & 2 & Series 10-11: 46mm"
     ⚠ Which one fits CANNOT be decided by matching millimetres against those strings: 42mm is the
     SMALLER size on a Series 10/11 and the LARGER one on a Series 1-9, and both strings say 42mm.
     The catalogue row itself states which end it is ("Pick smaller/larger size to match case
     (printed on back of watch)"), and that text is per case size, so it stays correct when the
     size dropdown is changed and it also covers the Ultras, which have no size dropdown at all. */
  function appleSizeWantsLarger() {
    const lug = String((currentWatchData && currentWatchData.lugWidth) || '');
    if (/pick\s+larger/i.test(lug)) return true;
    if (/pick\s+smaller/i.test(lug)) return false;
    return null;   // nothing stated - leave the strap's own default alone
  }
  function appleSizeOptionValue(option, wantLarger) {
    const vals = (option.values || []).filter(Boolean);
    if (vals.length < 2 || wantLarger === null) return null;
    // Rank by the largest case the value mentions (49 beats 42), so this does not depend on the
    // catalogue listing the smaller value first. Two-digit match only: "Series 1-9" is not a size.
    const maxMm = v => Math.max(0, ...(String(v).match(/\d{2}/g) || ['0']).map(Number));
    const sorted = [...vals].sort((a, b) => maxMm(a) - maxMm(b));
    const lo = sorted[0], hi = sorted[sorted.length - 1];
    if (maxMm(lo) === maxMm(hi)) return wantLarger ? vals[vals.length - 1] : vals[0];   // tie: use order
    return wantLarger ? hi : lo;
  }
  // Point the selected strap's size dropdown at the case size chosen on the watch side. Goes
  // through handleOptionChange so the variant, price, stock state and Add to Cart all follow, and
  // so any OTHER option the customer has picked (colour) is preserved.
  function syncAppleSizeSelection() {
    if (!currentDropdownProduct || !(currentWatchData && currentWatchData.isApple)) return;
    const options = currentDropdownProduct.options || [];
    const idx = options.findIndex(o => /apple\s*watch\s*size/i.test((o && o.name) || ''));
    if (idx < 0) return;
    const value = appleSizeOptionValue(options[idx], appleSizeWantsLarger());
    if (!value) return;
    const sel = document.getElementById('optionSelect_' + idx);
    if (!sel || sel.value === value) return;
    sel.value = value;
    handleOptionChange(idx, value);
  }

  /**
   * Formats the option label for display
   */
  function formatOptionLabel(optionName) {
    // Clean up common Shopify option naming patterns
    const name = optionName.trim();
    
    // Handle special cases
    if (/garmin\s*watch/i.test(name)) {
      return 'Select Size';
    }
    if (/strap\s*width/i.test(name)) {
      return 'Select Width';
    }
    if (/wrist\s*size/i.test(name)) {
      return 'Select Wrist Size';
    }
    if (/quickfit\s*connector\s*colou?r/i.test(name)) {
      return 'Select Connector Colour';
    }
    if (/adapter\s*colou?r|connector\s*colou?r|model\s*\/\s*colou?r/i.test(name)) {
      return 'Select Connector';   // 3.92.0
    }
    if (/buckle\s*colou?r/i.test(name)) {
      return 'Select Buckle Colour';
    }
    
    // For standard names, just prepend "Select"
    return `Select ${name}`;
  }

  /**
   * Friendly helper label shown ABOVE each variant dropdown (so people know what they're picking).
   * Returns just the field name (no "Select " prefix), normalising the common odd Shopify names.
   */
  function getVariantFieldLabel(optionName) {
    const n = (optionName || '').trim();
    if (/garmin\s*watch/i.test(n)) return 'Strap Width';
    if (/strap\s*width|^width$|^size$/i.test(n)) return 'Strap Width';
    if (/wrist\s*size/i.test(n)) return 'Wrist Size';
    if (/quickfit\s*connector\s*colou?r/i.test(n)) return 'Connector Colour';
    // 3.92.0: an adapter bundle's connector is just "Connector" (owner: "change connector colour
    // to just say connector"), and the Galaxy "Model/Colour" adapter option is the same thing.
    if (/adapter\s*colou?r|connector\s*colou?r|model\s*\/\s*colou?r/i.test(n)) return 'Connector';
    if (/buckle\s*colou?r/i.test(n)) return 'Buckle Colour';
    if (/^colou?r$|strap\s*colou?r/i.test(n)) return 'Colour';
    return n; // e.g. "Stitching", "Material" - show the merchant's own name
  }

  /* ---- The look-changing option is STICKY across a colour change ----
     Colour on most straps is a sibling PRODUCT, so picking another colour runs
     showStrapDetails -> createOptionBasedDropdowns, which wipes currentOptionSelections and
     preselects variants[0]. Choose "White" stitching on King Sailcloth Black, switch to Navy, and
     the details dropdown silently snapped back to "Matching" while the row dropdown still read
     "White" - two dropdowns disagreeing about the same choice, and the customer's pick lost.
     Remember the choice by option NAME and re-apply it on the new colour when that colour offers
     it. Scoped to the same colour GROUP so it can never leak onto an unrelated strap. */
  const SV_SIZE_OPT_RE = /colou?r|width|length|size|garmin\s*watch|wrist/i;
  let svStickyOpt = null;   // { groupKey, name, value }

  function svRememberStickyOption(product, optionName, value) {
    if (!product || !optionName) return;
    if (SV_SIZE_OPT_RE.test(optionName)) return;   // sizing choices are per-product, not sticky
    if (!value) { svStickyOpt = null; return; }
    svStickyOpt = { groupKey: getStrapGroupKey(product), name: optionName, value: value };
  }

  // The variant a freshly-selected strap should open on: variants[0], except that a sticky
  // look-changing choice (e.g. Stitching = White) carries over when this colour offers it.
  function svPreferredVariant(product) {
    const variants = (product && product.variants) || [];
    const v0 = variants[0];
    if (!v0 || !svStickyOpt || svStickyOpt.groupKey !== getStrapGroupKey(product)) return v0;
    const options = product.options || [];
    const oi = options.findIndex(o => o && o.name === svStickyOpt.name);
    if (oi < 0 || !(options[oi].values || []).includes(svStickyOpt.value)) return v0;
    const base = parseVariantOptionValues(v0.title, options);
    // Change ONLY the sticky option; every other option stays on the first variant's value.
    const match = variants.find(v => {
      const parts = parseVariantOptionValues(v.title, options);
      if (parts[oi] !== svStickyOpt.value) return false;
      for (let i = 0; i < options.length; i++) {
        if (i !== oi && base[i] !== undefined && parts[i] !== base[i]) return false;
      }
      return true;
    });
    return match || v0;
  }

  /* Push the live selections back onto the strap ROW's own dropdowns. The row is not re-rendered
     when the colour changes (setStrapGroupActive just swaps the thumbnail), so without this its
     selects keep displaying the previous colour's values. Matched by option NAME, not index, so a
     sibling colour whose options are ordered differently still lines up. */
  function syncRowOptionSelects(product) {
    const grid = document.getElementById('strapsGrid');
    if (!grid || !product) return;
    const img = grid.querySelector('img[data-id="' + product.id + '"]');
    const li = (img && img.closest('.strap-list-item')) || findStrapListItemForProduct(product);
    if (!li) return;
    const options = product.options || [];
    li.querySelectorAll('select[data-optname]').forEach(sel => {
      sel.dataset.pid = product.id;                       // the row may have changed member
      const oi = options.findIndex(o => o && o.name === sel.dataset.optname);
      const wrap = sel.closest('.strap-row-optwrap') || sel;
      // Colours of one family don't always share an option - King Sailcloth White has no
      // Stitching at all - so the row must not keep offering a choice this colour doesn't have.
      if (oi < 0) { wrap.style.display = 'none'; return; }
      wrap.style.display = '';
      sel.dataset.ci = oi;
      // Values can differ colour to colour too; rebuild when they do.
      const vals = options[oi].values || [];
      const cur = Array.prototype.map.call(sel.options, o => o.value);
      if (vals.length !== cur.length || vals.some((v, i) => v !== cur[i])) {
        sel.innerHTML = '';
        vals.forEach(v => {
          const o = document.createElement('option');
          o.value = v; o.textContent = v;
          sel.appendChild(o);
        });
      }
      const v = currentOptionSelections && currentOptionSelections[oi];
      if (v && sel.value !== v &&
          Array.prototype.some.call(sel.options, o => o.value === v)) {
        sel.value = v;
      }
    });
  }

  /**
   * Handles option dropdown change events
   */
  function handleOptionChange(changedOptionIndex, newValue) {
    if (!currentDropdownProduct) return;

    // Update selection state
    if (newValue) {
      currentOptionSelections[changedOptionIndex] = newValue;
    } else {
      delete currentOptionSelections[changedOptionIndex];
    }

    // Remember a look-changing choice (Stitching, Material, ...) so the next colour keeps it.
    const _changedOpt = (currentDropdownProduct.options || [])[changedOptionIndex];
    if (_changedOpt && newValue && SV_CONNECTOR_OPT.test(_changedOpt.name || '')) svRememberedConnector = newValue;
    if (_changedOpt) svRememberStickyOption(currentDropdownProduct, _changedOpt.name, newValue);

    // Find matching variant based on all selections
    const matchingVariant = findMatchingVariant();

    if (matchingVariant) {
      updateSelectedVariant(matchingVariant);
      updateVisualizerImage(matchingVariant);
      // Check for size mismatch warning
      checkSizeMismatch(matchingVariant, currentDropdownProduct, false);
      // Keep the strap row's own dropdowns showing what the details panel now holds.
      syncRowOptionSelects(currentDropdownProduct);
      // Update URL with new variant selection
      updateURLState();
    } else {
      // No exact match - update UI to show incompatible state
    }
  }

  /**
   * Finds a variant that matches all current option selections
   */
  function findMatchingVariant() {
    if (!currentDropdownProduct) return null;

    const variants = currentDropdownProduct.variants || [];
    const options = currentDropdownProduct.options || [];

    // If no selections made, return null
    const selectionCount = Object.keys(currentOptionSelections).length;
    if (selectionCount === 0) return null;

    // Find variant where all selected options match
    return variants.find(variant => {
      const parts = parseVariantOptionValues(variant.title, options);
      
      // Check each selection against the variant
      for (const [indexStr, selectedValue] of Object.entries(currentOptionSelections)) {
        const index = parseInt(indexStr, 10);
        if (parts[index] !== selectedValue) {
          return false;
        }
      }
      
      return true;
    });
  }

  /**
   * Updates the hidden variant ID input and related UI
   */
  function updateSelectedVariant(variant) {
    // Update hidden input for form submission
    const hiddenInput = document.getElementById('selectedVariantId');
    if (hiddenInput) {
      hiddenInput.value = variant.id;
    }

    // Update price display
    const priceEl = document.getElementById('strapPrice');
    if (priceEl) {
      priceEl.textContent = `Price: $${parseFloat(variant.price)}`;
    }

    // Update add to cart button
    updateAddToCartButton(variant);
  }

  /**
   * Updates the visualizer image based on selected variant
   */
  function updateVisualizerImage(variant) {
    if (!variant) return;

    // Default to the product's RESOLVED visualiser image (honours visualiser_image_position).
    // Do NOT default to variant.image - that's the variant's gallery/featured image, which is often
    // a marketing shot (e.g. Kingston's "Sweat Wicking Wings" front image, image[0]) and would
    // override the correct cutout, rendering a garbled/wrong strap. A variant-level
    // visualiser_image_position override (below) still wins if set.
    let imageToUse = variantVisualiserSrc(selectedStrapProduct, variant) || variant.image;

    if (imageToUse) {
      currentStrapURL = imageToUse;
      // Keep the strap list/grid thumbnail on the same colour as the preview.
      if (selectedStrapProduct) syncStrapThumb(selectedStrapProduct.id, imageToUse);
      combineImages();
    }
  }

  /************************************************************************
   * 9) AUTO-SELECT FIRST WATCH & FIRST STRAP
   ************************************************************************/
  // The storefront "Find your watch" header selector saves {brand, model, size} in
  // localStorage.selectedWatch, drawn from the SAME CRM catalogue this page's feed is a subset
  // of - so an exact brand+model hit IS the customer's watch (834 of the 838 visualiser rows
  // match the selector catalogue verbatim, incl. Apple's "Series 7:Case Size:41mm" strings).
  // When the exact row isn't in this feed (no visualiser image), fall back to the closest
  // SAME-BRAND row: best model-token overlap, with a strap-width tie-break - so a different
  // colourway of the same model wins first, then the nearest sibling model. Cross-brand guesses
  // are deliberately not made; with no same-brand row the page keeps its first-watch default.
  function svSelectorWatchPick() {
    let sel = null;
    try { sel = JSON.parse(localStorage.getItem('selectedWatch') || 'null'); } catch (e) {}
    if (!sel || (!sel.brand && !sel.model)) return null;
    const norm = s => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const selBrand = norm(sel.brand), selModel = norm(sel.model);
    if (!selModel) return null;
    const selSize = (norm(sel.size).match(/\d+/) || [])[0] || null;
    const imgs = [...document.querySelectorAll('#watchesGrid img[data-model]')];

    // Exact watch first - including a size hiding inside a merged Apple series row, where the
    // requested size's own model string lives on a sizeVariant, not on the row (same mechanism
    // restoreFromURLState uses for ?watch= links).
    for (const img of imgs) {
      if (norm(img.dataset.brand) === selBrand && norm(img.dataset.model) === selModel) return { img };
      const w = img._svWatch;
      const v = w && w.sizeVariants && w.sizeVariants.find(v =>
        norm(v.row.model) === selModel && norm(v.row.brand || img.dataset.brand) === selBrand);
      if (v) return { img, sizeLabel: v.label, model: v.row.model };
    }

    // Closest same-brand row.
    const selToks = selModel.split(' ').filter(Boolean);
    let best = null, bestScore = 0;
    for (const img of imgs) {
      if (norm(img.dataset.brand) !== selBrand) continue;
      const toks = norm(img.dataset.model).split(' ').filter(Boolean);
      let s = 0;
      for (const t of selToks) {
        if (toks.indexOf(t) >= 0) s += (t.length >= 3 ? 2 : 1);
        else if (t.length >= 4 && toks.some(o => o.length >= 4 && (o.indexOf(t) >= 0 || t.indexOf(o) >= 0))) s += 1;
      }
      if (!s) continue;
      const lug = (String(img.dataset.lugWidth || '').match(/\d+/) || [])[0] || null;
      if (selSize && lug && lug === selSize) s += 0.5;
      if (s > bestScore) { bestScore = s; best = img; }
    }
    return best ? { img: best } : null;
  }

  function svEarlySelectWatch() {
    if (svUserInteracted || currentWatchData) return;
    const grid = document.getElementById('watchesGrid');
    if (!grid) return;
    const want = SV_INITIAL_PARAMS.get('watch');
    let img = null, sizeLabel = null;
    const imgs = [...grid.querySelectorAll('img[data-model]')];
    if (want) {
      img = imgs.find(i => i.dataset.model === want) || null;
      if (!img) {
        for (const i of imgs) {
          const w = i._svWatch;
          const v = w && w.sizeVariants && w.sizeVariants.find(v => v.row.model === want);
          if (v) { img = i; sizeLabel = v.label; break; }
        }
      }
    } else {
      const pick = svSelectorWatchPick();
      if (pick && pick.img) { img = pick.img; sizeLabel = pick.sizeLabel || null; }
    }
    if (!img) return;
    if (sizeLabel) {
      const szSel = img.closest('.watch-list-item')?.querySelector('.watch-size-select');
      if (szSel) { szSel.value = sizeLabel; szSel.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    grid.querySelectorAll('img').forEach(i => i.classList.remove('selected'));
    grid.querySelectorAll('.watch-list-item').forEach(li => li.classList.remove('selected'));
    img.classList.add('selected');
    const li = img.closest('.watch-list-item');
    if (li) li.classList.add('selected');
    displayWatchDetails(img);
    svRaf(() => svRevealRow(img));
    window.__svTrace && window.__svTrace.push('early:watch:' + img.dataset.model);
  }

  function autoSelectFirstWatchAndStrap() {
    // Check if there are URL params to restore from
    const params = getURLParams();
    const watchParam = params.get('watch');
    const strapParam = params.get('strap');
    const hasValidURLState = (watchParam && watchParam.trim() !== '') || 
                              (strapParam && strapParam.trim() !== '');
    
    if (hasValidURLState) {
      // Restore from URL state instead of auto-selecting defaults
      restoreFromURLState();
      return;
    }
    
    // No URL params - proceed with default auto-selection
    window.__svTrace && window.__svTrace.push('autosel:path:default');

    // Wait a bit for everything to be ready
    setTimeout(() => {
      // If the user already started picking, don't override their selection with the first watch.
      if (svUserInteracted) return;
      // First watch - preferring the customer's own watch from the header selector.
      const watchGrid = document.getElementById("watchesGrid");
      const pick = svSelectorWatchPick();
      if (pick && pick.sizeLabel) {
        // Switch the merged Apple row over to the requested case size before selecting it.
        const szSel = pick.img.closest('.watch-list-item')?.querySelector('.watch-size-select');
        if (szSel) { szSel.value = pick.sizeLabel; szSel.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      const already = currentWatchData ? watchGrid.querySelector('img.selected') : null;   // 3.92.0: chosen early
      const firstWatch = already || (pick && pick.img) || watchGrid.querySelector("img[data-raw-link]");
      window.__svTrace && window.__svTrace.push('autosel:firstWatch:' + (firstWatch ? firstWatch.dataset.model : 'none') + (pick ? ':selectorPick' : ''));
      // A selector-matched row can be hundreds of rows down - bring it into view.
      if (pick && pick.img) svRaf(() => svRevealRow(pick.img));
      
      if (firstWatch) {
        firstWatch.classList.add("selected");
        
        // Manually set up watch data (instead of click which triggers async filtering)
        if (!already) displayWatchDetails(firstWatch);   // 3.92.0: chosen early, already displayed
        
        // Re-match variant if strap is already selected
        if (selectedStrapProduct) {
          showStrapDetails(selectedStrapProduct);
        }
        
        // Wait for filterStrapsByAllCategories RAF to complete, then select the first visible
        // strap. Retries because on a cold/slow load the strap list may not have rendered yet
        // when this first fires (the old empty-preview-on-load bug).
        const trySelectFirstStrap = (attempt) => {
          window.__svTrace && window.__svTrace.push('autosel:attempt:' + attempt);
          svRaf(() => {
            svRaf(() => {
              if (svUserInteracted) return; // user picked something in the meantime
              const strapsGrid = document.getElementById("strapsGrid");

              // Find first VISIBLE strap (after filtering has been applied)
              const allStrapImages = strapsGrid.querySelectorAll("img[data-id]");
              const firstVisibleStrap = Array.from(allStrapImages).find(isStrapImgShown);
              window.__svTrace && window.__svTrace.push('autosel:imgs:' + allStrapImages.length + ':vis:' + (firstVisibleStrap ? firstVisibleStrap.dataset.id : 'none'));

              if (!firstVisibleStrap) {
                if (attempt < 8) setTimeout(() => trySelectFirstStrap(attempt + 1), 400);
                return;
              }

              // Clear any previous strap selection
              strapsGrid.querySelectorAll("img").forEach(i => i.classList.remove("selected"));
              strapsGrid.querySelectorAll(".strap-list-item").forEach(item => item.classList.remove("selected"));

              firstVisibleStrap.classList.add("selected");

              // If in list view, also mark parent list item
              const listItem = firstVisibleStrap.closest('.strap-list-item');
              if (listItem) listItem.classList.add("selected");

              const chosenId = firstVisibleStrap.dataset.id;
              selectedStrapProduct = allStrapProducts.find(p => String(p.id) === String(chosenId));

              if (selectedStrapProduct) {
                currentStrapURL = svStrapUrl(selectedStrapProduct);
                showStrapDetails(selectedStrapProduct);

                if (currentWatchData && currentStrapURL) {
                  combineImages();
                }
              }
            });
          });
        };
        setTimeout(() => trySelectFirstStrap(0), 100); // small delay so the filter RAF starts first
      } else {
      }
    }, 1000); // Initial delay to ensure everything is loaded
  }
    
  /************************************************************************
   * UTILITY FUNCTIONS - OPTIMIZED
   ************************************************************************/
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  /**
   * Show/hide "no results" message when filters return zero items
   * @param {string} gridId - ID of the grid element ('watchesGrid' or 'strapsGrid')
   * @param {boolean} show - Whether to show the message
   * @param {string} itemType - Type of items ('watches' or 'straps')
   */
  /* "Loading straps…" placeholder, shown in place of the empty state while the strap list is
     still on its way. Same shape as the Apple spinner, but it covers the ordinary case: any watch
     picked before the catalogue has rendered. */
  function showStrapsLoading(on) {
    const grid = document.getElementById('strapsGrid');
    if (!grid) return;
    if (on && !document.getElementById('sv-apple-spin-style')) {
      const st = document.createElement('style'); st.id = 'sv-apple-spin-style';
      st.textContent = '@keyframes svspin{to{transform:rotate(360deg)}}'; document.head.appendChild(st);
    }
    // The fetch failed and the retry box owns the grid - don't spin underneath it forever.
    if (on && document.getElementById('svStrapRetryBtn')) on = false;
    // An Apple watch picked during the same window already has its own, more specific spinner.
    const ap = document.getElementById('strapsGrid-apples-loading');
    if (on && ap && ap.style.display !== 'none') on = false;
    let el = document.getElementById('strapsGrid-loading');
    if (on) {
      if (!el) {
        el = document.createElement('div');
        el.id = 'strapsGrid-loading';
        el.style.cssText = 'grid-column:1/-1;width:100%;display:flex;justify-content:center;align-items:center;min-height:200px;';
        el.innerHTML = '<div style="text-align:center;padding:40px 20px;color:#666;min-width:220px;"><div style="width:34px;height:34px;border:3px solid #eee;border-top-color:#b2955f;border-radius:50%;margin:0 auto 14px;animation:svspin .8s linear infinite;"></div><h3 style="margin:0 0 6px;color:#333;font-size:1.05rem;">Loading straps…</h3><p id="svStrapsLoadText" style="margin:0 0 10px;font-size:.9rem;">One moment</p><div style="height:6px;border-radius:3px;background:#eee;overflow:hidden;"><div id="svStrapsLoadBar" style="height:100%;width:0%;background:#b2955f;transition:width .3s;"></div></div></div>';
        grid.appendChild(el);
      }
      el.style.display = 'flex';
      svStrapsProgressPaint();
    } else if (el) {
      el.style.display = 'none';
    }
  }

  try { window.__svShowStrapsLoading = showStrapsLoading; } catch (e) {}   // debug hook

  /* 3.92.3: a progress bar under "Loading straps…" - pages land one at a time over ~26 s on a
     cold load, and a spinner that says nothing reads as a hang. The total is last visit's count
     (localStorage sv_straps_n); the first ever visit shows the running count alone. */
  let _svStrapsLoadedN = 0;
  let _svStrapsLoadMode = '';   // 3.93.0: 'watch' while the watch-first page is in flight
  function svStrapsProgress(loaded) {
    _svStrapsLoadedN = loaded;
    svStrapsProgressPaint();
  }
  function svStrapsProgressPaint() {
    const t = document.getElementById('svStrapsLoadText'), b = document.getElementById('svStrapsLoadBar');
    if (!t || !b) return;
    let total = 0;
    try { total = parseInt(localStorage.getItem('sv_straps_n') || '0', 10) || 0; } catch (e) {}
    const n = _svStrapsLoadedN;
    if (_svStrapsLoadMode === 'watch' && !n) { t.textContent = 'Straps for your watch first'; b.style.width = '35%'; return; }
    if (!n) { t.textContent = 'One moment'; b.style.width = '0%'; return; }
    if (total > n) {
      t.textContent = n.toLocaleString() + ' of ' + total.toLocaleString() + ' straps';
      b.style.width = Math.min(98, Math.round(100 * n / total)) + '%';
    } else {
      t.textContent = n.toLocaleString() + ' straps so far';
      b.style.width = '90%';
    }
  }

  function showNoResultsMessage(gridId, show, itemType) {
    const grid = document.getElementById(gridId);
    if (!grid) return;
    // The straps aren't ALL on screen yet: "loading", never "none found". 3.92.3: judged by the
    // final render, not the first partial page - with the watch chosen early (3.92.0) the first
    // pages filtered to nothing and the grid said "No matching straps" until the last page landed.
    if (gridId === 'strapsGrid' && !_svFinalStrapRender) {
      showStrapsLoading(true);
      show = false;
    } else if (gridId === 'strapsGrid' && _svFullStrapsPending && currentWatchData && !currentWatchData.isApple &&
               !currentWatchData.noStraps && (!_svWatchFirst || currentWatchData.collectionHandle !== _svWatchFirst.handle)) {
      // 3.93.0: only the first watch's straps are in; another watch is still loading, not empty.
      showStrapsLoading(true);
      show = false;
    } else if (gridId === 'strapsGrid') {
      showStrapsLoading(false);
    }
    // Never tell someone on an Apple watch that there are "no matching straps" while the Apple
    // range still isn't in hand - the honest states are "loading" (spinner) or, if the fetch
    // actually failed, the retry box. Derived from whether the straps are THERE rather than from
    // the in-flight flag alone, because a failed fetch clears that flag and used to fall straight
    // through to the empty state.
    if (gridId === 'strapsGrid' &&
        (window.__applesLoading || (currentWatchData && currentWatchData.isApple && !_appleStrapsReady))) {
      show = false;
    }
    // Same rule for the watch's own collection: while it is still loading, the honest state is
    // the spinner. Everything is hidden in that window (see collPending in the filter pass), so
    // without this the customer would be told this watch has no straps at all.
    if (gridId === 'strapsGrid' && currentWatchData && currentWatchData.collectionPending) {
      showStrapsLoading(true);
      show = false;
    }
    /* A watch we stock nothing for gets its own message: "no matching straps" reads as though the
       customer's filters are at fault, and an empty grid reads as a broken page. Driven from here
       because this runs on every filter pass, which includes every watch change. */
    if (gridId === 'strapsGrid') {
      const _none = !!(currentWatchData && currentWatchData.noStraps);
      svShowNoStrapsNotice(_none);
      if (_none) { showStrapsLoading(false); show = false; }
    }

    if (gridId === 'strapsGrid' && SV_EMBED) svEmbedNoFit(show || !!(currentWatchData && currentWatchData.isApple));   // 3.94.0: the rail is hidden - say it in the preview
    const messageId = `${gridId}-no-results`;
    let messageEl = document.getElementById(messageId);
    
    if (show) {
      // Create message if it doesn't exist
      if (!messageEl) {
        messageEl = document.createElement('div');
        messageEl.id = messageId;
        messageEl.className = 'no-results-message';
        messageEl.style.cssText = 'grid-column: 1 / -1; width: 100%; display: flex; justify-content: center; align-items: center; min-height: 200px;';
        messageEl.innerHTML = `
          <div style="text-align: center; padding: 40px 20px; color: #666;">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5" style="margin-bottom: 16px;">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              <line x1="8" y1="11" x2="14" y2="11"></line>
            </svg>
            <h3 style="margin: 0 0 8px 0; color: #333; font-size: 1.1rem;">No matching ${itemType} found</h3>
            <p style="margin: 0; font-size: 0.9rem;">Try adjusting your filters or search terms</p>
          </div>
        `;
        grid.appendChild(messageEl);
      }
      messageEl.style.display = 'flex';
    } else {
      // Hide message if it exists
      if (messageEl) {
        messageEl.style.display = 'none';
      }
    }
  }

  /************************************************************************
   * SORTING HELPER FUNCTIONS
   ************************************************************************/
  /**
   * Get sortable name by removing bracket prefixes like [Quick Release] or [Quickfit]
   * @param {string} name - Full product name
   * @returns {string} - Name without bracket prefix for sorting
   */
  function getSortableName(name) {
    if (!name) return '';
    // Remove [Quick Release], [Quickfit], or any other bracket prefix at the start
    return name.replace(/^\s*\[[^\]]+\]\s*/i, '').trim();
  }

  /**
   * Sort products alphabetically by their sortable name
   * @param {Array} products - Array of product objects with title property
   * @returns {Array} - Sorted array
   */
  function sortProductsAlphabetically(products) {
    return products.sort((a, b) => {
      const nameA = getSortableName(a.title || '').toLowerCase();
      const nameB = getSortableName(b.title || '').toLowerCase();
      return nameA.localeCompare(nameB);
    });
  }

  /************************************************************************
   * SEARCH HELPER FUNCTIONS
   ************************************************************************/
  /**
   * Check if strap product matches search query
   * Searches: title, colors, categories, variant sizes, strap types
   * @param {Object} product - Strap product object
   * @param {string} query - Search query
   * @returns {boolean} - True if match found
   */
  function strapMatchesSearch(product, query) {
    if (!query || query.trim() === '') return true;
    
    const searchTerm = query.toLowerCase().trim();
    
    // Build searchable fields array
    const searchableFields = [
      product.title || '',
      product.mainCategory || '',
      product.subCategory || '',
      product.productSubCategory || ''
    ];
    
    // Add all color variants
    if (product.strapColor) {
      try {
        const colorArray = JSON.parse(product.strapColor);
        if (Array.isArray(colorArray)) {
          searchableFields.push(...colorArray);
        }
      } catch (e) {
        searchableFields.push(product.strapColor);
      }
    }
    
    // Add all strap types
    if (product.strapTypes && Array.isArray(product.strapTypes)) {
      searchableFields.push(...product.strapTypes);
    }
    
    // Add variant information (sizes, colors from variant titles)
    if (product.variants && Array.isArray(product.variants)) {
      product.variants.forEach(variant => {
        if (variant.title) {
          searchableFields.push(variant.title);
          // Split variant title by " / " to get individual attributes
          const parts = variant.title.split(' / ');
          searchableFields.push(...parts);
        }
      });
    }
    
    // Check if any field contains the search term (case-insensitive, partial match)
    return searchableFields.some(field => 
      field && field.toString().toLowerCase().includes(searchTerm)
    );
  }

  // Add window resize listener to keep action buttons centered and enforce grid view on mobile
  window.addEventListener('resize', debounce(() => {
    centerActionButtons();
    enforceGridViewOnMobile();
  }, 250));

  /************************************************************************
   * IMAGE UTILS - OPTIMIZED WITH MEMORY MANAGEMENT
   ************************************************************************/
  // Image cache to avoid reloading (with size limit)
  const imageCache = new Map();
  const MAX_IMAGE_CACHE_SIZE = 50;
  
  function cleanupCache(cache, maxSize) {
    if (cache.size > maxSize) {
      const keysToDelete = Array.from(cache.keys()).slice(0, cache.size - maxSize);
      keysToDelete.forEach(key => cache.delete(key));
    }
  }

  // Shopify CDN on-the-fly resize: same image, far smaller payload. No-op for non-CDN/data/blob URLs.
  function cdnSized(url, w) {
    if (!url || url.indexOf('cdn.shopify.com') === -1 || url.indexOf('data:') === 0 || url.indexOf('blob:') === 0) return url;
    return url + (url.indexOf('?') === -1 ? '?width=' : '&width=') + w;
  }

  // ⚠⚠ A 200 from the CDN is NOT enough for these images, because we set crossOrigin.
  // If an edge node first caches a copy that was fetched WITHOUT an Origin header, that cached
  // copy carries no `Access-Control-Allow-Origin`, and the CDN keeps serving it to browsers that
  // DO send one. With img.crossOrigin = 'anonymous' the browser then rejects a perfectly healthy
  // 200 and fires onerror, so the preview draws nothing and the user sees a broken-image glyph in
  // an empty frame. Observed 2026-08-13 on the Amazfit Active 2 watch PNG: no ACAO header on one
  // request, present on the next, same URL. It is per-image and per-edge-node, which is why it
  // looks like "this one strap is broken on my phone but fine on desktop".
  //
  // We cannot just drop crossOrigin: it is load-bearing for the canvas export ("Download Image").
  // Without it the canvas is tainted and toDataURL/toBlob throws. So instead: retry ONCE with a
  // cache-busting param. That forces a MISS at the edge, the refetch carries our Origin, and the
  // response cached under that variant has the ACAO header - so the retry succeeds and the
  // download keeps working. The buster is bucketed per minute rather than fully random so a
  // burst of failures shares one variant instead of spraying unique URLs into the CDN cache.
  function corsRetryUrl(url) {
    const bucket = Math.floor(Date.now() / 60000);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'svcors=' + bucket;
  }

  function loadImage(url) {
    // Check cache first
    if (imageCache.has(url)) {
      return Promise.resolve(imageCache.get(url));
    }

    return new Promise((resolve, reject) => {
      let retried = false;

      const attempt = (src) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          // Cache under the ORIGINAL url, never the cache-busted one - otherwise every retry
          // becomes a permanent cache miss and we refetch the same image forever.
          imageCache.set(url, img);
          cleanupCache(imageCache, MAX_IMAGE_CACHE_SIZE);
          resolve(img);
        };
        img.onerror = () => {
          if (!retried) {
            retried = true;
            window.__svTrace && window.__svTrace.push('img:retry:' + url);
            attempt(corsRetryUrl(url));
            return;
          }
          // Never fail silently: an empty frame with nothing in the console is exactly what made
          // this take a day to find.
          console.error('[strap-visualiser] image failed twice (CORS or 404?):', url);
          reject(new Error('Failed to load ' + url));
        };
        img.src = src;
      };

      attempt(url);
    });
  }

  function drawToCanvas(img) {
    const c = document.createElement('canvas');
    c.width = img.width; c.height = img.height;
    const ctx = c.getContext('2d', { alpha: true, willReadFrequently: false });
    
    // Optimize canvas settings for performance
    ctx.imageSmoothingEnabled = false; // Faster for exact copy
    ctx.drawImage(img, 0, 0);
    return c;
  }

  /* Make a white studio background transparent, IN PLACE. Returns true when it fired.

     ⚠ Whiteness is distance from white, not brightness: a cream strap is bright too, and a
     brightness threshold eats it. A pixel counts as background only when every channel is high
     AND the channel spread is tiny (no colour cast), with a soft ramp either side so the weave
     keeps a clean edge instead of a white fringe.
     ⚠ Only fires when the image is essentially opaque AND its border is white - a real cutout,
     or a photo shot on anything else, is left exactly as it was. */
  function svKnockOutStudioWhite(cnv) {
    const w = cnv.width, h = cnv.height;
    if (!w || !h) return false;
    const ctx = cnv.getContext('2d');
    let img;
    try { img = ctx.getImageData(0, 0, w, h); } catch (e) { return false; }
    const d = img.data;
    const HI = 236, CHROMA = 16;
    const isWhite = i => {
      const r = d[i], g = d[i + 1], b = d[i + 2];
      const mn = r < g ? (r < b ? r : b) : (g < b ? g : b);
      const mx = r > g ? (r > b ? r : b) : (g > b ? g : b);
      return mn >= HI && (mx - mn) <= CHROMA;
    };
    // Only a studio shot: white border, and essentially no transparency of its own.
    let edge = 0, edgeWhite = 0, opaque = 0, sampled = 0;
    const step = Math.max(1, Math.round(Math.min(w, h) / 64));
    for (let x = 0; x < w; x += step) for (const y of [0, h - 1]) {
      const i = (y * w + x) * 4; edge++; if (d[i + 3] > 20 && isWhite(i)) edgeWhite++;
    }
    for (let y = 0; y < h; y += step) {
      for (const x of [0, w - 1]) { const i = (y * w + x) * 4; edge++; if (d[i + 3] > 20 && isWhite(i)) edgeWhite++; }
      for (let x = 0; x < w; x += step) { const i = (y * w + x) * 4; sampled++; if (d[i + 3] > 20) opaque++; }
    }
    if (!edge || !sampled) return false;
    if (edgeWhite / edge < 0.9) return false;
    if (opaque / sampled < 0.97) return false;

    /* ⚠ FLOOD FILL FROM THE BORDER, never a global "is this pixel white" test. A titanium bracelet
       shot on white IS near-white over most of its links: thresholding globally deleted the strap
       and left a torn staircase on the watch. Only background CONNECTED to the frame is removed,
       so a bright strap survives and an enclosed white gap (between links, inside a buckle) stays
       opaque - which is correct, it is not background the customer can see through. */
    const bg = new Uint8Array(w * h);
    const queue = new Int32Array(w * h);
    let qh = 0, qt = 0;
    const push = (x, y) => {
      if (x < 0 || y < 0 || x >= w || y >= h) return;
      const p = y * w + x;
      if (bg[p]) return;
      if (!isWhite(p * 4)) return;
      bg[p] = 1; queue[qt++] = p;
    };
    for (let x = 0; x < w; x++) { push(x, 0); push(x, h - 1); }
    for (let y = 0; y < h; y++) { push(0, y); push(w - 1, y); }
    while (qh < qt) {
      const p = queue[qh++], x = p % w, y = (p - x) / w;
      push(x + 1, y); push(x - 1, y); push(x, y + 1); push(x, y - 1);
    }
    let cleared = 0;
    for (let p = 0; p < bg.length; p++) if (bg[p]) { d[p * 4 + 3] = 0; cleared++; }
    if (cleared / (w * h) < 0.05) return false;      // nothing meaningful removed
    ctx.putImageData(img, 0, 0);
    return true;
  }

  // Crop a canvas to its non-transparent bounds. NOTE: no caching here on purpose - the old
  // version used origCanvas.toDataURL() as a cache key, which serialized the FULL-RES canvas to a
  // multi-MB base64 string on every call (4x per render) and retained up to 100 of them, OOM-ing
  // mobile browsers after many strap switches. The pixel scan below is cheap; recompute each time.
  // withOffset: return {canvas, offset} instead of the bare canvas, for callers that need to map a
  // pre-crop coordinate onto the cropped result. Every existing caller passes one argument and
  // keeps getting a canvas.
  // Rotate a canvas 180. Used by the per-product rotate180 override.
  function svRotate180(src) {
    const c = document.createElement('canvas');
    c.width = src.width; c.height = src.height;
    const x = c.getContext('2d');
    x.translate(src.width, src.height);
    x.rotate(Math.PI);
    x.drawImage(src, 0, 0);
    return c;
  }

  /* ---- Single-piece diagonal flat-lays ----
     Nearly every strap is photographed as two arms lying side by side, vertical, which is what the
     split-down-the-middle below assumes. The Steel Bracelet with Deployant Clasp family is shot
     the other way: ONE continuous bracelet running corner to corner across the frame, clasp in the
     middle. The vertical split happens to separate the two arms, so the render is not broken - but
     each arm keeps the photo's ~34 degree tilt and the composite comes out diagonal through the
     watch.
     ⚠ Measured across all 792 straps in the visualiser collection: 738 sit within 5 degrees of
     vertical and the next one is at 20.7 degrees, so a tilt like this is never noise. It is still
     driven by a per-product metafield rather than auto-detected, because the OTHER tilted straps
     are not diagonal flat-lays at all - Sailcloth, ElastoFlex, Cross/Alpha Militex and the
     "Deployment Clasp 3" bracelets have a whole WATCH in the frame (a lifestyle photo used as the
     visualiser image), and rotating those fixes nothing. Those need new artwork, not geometry. */

  // Angle of a canvas's ink, in degrees from horizontal, via the principal axis of its alpha mask.
  // Sampled on a <=320px downsample: this only needs the gross direction, and a full-resolution
  // pass would walk 4M pixels on every render.
  function svAlphaAxisAngle(src) {
    const long = Math.max(src.width, src.height);
    const k = long > 320 ? 320 / long : 1;
    const w = Math.max(1, Math.round(src.width * k));
    const h = Math.max(1, Math.round(src.height * k));
    const c = document.createElement('canvas');
    c.width = w; c.height = h;
    c.getContext('2d').drawImage(src, 0, 0, w, h);
    const d = c.getContext('2d').getImageData(0, 0, w, h).data;
    let n = 0, sx = 0, sy = 0;
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
      if (d[(y * w + x) * 4 + 3] > 16) { n++; sx += x; sy += y; }
    }
    if (n < 50) return 90;
    const mx = sx / n, my = sy / n;
    let cxx = 0, cxy = 0, cyy = 0;
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
      if (d[(y * w + x) * 4 + 3] > 16) {
        const dx = x - mx, dy = y - my;
        cxx += dx * dx; cxy += dx * dy; cyy += dy * dy;
      }
    }
    cxx /= n; cxy /= n; cyy /= n;
    // Larger eigenvector of the 2x2 covariance matrix.
    const tr = cxx + cyy, det = cxx * cyy - cxy * cxy;
    const l = tr / 2 + Math.sqrt(Math.max(0, tr * tr / 4 - det));
    const vx = (Math.abs(cxy) > 1e-9) ? (l - cyy) : 1;
    const vy = (Math.abs(cxy) > 1e-9) ? cxy : 0;
    let a = Math.atan2(vy, vx) * 180 / Math.PI;
    return ((a + 90) % 180) - 90;   // -90..90, from horizontal
  }

  // Rotate a canvas by `deg` (clockwise, screen coords), expanding so nothing is clipped.
  function svRotateDeg(src, deg) {
    const r = deg * Math.PI / 180;
    const cos = Math.abs(Math.cos(r)), sin = Math.abs(Math.sin(r));
    const w = Math.ceil(src.width * cos + src.height * sin);
    const h = Math.ceil(src.width * sin + src.height * cos);
    const c = document.createElement('canvas');
    c.width = w; c.height = h;
    const x = c.getContext('2d');
    x.translate(w / 2, h / 2);
    x.rotate(r);
    x.drawImage(src, -src.width / 2, -src.height / 2);
    return c;
  }

  // Turn a single-piece diagonal flat-lay into the pair of arms the rest of the pipeline expects:
  // stand the bracelet upright, cut it ACROSS the middle (down the middle would slice it
  // lengthwise), and hand back both halves connector-end-down, which is the orientation a normal
  // two-arm flat-lay already has.
  // Is this cut-out ONE tall band (a continuous loop/bracelet, or a pair of arms stacked in a
  // single column)? Long axis >= 3.5x the short one and no empty run across the short axis -
  // two arms side by side always have one. Landscape one-pieces (shot lying down) count too.
  function svLooksOnePiece(cnv) {
    try {
      const c = cropToContent(cnv);
      const w = c.width, h = c.height;
      if (!w || !h) return false;
      if (Math.max(w, h) / Math.min(w, h) < 3.5) return false;
      const d = c.getContext('2d').getImageData(0, 0, w, h).data;
      const vertical = h >= w, n = vertical ? w : h;
      const prof = new Array(n).fill(0);
      for (let y = 0; y < h; y += 2) for (let x = 0; x < w; x += 2)
        if (d[(y * w + x) * 4 + 3] > 16) prof[vertical ? x : y]++;
      let run = 0, gap = 0, seen = false;
      for (let i = 0; i < n; i++) {
        if (prof[i] === 0) { if (seen) run++; }
        else { seen = true; if (run > gap) gap = run; run = 0; }
      }
      const one = gap < Math.max(2, n * 0.02);
      window.__svTrace && window.__svTrace.push('strap:looksOnePiece:' + one + ':' + w + 'x' + h + ':gap' + gap);
      return one;
    } catch (e) { return false; }
  }

  function svSingleDiagonalArms(strapCanvas) {
    const a = svAlphaAxisAngle(strapCanvas);
    // Smallest turn that stands it up. ⚠ Canvas angles are y-DOWN, so rotate(r) ADDS r to the
    // measured axis angle: the turn is (target - a), not (a - target).
    const toVertical = (a > 0) ? (90 - a) : (-90 - a);
    const up = cropToContent(svRotateDeg(strapCanvas, toVertical));
    const w = up.width, h = up.height;
    /* ⚠ 3.52.0: cut at the GAP, not at the geometric midpoint. Two layouts arrive here:
       a genuinely continuous loop/bracelet (no gap - the midpoint is right) and a pair of
       arms STACKED one above the other in a tall single-column flat-lay (Original Silicone,
       Flexi Silicone, Leather Hybrid ...). The stacked pairs are not two equal halves, so a
       midpoint cut sliced through the lower arm and handed back one over-long arm plus a
       stub - the render came out ~21:1 with gaps at both lugs. Cutting on the empty band
       between them splits exactly where the artwork already separates. */
    const midY = (function(){
      const geom = Math.floor(h / 2);
      try {
        const d = up.getContext('2d').getImageData(0, 0, w, h).data;
        const cov = new Array(h).fill(0);
        for (let y = 0; y < h; y++){
          let n = 0;
          for (let x = 0; x < w; x += 2) if (d[(y * w + x) * 4 + 3] > 16) n++;
          cov[y] = n;
        }
        const lo = Math.floor(h * 0.2), hi = Math.floor(h * 0.8);
        let best = null, run = null;
        for (let y = lo; y < hi; y++){
          if (cov[y] === 0) { if (!run) run = [y, y]; else run[1] = y; }
          else { if (run && (!best || (run[1] - run[0]) > (best[1] - best[0]))) best = run; run = null; }
        }
        if (run && (!best || (run[1] - run[0]) > (best[1] - best[0]))) best = run;
        // A one-piece loop has no interior gap at all; anything under ~1% of the height is noise.
        if (best && (best[1] - best[0]) >= Math.max(2, h * 0.01)) {
          window.__svTrace && window.__svTrace.push('strap:cut-at-gap ' + best[0] + '-' + best[1]);
          return Math.round((best[0] + best[1]) / 2);
        }
      } catch (e) {}
      return geom;
    })();
    const cut = (y0, y1) => {
      const c = document.createElement('canvas');
      c.width = w; c.height = y1 - y0;
      c.getContext('2d').drawImage(up, 0, y0, w, y1 - y0, 0, 0, w, y1 - y0);
      return cropToMainComponent(c);
    };
    window.__svTrace && window.__svTrace.push('strap:deskewed ' + toVertical.toFixed(1));
    return {
      // Upper half runs connector-end UP, so flip it; the lower half already points the right way.
      top: flipVertical(cut(0, midY)),
      bottom: cut(midY, h)
    };
  }

  // Crop a strap ARM to its real body, ignoring stray specks.
  //
  // ⚠ A plain bounding-box crop is at the mercy of any loose fragment in the cutout. On
  // [Quick Release] Textured FKM Rubber the lower arm carries two crumbs of clasp - 1126px and
  // 80px against the strap's 419410px, hard against the left edge. They contribute 0.3% of the
  // ink and yet stretch the box far enough that the strap sits 4.3% of its own width off centre,
  // which then feeds the lug-based X alignment and the arm-width measurement.
  //
  // Components holding less than 1% of the ink are dropped. Straps with clean artwork are
  // untouched: Alcantara Black is a single component in both halves and comes out bit-identical.
  // ⚠ Do NOT do this with a column/row ink threshold instead - that trims real content, taking
  // Alcantara from 550px wide to 485px, because a tapered end has genuinely thin columns.
  //
  // Labelling runs on a mask downsampled to <=320px on the long side: we only need to find crumbs,
  // and full resolution would mean a flood fill over 4M pixels on every render.
  function cropToMainComponent(src, minFrac) {
    try {
      return svCropMainComponentInner(src, minFrac);
    } catch (e) {
      // This runs on every render for every strap. If the labelling ever throws - a tainted
      // canvas, an odd image, a browser quirk - fall back to the plain crop rather than taking
      // the whole visualiser down with it. A slightly off-centre strap beats a blank page.
      console.warn('[strap-visualiser] speck pruning failed, using the plain crop:', e);
      return cropToContent(src);
    }
  }

  function svCropMainComponentInner(src, minFrac) {
    const frac = minFrac || 0.01;
    const W = src.width, H = src.height;
    if (W < 8 || H < 8) return cropToContent(src);
    const scale = Math.min(1, 320 / Math.max(W, H));
    const w = Math.max(1, Math.round(W * scale)), h = Math.max(1, Math.round(H * scale));
    const tmp = document.createElement('canvas');
    tmp.width = w; tmp.height = h;
    tmp.getContext('2d').drawImage(src, 0, 0, w, h);
    const d = tmp.getContext('2d').getImageData(0, 0, w, h).data;

    const lab = new Int32Array(w * h).fill(-1);
    const stack = new Int32Array(w * h);
    const boxes = [];
    let total = 0;
    for (let i = 0; i < w * h; i++) if (d[i * 4 + 3] > 8) total++;
    if (!total) return cropToContent(src);

    let next = 0;
    for (let s = 0; s < w * h; s++) {
      if (lab[s] !== -1 || d[s * 4 + 3] <= 8) continue;
      const id = next++;
      let sp = 0, size = 0;
      let mnx = w, mxx = -1, mny = h, mxy = -1;
      stack[sp++] = s; lab[s] = id;
      while (sp) {
        const p = stack[--sp];
        const px = p % w, py = (p / w) | 0;
        size++;
        if (px < mnx) mnx = px; if (px > mxx) mxx = px;
        if (py < mny) mny = py; if (py > mxy) mxy = py;
        if (px > 0     && lab[p - 1] === -1 && d[(p - 1) * 4 + 3] > 8) { lab[p - 1] = id; stack[sp++] = p - 1; }
        if (px < w - 1 && lab[p + 1] === -1 && d[(p + 1) * 4 + 3] > 8) { lab[p + 1] = id; stack[sp++] = p + 1; }
        if (py > 0     && lab[p - w] === -1 && d[(p - w) * 4 + 3] > 8) { lab[p - w] = id; stack[sp++] = p - w; }
        if (py < h - 1 && lab[p + w] === -1 && d[(p + w) * 4 + 3] > 8) { lab[p + w] = id; stack[sp++] = p + w; }
      }
      boxes.push({size: size, mnx: mnx, mxx: mxx, mny: mny, mxy: mxy});
    }

    // ⚠⚠ ALWAYS take the box from the DOWNSAMPLED mask. The first version of this bailed out to
    // cropToContent(src) whenever it found one component or dropped nothing, which quietly made
    // the whole thing a no-op on the straps that needed it most. A speck small enough relative to
    // the image averages below the alpha threshold when the mask is built, so it never becomes a
    // component at all - and the fallback then returned the FULL-RESOLUTION bounding box, specks
    // and all. King Waffle Army Green: 1 component found at 320px, so it fell back to 1394x3462
    // instead of the real body at 650x2385, the left half stayed inflated by 68%, and the
    // "top arm is the smaller half" rule kept picking the wrong arm. It rendered upside down and
    // I had already declared it fixed.
    // Vanishing in the downsample is not a failure here, it is the same answer by another route:
    // either way the mask holds the body and not the crumbs. Verified: Alcantara Black moves by
    // +0.7%/+0.5% (noise, arm order unchanged) and Textured FKM keeps the order it was signed off
    // with, while King Waffle flips from RIGHT to LEFT, which is the correct arm.
    let mnx = w, mxx = -1, mny = h, mxy = -1, dropped = 0;
    for (const b of boxes) {
      if (b.size < total * frac) { dropped++; continue; }
      if (b.mnx < mnx) mnx = b.mnx; if (b.mxx > mxx) mxx = b.mxx;
      if (b.mny < mny) mny = b.mny; if (b.mxy > mxy) mxy = b.mxy;
    }
    if (mxx < mnx) return cropToContent(src);
    window.__svTrace && window.__svTrace.push(
      'arm:crop:' + boxes.length + 'comp:dropped' + dropped);

    // back to full resolution, padded a pixel each way so downsampling cannot shave the body
    const x0 = Math.max(0, Math.floor(mnx / scale) - 1);
    const y0 = Math.max(0, Math.floor(mny / scale) - 1);
    const x1 = Math.min(W, Math.ceil((mxx + 1) / scale) + 1);
    const y1 = Math.min(H, Math.ceil((mxy + 1) / scale) + 1);
    const out = document.createElement('canvas');
    out.width = Math.max(1, x1 - x0); out.height = Math.max(1, y1 - y0);
    out.getContext('2d').drawImage(src, x0, y0, out.width, out.height, 0, 0, out.width, out.height);
    return cropToContent(out);
  }

  function cropToContent(origCanvas, withOffset) {
    const {width, height} = origCanvas;
    const ctx = origCanvas.getContext('2d');
    const imageData = ctx.getImageData(0, 0, width, height);
    const data = imageData.data;

    let minX = width, maxX = 0, minY = height, maxY = 0, found = false;
    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        if (data[(y * width + x) * 4 + 3] > 0) {
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
          found = true;
        }
      }
    }
    if (!found) return withOffset ? { canvas: origCanvas, offset: { x: 0, y: 0 } } : origCanvas;

    const cropW = maxX - minX + 1, cropH = maxY - minY + 1;
    const newCanvas = document.createElement('canvas');
    newCanvas.width = cropW;
    newCanvas.height = cropH;
    newCanvas.getContext('2d').putImageData(imageData, -minX, -minY);
    return withOffset ? { canvas: newCanvas, offset: { x: minX, y: minY } } : newCanvas;
  }

  function getNonTransparentPoints(canvas) {
    const ctx = canvas.getContext('2d');
    const {width, height} = canvas;
    const imageData = ctx.getImageData(0, 0, width, height).data;
    const pts = [];
    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        const idx = (y * width + x) * 4;
        if (imageData[idx + 3] > 0) {
          pts.push({x, y});
        }
      }
    }
    return pts;
  }

  function distance(a, b) {
    return Math.sqrt((a.x - b.x)**2 + (a.y - b.y)**2);
  }

  function findWatchLugs(canvas) {
    // Heuristics from your original code
    const pts = getNonTransparentPoints(canvas);
    const w = canvas.width, h = canvas.height;

    let topLeft = {x:0, y:0}, distTL = -1;
    let topRight = {x:0, y:0}, distTR = -1;
    let bottomLeft = {x:0, y:0}, distBL = -1;
    let bottomRight = {x:0, y:0}, distBR = -1;

    for (const p of pts) {
      // top-left
      let dTL = (p.x)**2 + (p.y)**2;
      if (dTL > distTL) { distTL = dTL; topLeft = p; }
      // top-right
      let dTR = (p.x - (w-1))**2 + (p.y)**2;
      if (dTR > distTR) { distTR = dTR; topRight = p; }
      // bottom-left
      let dBL = (p.x)**2 + (p.y - (h-1))**2;
      if (dBL > distBL) { distBL = dBL; bottomLeft = p; }
      // bottom-right
      let dBR = (p.x - (w-1))**2 + (p.y - (h-1))**2;
      if (dBR > distBR) { distBR = dBR; bottomRight = p; }
    }
    return { topLeft, topRight, bottomLeft, bottomRight };
  }

  // Measure the inner gap between the two lug horns at one end of the watch cutout.
  // Returns { gap, rootY }: gap = median inner-edge distance (px) across the tip band,
  // rootY = rows from that end where the central gap closes (the case edge between the lugs).
  // Both null when no gap is detectable (e.g. no-lug watches like Fitbit Versa/Sense).
  function findLugInnerGap(canvas, atTop) {
    const w = canvas.width, h = canvas.height;
    if (!w || !h) return { gap: null, rootY: null };
    const scanDepth = Math.min(h, Math.max(4, Math.round(h * 0.25)));
    const band = Math.max(3, Math.round(h * 0.06));
    const data = canvas.getContext('2d').getImageData(0, atTop ? 0 : h - scanDepth, w, scanDepth).data;
    const gaps = [];
    let rootY = null, sawGap = false;
    for (let r = 0; r < scanDepth; r++) {
      const y = atTop ? r : scanDepth - 1 - r;   // r = distance from the tip end
      let runs = 0, firstEnd = -1, lastStart = -1, inRun = false;
      for (let x = 0; x < w; x++) {
        const a = data[(y * w + x) * 4 + 3] > 10;
        if (a && !inRun) { inRun = true; runs++; if (runs > 1) lastStart = x; }
        else if (!a && inRun) { inRun = false; if (runs === 1) firstEnd = x - 1; }
      }
      const gap = (runs >= 2 && lastStart > firstEnd) ? (lastStart - firstEnd) : 0;
      if (gap > w * 0.15) {
        if (r < band) gaps.push(gap);
        sawGap = true;
      } else if (sawGap && rootY === null) {
        rootY = r; // first row (from the tip) where the gap between the horns has closed
      }
    }
    if (gaps.length < 2) return { gap: null, rootY: null };
    gaps.sort((a, b) => a - b);
    return { gap: gaps[gaps.length >> 1], rootY };
  }

  function flipVertical(origCanvas) {
    const {width, height} = origCanvas;
    const tmp = document.createElement('canvas');
    tmp.width = width;
    tmp.height = height;
    const ctx = tmp.getContext('2d');
    ctx.translate(0, height);
    ctx.scale(1, -1);
    ctx.drawImage(origCanvas, 0, 0);
    return tmp;
  }

  function resizeCanvas(origCanvas, scaleX, scaleY) {
    const newW = Math.round(origCanvas.width * scaleX);
    const newH = Math.round(origCanvas.height * scaleY);
    const tmp = document.createElement('canvas');
    tmp.width = newW;
    tmp.height = newH;
    tmp.getContext('2d').drawImage(origCanvas, 0, 0, newW, newH);
    return tmp;
  }

  function overlayImageAlpha(destCtx, sourceCanvas, dx, dy) {
    destCtx.drawImage(sourceCanvas, dx, dy);
  }


  /* ══ LIGHTING (3.65.0) ═══════════════════════════════════════════════════════════════════
     The composite used to be a flat collage: a flat-lay photographed under dim, yellowish
     warehouse light, pasted under a watch render, with no shadow anywhere. Metal read as dull
     grey card. Four cheap passes, all gated on SV_LIGHT.on and tuned per MATERIAL:
       1. svLiftExposure  - the strap's own brightest 1% is scaled toward white (equal gain on
                            R,G,B, so hue and saturation are untouched). Capped, and skipped
                            when the strap has no highlight to anchor on (a black strap must
                            stay black). The browser-side cousin of the CRM's relight, which
                            needs the paper-in-frame original this page never sees.
       2. svShadeArm      - a strap on a wrist is a cylinder: the two long edges roll away
                            (darkened), and a light from the upper-left leaves a specular band
                            along the length - narrow and bright on metal, faint on leather and
                            silicone. Painted with source-atop, so the arm's alpha is untouched.
       3. contact shadow  - the case casts a shadow onto the strap where the arm runs under it
                            (the last ~13% of a case height before the lug line).
       4. svDropShadow    - a soft ground shadow under the whole assembly, painted BEHIND it
                            (destination-over) from a downscaled shadow-only layer.
     ⚠ Every pass runs AFTER the measurements: the lift changes RGB only, the shading writes
     only where alpha already is, and the drop shadow is added after the arms are placed - so
     lug detection, arm widths, overlaps and the staff adjust offsets are all bit-identical to
     3.64.0. The rail thumbnails and the product gallery are NOT lifted; if a lifted render ever
     reads brighter than its product photos, lower liftCap* here rather than the gallery. */
  const SV_LIGHT = {
    on: true,
    liftTarget: 245,        // where the strap's brightest 1% should land
    liftMinP99: 150,        // no highlight this bright -> nothing to anchor on, leave it alone
    liftMinP99Metal: 120,   // a metal always has a highlight; a dim one is exactly the target case
    liftCap: 1.15, liftCapMetal: 1.30, liftMinGain: 1.03,
    // 2026-09-16: edge darkening REMOVED (owner's call). The gradient painted rgba(0,0,0,ed)
    // down both long edges of every arm, fading out edgeWidth in from each side. Invisible on
    // black/navy, but on a WHITE strap (QuickFit Flexi Silicone - White) it read as a dirty grey
    // outline a quarter of the strap wide. `if (ed > 0)` in svShadeArm skips the fill entirely at
    // 0, so this is a clean disable - restore the old values to bring it back.
    edgeDark: { metal: 0, gloss: 0, matte: 0 }, edgeWidth: 0.26,   // was { 0.30, 0.24, 0.20 }
    specPos: 0.38, specSigma: 0.10, specPeak: { metal: 0.34, gloss: 0.16, matte: 0.07 },
    spec2Pos: 0.80, spec2Sigma: 0.06, spec2Peak: { metal: 0.11, gloss: 0.05, matte: 0 },
    contactAlpha: 0.42, contactDepth: 0.13,   // fraction of case height
    dropAlpha: 0.16, dropBlur: 0.045, dropDy: 0.025   // fractions of case width
  };
  try { window.SV_LIGHT = SV_LIGHT; } catch (e) {}   // tune live from the console
  /* Material by NAME (and the strap_type metafield). Same exclusion-first shape as the swatch
     palette's svoIsMetalRow, plus a "gloss" tier for ceramic / acetate / resin, which reflect
     like metal but are not metal. Anything else is matte (leather, silicone, nylon, fabric). */
  const SV_MAT_METAL_RE = /\b(bracelet|milanese|mesh|jubilee|engineer|oyster|link|beads of rice|steel|titanium|metal)\b/i;
  const SV_MAT_NOT_METAL_RE = /leather|nylon|silicone|rubber|fabric|nato|canvas|resin|acetate|woven|ceramic|velcro|sailcloth|elastic|perlon|fkm|alcantara|suede|loop/i;
  const SV_MAT_GLOSS_RE = /ceramic|acetate|resin|zirconia|crystal|patent|gloss|shimmer|sparkle|pearl/i;
  function svMaterialOf(product) {
    const t = String((product && product.title) || '');
    const types = (product && Array.isArray(product.strapTypes) ? product.strapTypes : []).join(' ');
    if (SV_MAT_GLOSS_RE.test(t)) return 'gloss';
    if (/metal|steel|titanium/i.test(types) && !SV_MAT_NOT_METAL_RE.test(t)) return 'metal';
    if (SV_MAT_METAL_RE.test(t) && !SV_MAT_NOT_METAL_RE.test(t)) return 'metal';
    return 'matte';
  }
  // Pass 1. In place. Returns the gain applied (1 = untouched).
  function svLiftExposure(canvas, mat) {
    if (!SV_LIGHT.on || !canvas) return 1;
    try {
      const w = canvas.width, h = canvas.height;
      if (w < 2 || h < 2) return 1;
      const s = Math.min(1, 160 / Math.max(w, h));
      const sw = Math.max(1, Math.round(w * s)), sh = Math.max(1, Math.round(h * s));
      const t = document.createElement('canvas'); t.width = sw; t.height = sh;
      const tx = t.getContext('2d'); tx.drawImage(canvas, 0, 0, sw, sh);
      const d = tx.getImageData(0, 0, sw, sh).data;
      const hist = new Uint32Array(256); let n = 0;
      for (let i = 0; i < d.length; i += 4) {
        if (d[i + 3] < 200) continue;
        hist[((d[i] * 299 + d[i + 1] * 587 + d[i + 2] * 114) / 1000) | 0]++; n++;
      }
      if (n < 50) return 1;
      let acc = 0, p99 = 255;
      for (let v = 0; v < 256; v++) { acc += hist[v]; if (acc >= n * 0.99) { p99 = v; break; } }
      const metal = mat === 'metal';
      if (p99 < (metal ? SV_LIGHT.liftMinP99Metal : SV_LIGHT.liftMinP99)) return 1;
      const gain = Math.min(metal ? SV_LIGHT.liftCapMetal : SV_LIGHT.liftCap, SV_LIGHT.liftTarget / Math.max(1, p99));
      if (gain < SV_LIGHT.liftMinGain) return 1;
      const ctx = canvas.getContext('2d');
      const img = ctx.getImageData(0, 0, w, h), px = img.data;
      const lut = new Uint8ClampedArray(256);
      for (let v = 0; v < 256; v++) lut[v] = Math.round(v * gain);
      for (let i = 0; i < px.length; i += 4) {
        if (px[i + 3] === 0) continue;
        px[i] = lut[px[i]]; px[i + 1] = lut[px[i + 1]]; px[i + 2] = lut[px[i + 2]];
      }
      ctx.putImageData(img, 0, 0);
      window.__svTrace && window.__svTrace.push('light:lift:' + gain.toFixed(3) + ':p99:' + p99 + ':' + mat);
      return gain;
    } catch (e) { return 1; }
  }
  // Passes 2 + 3. Returns a NEW canvas (the measured arm is never mutated). caseEnd is the edge
  // of THIS canvas that meets the watch: 'bottom' for the upper arm, 'top' for the flipped lower.
  function svShadeArm(arm, mat, caseH, caseEnd) {
    if (!SV_LIGHT.on || !arm || arm.width < 4 || arm.height < 4) return arm;
    try {
      const w = arm.width, h = arm.height, L = SV_LIGHT, m = mat || 'matte';
      const c = document.createElement('canvas'); c.width = w; c.height = h;
      const x = c.getContext('2d');
      x.drawImage(arm, 0, 0);
      x.globalCompositeOperation = 'source-atop';
      const ed = L.edgeDark[m] || 0;
      if (ed > 0) {
        const g = x.createLinearGradient(0, 0, w, 0);
        g.addColorStop(0, 'rgba(0,0,0,' + ed + ')');
        g.addColorStop(L.edgeWidth, 'rgba(0,0,0,0)');
        g.addColorStop(1 - L.edgeWidth, 'rgba(0,0,0,0)');
        g.addColorStop(1, 'rgba(0,0,0,' + ed + ')');
        x.fillStyle = g; x.fillRect(0, 0, w, h);
      }
      const spec = (pos, sigma, peak) => {
        if (!(peak > 0)) return;
        const g = x.createLinearGradient(0, 0, w, 0);
        for (let i = 0; i <= 20; i++) {
          const t = i / 20, dd = (t - pos) / sigma;
          g.addColorStop(t, 'rgba(255,255,255,' + (peak * Math.exp(-0.5 * dd * dd)).toFixed(4) + ')');
        }
        x.fillStyle = g; x.fillRect(0, 0, w, h);
      };
      spec(L.specPos, L.specSigma, L.specPeak[m] || 0);
      spec(L.spec2Pos, L.spec2Sigma, L.spec2Peak[m] || 0);
      if (L.contactAlpha > 0) {
        const depth = Math.min(h, Math.max(4, Math.round((caseH || h) * L.contactDepth)));
        const g = caseEnd === 'top' ? x.createLinearGradient(0, 0, 0, depth)
                                    : x.createLinearGradient(0, h, 0, h - depth);
        g.addColorStop(0, 'rgba(0,0,0,' + L.contactAlpha + ')');
        g.addColorStop(0.5, 'rgba(0,0,0,' + (L.contactAlpha * 0.35).toFixed(3) + ')');
        g.addColorStop(1, 'rgba(0,0,0,0)');
        x.fillStyle = g;
        x.fillRect(0, caseEnd === 'top' ? 0 : h - depth, w, depth);
      }
      return c;
    } catch (e) { return arm; }
  }
  // Pass 4. drawFn(ctx) must paint the WHOLE assembly (arms + watch) in canvas coordinates; it
  // is called twice on a downscaled offscreen (once with the shadow, once with destination-out
  // to knock the assembly itself back out), and the shadow-only layer goes under the canvas.
  // caseW scales the blur/offset so a big watch and a small watch cast the same-looking shadow.
  function svDropShadow(canvas, drawFn, caseW) {
    if (!SV_LIGHT.on || !(SV_LIGHT.dropAlpha > 0) || !canvas || !canvas.width) return;
    try {
      const W = canvas.width, H = canvas.height;
      const s = Math.min(1, 1400 / Math.max(W, H));
      const off = document.createElement('canvas');
      off.width = Math.max(1, Math.round(W * s)); off.height = Math.max(1, Math.round(H * s));
      const o = off.getContext('2d');
      o.scale(s, s);
      // shadow blur/offset are in DEVICE pixels (not transformed), hence the * s
      o.shadowColor = 'rgba(0,0,0,' + SV_LIGHT.dropAlpha + ')';
      o.shadowBlur = Math.max(2, caseW * SV_LIGHT.dropBlur * s);
      o.shadowOffsetY = caseW * SV_LIGHT.dropDy * s;
      drawFn(o);
      o.shadowColor = 'rgba(0,0,0,0)'; o.shadowBlur = 0; o.shadowOffsetY = 0;
      o.globalCompositeOperation = 'destination-out';
      drawFn(o);
      const ctx = canvas.getContext('2d');
      ctx.save();
      ctx.globalCompositeOperation = 'destination-over';
      ctx.imageSmoothingEnabled = true;
      ctx.drawImage(off, 0, 0, W, H);
      ctx.restore();
    } catch (e) {}
  }
  // Apple path: the strap is drawn straight from the <img>; lift it once per image, and shade
  // each arm crop once per (crop, case end, case height). Cached on the image object.
  function svLiftedSource(img, mat) {
    if (!SV_LIGHT.on || !img) return img;
    try {
      if (img._svLift && img._svLift.mat === mat) return img._svLift.canvas;
      const c = document.createElement('canvas');
      c.width = img.naturalWidth || img.width; c.height = img.naturalHeight || img.height;
      c.getContext('2d').drawImage(img, 0, 0);
      svLiftExposure(c, mat);
      img._svLift = { mat, canvas: c, arms: {} };
      return c;
    } catch (e) { return img; }
  }
  function svAppArmCanvas(src, sx, sy, sw, sh, mat, caseH, caseEnd) {
    const key = [sx, sy, sw, sh, mat, Math.round(caseH), caseEnd].join(':');
    const cache = (src && src._svArms) || (src._svArms = {});
    if (cache[key]) return cache[key];
    const c = document.createElement('canvas'); c.width = Math.max(1, sw); c.height = Math.max(1, sh);
    c.getContext('2d').drawImage(src, sx, sy, sw, sh, 0, 0, sw, sh);
    const out = svShadeArm(c, mat, caseH, caseEnd);
    const keys = Object.keys(cache); if (keys.length > 12) delete cache[keys[0]];
    cache[key] = out;
    return out;
  }

  /* ══ STAFF ADJUST MODE ═══════════════════════════════════════════════════════
     A manual override of the computed arm placement, for the cases the automatic
     maths gets wrong. The engine's own calculation stays the default: a strap with
     no saved adjustment takes the untouched code path and renders bit-identically.

     Offsets are a FRACTION of the watch case width, never pixels, so an adjustment
     made on one watch holds on every other watch and at any canvas size.
     Resolution order: staff's unsaved localStorage draft > the product's saved
     custom.visualiser_adjust metafield > null (= no adjustment, default render). */
  const SV_ADJ_LS = 'sv_adj_';
  function svAdjNormalise(o) {
    if (!o || typeof o !== 'object') return null;
    const arm = (a) => ({
      dx: parseFloat(a && a.dx) || 0,
      dy: parseFloat(a && a.dy) || 0,
      /* ⚠ WIDTH and LENGTH are separate, and must stay separate. The first version of this
         panel had a single uniform `scale`, which could not express "wider but not longer".
         The engine has treated the two axes independently since 3.26.0, so a single number
         was ambiguous: shrinking a strap to correct its LENGTH also narrowed it, and reading
         that back as a width correction produced a wrong visualiser_strap_scale. A legacy
         `scale` is still honoured and applied to both axes so old saved values keep working. */
      sx: (isFinite(parseFloat(a && a.sx)) ? Math.max(0.3, Math.min(3, parseFloat(a.sx)))
           : (isFinite(parseFloat(a && a.scale)) ? Math.max(0.3, Math.min(3, parseFloat(a.scale))) : 1)),
      sy: (isFinite(parseFloat(a && a.sy)) ? Math.max(0.3, Math.min(3, parseFloat(a.sy)))
           : (isFinite(parseFloat(a && a.scale)) ? Math.max(0.3, Math.min(3, parseFloat(a.scale))) : 1)),
      rot: (isFinite(parseFloat(a && a.rot)) ? Math.max(-30, Math.min(30, parseFloat(a.rot))) : 0)
    });
    const out = { top: arm(o.top), bottom: arm(o.bottom) };
    const flat = [out.top, out.bottom];
    // All-default is the same as no adjustment; return null so the default path runs.
    if (flat.every(a => !a.dx && !a.dy && a.sx === 1 && a.sy === 1 && !a.rot)) return null;
    return out;
  }
  /* 3.92.1: a PER-WATCH adjustment, applied to every strap on that watch, under the strap's own.
     The Galaxy Watch 8 / 9 / Ultra rows all sit the same way off the computed placement, and the
     owner tuned it once in the staff panel ("use this to fix the alignment on all the galaxy watch
     8-9 and ultra watches"): top arm down 0.03 of the case width, bottom arm 0.03 left and 0.07 up.
     A strap's own visualiser_adjust (or a staff draft) is composed ON TOP - offsets and rotation
     add, scales multiply - so a per-strap fix still works on these watches. Fractions of the case
     width, like every other adjustment here. */
  // First match wins - the specific rows before the family fallback. 3.92.5: the owner tuned the
  // Ultra, Watch 8 All Models and Watch 8 Classic rows separately; the Watch 9 rows keep the
  // original figures.
  /* 3.93.0: the hand-nudged OFFSETS (dx/dy) are gone - placement is now the adapter-foot rule and
     the end-row centring in performCombination, which apply to every adapter watch without a row
     here. What remains is the owner's SIZE preference per row (arms 22% wider on the Ultra, 8-10%
     on the Watch 8), which is taste, not alignment; a new model gets the default width and needs
     nothing here. Prefer the catalogue's "scale top"/"scale bottom" for a new row over adding one. */
  const SV_WATCH_ADJUST = [
    { test: (w) => /samsung/i.test(w.brand || '') && /galaxy\s*watch\s*ultra/i.test(w.model || ''),
      adj: { top: { dx: 0, dy: 0, sx: 1.22, sy: 1, rot: 0 }, bottom: { dx: 0, dy: 0, sx: 1.22, sy: 1, rot: 0 } } },
    { test: (w) => /samsung/i.test(w.brand || '') && /galaxy\s*watch\s*8\s*classic/i.test(w.model || ''),
      adj: { top: { dx: 0, dy: 0, sx: 1.1, sy: 1, rot: 0 }, bottom: { dx: 0, dy: 0, sx: 1.1, sy: 1, rot: 0 } } },
    { test: (w) => /samsung/i.test(w.brand || '') && /galaxy\s*watch\s*8\s*all\s*models/i.test(w.model || ''),
      adj: { top: { dx: 0, dy: 0, sx: 1.08, sy: 1, rot: 0 }, bottom: { dx: 0, dy: 0, sx: 1.08, sy: 1, rot: 0 } } }
  ];
  function svWatchAdjustFor() {
    const w = currentWatchData;
    if (!w) return null;
    const hit = SV_WATCH_ADJUST.find(e => { try { return e.test(w); } catch (x) { return false; } });
    return hit ? svAdjNormalise(hit.adj) : null;
  }
  function svComposeAdjust(base, over) {
    if (!base) return over || null;
    if (!over) return base;
    const arm = (b, o) => ({ dx: b.dx + o.dx, dy: b.dy + o.dy, sx: b.sx * o.sx, sy: b.sy * o.sy, rot: b.rot + o.rot });
    return svAdjNormalise({ top: arm(base.top, over.top), bottom: arm(base.bottom, over.bottom) });
  }
  function svStrapOwnAdjust(product) {
    if (!product) return null;
    try {
      const draft = localStorage.getItem(SV_ADJ_LS + product.id);
      if (draft) { const n = svAdjNormalise(JSON.parse(draft)); if (n) return n; }
    } catch (e) {}
    try {
      if (product.adjust) return svAdjNormalise(product.adjust);
    } catch (e) {}
    return null;
  }
  function svAdjustFor(product) {
    if (!product) return null;
    return svComposeAdjust(svWatchAdjustFor(), svStrapOwnAdjust(product));
  }
  // Draw an arm scaled/rotated about the edge that MEETS THE WATCH, so a nudge pivots
  // at the lug rather than the middle of the strap - which is how it reads to the eye.
  function svDrawArmAdjusted(ctx, cnv, x, y, sx, sy, rot, anchorEdge) {
    const w = cnv.width, h = cnv.height;
    const px = w / 2, py = (anchorEdge === 'bottom') ? h : 0;
    ctx.save();
    ctx.translate(x + px, y + py);
    ctx.rotate((rot || 0) * Math.PI / 180);
    ctx.scale(sx || 1, sy || 1);   // width and length independently
    ctx.drawImage(cnv, -px, -py);
    ctx.restore();
  }

  /* ── Row thumbnails for single-column flat-lays ────────────────────────────
     Loops and stacked pairs are photographed as ONE tall column, so the rail thumbnail
     showed the two arms on top of each other in a 46x76 tile - unreadable at that size.
     Rebuild it through the SAME svSingleDiagonalArms cut the compositor uses, then lay the
     two arms side by side, which is how every other strap's flat-lay already reads.
     Falls back to the original image on any failure (a tainted canvas, a slow load). */
  const svThumbCache = new Map();
  function svThumbCompose(arms) {
    const t = arms.top, b = arms.bottom;
    if (!t || !b || !t.width || !b.width) return null;
    const h = Math.max(t.height, b.height);
    const gap = Math.round(Math.max(t.width, b.width) * 0.18);
    const pad = Math.round(h * 0.03);
    const c = document.createElement('canvas');
    c.width = t.width + gap + b.width + pad * 2;
    c.height = h + pad * 2;
    const x = c.getContext('2d');
    // Bottom-aligned: both arms meet the watch at their lower edge.
    x.drawImage(t, pad, pad + (h - t.height));
    x.drawImage(b, pad + t.width + gap, pad + (h - b.height));
    return c;
  }
  const svThumbPending = new Set();
  function svThumbSideBySide(img) {
    if (!img || !img.closest) return;
    const row = img.closest('.strap-list-item');
    if (!row || row.dataset.svSd !== '1') return;
    const src = img.getAttribute('src') || '';
    if (!src || src.indexOf('data:') === 0) return;   // already ours (or a placeholder)
    const key = src.split('?')[0];
    const done = (url) => {
      if (!url || img.getAttribute('src') === url) return;
      img.dataset.svThumbFrom = src;
      img.classList.add('sv-thumb2');   // CSS switches these to object-fit:contain
      img.src = url;
    };
    /* ⚠ Do NOT skip on "we already rebuilt this src". The lazy loader assigns data-src ->
       src AFTER our rebuild lands, which puts the original tall column back; a
       once-per-source guard then refused to rebuild it and the thumbnail silently reverted
       (owner: "thumbnail hasn't changed"). Re-applying from cache is cheap and idempotent -
       the data: URL short-circuits at the top on the next mutation. */
    if (svThumbCache.has(key)) { done(svThumbCache.get(key)); return; }   // '' = checked, unusable
    if (svThumbPending.has(key)) return;
    svThumbPending.add(key);
    const im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function(){
      svThumbPending.delete(key);
      try {
        const c = document.createElement('canvas');
        c.width = im.naturalWidth; c.height = im.naturalHeight;
        c.getContext('2d').drawImage(im, 0, 0);
        const out = svThumbCompose(svSingleDiagonalArms(c));
        if (!out) return;
        /* Sanity gate: a two-arm flat-lay is roughly 0.8-3.2 tall/wide. Anything outside that
           means the source was not the layout we think it is (one colour of Flexi Sports
           Silicone 2 18mm still points at a wide product PHOTO, which composed to 884x212),
           so keep the original thumbnail rather than show a mangled one. */
        const ar = out.height / out.width;
        if (!(ar >= 0.8 && ar <= 3.2)) { svThumbCache.set(key, ''); return; }
        const url = out.toDataURL('image/png');
        svThumbCache.set(key, url);
        // Re-apply to EVERY row showing this source, not just the one that triggered the
        // load: the same flat-lay is the thumbnail for several colours/rows.
        document.querySelectorAll('.strap-list-item[data-sv-sd="1"] img').forEach(function(o){
          const s2 = o.getAttribute('src') || '';
          if (s2.split('?')[0] === key) { o.dataset.svThumbFrom = s2; o.classList.add('sv-thumb2'); o.src = url; }
        });
        done(url);
      } catch (e) { /* tainted canvas or a bad cut: keep the original thumbnail */ }
    };
    im.onerror = function(){ svThumbPending.delete(key); };
    im.src = src.indexOf('cdn.shopify.com') > -1
      ? (src.split('&width=')[0] + (src.indexOf('?') > -1 ? '&' : '?') + 'width=400')
      : src;
  }

  /************************************************************************
   * COMBINE WATCH & STRAP - OPTIMIZED
   ************************************************************************/
  async function combineImages() {
    if (!currentWatchData || !currentStrapURL) {
      return;
    }

    /* 3.66.2 (owner): a new combination KEEPS the zoom the customer last used; only the very
       first render applies the resting default. Used to reset to default on every strap change.
       ⚠ 3.76.1: EXCEPT after a watch-only render, which forces scale 1 so a near-square watch
       bitmap is not cropped. "Keep the last zoom" would carry that 1x into the next composite -
       invisible on desktop (default is 1) and plainly wrong on a phone, where the resting zoom is
       2.0. Coming back from that state resets rather than keeps. */
    if (_svWatchOnlyShown) {
      _svWatchOnlyShown = false;
      if (typeof resetInlineZoom === 'function') resetInlineZoom();
    } else if (typeof svKeepInlineZoom === 'function') {
      svKeepInlineZoom();
    }

    // Debounce rapid calls to combineImages
    if (combineImages.timeout) {
      clearTimeout(combineImages.timeout);
    }
    
    combineImages.timeout = setTimeout(async () => {
      await performCombination();
    }, 100);
  }

  // Monotonic render token: a slow image load from an EARLIER selection must never paint
  // over a newer one (tap strap A then B on a slow connection -> A's fetch resolves last).
  let svRenderSeq = 0;

  /* Preview-level render failure (e.g. the canvas-cap backstop). Shown in the preview viewport
     ONLY - the strap rail must stay usable. showStrapLoadError() is the wrong surface for a
     render failure: it replaces the entire rail with "Couldn't load the strap list", which is
     both untrue (the list loaded fine) and destructive (every row disappears). */
  function svShowPreviewError() {
    const fc = document.getElementById('finalCanvas');
    if (fc) {
      const x = fc.getContext('2d');
      if (x) x.clearRect(0, 0, fc.width, fc.height);
    }
    const host = fc && fc.parentElement;
    if (!host) return;
    let el = document.getElementById('svPreviewError');
    if (!el) {
      el = document.createElement('div');
      el.id = 'svPreviewError';
      el.style.cssText = 'text-align:center;padding:26px 14px;color:#666;font-size:.92rem;line-height:1.5;';
      host.insertBefore(el, fc);
    }
    el.innerHTML = 'Sorry &mdash; we can\'t preview this strap on a watch yet.<br>Pick another strap, or tap the strap\'s name to see its product photos.';
    el.style.display = 'block';
  }
  function svHidePreviewError() {
    const el = document.getElementById('svPreviewError');
    if (el) el.style.display = 'none';
  }

  /* Draw the WATCH ALONE. The compositor returns early without a strap (by design - every other
     strapless moment is a transient one that should show nothing), so a watch we stock no straps
     for had an empty preview box. Mirrors performCombination's tail exactly: same crop, same
     proportional margin, same zoom setup, so pan/zoom/download behave identically.
     ⚠ Takes the same render token as performCombination - a slow watch-only load must never
     paint over a newer selection (pick a no-strap watch, then a normal one on a slow connection). */
  let _svWatchOnlyShown = false;   // the last thing painted was a bare watch, not a composite
  async function svDrawWatchOnly() {
    if (!currentWatchData) return;
    const wd = currentWatchData;
    /* Claim the render token so a composite still in flight from the PREVIOUS watch cannot paint
       over this. ⚠ Do NOT then abort on `seq !== svRenderSeq`: switching away from a normal watch
       leaves a debounced combineImages queued, and its performCombination bumps the token again
       before returning early (no strap). That silently killed this paint and left the old, cleared
       canvas on screen. Identity is the honest test - still the same watch, still strapless. */
    ++svRenderSeq;
    const url = wd.finalImageData || wd.rawLink;
    if (!url) return;
    const finalCanvas = document.getElementById('finalCanvas');
    if (!finalCanvas) return;
    try {
      const img = await loadImage(url);
      if (currentWatchData !== wd || !wd.noStraps || currentStrapURL) return;   // state moved on
      const drawn = drawToCanvas(img);
      const rendered = cropToContent(drawn);
      const padY = Math.max(10, Math.round(rendered.height * 0.025));
      const padX = Math.max(10, Math.round(rendered.width * 0.02));
      finalCanvas.width = rendered.width + padX * 2;
      finalCanvas.height = rendered.height + padY * 2;
      const ctx = finalCanvas.getContext('2d');
      ctx.clearRect(0, 0, finalCanvas.width, finalCanvas.height);
      ctx.drawImage(rendered, padX, padY);
      setupZoomFunctionality();
      /* ⚠ FIT, DON'T APPLY THE RESTING ZOOM. inlineZoomDefault() is 2.0 on a phone because the
         normal bitmap is a tall strap composite that has to read large. A watch on its own is
         near-square (301x320 here), and 2x in a 449px-high box crops the case top and bottom.
         Scale 1 shows the whole watch, which is the entire point of this render. */
      inlineZoom.scale = 1; inlineZoom.x = 0; inlineZoom.y = 0;
      inlineZoom.mode = false; inlineZoom.dragging = false;
      _svWatchOnlyShown = true;   // see combineImages: this 1x must not leak into the next composite
      applyInlineZoom();
      hideLoadingOverlay();
      setTimeout(() => { centerActionButtons(); }, 100);
    } catch (e) {
      console.warn('Watch-only preview failed', e);
    }
  }

  async function performCombination() {
    const seq = ++svRenderSeq;
    svHidePreviewError();   // any new render attempt clears a previous "can't preview" notice

    if (!currentWatchData || !currentStrapURL) {

      return;
    }

    // Apple/normal mismatch guard: never composite a normal strap on the Apple watch (or an Apple
    // strap on a normal watch). This happens for a beat while the Apple strap list lazy-loads and
    // the previously-selected (normal) strap lingers - clear the preview and wait for a match.
    const _strapIsApple = !!(selectedStrapProduct && (selectedStrapProduct.isApple ||
      (Array.isArray(selectedStrapProduct.watchType) && selectedStrapProduct.watchType.indexOf('Apple') !== -1)));
    if (!!currentWatchData.isApple !== _strapIsApple) {
      const _fc = document.getElementById('finalCanvas');
      if (_fc) { const _x = _fc.getContext('2d'); if (_x) _x.clearRect(0, 0, _fc.width, _fc.height); }
      return;
    }

    try {
      const _isApple = !!currentWatchData.isApple;

      // We'll use the watch's refined thumbnail (blob URL) or fallback to the raw link
      let watchUrl = currentWatchData.finalImageData;

      if (_isApple && currentWatchData.rawLink) {
        // Apple uses one fixed representative face - always the clean raw image, never a lug-
        // refined thumbnail (refinement assumes lugs, which the Apple face doesn't have).
        // ⚠ At SV_APPLE_FACE_W, not 600: THIS is the image the composite is built from, and the
        // 600px derivative is still Shopify's pre-re-cut master (see that constant). Fetching it
        // here at 600 is what kept drawing a faint 212,212,212 line above the case long after the
        // face files themselves were fixed and the grid icons had gone clean.
        watchUrl = cdnSized(currentWatchData.rawLink, SV_APPLE_FACE_W);
      } else if (watchUrl && watchUrl.startsWith('data:image/svg+xml')) {
        // If the watch image is still a placeholder (not refined yet), use the CDN-resized raw link
        if (currentWatchData.rawLink) {
          watchUrl = cdnSized(currentWatchData.rawLink, 600);
        }
      }

      const manualScale = currentWatchData.scale;


      // 1) Load watch & strap images. The strap is composited at CDN width=900 - its arms end
      // up ~200-300px wide in the final canvas, so 900px source is already 3x oversampled and
      // the pixel scans below run ~5-10x faster than on the full-res original.
      let [strapImg, watchImg] = await Promise.all([
        loadImage(cdnSized(currentStrapURL, 900)),
        loadImage(watchUrl)
      ]);

      // A newer selection superseded this render while the images were loading - drop it.
      if (seq !== svRenderSeq) return;

      /* 3.93.2: THE FIRST PAINT IS BUILT FROM THE SHARP WATCH, INLINE. 3.93.1 made the sharp
         copy retry, and the owner's phone still showed a 300px watch blown up ("blurry pics still
         there", Galaxy Watch 8 All Models, SV_BUILD 3.93.1 on screen). Whatever is failing in the
         upgrade-then-repaint dance on that phone, this path does not depend on it: if the watch
         bitmap we are about to draw is smaller than 700px (the 300px catalogue thumbnail, or the
         600px raw fallback), wait for the sharp copy HERE and draw from it. Costs one image load
         (~1 s) on the first paint of a watch; a sharp watch (900px normalised, or a custom
         photo) skips it. The render token still guards a superseded paint. Each of the first
         five paints reports what it drew through the usage telemetry ('render'), so the phones
         answer the question the desktop cannot. */
      const svWatchNat = watchImg.naturalWidth || watchImg.width || 0;
      let svSharpState = 'sharp';
      if (!_isApple && !currentWatchData.isCustom && svWatchNat && svWatchNat < 700 &&
          currentWatchData.watchObj && !currentWatchData.watchObj._custom) {
        svSharpState = 'fail';
        try {
          const sharp = await refineWatchHiRes(currentWatchData.watchObj);
          if (seq !== svRenderSeq) return;
          if (sharp) {
            currentWatchData.finalImageData = sharp;
            watchImg = await loadImage(sharp);
            if (seq !== svRenderSeq) return;
            svSharpState = 'inline';
          }
        } catch (e) { svSharpState = 'err'; }
      }

      // Apple Watch: fixed face + split-and-adapter-tuck compositor (no lug detection / arm-scaling).
      if (_isApple) {
        // First paint from the 900/612 images so nothing is slower to appear; then, on a
        // high-DPI screen, fetch the sharp draw sources and repaint once they land (3.66.0).
        svAppHi = null;   // the previous strap's sharp sources must not dress this one
        performAppleCombination(strapImg, watchImg, null);
        if (SV_APP_HIDPI > 1 && currentWatchData.rawLink) {
          Promise.all([
            loadImage(cdnSized(currentStrapURL, SV_APP_STRAP_HI_W)),
            loadImage(cdnSized(currentWatchData.rawLink, SV_APP_FACE_HI_W))
          ]).then(([hs, hf]) => {
            if (seq !== svRenderSeq) return;   // the customer moved on while these loaded
            performAppleCombination(strapImg, watchImg, { strap: hs, face: hf });
          }).catch(() => { /* the 1x render is already up; a sharp copy is a bonus, never a failure */ });
        }
        return;
      }
      svAppHideAdjust();   // the manual strap adjustment only applies to the Apple compositor


      // 2) Convert to canvas + crop
      /* 3.89.0: KNOCK OUT A WHITE STUDIO BACKGROUND rather than refusing the image. The bundle
         photos are JPGs shot on white - the only reason a perfectly good picture of the strap
         WITH its adapter fitted could not be used. Runs before the crop, because cropToContent
         measures alpha, and is a no-op on a picture that is not a white studio shot, so a normal
         transparent flat-lay is byte-identical to before. */
      const _strapRaw = drawToCanvas(strapImg);
      svKnockOutStudioWhite(_strapRaw);
      let strapCanvas = cropToContent(_strapRaw);

      /* ⚠ NO-ALPHA GUARD (3.38.0). The compositor needs a TRANSPARENT-BACKGROUND cutout; an
         ordinary product photo (JPG, or a PNG with no clear pixels) makes cropToContent's bbox
         the whole frame and the "strap" composites as a giant photo rectangle (hit on
         [Quick Release] Link Bracelet Black/Silver 2026-08-22: colours whose flat-lay is not
         shot yet fall back to gallery image 0, a watch shot). A legitimate flat-lay always has
         a mostly-transparent frame, so >97% opaque pixels can only be a wrong image - show the
         preview notice instead of confidently drawing garbage. Sampled on a downscale so the
         check costs ~1ms. */
      {
        const gW = Math.min(64, strapCanvas.width), gH = Math.min(64, strapCanvas.height);
        const g = document.createElement('canvas'); g.width = gW; g.height = gH;
        const gx = g.getContext('2d');
        gx.drawImage(strapCanvas, 0, 0, gW, gH);
        try {
          const gd = gx.getImageData(0, 0, gW, gH).data;
          let op = 0, tot = gW * gH;
          for (let i = 3; i < gd.length; i += 4) { if (gd[i] > 20) op++; }
          if (op / tot > 0.97) {
            console.warn('[strap-visualiser] flat-lay has no transparency (' +
                         Math.round(op / tot * 100) + '% opaque) - refusing to composite. strap=' +
                         ((selectedStrapProduct && selectedStrapProduct.title) || '?') +
                         ' url=' + currentStrapURL);
            window.__svTrace && window.__svTrace.push('strap:no-alpha');
            svShowPreviewError();
            return;
          }
        } catch (e) { /* tainted canvas etc. - fall through and let the old path run */ }
      }
      // LIGHTING pass 1 (3.65.0): equal-gain exposure lift, RGB only - alpha, and therefore
      // every measurement below, is untouched. Before the split so both arms match.
      const svMat = svMaterialOf(selectedStrapProduct);
      svLiftExposure(strapCanvas, svMat);
      const watchCanvas = cropToContent(drawToCanvas(watchImg));

      // 3) Split strap into top vs bottom.
      // ⚠ ONE-SIDED STRAPS ARE NOT SPLIT. A normal flat-lay is two halves side by side, so this
      // halves the image down the middle - on a fob, which is a single piece, that would cut the
      // body in two lengthwise and hang one slice under the watch. The whole photo becomes the top
      // arm and the lower arm is left empty (a 1x1 transparent canvas, so every measurement and
      // offset below stays valid and drawing it is a no-op).
      const oneSided = svIsOneSidedStrap(selectedStrapProduct);

      // Per-product 180 rotation. Some flat-lays are shot end-for-end relative to the rest of the
      // range: the arm that should sit ABOVE the watch is on the right, and each arm points the
      // wrong way, so the connector ends face outwards instead of meeting the case. Rotating the
      // whole photo before the split fixes both at once - a 180 turn maps the left half onto the
      // right half's position AND turns each piece end-for-end. Confirmed on
      // [Quick Release] Textured FKM Rubber 2026-08-13 by rendering all three candidates.
      // ⚠ The area heuristic below must be SKIPPED for these, or "top is the smaller half" will
      // promptly swap the arms back and undo the rotation.
      if (selectedStrapProduct && selectedStrapProduct.rotate180) {
        strapCanvas = svRotate180(strapCanvas);
        window.__svTrace && window.__svTrace.push('strap:rotated180');
      }

      const sW = strapCanvas.width, sH = strapCanvas.height;
      const centerX = Math.floor(sW / 2);

      // One continuous strap laid corner to corner: stand it up and cut it across, not down.
      /* 3.91.1: the picture decides too. `visualiser_strap_single_diagonal` is set by hand on
         the base product and does not always reach a bundle ([Pixel Watch] Shimmer Bracelet had
         none and rendered 21:1, sliced down its length). A tall single column with no gutter
         across it IS a one-piece layout whatever the metafield says - the same rule as
         project_visualiser_flatlay_layouts' detection (aspect >= 3.5, no side-by-side gap), so
         every watch model gets the same answer from the same code. */
      const singleDiagonal = svStrapIsSingleDiagonal(selectedStrapProduct) || svLooksOnePiece(strapCanvas);

      let topCropped, bottomCropped;
      if (singleDiagonal && !oneSided) {
        const arms = svSingleDiagonalArms(strapCanvas);
        topCropped = arms.top;
        bottomCropped = arms.bottom;
      } else if (oneSided) {
        topCropped = strapCanvas;
        bottomCropped = document.createElement('canvas');
        bottomCropped.width = 1; bottomCropped.height = 1;   // empty lower arm
      } else {
        const topCanvas = document.createElement('canvas');
        topCanvas.width = centerX;
        topCanvas.height = sH;
        topCanvas.getContext('2d').drawImage(
          strapCanvas,
          0, 0, centerX, sH,
          0, 0, centerX, sH
        );
        topCropped = cropToMainComponent(topCanvas);

        const bottomCanvas = document.createElement('canvas');
        bottomCanvas.width = sW - centerX;
        bottomCanvas.height = sH;
        bottomCanvas.getContext('2d').drawImage(
          strapCanvas,
          centerX, 0, sW - centerX, sH,
          0, 0, sW - centerX, sH
        );
        bottomCropped = cropToMainComponent(bottomCanvas);
      }

      // Check if this is a vulcanised strap
      const isVulcanised = selectedStrapProduct &&
                          selectedStrapProduct.title.toLowerCase().includes("vulcanised");

      // For vulcanised straps: left slice = top, right slice = bottom (no swapping)
      // For regular straps: ensure top is smaller half
      // ⚠ Skipped when rotate180 is set - the rotation already put the arms in the right order,
      // and this rule would swap them straight back. It is also the rule that misfires on these
      // straps in the first place: it picks by AREA, and their halves differ by ~2%, which is
      // noise. 110 straps in the collection are within 10% and four families currently contradict
      // themselves colour to colour.
      // ⚠ Also skipped for a single-piece diagonal flat-lay: its two halves were cut and oriented
      // explicitly above, so the area rule could only undo that.
      if (!isVulcanised && !oneSided && !singleDiagonal &&
          !(selectedStrapProduct && selectedStrapProduct.rotate180)) {
        const topArea = topCropped.width * topCropped.height;
        const bottomArea = bottomCropped.width * bottomCropped.height;
        if (bottomArea < topArea) {
          const temp = topCropped;
          topCropped = bottomCropped;
          bottomCropped = temp;
        }
      }
      

      const bottomFlipped = flipVertical(bottomCropped);

      // 4) Find watch lugs. Corners are Y-sorted and PAIRED from the sorted order:
      // findWatchLugs' corner names invert on asymmetric watches (e.g. shrouded Seikos), which
      // used to scale the top arm by the BOTTOM lug span (up to ~37% off) and vice versa.
      const watchLugs = findWatchLugs(watchCanvas);
      const stoLugPts = [watchLugs.topLeft, watchLugs.topRight, watchLugs.bottomLeft, watchLugs.bottomRight].slice().sort((a,b)=>a.y-b.y);
      let topLugDistance = distance(stoLugPts[0], stoLugPts[1]);
      let bottomLugDistance = distance(stoLugPts[2], stoLugPts[3]);
      // Measured inner gap between the lug horns at each end (nulls when undetectable).
      const topLug = findLugInnerGap(watchCanvas, true);
      const bottomLug = findLugInnerGap(watchCanvas, false);

      /* 3.88.0: A GAP AT ONE END ONLY IS NOT A LUG GAP. stoArmScale scales the arm to a measured
         horn gap when it finds one, and to 0.54 of the case width when it does not - so a single
         false reading makes ONE arm a different size from the other. Measured on the Pixel Watch 4
         45mm: no gap at the top, a 146px "gap" at the bottom (the case's own stub nubs), which
         scaled the top arm 2.185 and the bottom 0.894 off nearly identical lug spans and strap
         widths. The bottom arm rendered less than half the width of the top - "a skinny one on
         the bottom".
         Real horns come in pairs, so an end that disagrees with the other end is the measurement
         failing, not the watch: when only one end reports a gap, or the two gaps differ by more
         than 1.6x, neither is trusted and both ends fall back to the case-width rule. Clearing
         rootY with it also lets the lug-less symmetry rule below apply, which this watch was
         missing for the same reason. */
      if (!!topLug.gap !== !!bottomLug.gap ||
          (topLug.gap && bottomLug.gap &&
           Math.max(topLug.gap, bottomLug.gap) / Math.min(topLug.gap, bottomLug.gap) > 1.6)) {
        topLug.gap = null; topLug.rootY = null;
        bottomLug.gap = null; bottomLug.rootY = null;
      }

      /* 3.83.0: A WATCH WITH NO HORNS HAS NO LUG LINE TO MEASURE, so both ends must be treated as
         one. findWatchLugs takes the farthest point from each corner, which on a round lug-less
         case just returns whatever bump is nearest that quadrant - the crown and the side button.
         Measured on the Pixel Watch 5: top span 440.5, bottom span 399.1, a 10% disagreement on a
         case that is a circle. That scaled the two arms differently AND put their centre x 22px
         apart, so the strap visibly stepped sideways across the watch and the two connector ends
         met the case at different depths. When neither end shows a horn gap, the ends share the
         mean span and the case's own horizontal centre. Watches with real lugs are untouched -
         there the asymmetry is the watch, not the measurement. */
      if (topLug.gap == null && bottomLug.gap == null) {
        /* 3.93.0: centre each end on the CASE BODY where the strap meets it, not on the whole
           picture's bounding box. The Galaxy Watch Ultra's crown and two buttons stand ~0.06 case
           widths proud of the right side, so the bbox centre sat right of the case and every strap
           stepped right - the owner had hand-nudged the top arm 0.04 left for that one row. The
           opaque rows in the outer 14% of the case at each end carry no side hardware, so their
           mean centre IS the case centre at that end, on every lug-less watch there is or will be.
           Falls back to the bbox centre when an end has no rows. */
        const _cw = watchCanvas.width, _ch = watchCanvas.height;
        const _wd = watchCanvas.getContext('2d').getImageData(0, 0, _cw, _ch).data;
        let cminX = _cw, cmaxX = 0;
        const rowMid = new Float64Array(_ch); const rowHas = new Uint8Array(_ch);
        for (let y = 0; y < _ch; y++) {
          let mn = _cw, mx = -1;
          for (let x = 0; x < _cw; x++) {
            if (_wd[(y * _cw + x) * 4 + 3] > 0) { if (x < mn) mn = x; if (x > mx) mx = x; }
          }
          if (mx >= mn) { rowHas[y] = 1; rowMid[y] = 0.5 * (mn + mx); if (mn < cminX) cminX = mn; if (mx > cmaxX) cmaxX = mx; }
        }
        const endMean = (y0, y1) => { let s = 0, n = 0; for (let y = Math.max(0, y0); y < Math.min(_ch, y1); y++) if (rowHas[y]) { s += rowMid[y]; n++; } return n ? s / n : null; };
        if (cmaxX >= cminX) {
          const band = Math.max(2, Math.round(_ch * 0.14));
          const bbox = 0.5 * (cminX + cmaxX);
          const cxT = endMean(0, band), cxB = endMean(_ch - band, _ch);
          const cx1 = (cxT == null) ? bbox : cxT, cx2 = (cxB == null) ? bbox : cxB;
          const d = 0.5 * (topLugDistance + bottomLugDistance);
          stoLugPts[0].x = cx1 - d / 2; stoLugPts[1].x = cx1 + d / 2;
          stoLugPts[2].x = cx2 - d / 2; stoLugPts[3].x = cx2 + d / 2;
          topLugDistance = bottomLugDistance = d;
          window.__svTrace && window.__svTrace.push('watch:endcentre:' + (cx1 - bbox).toFixed(1) + '/' + (cx2 - bbox).toFixed(1));
        }
      }

      // 5) strap extremes
      function findStrapExtremeDistanceTop(canvas) {
        const pts = getNonTransparentPoints(canvas);
        const w = canvas.width;
        let distLeft = -1, distRight = -1;
        let leftP={x:0,y:0}, rightP={x:0,y:0};
        for (const p of pts) {
          const dL = (p.x - 0)**2 + (p.y - 0)**2;
          if (dL > distLeft) { distLeft = dL; leftP = p; }
          const dR = (p.x - (w-1))**2 + (p.y - 0)**2;
          if (dR > distRight) { distRight = dR; rightP = p; }
        }
        return distance(leftP, rightP);
      }
      function findStrapExtremeDistanceBottom(canvas) {
        const pts = getNonTransparentPoints(canvas);
        const w = canvas.width, h = canvas.height;
        let distLeft = -1, distRight = -1;
        let leftP={x:0,y:0}, rightP={x:0,y:0};
        for (const p of pts) {
          const dL = (p.x - 0)**2 + (p.y - (h-1))**2;
          if (dL > distLeft) { distLeft = dL; leftP = p; }
          const dR = (p.x - (w-1))**2 + (p.y - (h-1))**2;
          if (dR > distRight) { distRight = dR; rightP = p; }
        }
        return distance(leftP, rightP);
      }
      // The opaque run along a canvas's bottom edge. For a one-sided strap that edge IS the end
      // that meets the lugs, so it is what should be matched to the lug gap - the diagonal-extremes
      // measures above assume a split half and would size a fob by its body instead.
      function svBottomEdgeWidth(canvas) {
        const pts = getNonTransparentPoints(canvas);
        if (!pts.length) return 1;
        let maxY = 0;
        for (const p of pts) if (p.y > maxY) maxY = p.y;
        const band = Math.max(1, Math.round(canvas.height * 0.02));
        let mn = Infinity, mx = -Infinity;
        for (const p of pts) if (p.y >= maxY - band) { if (p.x < mn) mn = p.x; if (p.x > mx) mx = p.x; }
        return Math.max(1, mx - mn + 1);
      }
      // ⚠⚠ THE EXTREME-DISTANCE MEASUREMENTS CAN COLLAPSE, AND WHEN THEY DO THE STRAP VANISHES.
      // findStrapExtremeDistance*() takes the point furthest from one top corner and the point
      // furthest from the other, then the distance BETWEEN them. That equals the strap's width
      // only while those two extremes land on OPPOSITE SIDES of the arm. On an arm that ends in a
      // pointed taper they both land on the same tip and the result is a few pixels.
      //
      // The scale below DIVIDES by this number, so a 3px reading where the true width is ~100px
      // inflates the scale ~50x, and the final canvas is sized from the scaled arm. Measured on
      // [Quick Release] Textured FKM Rubber: top half 97px wide, measurement 3.0px, scale 162x,
      // final canvas 16814 x 199425 - past the browser's ~16384px cap, so the canvas fails to
      // allocate and NOTHING is painted. The user sees an empty sliver, and no error is raised
      // anywhere. Alcantara Black for comparison: 107px on a 142px half, scale 4.5x, canvas fine.
      //
      // So: sanity-check the reading against the half's own width and fall back to the bottom-edge
      // run, which is what physically meets the lugs and is already the trusted measure for
      // one-sided straps. A healthy arm measures ~0.75 of its half width; a collapsed one ~0.03.
      // The fallback is the half's CROPPED WIDTH scaled by the ratio a healthy strap actually
      // measures. Two rejected alternatives, both checked against the real catalogue rather than
      // reasoned about:
      //   * svBottomEdgeWidth - on a tapered arm the bottom edge IS the taper (26px where the
      //     true width is ~97px), which still blew the canvas to 2913x30658.
      //   * the TOP edge, i.e. the lug end - collapses on 47 of the 48 affected straps, because
      //     these flat-lays taper at the top too ([QuickFit] Sailcloth measures 9px on a 145px
      //     half). It looked right on the one sample I had, and was wrong on the population.
      // Measured across the 741 healthy straps, raw/halfWidth is min 0.388, MEDIAN 0.755, max
      // 1.009. Using the bare half width therefore hands the collapsed straps ~1.000 - a third
      // wider than a typical strap - and renders them correspondingly narrow. Using the median
      // puts them in the middle of the healthy distribution instead of at its edge.
      // ⚠ 0.755 is a calibration constant derived from that population, not a physical law. If
      // these straps ever look systematically too wide or too narrow, this is the number to nudge,
      // and per-watch "scale top"/"scale bottom" in the CRM watch catalogue override it entirely.
      const SV_MIN_ARM_RATIO = 0.25;
      const SV_TYPICAL_ARM_RATIO = 0.755;
      function svArmWidth(canvas, raw, label) {
        const halfW = canvas.width || 1;
        if (raw >= halfW * SV_MIN_ARM_RATIO) return raw;
        const used = halfW * SV_TYPICAL_ARM_RATIO;
        console.warn('[strap-visualiser] ' + label + ' arm measurement collapsed (' +
                     raw.toFixed(1) + 'px on a ' + halfW + 'px half); using ' +
                     used.toFixed(1) + 'px instead.');
        window.__svTrace && window.__svTrace.push(
          'arm:collapsed:' + label + ':' + raw.toFixed(1) + '->' + used.toFixed(1));
        return used;
      }

      const topStrapDistance = oneSided
        ? svBottomEdgeWidth(topCropped)
        : svArmWidth(topCropped, findStrapExtremeDistanceTop(topCropped), 'top');
      const bottomStrapDistance = oneSided
        ? findStrapExtremeDistanceBottom(bottomFlipped)
        : svArmWidth(bottomFlipped, findStrapExtremeDistanceBottom(bottomFlipped), 'bottom');

      // 6) scale factor. Preferred: strap connection width = MEASURED inner lug gap x 1.02
      // (slight tuck under the horns) - a per-watch measurement instead of the one-size ~0.8
      // approximation (real gap/outer ratios span 0.74-0.90). Fallbacks: an explicit CSV
      // "scale top"/"scale bottom" override forces the legacy formula for that arm (used by
      // no-lug watches like Fitbit Versa); no detectable gap falls back to outer-span x factor.
      // Sizing precedence: explicit CSV override (a human said so) > measured lug gap (the
      // physical answer) > cover-a-good-portion default. The old last resort - outer span x
      // manualScale - had nothing physical behind it and swung from far too narrow (the Active 2
      // Square drew its strap at 37% of the case) to far too wide; watches that reach it are the
      // integrated-strap smartwatches with no measurable lugs, whose straps really do sit at
      // ~0.54 of the case width (a 20mm strap on a ~37mm case).
      function stoArmScale(ovr, lug, lugDist, strapDist){
        const n = parseFloat(ovr);
        if (isFinite(n)) return (lugDist / strapDist) * Math.max(0.3, Math.min(2.5, n));
        /* ⚠ The 1.02 tuck factor and the 0.54 fallback were both ~8% too generous, measured
           against the owner's hand placement of a control strap on two unlike watches (see the
           SV_OV_TRIM note further down for the full reasoning). SV_ARM_TRIM carries that 8% as
           one knob rather than editing two magic numbers independently. The explicit per-watch
           CSV override above is NOT trimmed - a human typed that figure deliberately. */
        const SV_ARM_TRIM = 0.925;
        if (lug && lug.gap) return (lug.gap * 1.02 * SV_ARM_TRIM) / strapDist;
        return (watchCanvas.width * 0.54 * SV_ARM_TRIM) / strapDist;
      }
      // Per-strap width correction (custom.visualiser_strap_scale). Applied AFTER the per-watch
      // rules so the precedence stays: human CSV override > measured lug gap > 0.54 default, and
      // this only nudges whichever of those won. Defaults to 1, so every existing strap is
      // bit-identical.
      // ⚠ svStrapScale corrects WIDTH ONLY, so it must not touch the Y axis. The arm width is
      // measured from the arm's END, which on a strap with a wide connector plate (the Acetate
      // Bangle: 233px plate over a 122px body) is nearly 2x the body. Correcting that needs a
      // ~1.9x factor, and while it was fed to BOTH axes of resizeCanvas it also stretched the
      // strap 1.9x LONGER - so the arms ran off down the canvas and the watch read as tiny. The
      // per-watch "scale top"/"scale bottom" overrides are genuine uniform scales and stay on
      // both axes; only the per-strap width correction is split out.
      const svStrapScale = (selectedStrapProduct && selectedStrapProduct.strapScale) || 1;
      let topScaleY = stoArmScale(currentWatchData.scaleTop, topLug, topLugDistance, topStrapDistance);
      // No lower arm on a one-sided strap: keep its placeholder at 1x rather than dividing by a
      // 1px-wide "strap".
      let bottomScaleY = oneSided
        ? 1
        : stoArmScale(currentWatchData.scaleBot, bottomLug, bottomLugDistance, bottomStrapDistance);
      /* 3.94.1: A KIT PHOTO'S TWO ARMS SHARE ONE SCALE. Each arm is sized so its END band equals the
         lug distance, and on a bundle the end band is the adapter foot. The two feet are the same
         part but are not photographed at the same width (Pixel Acetate Bangle: 68 px at the top,
         55 px at the bottom - one flares toward the camera), so per-arm sizing drew the bottom band
         ~10% wider than the top of the SAME bangle (owner: "bottom and top aren't matching sizes").
         Averaging the two scales keeps the photo's own proportions - the bands come out equal, as
         they are - and lands the mean foot on the lug. Ordinary flat-lays (no kit photo) and a
         hand-typed per-watch scale top/bottom are untouched. */
      const svKitArms = !oneSided && !!(selectedStrapProduct && typeof svBundleKitSrc === 'function' && svBundleKitSrc(selectedStrapProduct)) &&
        !isFinite(parseFloat(currentWatchData.scaleTop)) && !isFinite(parseFloat(currentWatchData.scaleBot));
      if (svKitArms && isFinite(topScaleY) && isFinite(bottomScaleY) && topScaleY > 0 && bottomScaleY > 0) {
        const _m = (topScaleY + bottomScaleY) / 2;
        window.__svTrace && window.__svTrace.push('kit:one-scale:' + topScaleY.toFixed(3) + '/' + bottomScaleY.toFixed(3) + '->' + _m.toFixed(3));
        topScaleY = bottomScaleY = _m;
      }
      const topScale = topScaleY * svStrapScale;   // X (width)
      const bottomScale = bottomScaleY * svStrapScale;   // X (width)

      // Resize strap segments (X = corrected width, Y = uncorrected length)
      const topResized = resizeCanvas(topCropped, topScale, topScaleY);
      const bottomResized = resizeCanvas(bottomFlipped, bottomScale, bottomScaleY);
      // LIGHTING passes 2+3 (3.65.0): shaded COPIES for drawing. The measurements further down
      // (svArmRowWidths, edge points) keep reading topResized / bottomResized.
      const topLit = svShadeArm(topResized, svMat, watchCanvas.height, 'bottom');
      const bottomLit = oneSided ? bottomResized : svShadeArm(bottomResized, svMat, watchCanvas.height, 'top');

      // 7) Final canvas - optimized sizing
      // ⚠ The top arm was landing flush against the canvas edge, and the end of the strap got
      // clipped. `margin` is max(topArmHeight, 100) and the watch is drawn at y = margin, so the
      // arm starts at margin + watchTopY + topOvPx - topArmHeight. Whenever the arm is the taller
      // term - which it usually is - that collapses to roughly watchTopY + topOvPx, i.e. a few
      // pixels. There was nothing wrong with the maths, there was simply no headroom, so any
      // rounding in the preview viewport ate the strap's end.
      // A pad proportional to the WATCH (not the arm, or a long strap would push its own padding
      // up with it) shifts the whole composite down inside the canvas and guarantees clearance at
      // both ends. The canvas grows by 2x the pad, so the fit-to-height scaling shrinks the render
      // by a couple of percent - a fair trade for not amputating the strap.
      const SV_EDGE_PAD = Math.max(24, Math.round(watchCanvas.height * 0.10));
      const margin = Math.max(topResized.height, 100) + SV_EDGE_PAD;
      const bigW = watchCanvas.width + Math.max(topResized.width, bottomResized.width) + 200;
      // ⚠ bigH was `... + margin * 2`, and margin is the TOP arm's height. The top needs that much
      // headroom because the watch is drawn at y = margin and the arm hangs above it - but the
      // BOTTOM was then given the same allowance on top of the bottom arm's own height, so the
      // canvas ran far past the content. Measured on a typical render: 137px of clearance above
      // the strap and 4066px of blank below it, on an 8907px canvas. The viewport scales the
      // canvas to fit and centres it, so all that dead space at the bottom dragged the strap up
      // and its end off the top edge. Sizing the bottom to what is actually drawn there
      // (watch + bottom arm + the same pad) leaves both ends even.
      const bigH = margin + watchCanvas.height + bottomResized.height + SV_EDGE_PAD;

      // Backstop. Browsers cap a canvas at ~16384px per side; past that the canvas silently fails
      // to allocate and every draw is a no-op, so the user gets an empty frame with nothing in the
      // console. The arm-width guard above should make this unreachable - it is here so that if
      // some other measurement collapses in future, it announces itself instead of rendering
      // nothing. Deliberately not "fixed" by clamping the dimensions: a clamped canvas would draw
      // a wrong picture confidently, which is worse than a loud failure.
      const SV_MAX_CANVAS = 16384;
      if (bigW > SV_MAX_CANVAS || bigH > SV_MAX_CANVAS) {
        console.error('[strap-visualiser] refusing to size the canvas ' +
                      Math.round(bigW) + 'x' + Math.round(bigH) + ' (cap ' + SV_MAX_CANVAS +
                      '). A strap measurement has collapsed. strap=' +
                      ((selectedStrapProduct && selectedStrapProduct.title) || '?') +
                      ' topDist=' + topStrapDistance + ' bottomDist=' + bottomStrapDistance +
                      ' topScale=' + topScale + ' bottomScale=' + bottomScale);
        window.__svTrace && window.__svTrace.push('canvas:refused:' + Math.round(bigW) + 'x' + Math.round(bigH));
        svShowPreviewError();   // render failure -> preview message; NEVER wipe the strap rail
        return;
      }

      const finalCanvas = document.getElementById('finalCanvas');
      const finalCtx = finalCanvas.getContext('2d');
      
      // Only resize canvas if dimensions changed
      if (finalCanvas.width !== bigW || finalCanvas.height !== bigH) {
      finalCanvas.width = bigW;
      finalCanvas.height = bigH;
      }
      
      // Use faster clearRect
      finalCtx.clearRect(0, 0, bigW, bigH);

      // 8) place watch
      const watch_offset_x = Math.floor((bigW - watchCanvas.width) / 2);
      const watch_offset_y = margin;
      overlayImageAlpha(finalCtx, watchCanvas, watch_offset_x, watch_offset_y);

      // 9) find watch topmost/bottommost pixel in center column
      const watchCenterColumn = Math.floor(watchCanvas.width / 2);
      const watchData = watchCanvas.getContext('2d').getImageData(0, 0, watchCanvas.width, watchCanvas.height).data;
      let watchTopY = -1, watchBottomY = -1;
      for (let y = 0; y < watchCanvas.height; y++) {
        const i = (y * watchCanvas.width + watchCenterColumn) * 4;
        if (watchData[i+3] > 0) {
          watchTopY = y;
          break;
        }
      }
      for (let y = watchCanvas.height - 1; y >= 0; y--) {
        const i = (y * watchCanvas.width + watchCenterColumn) * 4;
        if (watchData[i+3] > 0) {
          watchBottomY = y;
          break;
        }
      }
      const finalWatchTop = watch_offset_y + watchTopY;
      const finalWatchBottom = watch_offset_y + watchBottomY;

      // Overlap each arm under the watch (top usually needs more, since the centre-top sits above
      // the lug line). Defaults 12%/8% of watch height; per-watch "overlap top"/"overlap bottom".
      // When the lug-root row was measured, DEEPEN (never shallow) the overlap so the strap end
      // always reaches the case between the horns - straps draw under the watch, so extra depth
      // is invisible, while too-shallow shows a gap on long-lugged watches.
      function stoOvPct(v, def){ const n=parseFloat(v); return isFinite(n) ? Math.max(0,Math.min(0.5,n/100)) : def; }
      const topOv = stoOvPct(currentWatchData.ovTop, 0.12), botOv = stoOvPct(currentWatchData.ovBot, 0.08);
      const wH = watchCanvas.height;
      let topOvPx = Math.round(wH * topOv), botOvPx = Math.round(wH * botOv);
      if (!isFinite(parseFloat(currentWatchData.ovTop)) && topLug.rootY != null) {
        topOvPx = Math.max(topOvPx, topLug.rootY + Math.round(wH * 0.02) - watchTopY);
      }
      if (!isFinite(parseFloat(currentWatchData.ovBot)) && bottomLug.rootY != null) {
        botOvPx = Math.max(botOvPx, watchBottomY - (wH - 1 - bottomLug.rootY) + Math.round(wH * 0.02));
      }

      // ⚠ The rules above measure the case edge at the CENTRE column only, and the strap's end at
      // its very tip. Two things escape that: the case edge is not flat (rounded corners curve
      // away, and stub-lug watches have no horns to hide behind), and the strap's CONNECTOR ZONE - 
      // the bare spring bar with quick-release pins protruding sideways - sits a little way in
      // from the tip. On a short-lugged Amazfit the pins drew fully visible under the rounded
      // corner. So: measure the case edge across the strap's actual landing span, measure how deep
      // the pin bulge runs on the arm (rows wider than the arm's own end width), and deepen the
      // overlap until the whole connector sits behind the case. Never shallower than the rules
      // above; capped so a deeply-curved case cannot swallow half the strap.
      function svArmRowWidths(cnv) {
        const d = cnv.getContext('2d').getImageData(0, 0, cnv.width, cnv.height).data;
        const W = new Int32Array(cnv.height);
        for (let y = 0; y < cnv.height; y++) {
          let mn = 1e9, mx = -1;
          for (let x = 0; x < cnv.width; x++) if (d[(y * cnv.width + x) * 4 + 3] > 24) { if (x < mn) mn = x; if (x > mx) mx = x; }
          W[y] = mx >= mn ? mx - mn + 1 : 0;
        }
        return W;
      }
      // Depth (px from the case end) of the last row still wider than the plain end width - the
      // spring-bar pin bulge. 0 when the end has no bulge (fixed-bar silicone etc).
      function svConnDepth(W, fromBottom) {
        const n = W.length, probe = Math.max(4, Math.round(n * 0.15));
        // plain end width = median of the probe zone (the bulge is only a few rows, the median
        // ignores it)
        const zone = [];
        for (let i = 0; i < probe; i++) {
          const j = fromBottom ? n - 1 - i : i;
          if (j >= 0 && j < n && W[j]) zone.push(W[j]);
        }
        if (zone.length < 4) return 0;
        const med = zone.slice().sort((a, b) => a - b)[zone.length >> 1];
        let last = 0;
        for (let i = 0; i < probe; i++) {
          const j = fromBottom ? n - 1 - i : i;
          if (W[j] > med * 1.05) last = i + 1;
        }
        return last;
      }
      // Deepest case edge across [x0,x1] (watchCanvas coords): for the TOP side, the maximum
      // first-opaque-y; for the BOTTOM side, the minimum last-opaque-y. Columns with no pixels
      // are ignored.
      function svEdgeExtreme(x0, x1, atTop) {
        let out = null;
        const xa = Math.max(0, Math.round(x0)), xb = Math.min(watchCanvas.width - 1, Math.round(x1));
        for (let x = xa; x <= xb; x++) {
          if (atTop) {
            for (let y = 0; y < watchCanvas.height; y++) {
              if (watchData[(y * watchCanvas.width + x) * 4 + 3] > 0) { if (out === null || y > out) out = y; break; }
            }
          } else {
            for (let y = watchCanvas.height - 1; y >= 0; y--) {
              if (watchData[(y * watchCanvas.width + x) * 4 + 3] > 0) { if (out === null || y < out) out = y; break; }
            }
          }
        }
        return out;
      }
      const svOvCap = Math.round(wH * 0.45);
      if (!isFinite(parseFloat(currentWatchData.ovTop))) {
        const tw = svArmRowWidths(topResized);
        // end width of the arm where it lands (last rows), for the span to check
        let endW = 0;
        for (let i = topResized.height - 1; i >= Math.max(0, topResized.height - Math.max(3, Math.round(topResized.height * 0.03))); i--) if (tw[i] > endW) endW = tw[i];
        if (!endW) endW = topResized.width;
        const cxW = 0.5 * (stoLugPts[0].x + stoLugPts[1].x);   // top lug-centre x in watchCanvas
        const deepEdge = svEdgeExtreme(cxW - endW / 2, cxW + endW / 2, true);
        if (deepEdge != null) {
          const need = (deepEdge - watchTopY) + svConnDepth(tw, true) + Math.round(wH * 0.02);
          topOvPx = Math.min(svOvCap, Math.max(topOvPx, need));
        }
      }
      if (!oneSided && !isFinite(parseFloat(currentWatchData.ovBot))) {
        const bw = svArmRowWidths(bottomResized);
        let endW = 0;
        for (let i = 0; i < Math.max(3, Math.round(bottomResized.height * 0.03)); i++) if (bw[i] > endW) endW = bw[i];
        if (!endW) endW = bottomResized.width;
        const cxW = 0.5 * (stoLugPts[2].x + stoLugPts[3].x);   // bottom lug-centre x
        const shallowEdge = svEdgeExtreme(cxW - endW / 2, cxW + endW / 2, false);
        if (shallowEdge != null) {
          const need = (watchBottomY - shallowEdge) + svConnDepth(bw, false) + Math.round(wH * 0.02);
          botOvPx = Math.min(svOvCap, Math.max(botOvPx, need));
        }
      }
      /* ⚠ CALIBRATION AGAINST HAND PLACEMENT (2026-08-16).
         The owner positioned a control strap (Alcantara Black, which carries no
         visualiser_strap_scale, so it is the bare engine) on two structurally different
         watches. Both needed the arms lifted ~0.130 case widths OUT of the watch, and both
         needed them ~8% SMALLER - Approach J1 scale 0.910 / lift 0.130, Amazfit Bip 0.940 /
         0.120. Matching corrections on unlike watches means the error is in this compositor,
         not in any watch's data.
         Measured on the J1, the effective overlap was 0.197 (top) and 0.186 (bottom) case
         widths, against a target of 0.066 / 0.056. Trimming the DEFAULTS alone cannot fix it:
         the lug-root and connector-depth rules above take Math.max, so they would still win.
         The trim is therefore applied to the FINAL figure, which keeps those rules' relative
         behaviour - a strap that needs a deeper tuck still gets proportionally more.
         Both constants are single knobs on purpose: re-run the hand placement after changing
         either, and the control should then need no adjustment at all. */
      /* Calibrated in two passes against the control. Pass 1 used 0.32, derived from a reading
         taken while the canvas was still settling; the control then still needed 0.040 case
         widths of lift, which put the true figure near 0.048. Using 0.08 instead leaves a sliver
         of tuck (~0.012 case widths, about 4px on a 740px case) rather than none at all.
         ⚠ This all but disables the lug-root / connector-depth deepening, which existed to stop
         spring-bar pins showing under rounded cases. If pins ever appear on a short-lugged watch,
         raise this rather than reinstating the old defaults. */
      /* 3.82.0: the trim calibrates the DERIVED overlap only. A catalogue "overlap top"/
         "overlap bottom" is a hand-measured figure for that one watch, so multiplying it by
         0.08 made it meaningless (50%, the clamp ceiling, still only bought 4% of case height).
         Lug-less round cases - the Pixel Watch - need a real tuck to hide the spring-bar pins,
         and now get it by entering the percentage they actually need. */
      const SV_OV_TRIM = 0.08;
      if (!isFinite(parseFloat(currentWatchData.ovTop))) topOvPx = Math.round(topOvPx * SV_OV_TRIM);
      if (!isFinite(parseFloat(currentWatchData.ovBot))) botOvPx = Math.round(botOvPx * SV_OV_TRIM);

      /* 3.93.0: AN ADAPTER BUNDLE'S FOOT GOES INTO THE CASE - on every adapter watch, by rule.
         A bundle's kit photo ends in the adapter: a bar about 0.31 of its own width tall, whose
         prongs (the half nearer the end) slide into the case's channel while the bar itself shows
         between case and strap (the Galaxy 8/9/Ultra "Dynamic Lug" family; the Pixel's adapter
         disappears completely and its catalogue rows already say so with a 17.1% overlap, which
         wins below because this is a floor, never a ceiling). Until now the tip was tucked ~1% and
         the owner nudged each Galaxy ROW by hand (top down 0.03-0.06, bottom up 0-0.07 of the
         case) - figures that disagreed with each other and had to be typed again for every new
         model. The rule: tuck the end by half the foot's height, plus however far the case's
         rounded edge falls away across the foot's own span, plus 2% - measured on THIS arm and
         THIS watch, so it holds for any strap, any colour, any future adapter watch. The foot's
         width is the arm's end band (the same measurement stoArmScale sizes the arm by), so the
         depth scales with the render and never needs a per-watch number. Ordinary straps (no kit
         photo) are untouched. */
      const svKitPhoto = !!(selectedStrapProduct && typeof svBundleKitSrc === 'function' && svBundleKitSrc(selectedStrapProduct));
      if (svKitPhoto && !oneSided) {
        const SV_KIT_FOOT_ASPECT = 0.31, SV_KIT_FOOT_TUCK = 0.5;
        const footRule = (arm, atTop) => {
          const W = svArmRowWidths(arm);
          const n = W.length; if (!n) return 0;
          // end band = the widest of the last 3% of rows at the connector end (the foot)
          let endW = 0; const k = Math.max(3, Math.round(n * 0.03));
          for (let i = 0; i < k; i++) { const j = atTop ? n - 1 - i : i; if (W[j] > endW) endW = W[j]; }
          if (!endW) return 0;
          const footH = endW * SV_KIT_FOOT_ASPECT;
          const cxW = atTop ? 0.5 * (stoLugPts[0].x + stoLugPts[1].x) : 0.5 * (stoLugPts[2].x + stoLugPts[3].x);
          const edge = svEdgeExtreme(cxW - endW / 2, cxW + endW / 2, atTop);
          const curve = (edge == null) ? 0 : (atTop ? (edge - watchTopY) : (watchBottomY - edge));
          /* 3.94.2 (owner): "show the Pixel adapters, don't tuck them fully like the other straps".
             The Pixel's connector is a visible plate, not a Dynamic-Lug bar that vanishes into a
             channel, so on a Pixel only the prongs go in: half the foot + 2%, WITHOUT the case-
             curvature term (which on a round case swallowed the whole plate - 149 px on the
             Acetate Bangle), and the catalogue row's 17.1% (typed when adapters were not drawn at
             all) no longer applies to a kit photo. Galaxy rows keep the full rule. */
          if (svPixelKit) return Math.round(footH * SV_KIT_FOOT_TUCK + wH * 0.02);
          return Math.round(footH * SV_KIT_FOOT_TUCK + Math.max(0, curve) + wH * 0.02);
        };
        /* 3.94.4 (owner): "the top adapter needs to be less visible, the bottom more". The two feet of
           one kit photo are not shot alike - on the Acetate Bangle the top plate is face-on and tall,
           the bottom edge-on and short - so an equal tuck left a whole plate showing at the top and
           nothing at the bottom. Measure each foot's height from the picture (rows from the
           connector end whose width differs from the band's by more than 8%) and tuck so BOTH show
           the same amount: half of the SMALLER foot. Pixel rows only; Galaxy keeps footRule. */
        const footHeightPx = (arm, atTop) => {
          const W = svArmRowWidths(arm); const n = W.length; if (n < 20) return 0;
          const at = i => W[atTop ? n - 1 - i : i];
          const band = (() => { const seg = []; for (let i = Math.round(n * 0.2); i < Math.round(n * 0.6); i++) seg.push(at(i)); seg.sort((a, b) => a - b); return seg[Math.floor(seg.length / 2)] || 0; })();
          if (!band) return 0;
          let h = 0; const cap = Math.round(n * 0.25);
          for (let i = 0; i < cap; i++) { const w = at(i); if (!w) continue; if (Math.abs(w - band) / band > 0.08) h = i + 1; else if (i > 2) break; }
          // A plate is never taller than ~0.6 of its own width; a tapering leather end would
          // otherwise read as a 379-row "foot" and the adapter vanished into the case.
          let endW = 0; for (let i = 0; i < Math.max(3, Math.round(n * 0.03)); i++) endW = Math.max(endW, at(i) || 0);
          return Math.min(h, Math.round(endW * 0.6));
        };
        const svPixelKit = /pixel/i.test(String(currentWatchData.model || '')) || /google/i.test(String(currentWatchData.brand || ''));
        let needT = Math.min(svOvCap, footRule(topResized, true));
        let needB = Math.min(svOvCap, footRule(bottomResized, false));
        if (svPixelKit) {
          const fT = footHeightPx(topResized, true), fB = footHeightPx(bottomResized, false);
          if (fT >= 3 && fB >= 3) {
            // Keep the 3.94.2 depth overall, but split it so each foot SHOWS the same height.
            const visT = Math.max(0, fT - needT), visB = Math.max(0, fB - needB);
            const show = Math.round((visT + visB) / 2);
            /* 3.94.5: never LESS tuck than a quarter of the foot + 2%. Evening the two feet can only
               move tuck between them; with no floor a badly measured leather end (Alligator 41mm:
               112 vs 192) left the top plate hanging ABOVE the case with a gap - "the adapter isn't
               on the end of the strap". The prongs always go in. */
            const two = Math.round(wH * 0.02);
            const minT = Math.round((needT - two) * 0.5 + two), minB = Math.round((needB - two) * 0.5 + two);
            needT = Math.min(svOvCap, Math.max(minT, fT - show));
            needB = Math.min(svOvCap, Math.max(minB, fB - show));
            window.__svTrace && window.__svTrace.push('kit:foot-measured:' + fT + '/' + fB + ':vis' + visT + '/' + visB + ':show' + show);
          }
          topOvPx = needT; botOvPx = needB;
        }
        else {
          if (needT > topOvPx) topOvPx = needT;
          if (needB > botOvPx) botOvPx = needB;
        }
        window.__svTrace && window.__svTrace.push('kit:foot-tuck:' + needT + '/' + needB + (svPixelKit ? ':pixel' : ''));
      }
      if (window.__svOverlap) {
        window.__svOverlap.trim = SV_OV_TRIM;
        window.__svOverlap.topOvTrimmedInCaseW = +(topOvPx / watchCanvas.width).toFixed(4);
        window.__svOverlap.botOvTrimmedInCaseW = +(botOvPx / watchCanvas.width).toFixed(4);
      }
      const topStrapY = finalWatchTop + topOvPx - topResized.height;
      const bottomStrapY = finalWatchBottom - botOvPx;

      // Diagnostics for driving this compositor from the console/harness; inert unless enabled.
      if (window.__svDebugOn) window.__svNormalDebug = {
        topLug, bottomLug, topLugDistance, bottomLugDistance,
        topStrapDistance, bottomStrapDistance, topScale, bottomScale,
        topOvPx, botOvPx, watchTopY, watchBottomY,
        wH, watchW: watchCanvas.width, strapW: sW, strapH: sH,
        topArmW: topResized.width, topArmH: topResized.height
      };

      // 10) lug-based X alignment
      const watchTopCenterX = 0.5 * (stoLugPts[0].x + stoLugPts[1].x);
      const finalWatchTopCenterX = watch_offset_x + watchTopCenterX;
      function getStrapBottomEdgePoints(canvas) {
        const pts = getNonTransparentPoints(canvas);
        const w = canvas.width;
        let distLeft = -1, distRight = -1;
        let leftP={x:0,y:0}, rightP={x:0,y:0};
        for (const p of pts) {
          const dL = (p.x-0)**2 + (p.y-0)**2;
          if (dL > distLeft) { distLeft = dL; leftP = p; }
          const dR = (p.x-(w-1))**2 + (p.y-0)**2;
          if (dR > distRight) { distRight = dR; rightP = p; }
        }
        return { leftP, rightP };
      }
      /* 3.84.0: ALIGN ON THE END, NOT ON THE WIDEST ROW. getStrapBottomEdgePoints takes the
         farthest point from each top corner, which on a strap that tapers is the widest row up
         near the buckle, not the connector end that actually meets the watch. The bottom arm is
         the same image turned 180 degrees, so its widest row is at the other end and its bias
         runs the opposite way: measured on the Pixel Alcantara, the two arms sat 10px either
         side of the case centre, a 20px step across a 700px canvas that reads as the strap not
         lining up through the watch. svEndBandCenterX measures the mid-line of the end band
         itself - the same thing the oneSided branch below has always done for fobs. Falls back
         to the corner reading when the band is degenerate. */
      /* 3.86.0: ALIGN THE TWO ARMS ON THE SAME CENTRELINE. Aligning each arm on its own end band
         (3.84.0) lines up the two connector ends, but the ends are the part that disappears under
         the case - what the eye actually reads is the strap running through the watch, and there
         the two arms stepped sideways from each other. The cause is that a strap's end band is not
         centred on its own body: it is the buckle half in one arm and the tail half in the other,
         so the two errors run opposite ways. The median row centre of the whole arm is stable
         against that, and it is the line a person judges. Falls back to the end band, then to the
         corner reading, if the arm is degenerate. */
      function svArmCenterX(canvas) {
        const pts = getNonTransparentPoints(canvas);
        if (!pts.length) return null;
        const rows = new Map();
        for (const p of pts) {
          const r = rows.get(p.y);
          if (!r) rows.set(p.y, [p.x, p.x]);
          else { if (p.x < r[0]) r[0] = p.x; if (p.x > r[1]) r[1] = p.x; }
        }
        const mids = [];
        rows.forEach(r => mids.push((r[0] + r[1]) / 2));
        if (!mids.length) return null;
        mids.sort((a, b) => a - b);
        return mids[mids.length >> 1];
      }
      function svEndBandCenterX(canvas, atBottom) {
        const pts = getNonTransparentPoints(canvas);
        if (!pts.length) return null;
        let edge = atBottom ? 0 : canvas.height;
        for (const p of pts) { if (atBottom) { if (p.y > edge) edge = p.y; } else if (p.y < edge) edge = p.y; }
        const band = Math.max(1, Math.round(canvas.height * 0.02));
        let mn = Infinity, mx = -Infinity;
        for (const p of pts) {
          if (atBottom ? (p.y >= edge - band) : (p.y <= edge + band)) {
            if (p.x < mn) mn = p.x; if (p.x > mx) mx = p.x;
          }
        }
        return mx >= mn ? (mn + mx) / 2 : null;
      }
      const topStrapEdge = getStrapBottomEdgePoints(topResized);
      let topStrapBottomEdgeCenterX = 0.5 * (topStrapEdge.leftP.x + topStrapEdge.rightP.x);
      {
        const b = svArmCenterX(topResized);
        const e = (b == null) ? svEndBandCenterX(topResized, true) : b;
        if (e != null) topStrapBottomEdgeCenterX = e;
      }
      if (oneSided) {
        // Centre a fob on the middle of the end that meets the lugs, not on the extremes of its
        // body - a carabiner or a nurse-fob paddle is much wider than the strap end above it.
        const pts = getNonTransparentPoints(topResized);
        let maxY = 0;
        for (const p of pts) if (p.y > maxY) maxY = p.y;
        const band = Math.max(1, Math.round(topResized.height * 0.02));
        let mn = Infinity, mx = -Infinity;
        for (const p of pts) if (p.y >= maxY - band) { if (p.x < mn) mn = p.x; if (p.x > mx) mx = p.x; }
        if (mx >= mn) topStrapBottomEdgeCenterX = (mn + mx) / 2;
      }
      const topStrapX = finalWatchTopCenterX - topStrapBottomEdgeCenterX;

      const watchBottomCenterX = 0.5 * (stoLugPts[2].x + stoLugPts[3].x);
      const finalWatchBottomCenterX = watch_offset_x + watchBottomCenterX;
      function getStrapTopEdgePoints(canvas) {
        const pts = getNonTransparentPoints(canvas);
        const w = canvas.width, h = canvas.height;
        let distLeft = -1, distRight = -1;
        let leftP={x:0,y:0}, rightP={x:0,y:0};
        for (const p of pts) {
          const dL = (p.x-0)**2 + (p.y-(h-1))**2;
          if (dL > distLeft) { distLeft = dL; leftP = p; }
          const dR = (p.x-(w-1))**2 + (p.y-(h-1))**2;
          if (dR > distRight) { distRight = dR; rightP = p; }
        }
        return { leftP, rightP };
      }
      const bottomStrapEdge = getStrapTopEdgePoints(bottomResized);
      let bottomStrapTopEdgeCenterX = 0.5 * (bottomStrapEdge.leftP.x + bottomStrapEdge.rightP.x);
      {
        const b = svArmCenterX(bottomResized);
        const e = (b == null) ? svEndBandCenterX(bottomResized, false) : b;
        if (e != null) bottomStrapTopEdgeCenterX = e;
      }
      const bottomStrapX = finalWatchBottomCenterX - bottomStrapTopEdgeCenterX;

      // 11) Overlay straps & watch
      /* STAFF ADJUST MODE: a per-strap manual override of the computed arm placement. The
         automatic maths above is the default and is untouched; this only nudges the result, so a
         strap with no saved adjustment renders bit-identically. Offsets are stored as a FRACTION
         of the watch case width, not pixels, so one adjustment holds across every watch and every
         canvas size. Read svAdjustFor() for the resolution order. */
      const svAdj = (typeof svAdjustFor === 'function')
        ? svAdjustFor(selectedStrapProduct) : null;
      // The whole assembly as ONE routine: painted for real here, and again (twice) by
      // svDropShadow onto its downscaled shadow layer - the placement maths runs once.
      const svPaintAssembly = (c) => {
        if (svAdj) {
          const u = watchCanvas.width;   // fraction unit = case width
          svDrawArmAdjusted(c, topLit,
            topStrapX + (svAdj.top.dx || 0) * u, topStrapY + (svAdj.top.dy || 0) * u,
            svAdj.top.sx || 1, svAdj.top.sy || 1, svAdj.top.rot || 0, 'bottom');
          svDrawArmAdjusted(c, bottomLit,
            bottomStrapX + (svAdj.bottom.dx || 0) * u, bottomStrapY + (svAdj.bottom.dy || 0) * u,
            svAdj.bottom.sx || 1, svAdj.bottom.sy || 1, svAdj.bottom.rot || 0, 'top');
        } else {
          overlayImageAlpha(c, topLit, topStrapX, topStrapY);
          overlayImageAlpha(c, bottomLit, bottomStrapX, bottomStrapY);
        }
        overlayImageAlpha(c, watchCanvas, watch_offset_x, watch_offset_y);
      };
      /* 3.85.0: EXPORT THE PIECES, not just the numbers. The fitting tool has to show the same
         assembly the engine paints, and re-deriving arm scale and lug alignment outside the
         engine drifts from it (that is exactly how the hand-placement calibration went wrong
         once already). Handing over the three finished bitmaps plus the placement lets the tool
         re-lay them under a different overlap or adjust and stay bit-identical to this render.
         Inert unless __svDebugOn, and the canvases are already read with getImageData above, so
         toDataURL cannot be tainted here. */
      if (window.__svDebugOn) {
        try {
          window.__svNormalPieces = {
            canvasW: finalCanvas.width, canvasH: finalCanvas.height,
            unit: watchCanvas.width, caseH: watchCanvas.height,
            finalWatchTop: finalWatchTop, finalWatchBottom: finalWatchBottom,
            topOvPx: topOvPx, botOvPx: botOvPx,
            watch: { x: watch_offset_x, y: watch_offset_y, png: watchCanvas.toDataURL('image/png') },
            top: { x: topStrapX, y: topStrapY, w: topLit.width, h: topLit.height, png: topLit.toDataURL('image/png') },
            bottom: { x: bottomStrapX, y: bottomStrapY, w: bottomLit.width, h: bottomLit.height, png: bottomLit.toDataURL('image/png') }
          };
        } catch (e) {}
      }
      window.__svLastAdjustGeom = {
        unit: watchCanvas.width,
        top: { x: topStrapX, y: topStrapY, w: topResized.width, h: topResized.height },
        bottom: { x: bottomStrapX, y: bottomStrapY, w: bottomResized.width, h: bottomResized.height }
      };
      svPaintAssembly(finalCtx);
      svEnsureSharpWatch();   // 3.93.1: a 300px watch here means the sharp copy failed - fetch it again
      // 3.93.2: what was drawn - see the note above the sharp-watch step.
      try {
        if ((window.__svRenderTel = (window.__svRenderTel || 0) + 1) <= 5 && window.__svTelPush) {
          window.__svTelPush('render', {
            model: currentWatchData.model || '',
            title: 'u=' + watchCanvas.width + ' nat=' + svWatchNat + ' ' + svSharpState +
                   ' dpr=' + (window.devicePixelRatio || 1) + ' cw=' + finalCanvas.width + 'x' + finalCanvas.height +
                   ' z=' + ((typeof inlineZoom !== 'undefined' && inlineZoom && inlineZoom.scale) || 1) +
                   ' hid=' + (document.visibilityState === 'hidden' ? 1 : 0) +
                   ' b=' + SV_BUILD
          });
        }
      } catch (e) {}
      // Diagnostic: the EFFECTIVE overlap actually used, after the lug-root and connector-depth
      // rules deepen the 0.12/0.08 defaults. Expressed in case widths so it is directly
      // comparable with the owner's hand-placed dy values.
      window.__svOverlap = {
        caseW: watchCanvas.width, caseH: watchCanvas.height,
        topOvPx: topOvPx, botOvPx: botOvPx,
        topOvInCaseW: +(topOvPx / watchCanvas.width).toFixed(4),
        botOvInCaseW: +(botOvPx / watchCanvas.width).toFixed(4),
        defaultTopInCaseW: +((watchCanvas.height * 0.12) / watchCanvas.width).toFixed(4),
        defaultBotInCaseW: +((watchCanvas.height * 0.08) / watchCanvas.width).toFixed(4)
      };
      // LIGHTING pass 4 (3.65.0): ground shadow under everything, before the crop.
      svDropShadow(finalCanvas, svPaintAssembly, watchCanvas.width);

      /* 12) Crop final, then give it a margin.
         ⚠ The crop is TIGHT to the ink, so the strap's two ends land on the very first and last
         rows of the bitmap. The preview then scales that bitmap to fill its box, and both ends
         touch the edge with no daylight - which reads as the strap having been trimmed, even
         though nothing is missing. No CSS can fix it: any box the canvas is given is filled edge
         to edge by definition. Baking the margin into the bitmap fixes the preview, the zoom view
         and the downloaded image in one place. */
      const rendered = cropToContent(finalCanvas);
      const svPadY = Math.max(10, Math.round(rendered.height * 0.025));
      const svPadX = Math.max(10, Math.round(rendered.width * 0.02));
      finalCanvas.width = rendered.width + svPadX * 2;
      finalCanvas.height = rendered.height + svPadY * 2;
      finalCtx.clearRect(0, 0, finalCanvas.width, finalCanvas.height);
      finalCtx.drawImage(rendered, svPadX, svPadY);

      
      
      // Setup zoom functionality after successful combination
      setupZoomFunctionality();

      // The preview is now on screen - drop the loading overlay immediately (no forced delay).
      hideLoadingOverlay();

      // Center action buttons below final image
      setTimeout(() => {
        centerActionButtons();
      }, 100);
    } catch (err) {
    }
  }

  /************************************************************************
   * APPLE WATCH COMPOSITOR - fixed representative face + split/adapter-tuck.
   * Ported from the storefront apple-visualiser snippet. Apple straps are photographed with the
   * lug adapters at the two OUTER ends and the buckle/tail toward the centre gap; we place the
   * face over the centre and fan each arm outward with its adapter tucked under the case (buckle
   * arm on top). Single-piece straps (no gap) draw whole, centred.
   ************************************************************************/
  /* ---- One-sided straps ----
     A fob clips to the TOP lug and there is nothing below the case, so its flat-lay is a single
     piece. Both compositors otherwise assume two arms and will manufacture a second one out of the
     same photo (the Apple path splits at the narrow waist, the normal path halves the image down
     the middle), drawing an offcut under the watch that the product does not have.
     Matched on the title because that is all the strap objects carry client-side, and every fob in
     the catalogue is titled "… Fob" / "… Job Fobs" - Apple, Quick Release, QuickFit and Fitbit
     alike, so this covers whichever connector's fobs are in the visualiser. A dedicated metafield
     would be tidier if the range ever grows a one-sided strap that isn't called a fob. */
  function svIsOneSidedStrap(product) {
    if (!product) return false;
    return /\bfobs?\b/i.test(String(product.title || ''));
  }
  // Set by the Apple compositor for the Realign controls: with no lower arm, a "Bottom" resize and
  // a drag below the case have nothing to move.
  let svAppSolo = false;

  function svAppImgData(img) {
    try {
      const w = img.naturalWidth, h = img.naturalHeight, c = document.createElement('canvas');
      c.width = w; c.height = h; const o = c.getContext('2d'); o.drawImage(img, 0, 0);
      return { d: o.getImageData(0, 0, w, h).data, w, h };
    } catch (e) { return null; }
  }
  function svAppBbox(P) {
    const d = P.d, w = P.w, h = P.h; let x0 = w, y0 = h, x1 = 0, y1 = 0, f = false;
    for (let y = 0; y < h; y += 2) for (let x = 0; x < w; x += 2) if (d[(y * w + x) * 4 + 3] > 24) { f = true; if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    return f ? { x: x0, y: y0, w: x1 - x0, h: y1 - y0 } : { x: 0, y: 0, w: w, h: h };
  }
  function svAppGap(P, box) {
    const d = P.d, w = P.w, cov = [];
    for (let y = box.y; y < box.y + box.h; y++) { let n = 0; for (let x = box.x; x < box.x + box.w; x++) if (d[(y * w + x) * 4 + 3] > 24) n++; cov.push(n); }
    let mx = 0; for (let i = 0; i < cov.length; i++) if (cov[i] > mx) mx = cov[i];
    const thr = mx * 0.18, lo = Math.floor(box.h * 0.2), hi = Math.floor(box.h * 0.8); let best = null, run = null;
    for (let i = lo; i < hi; i++) { if (cov[i] < thr) { if (!run) run = [i, i]; else run[1] = i; } else { if (run && (!best || run[1] - run[0] > best[1] - best[0])) best = run; run = null; } }
    if (run && (!best || run[1] - run[0] > best[1] - best[0])) best = run;
    return { gy: best ? Math.round(box.y + (best[0] + best[1]) / 2) : Math.round(box.y + box.h / 2), gapLen: best ? best[1] - best[0] : 0 };
  }
  function svAppBuckle(P, box, y0, y1) {
    const d = P.d, w = P.w; let metal = 0, tot = 0, wmax = 0;
    for (let y = y0; y < y1; y++) { let mn = w, mxx = 0; for (let x = box.x; x < box.x + box.w; x++) { const i = (y * w + x) * 4; if (d[i + 3] < 60) continue; tot++; const r = d[i], g = d[i + 1], b = d[i + 2]; const mxc = Math.max(r, g, b), mnc = Math.min(r, g, b); const sat = mxc ? (mxc - mnc) / mxc : 0, lum = 0.299 * r + 0.587 * g + 0.114 * b; if (sat < 0.20 && lum > 70) metal++; if (x < mn) mn = x; if (x > mxx) mxx = x; } if (mxx > mn) wmax = Math.max(wmax, mxx - mn); }
    return (tot ? metal / tot : 0) + 0.4 * (wmax / box.w);
  }
  function svAppFaceMetrics(fP) {
    const def = { ct: 0.185, cb: 0.82, lug: 0.463, cw: 0, ok: false };
    if (!fP) return def;
    const fb = svAppBbox(fP), ct = fb.y / fP.h, cb = (fb.y + fb.h) / fP.h;
    let lo = fP.w, hi = 0; const y0 = Math.round(fb.y + fb.h * 0.05), y1 = Math.round(fb.y + fb.h * 0.15);
    for (let y = y0; y < y1; y++) for (let x = 0; x < fP.w; x++) if (fP.d[(y * fP.w + x) * 4 + 3] > 60) { if (x < lo) lo = x; if (x > hi) hi = x; }
    // cw = how much of the drawn face image the CASE actually occupies. The face arrives as a
    // 300px lug-normalised thumbnail (normalizeWatchThumbnail), so how much transparent padding
    // sits around the case varies per image - sizing the watch off the image width alone is
    // therefore sizing it off that padding.
    return { ct, cb, lug: hi > lo ? ((lo + hi) / 2) / fP.w : 0.463, cw: fb.w / fP.w, ok: fb.w > 0 };
  }
  // One pass over the strap bbox: per-row visible extent (width) and x-centre. Every geometric
  // measurement below reads these arrays instead of re-scanning pixels.
  function svAppRowScan(P, box) {
    const d = P.d, w = P.w, W = new Int32Array(box.h), C = new Float64Array(box.h);
    for (let i = 0; i < box.h; i++) {
      const y = box.y + i;
      let mn = 1e9, mx = -1;
      for (let x = box.x; x < box.x + box.w; x++) if (d[(y * w + x) * 4 + 3] > 24) { if (x < mn) mn = x; if (x > mx) mx = x; }
      if (mx >= mn) { W[i] = mx - mn + 1; C[i] = (mn + mx) / 2; } else { W[i] = 0; C[i] = NaN; }
    }
    return { W, C };
  }
  // The width a customer reads as "the strap": the 70th-PERCENTILE row width over [i0,i1).
  // Not the median - a link bracelet's median row is the narrow WAIST of its H-links (Titanium:
  // 58px against a real 230px link), which made bracelets measure as if they were chains. Not the
  // bbox either - that is the widest hardware anywhere in the photo.
  function svAppEnvWidth(W, i0, i1) {
    const nz = [];
    for (let i = Math.max(0, i0); i < Math.min(W.length, i1); i++) if (W[i] > 0) nz.push(W[i]);
    if (!nz.length) return 1;
    nz.sort((a, b) => a - b);
    return nz[Math.floor(nz.length * 0.70)];
  }
  // How deep the lug adapter runs from one end: the deepest row, within `lim` rows of that end,
  // still wider than envW * thresh. Measured rather than assumed because the adapters differ by
  // a factor of six across the Apple range.
  function svAppRun(W, envW, start, step, lim, thresh) {
    let last = 0;
    for (let i = 0; i < lim; i++) {
      const j = start + i * step;
      if (j < 0 || j >= W.length) break;
      if (!W[j]) continue;
      if (W[j] > envW * thresh) last = i + 1;
    }
    return last;
  }
  // Widest row + median x-centre over n rows from one end - the adapter zone. The centre is what
  // the arm is aligned on: the rows that actually meet the case must sit on the slot's axis, even
  // when the rest of a skewed or curved strap photo leans away from it.
  // ⚠ The centre is taken only from rows at least 60% of the zone's max width: the first rows of
  // a bar are its rounded CORNERS, narrow and off-centre - the Carabiner Fob's first 7 rows read
  // 30px off the true bar centre and shoved the whole fob sideways off its watch.
  function svAppZone(W, C, start, step, n) {
    let mw = 0; const rows = [];
    for (let i = 0; i < n; i++) {
      const j = start + i * step;
      if (j < 0 || j >= W.length || !W[j]) continue;
      if (W[j] > mw) mw = W[j];
      rows.push([W[j], C[j]]);
    }
    if (!rows.length) return { w: 0, c: NaN };
    let cs = rows.filter(r => r[0] >= mw * 0.6).map(r => r[1]);
    if (!cs.length) cs = rows.map(r => r[1]);
    cs.sort((a, b) => a - b);
    return { w: mw, c: cs[Math.floor(cs.length / 2)] };
  }

  /* ---- Manual strap adjustment ----
     Automatic placement is right for almost every combination, but a strap photographed at a
     slight angle can still land a few pixels out. Rather than leave someone stuck with a preview
     that looks a bit off, the top and bottom of the strap can be dragged into place by hand.
     Offsets are in FINAL-CANVAS pixels and reset whenever the watch or strap changes, because
     a nudge measured against one combination means nothing against the next. */
  // x/y in FINAL-CANVAS pixels, s = size multiplier for that arm (1 = as calculated).
  let svAppNudge = { top: { x: 0, y: 0, s: 1 }, bottom: { x: 0, y: 0, s: 1 } };
  const SV_ARM_S_MIN = 0.7, SV_ARM_S_MAX = 1.4, SV_ARM_S_STEP = 0.04;
  let svAppAdjust = false;          // adjust mode on/off
  let svAppLast = null;             // {strapImg, watchImg, hi} so a nudge can repaint without re-selecting
  let svAppHi = null;               // 3.66.0: the sharp {strap, face} sources of the CURRENT strap, once landed
  let svAppLayout = null;           // case band position in FINAL canvas pixels, for hit-testing

  function svAppNudged() {
    const n = svAppNudge;
    return !!(n.top.x || n.top.y || n.bottom.x || n.bottom.y || n.top.s !== 1 || n.bottom.s !== 1);
  }
  function svAppResizeArm(side, dir) {
    const n = svAppNudge[side];
    n.s = Math.max(SV_ARM_S_MIN, Math.min(SV_ARM_S_MAX, (n.s || 1) + dir * SV_ARM_S_STEP));
    if (svAppLast) performAppleCombination(svAppLast.strapImg, svAppLast.watchImg, svAppLast.hi);
    svAppSyncControls();
  }
  function svAppResetNudge(repaint) {
    svAppNudge = { top: { x: 0, y: 0, s: 1 }, bottom: { x: 0, y: 0, s: 1 } };
    if (repaint && svAppLast) performAppleCombination(svAppLast.strapImg, svAppLast.watchImg, svAppLast.hi);
    svAppSyncControls();
  }

  // "Realign strap" toggle + Reset, shown beside Zoom / Download and only while an Apple watch is
  // composited. A deliberate toggle rather than always-on dragging: the preview already supports
  // pan and pinch-zoom, and silently stealing those gestures would break zooming for the many
  // people who never need to adjust anything.
  function svAppSetupAdjust() {
    const canvas = document.getElementById('finalCanvas');
    if (!canvas) return;
    let bar = document.getElementById('svAppAdjustBar');
    if (!bar) {
      // Below the preview, NOT inside .preview-viewport - that is the zoom/pan viewport, so
      // anything appended there is laid over the picture instead of under it. The .final-image-
      // container (rather than the Zoom/Download row) because that row is display:none on mobile,
      // and phones are exactly where a strap most needs nudging.
      const host = canvas.closest('.final-image-container') || canvas.parentElement;
      if (!host) return;
      bar = document.createElement('div');
      bar.id = 'svAppAdjustBar';
      bar.style.cssText = 'display:flex;gap:8px;justify-content:center;align-items:center;flex-wrap:wrap;margin:8px 0 0;';
      bar.innerHTML =
        '<button type="button" id="svAppAdjustBtn" style="padding:7px 14px;border:1px solid #b2955f;border-radius:999px;' +
        'background:#fff;color:#6b5a37;font-size:.85rem;font-weight:600;cursor:pointer;">Realign strap</button>' +
        '<button type="button" id="svAppResetBtn" style="padding:7px 12px;border:1px solid #ddd;border-radius:999px;' +
        'background:#fff;color:#777;font-size:.82rem;cursor:pointer;display:none;">Reset</button>' +
        '<span id="svAppAdjustHint" style="width:100%;text-align:center;font-size:.8rem;color:#777;display:none;">' +
        'Drag the top or bottom of the strap to line it up, or resize either side.</span>' +
        '<div id="svAppSizeRow" style="display:none;width:100%;justify-content:center;gap:18px;align-items:center;">' +
        svAppSizeGroup('top', 'Top') + svAppSizeGroup('bottom', 'Bottom') + '</div>';
      host.appendChild(bar);
      bar.querySelectorAll('[data-arm]').forEach(b => {
        b.addEventListener('click', () => svAppResizeArm(b.dataset.arm, parseInt(b.dataset.dir, 10)));
      });
      bar.querySelector('#svAppAdjustBtn').addEventListener('click', () => {
        svAppAdjust = !svAppAdjust;
        svAppSyncControls();
      });
      bar.querySelector('#svAppResetBtn').addEventListener('click', () => svAppResetNudge(true));
      svAppBindDrag(canvas);
    }
    bar.style.display = '';
    svAppSyncControls();
  }

  function svAppSizeGroup(arm, label) {
    const btn = (dir, glyph) =>
      '<button type="button" data-arm="' + arm + '" data-dir="' + dir + '" aria-label="' + label +
      (dir > 0 ? ' bigger' : ' smaller') + '" style="width:30px;height:30px;border:1px solid #ddd;' +
      'border-radius:50%;background:#fff;color:#6b5a37;font-size:1rem;line-height:1;cursor:pointer;' +
      // inline-flex + zero padding, or the glyph sits off-centre in the circle: a button's default
      // padding and text baseline do NOT centre a single character.
      'display:inline-flex;align-items:center;justify-content:center;padding:0;font-family:inherit;">' +
      glyph + '</button>';
    // The label is its own element so a one-sided strap can drop it: with only one arm on screen,
    // "Top" beside the only pair of buttons implies a Bottom that isn't there.
    return '<span style="display:inline-flex;align-items:center;gap:6px;font-size:.82rem;color:#777;">' +
      '<span class="sv-arm-label">' + label + '</span>' + btn(-1, '&minus;') + btn(1, '+') + '</span>';
  }

  function svAppSyncControls() {
    const btn = document.getElementById('svAppAdjustBtn');
    const reset = document.getElementById('svAppResetBtn');
    const hint = document.getElementById('svAppAdjustHint');
    const canvas = document.getElementById('finalCanvas');
    if (!btn) return;
    btn.textContent = svAppAdjust ? 'Done realigning' : 'Realign strap';
    btn.style.background = svAppAdjust ? '#b2955f' : '#fff';
    btn.style.color = svAppAdjust ? '#fff' : '#6b5a37';
    if (hint) {
      hint.style.display = svAppAdjust ? '' : 'none';
      hint.textContent = svAppSolo
        ? 'Drag the strap to line it up, or resize it.'
        : 'Drag the top or bottom of the strap to line it up, or resize either side.';
    }
    const sizeRow = document.getElementById('svAppSizeRow');
    if (sizeRow) sizeRow.style.display = svAppAdjust ? 'flex' : 'none';
    // A one-sided strap has no lower arm, so hide its Bottom resize and drop the "Top" caption.
    const botGroup = document.querySelector('#svAppSizeRow [data-arm="bottom"]');
    const botWrap = botGroup && botGroup.parentElement;
    if (botWrap) botWrap.style.display = svAppSolo ? 'none' : '';
    const topGroup = document.querySelector('#svAppSizeRow [data-arm="top"]');
    const topLabel = topGroup && topGroup.parentElement && topGroup.parentElement.querySelector('.sv-arm-label');
    if (topLabel) topLabel.style.display = svAppSolo ? 'none' : '';
    if (reset) reset.style.display = svAppNudged() ? '' : 'none';
    if (canvas) {
      canvas.style.cursor = svAppAdjust ? 'grab' : '';
      canvas.style.touchAction = svAppAdjust ? 'none' : '';   // let a drag beat the page scroll
    }
  }

  function svAppHideAdjust() {
    const bar = document.getElementById('svAppAdjustBar');
    if (bar) bar.style.display = 'none';
    svAppSolo = false;
    svAppAdjust = false;
    const canvas = document.getElementById('finalCanvas');
    if (canvas) { canvas.style.cursor = ''; canvas.style.touchAction = ''; }
  }

  function svAppBindDrag(canvas) {
    let dragging = null;    // 'top' | 'bottom'
    let startX = 0, startY = 0, base = null, pending = false;

    const toCanvasPx = (e) => {
      const r = canvas.getBoundingClientRect();
      return { x: (e.clientX - r.left) * (canvas.width / r.width),
               y: (e.clientY - r.top) * (canvas.height / r.height) };
    };

    canvas.addEventListener('pointerdown', (e) => {
      if (!svAppAdjust || !svAppLayout) return;
      const p = toCanvasPx(e);
      // One-sided: the only arm is the top one, so a drag anywhere moves it (grabbing below the
      // case would otherwise nudge an arm that isn't drawn, and appear to do nothing).
      dragging = (svAppSolo || p.y < svAppLayout.caseMidY) ? 'top' : 'bottom';
      base = { x: svAppNudge[dragging].x, y: svAppNudge[dragging].y };
      startX = e.clientX; startY = e.clientY;
      canvas.style.cursor = 'grabbing';
      try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
      e.preventDefault();
    });

    canvas.addEventListener('pointermove', (e) => {
      if (!dragging || !svAppLast) return;
      const r = canvas.getBoundingClientRect();
      const k = canvas.width / r.width;
      // Clamped so the strap can be lined up but never dragged off its watch.
      const limX = svAppLayout.canvasW * 0.25, limY = svAppLayout.canvasH * 0.06;
      svAppNudge[dragging] = {
        x: Math.max(-limX, Math.min(limX, base.x + (e.clientX - startX) * k)),
        y: Math.max(-limY, Math.min(limY, base.y + (e.clientY - startY) * k))
      };
      if (!pending) {           // one repaint per frame, not one per pointer event
        pending = true;
        svRaf(() => {
          pending = false;
          // 1x while the finger is down - the 2x canvas is too heavy to repaint per frame.
          if (svAppLast) performAppleCombination(svAppLast.strapImg, svAppLast.watchImg, null);
        });
      }
      e.preventDefault();
    });

    const end = (e) => {
      if (!dragging) return;
      dragging = null;
      canvas.style.cursor = svAppAdjust ? 'grab' : '';
      try { canvas.releasePointerCapture(e.pointerId); } catch (err) {}
      svAppSyncControls();
      // Finger up: put the sharp copy back (the drag frames painted at 1x).
      if (svAppLast && svAppHi) performAppleCombination(svAppLast.strapImg, svAppLast.watchImg, svAppHi);
    };
    canvas.addEventListener('pointerup', end);
    canvas.addEventListener('pointercancel', end);
  }

  function performAppleCombination(strapImg, watchImg, hi) {
    // The case is sized from the LUG ADAPTER - the one physically standard part of every Apple
    // strap (they all end in the same slot bar), scaled so it always spans SLOT_FRAC of the case
    // width. The old rule - max(band*1.25, bbox*1.02) - let the bbox term win for most straps
    // (the bbox is the widest hardware anywhere in the photo), so the adapter spanned 95-98% of
    // the case and every strap got its own arbitrary proportion; measured across all 227 strap
    // products the band/case ratio swung 0.20-0.81. Anchoring on the adapter makes every strap
    // attach with identical junction geometry, and band width falls wherever the product's real
    // band/adapter ratio puts it.
    // ADAPTER_SHOW leaves a sliver of the adapter visible so its colour still reads.
    // ⚠ ADAPTER_T is the sensitive one. At 1.04 it counted the strap's own gentle widening toward
    // the case as "adapter"; at 1.15 it isolates the actual adapter step. It is applied against
    // the PER-ARM envelope width - against a global envelope, a thin tail piece makes the whole
    // of a wider buckle piece read as "adapter" and the tuck runs to its cap (the Double Tour).
    // Tuck bounds are fractions of CASE height, not face-image height: face padding varies per
    // watch (Series 7's case fills 99% of its image, the SE's 54%), and image-relative bounds
    // gave the same strap visibly different junction depths on different watches.
    const ADAPTER_SHOW = 0.18, ADAPTER_T = 1.15;
    const SLOT_FRAC = 0.85, SLOT_FRAC_SOLO = 0.95;   // fob flares wrap the case, so nearly match it
    const TUCK_MIN_CASE = 0.135, TUCK_MAX_CASE = 0.26;
    const CASE_OVER_BAND_MIN = 1.15, LEGACY_CASE_W = 2.15;
    const canvas = document.getElementById('finalCanvas'), ctx = canvas.getContext('2d');
    // 3.66.0: `hi` = { strap, face } sharp draw sources (optional). The canvas is K x the 1x
    // 868x1100 whenever they are in play; every measurement below still reads strapImg/watchImg
    // (the 900/612 images), and kS maps a 900-image source rect onto the sharp strap.
    const _hiStrap = (hi && hi.strap && hi.strap.naturalWidth > strapImg.naturalWidth) ? hi.strap : null;
    const _hiFace = (hi && hi.face && hi.face.naturalWidth > watchImg.naturalWidth) ? hi.face : null;
    if (_hiStrap || _hiFace) svAppHi = { strap: _hiStrap, face: _hiFace };
    const K = (_hiStrap || _hiFace) ? SV_APP_HIDPI : 1;
    const kS = _hiStrap ? _hiStrap.naturalWidth / strapImg.naturalWidth : 1;
    const CH = Math.round(1100 * K), CW = Math.round(CH * 600 / 760);
    if (canvas.width !== CW || canvas.height !== CH) { canvas.width = CW; canvas.height = CH; }
    ctx.clearRect(0, 0, CW, CH);
    const P = svAppImgData(strapImg), fP = svAppImgData(watchImg);
    // LIGHTING (3.65.0): draw from the exposure-lifted copy; arms are shaded per crop below.
    const svMatA = svMaterialOf(selectedStrapProduct);
    const strapSrc = svLiftedSource(_hiStrap || strapImg, svMatA);
    const faceSrc = _hiFace || watchImg;
    const box = P ? svAppBbox(P) : { x: 0, y: 0, w: strapImg.naturalWidth, h: strapImg.naturalHeight };
    const fm = svAppFaceMetrics(fP);
    const ar = watchImg.naturalHeight / watchImg.naturalWidth;
    const R = P ? svAppRowScan(P, box) : null;
    const envW = R ? svAppEnvWidth(R.W, 0, box.h) : box.w;
    const caseHf = fm.cb - fm.ct;   // case height as a fraction of the face image height

    // Which half goes above the case has to be settled BEFORE the adapter measurement, because
    // the per-arm envelopes need the split point. None of this depends on scale.
    const g = P ? svAppGap(P, box) : { gy: box.y + Math.round(box.h / 2), gapLen: 0 };
    const topArm = { y0: box.y, y1: g.gy, a0: true }, botArm = { y0: g.gy, y1: box.y + box.h, a0: false };
    let buckleArm = botArm;
    if (P && g.gapLen > box.h * 0.03) {
      const tH = g.gy - box.y, bH = (box.y + box.h) - g.gy;
      const ts = svAppBuckle(P, box, g.gy - Math.round(tH * 0.35), g.gy);
      const bs = svAppBuckle(P, box, g.gy, g.gy + Math.round(bH * 0.35));
      buckleArm = bs >= ts ? botArm : topArm;
    }
    const tailArm = buckleArm === botArm ? topArm : botArm;
    // ⚠ The split above is NOT used for a one-sided strap, and not merely as a redundancy: svAppGap
    // finds a "gap" at the waist where the fob body meets the strap, which is why the Carabiner Fob
    // drew a carabiner above the case and its own strap end below, reading as a phantom lower strap.

    // ONE-SIDED STRAPS (fobs) clip to the TOP of the watch and there is nothing below it, so the
    // whole photo is a single arm. Which end meets the case is decided by where the lug adapter
    // is; svAppBuckle is no help, a fob has no buckle. ⚠ NOT by which end is WIDER - a carabiner
    // ring is wider than the band, so the widest-end test put the carabiner against the case. The
    // adapter is a SHALLOW step and the fob body a long flare: probe each end to half the piece
    // and take the SHORTER run (measured 7% Carabiner / 10% Job Fob at the adapter vs 37% / 21%
    // at the body).
    const oneSided = svIsOneSidedStrap(selectedStrapProduct);
    svAppSolo = oneSided;
    const soloArm = { y0: box.y, y1: box.y + box.h, a0: true };
    // Adapter measurement per case end: run depth (rows wider than the arm's own envelope), then
    // widest row + median x-centre over that zone. adRef is the physical anchor for the case.
    let runT = 0, runB = 0, soloRows = 0, adRef = 1, slot = SLOT_FRAC;
    let zT = { w: 0, c: NaN }, zB = { w: 0, c: NaN };
    if (R) {
      if (oneSided) {
        const deep = Math.round(box.h * 0.5);
        const dT = svAppRun(R.W, envW, 0, 1, deep, ADAPTER_T);
        const dB = svAppRun(R.W, envW, box.h - 1, -1, deep, ADAPTER_T);
        // Which end meets the case: the adapter end terminates in a FLAT moulded slot bar, so it
        // hits its full width almost immediately; a carabiner ring or rounded paddle starts
        // narrow. (The old shorter-wide-run rule was ambiguous when both ends carry long wide
        // features - the Carabiner Fob's flare vs its carabiner - and put the watch on the ring.)
        const svAppEdgeFlat = (start, step) => {
          // Width of the 3rd visible row (past the antialiased corner rows) over the zone max.
          const span = Math.max(3, Math.round(box.h * 0.04));
          let first = 0, seen = 0, mx = 1;
          for (let i = 0; i < span; i++) {
            const j = start + i * step;
            if (j < 0 || j >= R.W.length) break;
            if (R.W[j]) { seen++; if (seen === 3 && !first) first = R.W[j]; }
            if (R.W[j] > mx) mx = R.W[j];
          }
          return first / mx;
        };
        soloArm.a0 = svAppEdgeFlat(0, 1) >= svAppEdgeFlat(box.h - 1, -1);
        // Window over the CHOSEN end's own adapter run - min(dT,dB) collapses to 0 whenever the
        // free end has no wide step at all (the Carabiner Fob), which shrank the zone to the bar's
        // corner rows and misread its centre.
        soloRows = Math.min(soloArm.a0 ? dT : dB, Math.round(box.h * 0.15));
        const win = Math.max(3, soloRows, Math.round(box.h * 0.01));
        zT = svAppZone(R.W, R.C, 0, 1, win);
        zB = svAppZone(R.W, R.C, box.h - 1, -1, win);
        adRef = Math.max(soloArm.a0 ? zT.w : zB.w, 1);
        slot = SLOT_FRAC_SOLO;
        runT = runB = soloRows;
      } else {
        const gi = g.gy - box.y;
        const topEnv = gi > 0 ? svAppEnvWidth(R.W, 0, gi) : envW;
        const botEnv = box.h - gi > 0 ? svAppEnvWidth(R.W, gi, box.h) : envW;
        runT = svAppRun(R.W, topEnv, 0, 1, Math.max(1, Math.round(gi * 0.30)), ADAPTER_T);
        runB = svAppRun(R.W, botEnv, box.h - 1, -1, Math.max(1, Math.round((box.h - gi) * 0.30)), ADAPTER_T);
        const winT = Math.max(3, runT, Math.round(box.h * 0.01));
        const winB = Math.max(3, runB, Math.round(box.h * 0.01));
        zT = svAppZone(R.W, R.C, 0, 1, winT);
        zB = svAppZone(R.W, R.C, box.h - 1, -1, winB);
        adRef = Math.max(zT.w, zB.w, 1);
      }
    }
    // Case width per unit of strap scale: the adapter maps to SLOT_FRAC of the case, floored so
    // the case is never narrower than 1.15x the band envelope (covers the odd photo whose adapter
    // reads narrower than its band). Everything below is linear in `scale`, which lets the scale
    // be solved for the WHOLE assembly in one pass.
    const wwPer = (fm.ok && R)
      ? Math.max(adRef / slot, envW * CASE_OVER_BAND_MIN) / fm.cw
      : box.w * LEGACY_CASE_W;

    // Apple straps are photographed adapters-outward, so each arm meets the case at one of the
    // photo's OUTER ends (arm.a0 = its case end is the photo's TOP end). rows/(wwPer*ar) is the
    // adapter as a fraction of the face image height with the scale cancelling out.
    function svAppTuckRows(rows) {
      return Math.max(TUCK_MIN_CASE * caseHf,
        Math.min(TUCK_MAX_CASE * caseHf, (rows * (1 - ADAPTER_SHOW)) / (wwPer * ar)));
    }
    // One-sided: no lower arm, so the whole case below the tuck stays exposed (tuckBot = 0 feeds
    // straight through the `spread` and `scale` expressions below).
    const tuckTop = oneSided
      ? (R ? svAppTuckRows(soloRows) : TUCK_MIN_CASE * caseHf)
      : (R ? svAppTuckRows(buckleArm.a0 ? runT : runB) : TUCK_MIN_CASE * caseHf);
    const tuckBot = oneSided ? 0 : (R ? svAppTuckRows(tailArm.a0 ? runT : runB) : TUCK_MIN_CASE * caseHf);

    const spread = Math.max(0.05, (fm.cb - fm.ct) - (tuckTop + tuckBot));   // case the arms straddle
    const cx = CW / 2;
    let cy = CH / 2;
    let scale = (CH * 0.92) / (box.h + wwPer * ar * spread);
    if (oneSided) {
      // ⚠ The two-sided solve leans on symmetry: it centres the WATCH, and each arm reaches about
      // half of box.h away from it. With one arm the whole of box.h goes upward, so the same scale
      // ran the fob body off the top of the canvas (the carabiner came out clipped). Solve on the
      // real one-sided extent instead - arm + the whole face below it, less the tuck - and then
      // centre the ASSEMBLY rather than the watch.
      scale = (CH * 0.96) / (box.h + wwPer * ar * (1 - tuckTop));
      // A one-armed assembly is also much shorter, so the height solve can push it wider than the
      // canvas; cap on width as well. Only ever reduces the scale.
      scale = Math.min(scale, (CW * 0.94) / Math.max(wwPer, box.w));
      const armH = box.h * scale, whOne = wwPer * scale * ar;
      const assemblyH = armH + whOne * (1 - tuckTop);
      cy = (CH - assemblyH) / 2 + armH - whOne * tuckTop + whOne / 2 - fm.ct * whOne;
    }
    const armW = box.w * scale;
    const ww = wwPer * scale, wh = ww * ar;
    const strapCX = cx - ww / 2 + fm.lug * ww;
    const caseTopY = cy - wh / 2 + fm.ct * wh, caseBotY = cy - wh / 2 + fm.cb * wh;
    const adTop = caseTopY + wh * tuckTop, adBot = caseBotY - wh * tuckBot;
    function drawArm(arm, side, c) {
      c = c || ctx;
      const h = (arm.y1 - arm.y0) * scale;
      const flip = side === 'above' ? arm.a0 : !arm.a0;
      const dy = side === 'above' ? (flip ? 0 : -h) : (flip ? -h : 0);
      // Centre this arm on its ADAPTER's x-centre - the rows that actually meet the case (capped,
      // so a strange photo can't fling it sideways) - then apply whatever the customer dragged.
      // The old rule centred on the arm's own median band axis, which leaves the CASE END offset
      // whenever the photo's arm is skewed or curved: the junction is what has to line up.
      let ax = 0;
      if (R) {
        const zc = arm.a0 ? zT.c : zB.c;
        if (!isNaN(zc)) {
          const lim = armW * 0.15;
          ax = Math.max(-lim, Math.min(lim, (zc - (box.x + box.w / 2)) * scale));
        }
      }
      // Per-arm size. Anchored at the case end, so a resize grows the arm AWAY from the watch
      // instead of sliding its adapter out from under the case.
      const nudge = svAppNudge[side === 'above' ? 'top' : 'bottom'];
      const s = nudge.s || 1, aw = armW * s, ah = h * s;
      const ady = side === 'above' ? (flip ? 0 : -ah) : (flip ? -ah : 0);
      c.save();
      c.translate(strapCX - ax + nudge.x, (side === 'above' ? adTop : adBot) + nudge.y);
      c.scale(1, flip ? -1 : 1);
      // The arm's case end in SOURCE orientation is the photo's top end when a0 (the flip
      // above turns it toward the case). Case height in source px = drawn case height / scale.
      // Source rect in the SHARP strap's pixels (kS = 1 when drawing from the 900px image).
      const armC = svAppArmCanvas(strapSrc, Math.round(box.x * kS), Math.round(arm.y0 * kS),
                                  Math.round(box.w * kS), Math.round((arm.y1 - arm.y0) * kS), svMatA,
                                  (((fm.cb - fm.ct) * wh) / (scale || 1)) * kS, arm.a0 ? 'top' : 'bottom');
      c.drawImage(armC, 0, 0, armC.width, armC.height, -aw / 2, ady, aw, ah); c.restore();
    }
    const svAppPaint = (c) => {
      if (P) {
        if (oneSided) drawArm(soloArm, 'above', c);
        else { drawArm(buckleArm, 'above', c); drawArm(tailArm, 'below', c); }
      } else {
        const dw = box.w * scale, dh = box.h * scale;
        c.drawImage(strapSrc, box.x * kS, box.y * kS, box.w * kS, box.h * kS, cx - dw / 2, cy - dh / 2, dw, dh);
      }
      c.drawImage(faceSrc, cx - ww / 2, cy - wh / 2, ww, wh);
    };
    svAppPaint(ctx);
    svDropShadow(canvas, svAppPaint, ww);   // LIGHTING pass 4 (3.65.0)
    // cropToContent shifts the origin, so record where the case ended up in FINAL canvas pixels -
    // that is what decides whether a drag grabbed the top arm or the bottom one.
    const _cropped = cropToContent(canvas, true);
    const rendered = _cropped.canvas || _cropped;
    const _off = _cropped.offset || { x: 0, y: 0 };
    svAppLast = { strapImg, watchImg, hi: (_hiStrap || _hiFace) ? { strap: _hiStrap, face: _hiFace } : null };
    svAppLayout = { caseMidY: cy - _off.y, caseTopY: caseTopY - _off.y, caseBotY: caseBotY - _off.y,
                    canvasH: rendered.height, canvasW: rendered.width };
    canvas.width = rendered.width; canvas.height = rendered.height;
    ctx.clearRect(0, 0, canvas.width, canvas.height); ctx.drawImage(rendered, 0, 0);
    svAppSetupAdjust();
    if (typeof setupZoomFunctionality === 'function') setupZoomFunctionality();
    hideLoadingOverlay();
    setTimeout(() => { if (typeof centerActionButtons === 'function') centerActionButtons(); }, 100);
  }

  /************************************************************************
   * IN-PLACE ZOOM & PAN (within the preview box, not a popup)
   ************************************************************************/
  let inlineZoom = { mode:false, scale:1, x:0, y:0, dragging:false, sx:0, sy:0, wired:false };

  /* 3.93.3: ON A PHONE, ZOOM BY SIZING THE CANVAS BOX, NOT BY A CSS TRANSFORM. The owner's
     "blurry pics" (three screenshots over 3.92.5 -> 3.93.2): the phones' own `render` reports
     showed a SHARP bitmap every time - `nat=900 sharp`, canvas 981-1387px wide - at dpr 3 with the
     mobile resting zoom of 2. The canvas is laid out small (fit to --sv-canvas-h, ~110 css px
     wide), iOS Safari rasterises it at THAT layout size, and `transform: scale(2)` then magnifies
     the raster - a 2x blur of a 330-device-px picture, with the sharp 981px bitmap never sampled.
     Desktop is dpr 1 at zoom 1, so it never showed there, and a Blink emulation samples the bitmap
     through the transform, so headless Chrome could not reproduce it either. Setting the box to
     base x scale makes the layout size the displayed size, so WebKit rasterises the canvas at
     what is on screen. The box is a flex item centred both ways in an overflow:hidden viewport, so
     growing it about its centre is exactly what the transform did and the pan translate is
     unchanged. The resting layout size is measured with our sizing removed and cached per
     (bitmap, viewport, preview height) so a drag does not re-layout on every touchmove.
     Desktop keeps the transform - its viewport is not clipped and a bigger box would push the
     page around. */
  function svZoomBySize() { return window.innerWidth <= 768; }
  function applyInlineZoom() {
    const canvas = document.getElementById('finalCanvas');
    if (!canvas) return;
    canvas.style.transformOrigin = 'center center';
    if (svZoomBySize()) {
      const s = inlineZoom.scale || 1;
      const vp = canvas.parentElement;
      const key = canvas.width + 'x' + canvas.height + '@' + window.innerWidth + 'x' + window.innerHeight +
                  '/' + (vp ? vp.clientWidth + 'x' + vp.clientHeight : '');
      if (inlineZoom._baseKey !== key || !inlineZoom._baseW) {
        ['width', 'height', 'max-width', 'max-height', 'flex'].forEach(p => canvas.style.removeProperty(p));
        inlineZoom._baseW = canvas.offsetWidth; inlineZoom._baseH = canvas.offsetHeight;
        inlineZoom._baseKey = key;
      }
      if (s > 1.001 && inlineZoom._baseW && inlineZoom._baseH) {
        canvas.style.setProperty('width', Math.round(inlineZoom._baseW * s) + 'px', 'important');
        canvas.style.setProperty('height', Math.round(inlineZoom._baseH * s) + 'px', 'important');
        canvas.style.setProperty('max-width', 'none', 'important');
        canvas.style.setProperty('max-height', 'none', 'important');
        canvas.style.setProperty('flex', '0 0 auto', 'important');
      } else {
        ['width', 'height', 'max-width', 'max-height', 'flex'].forEach(p => canvas.style.removeProperty(p));
      }
      canvas.style.transform = `translate(${inlineZoom.x}px, ${inlineZoom.y}px)`;
    } else {
      ['width', 'height', 'max-width', 'max-height', 'flex'].forEach(p => canvas.style.removeProperty(p));
      canvas.style.transform = `translate(${inlineZoom.x}px, ${inlineZoom.y}px) scale(${inlineZoom.scale})`;
    }
    canvas.style.cursor = inlineZoom.scale > 1 ? (inlineZoom.dragging ? 'grabbing' : 'grab') : 'default';
    // Keep the button label/state in sync: "Zoom In" → "Zoom Out" once zoomed.
    const zoomBtn = document.getElementById('zoomBtn');
    if (zoomBtn) {
      const zoomed = inlineZoom.scale > inlineZoomDefault() + 0.01;
      zoomBtn.textContent = zoomed ? 'Zoom Out' : 'Zoom In';
      zoomBtn.classList.toggle('active', zoomed);
    }
  }

  function clampInlineZoom() {
    const c = document.querySelector('.preview-viewport');
    const canvas = document.getElementById('finalCanvas');
    if (!c || !canvas) return;
    // Pan limit = how far the scaled canvas overflows the viewport on each side,
    // so the top of the watch / bottom of the strap can be panned fully into view.
    // 3.93.3: in size mode the box already carries the scale - measure from the resting size.
    const bw = (svZoomBySize() && inlineZoom._baseW) ? inlineZoom._baseW : canvas.offsetWidth;
    const bh = (svZoomBySize() && inlineZoom._baseH) ? inlineZoom._baseH : canvas.offsetHeight;
    const mx = Math.max(0, (bw * inlineZoom.scale - c.clientWidth)  / 2);
    const my = Math.max(0, (bh * inlineZoom.scale - c.clientHeight) / 2);
    inlineZoom.x = Math.max(-mx, Math.min(mx, inlineZoom.x));
    inlineZoom.y = Math.max(-my, Math.min(my, inlineZoom.y));
  }

  /* 3.66.2: the zoom survives a strap / colour / watch change. The first render of the session
     takes the resting default (resetInlineZoom); every later render keeps inlineZoom.scale and
     the pan, re-clamped against the NEW canvas so nothing is left panned off its edge. The Zoom
     button, the wheel, the mobile slider and double-click still change it as before. */
  let svZoomSeeded = false;
  function svKeepInlineZoom() {
    if (!svZoomSeeded) { svZoomSeeded = true; resetInlineZoom(); return; }
    inlineZoom.dragging = false;
    inlineZoom.mode = inlineZoom.scale > inlineZoomDefault() + 0.01;
    clampInlineZoom();
    applyInlineZoom();
  }

  function resetInlineZoom() {
    // Default view zooms to 180% on MOBILE so the watch reads large; desktop stays fit-to-box.
    // Both now have a Zoom button, which steps up from this resting size and back again.
    const def = inlineZoomDefault();
    inlineZoom.scale = def; inlineZoom.x = 0; inlineZoom.y = 0; inlineZoom.dragging = false;
    inlineZoom.mode = def > 1;
    const zoomBtn = document.getElementById('zoomBtn');
    if (zoomBtn) zoomBtn.classList.remove('active');
    applyInlineZoom();
  }

  // Mobile opens the preview already enlarged, so "zoomed" means bigger than THAT, not bigger
  // than 1. Comparing against 1 made the mobile button a no-op: it zoomed to 1.7 while the
  // resting state was already 1.8, so a tap changed nothing visible.
  // 3.66.1 (owner: "slightly more zoomed by default"): 1.8 -> 2.0. The Zoom button's 2.9 is still
  // a real step up from this.
  // 3.93.4 (owner): "the images on mobile are usually too zoomed up on initial load" - the resting
  // zoom drops from 2.0 to 1.5; the Zoom button still steps up to 2.9 from here.
  function inlineZoomDefault() { return window.innerWidth <= 768 ? 1.5 : 1; }

  function toggleInlineZoom() {
    if (inlineZoom.scale > inlineZoomDefault() + 0.01) {
      resetInlineZoom();
    } else {
      const onMobile = window.innerWidth <= 768;
      inlineZoom.mode = true;
      inlineZoom.scale = onMobile ? 2.9 : 2;   // a real step up from the mobile resting size
      // On mobile, start pinned to the top so the watch is in view (not the strap mid-point)
      if (onMobile) { inlineZoom.x = 0; inlineZoom.y = 99999; }
      const zoomBtn = document.getElementById('zoomBtn');
      if (zoomBtn) zoomBtn.classList.add('active');
      clampInlineZoom();
      applyInlineZoom();
    }
  }

  function setupInlineZoom() {
    const container = document.querySelector('.preview-viewport');
    const canvas = document.getElementById('finalCanvas');
    if (!container || !canvas || inlineZoom.wired) return;
    inlineZoom.wired = true;
    container.style.overflow = 'hidden'; // clip the zoomed canvas to the viewport

    container.addEventListener('wheel', (e) => {
      if (typeof isMobileView === 'function' && isMobileView()) return;
      if (!inlineZoom.mode && inlineZoom.scale <= 1) return; // don't hijack normal page scroll
      e.preventDefault();
      inlineZoom.scale = Math.max(1, Math.min(3, inlineZoom.scale + (e.deltaY < 0 ? 0.2 : -0.2)));
      inlineZoom.mode = inlineZoom.scale > 1;
      if (inlineZoom.scale === 1) { inlineZoom.x = 0; inlineZoom.y = 0; }
      clampInlineZoom();
      applyInlineZoom();
    }, { passive:false });

    container.addEventListener('mousedown', (e) => {
      if (inlineZoom.scale <= 1) return;
      inlineZoom.dragging = true;
      inlineZoom.sx = e.clientX - inlineZoom.x;
      inlineZoom.sy = e.clientY - inlineZoom.y;
      applyInlineZoom();
      e.preventDefault();
    });
    window.addEventListener('mousemove', (e) => {
      if (!inlineZoom.dragging) return;
      inlineZoom.x = e.clientX - inlineZoom.sx;
      inlineZoom.y = e.clientY - inlineZoom.sy;
      clampInlineZoom();
      applyInlineZoom();
    });
    window.addEventListener('mouseup', () => {
      if (inlineZoom.dragging) { inlineZoom.dragging = false; applyInlineZoom(); }
    });
    container.addEventListener('dblclick', () => resetInlineZoom());

    // Touch pan (mobile) when zoomed in
    container.addEventListener('touchstart', (e) => {
      if (inlineZoom.scale <= 1 || e.touches.length !== 1) return;
      inlineZoom.dragging = true;
      inlineZoom.sx = e.touches[0].clientX - inlineZoom.x;
      inlineZoom.sy = e.touches[0].clientY - inlineZoom.y;
    }, { passive: true });
    container.addEventListener('touchmove', (e) => {
      if (!inlineZoom.dragging || e.touches.length !== 1) return;
      inlineZoom.x = e.touches[0].clientX - inlineZoom.sx;
      inlineZoom.y = e.touches[0].clientY - inlineZoom.sy;
      clampInlineZoom();
      applyInlineZoom();
      e.preventDefault(); // stop the page scrolling while panning the zoomed image
    }, { passive: false });
    container.addEventListener('touchend', () => { inlineZoom.dragging = false; applyInlineZoom(); });

    applyInlineZoom();
  }

  function setupZoomFunctionality() {
    const zoomBtn = document.getElementById('zoomBtn');
    const downloadBtn = document.getElementById('downloadBtn');

    // Zoom & pan happens inside the preview box now (no popup).
    if (zoomBtn) {
      zoomBtn.onclick = () => {
        toggleInlineZoom();
      };
    }
    setupInlineZoom();

    // Setup download button (works on both mobile and desktop)
    if (downloadBtn) {
      downloadBtn.onclick = () => {
        downloadCanvasAsImage();
      };
    }
    
          // Center action buttons below final image container
      centerActionButtons();
    
    
  }

  function centerActionButtons() {
    const actionButtonsContainer = document.querySelector('.action-buttons-container');
    if (actionButtonsContainer) {
      // Now lives inside the preview column, directly under the canvas.
      actionButtonsContainer.style.width = '100%';
      actionButtonsContainer.style.justifyContent = 'center';
      actionButtonsContainer.style.margin = '10px 0 0';
      actionButtonsContainer.style.padding = '0';
    }
  }

  async function downloadCanvasAsImage() {
    const finalCanvas = document.getElementById('finalCanvas');
    if (!finalCanvas) {
      return;
    }

    try {
      // Create styled download image
      const styledCanvas = await createStyledDownloadImage(finalCanvas);
      
      // Create download link, named "<brand> <watch name> - <strap name>.png"
      const safe = (str) => String(str || '').replace(/[\\/:*?"<>|]+/g, ' ').replace(/\s+/g, ' ').trim();
      const brand = safe(document.getElementById('watchBrand')?.textContent);
      const model = safe(document.getElementById('watchTitle')?.textContent);
      const wName = [brand, model].filter(Boolean).join(' ') || 'Watch';
      const sName = safe(selectedStrapProduct ? (selectedStrapProduct.title || '').replace(/^\s*\[[^\]]*\]\s*/, '') : '') || 'Strap';
      const link = document.createElement('a');
      link.download = `${wName} - ${sName}.png`;
      link.href = styledCanvas.toDataURL('image/png');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      

      
      // Show brief feedback
      const downloadBtn = document.getElementById('downloadBtn');
      const originalText = downloadBtn.textContent;
      downloadBtn.textContent = '✓ Downloaded!';
      setTimeout(() => {
        downloadBtn.textContent = originalText;
      }, 2000);
      
    } catch (error) {
      alert('Error downloading image. Please try again.');
    }
  }

  async function createStyledDownloadImage(originalCanvas) {
    return new Promise((resolve) => {
      // Get strap name to calculate required width
      const strapName = getStrapName();
      
      // Create a larger canvas for the styled version
      const padding = 80; // Increased padding
      const logoHeight = 60; // Reduced since no subheading
      const textHeight = 60; // Reduced since only strap name now
      const spacing = 40;
      const imagePadding = 20; // Increased padding around strap image
      
      // Calculate minimum width needed for strap name using Montserrat font
      const tempCanvas = document.createElement('canvas');
      const tempCtx = tempCanvas.getContext('2d');
      tempCtx.font = 'bold 22px Montserrat, Arial, sans-serif'; // Test with target font size
      const strapTextWidth = tempCtx.measureText('Strap: ' + strapName).width;
      
      // Ensure canvas is wide enough for both image and text
      const minWidthForText = strapTextWidth + (padding * 2);
      const minWidthForImage = originalCanvas.width + (padding * 2) + (imagePadding * 2);
      const styledWidth = Math.max(minWidthForText, minWidthForImage, 600); // Minimum 600px width
      
      const styledHeight = originalCanvas.height + logoHeight + textHeight + (spacing * 3) + (padding * 2) + (imagePadding * 2);
      
      const styledCanvas = document.createElement('canvas');
      styledCanvas.width = styledWidth;
      styledCanvas.height = styledHeight;
      const ctx = styledCanvas.getContext('2d');
      
      // Set background to white with subtle border
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, styledWidth, styledHeight);
      
      // Add subtle border
      ctx.strokeStyle = '#e0e0e0';
      ctx.lineWidth = 2;
      ctx.strokeRect(1, 1, styledWidth - 2, styledHeight - 2);
      
      let currentY = padding;
      
      // Add company logo/branding at the top with background accent
      ctx.fillStyle = '#f8f8f8';
      ctx.fillRect(padding, currentY - 10, styledWidth - (padding * 2), logoHeight);
      
      // Create gradient for brand name (purple to blue)
      const gradient = ctx.createLinearGradient(0, currentY, 0, currentY + 50);
      gradient.addColorStop(0, '#8e44ad'); // Purple
      gradient.addColorStop(1, '#3498db'); // Blue
      
      // Add brand name with Montserrat font and heavy letter spacing
      ctx.fillStyle = gradient;
      ctx.font = '48px Montserrat, Arial, sans-serif'; // Using Montserrat
      ctx.textAlign = 'center';
      ctx.letterSpacing = '8px'; // Heavy letter spacing
      ctx.fillText('STRAPIFY', styledWidth / 2, currentY + 40);
      
      currentY += logoHeight + spacing;
      
      // Add shadow for the main combined image with increased padding
      const imageX = (styledWidth - originalCanvas.width) / 2;
      const shadowOffset = 8;
      ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
      ctx.fillRect(imageX + shadowOffset - imagePadding, currentY + shadowOffset - imagePadding, originalCanvas.width + (imagePadding * 2), originalCanvas.height + (imagePadding * 2));
      
      // Add white background for the image with increased padding
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(imageX - imagePadding, currentY - imagePadding, originalCanvas.width + (imagePadding * 2), originalCanvas.height + (imagePadding * 2));
      
      // Add border around the image with increased padding
      ctx.strokeStyle = '#e0e0e0';
      ctx.lineWidth = 2;
      ctx.strokeRect(imageX - imagePadding, currentY - imagePadding, originalCanvas.width + (imagePadding * 2), originalCanvas.height + (imagePadding * 2));
      
      // Add the main combined image
      ctx.drawImage(originalCanvas, imageX, currentY);
      
      currentY += originalCanvas.height + spacing + (imagePadding * 2);
      
      // Add bottom section background
      ctx.fillStyle = '#f8f8f8';
      ctx.fillRect(padding, currentY - 10, styledWidth - (padding * 2), textHeight);
      
      // Add strap information only (no watch name) using Montserrat
      ctx.fillStyle = '#2c2c2c';
      ctx.font = 'bold 22px Montserrat, Arial, sans-serif'; // Using Montserrat
      ctx.textAlign = 'center';
      ctx.letterSpacing = '0px'; // Reset letter spacing for text
      
      if (strapName) {
        // Display full strap name without truncation since we sized the canvas for it
        const strapText = 'Strap: ' + strapName;
        ctx.fillText(strapText, styledWidth / 2, currentY + 25);
      }
      
      // Add website using Montserrat
      ctx.fillStyle = '#b2955f';
      ctx.font = 'bold 14px Montserrat, Arial, sans-serif';
      ctx.fillText('www.strapify.com.au', styledWidth / 2, currentY + 50);
      
      resolve(styledCanvas);
    });
  }

  function getStrapName() {
    // Get strap name from current selection
    if (selectedStrapProduct && selectedStrapProduct.title) {
      return selectedStrapProduct.title.trim(); // Return full name without truncation
    }
    return 'Selected Strap';
  }
  
  // Note: Variant selection is now handled by the option-based dropdown system
  // See handleOptionChange() and createOptionBasedDropdowns() functions

  // Add AJAX add-to-cart handling and trigger cart drawer open
  document.getElementById("addToCartForm").addEventListener("submit", async function(e) {
    e.preventDefault();
    const form = e.target;
    const addToCartBtn = form.querySelector('.add-to-cart-btn');
    const originalText = addToCartBtn.textContent;
    
    // Check if button is disabled (out of stock)
    if (addToCartBtn.disabled) {
      return;
    }
    
    // Show adding state
    addToCartBtn.textContent = "Adding...";
    addToCartBtn.disabled = true;
    addToCartBtn.style.opacity = "0.7";
    
    const formData = new FormData(form);
    if (SV_EMBED) {   // 3.94.0: the product page adds it - the cart cookie is the store's, not this origin's
      svEmbedAddToCart(formData, addToCartBtn, originalText);
      return;
    }
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Accept": "application/json" },
        body: formData
      });
      if (!response.ok) throw new Error("Network response was not ok");
      const lineItem = await response.json();
      
      // Show success state briefly
      addToCartBtn.textContent = "Added!";
      addToCartBtn.classList.add('atc-added');
      
      // For Impact theme: refresh and show cart drawer if available
      const cartDrawerSlide = document.querySelector("#cart-drawer");
      if (SV_EMBED) {
        svEmbedPost({ sv: 'cart-added', line: lineItem });   // 3.94.0: the product page owns the drawer
      } else if (cartDrawerSlide) {
        cartDrawerSlide._onCartRefresh().then(() => cartDrawerSlide.show());
      } else {
        // Fallback for other themes: dispatch standard cart events
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { line: lineItem } }));
        document.dispatchEvent(new Event("cart:open"));
      }
      
              // Reset button after 2 seconds
        setTimeout(() => {
          addToCartBtn.textContent = originalText;
          addToCartBtn.disabled = false;
          addToCartBtn.style.opacity = "1";
          addToCartBtn.classList.remove('atc-added');
        }, 2000);

    } catch (error) {

              // Show error state
        addToCartBtn.textContent = "Error - Try Again";
        addToCartBtn.classList.add('atc-err');

        // Reset button after 3 seconds
        setTimeout(() => {
          addToCartBtn.textContent = originalText;
          addToCartBtn.disabled = false;
          addToCartBtn.style.opacity = "1";
          addToCartBtn.classList.remove('atc-err');
        }, 3000);
    }
  });
  /* ===== Mobile: dock the fixed preview under the auto-hiding theme header, and wire the
     progress stepper to the two-step (watch -> strap) flow. Desktop is untouched. ===== */
  (function svMobileHeaderStepper(){
    var isMobile = function(){ return window.innerWidth <= 768; };
    var headerEl = document.querySelector('.shopify-section--header');
    var root = document.documentElement;
    var hdrH = 0, lastY = -1, ticking = false;

    function measure(){
      hdrH = headerEl ? headerEl.offsetHeight : 0;                       // for the preview docking
      // Distance from the page top down to the .container (= everything reserved above it, mainly
      // the sticky header group). The content padding-top uses this to land the filters/list exactly
      // at the fixed preview's bottom edge (kills the gap under the preview).
      var cont = document.querySelector('.container');
      var off = cont ? Math.round(cont.getBoundingClientRect().top + (window.pageYOffset || 0)) : 0;
      root.style.setProperty('--sv-hdr-h', Math.max(0, off) + 'px');
    }

    // CHEAP scroll handler. The previous version called getBoundingClientRect() every animation
    // frame (a forced synchronous layout) on a 366-row page, which caused the scroll lag. This one
    // reads scrollY (no layout), picks the docked offset by direction, and lets a CSS transition
    // glide the preview to match the theme header's own hide/reveal.
    function update(){
      ticking = false;
      if (!isMobile() || !headerEl){ root.style.removeProperty('--sv-prev-top'); return; }
      var y = window.pageYOffset || root.scrollTop || 0;
      var docked;
      if (y <= 4) docked = hdrH;                  // at the very top: header fully shown
      else if (y > lastY + 2) docked = 0;         // scrolling down: theme hides the header
      else if (y < lastY - 2) docked = hdrH;      // scrolling up: header revealed
      else { lastY = y; return; }                 // negligible move - skip
      lastY = y;
      root.style.setProperty('--sv-prev-top', docked + 'px');
    }
    function onScroll(){ if (!ticking){ ticking = true; requestAnimationFrame(update); } }

    // Keep the strap list clear of the floating action bar (#strapDetails, fixed at the bottom on the
    // strap step). ResizeObserver only fires when the bar's height actually changes - cheap.
    function watchBar(){
      var bar = document.getElementById('strapDetails');
      if (!bar) return;
      var apply = function(){
        if (!isMobile()){ root.style.removeProperty('--sv-bar-h'); return; }
        root.style.setProperty('--sv-bar-h', (bar.offsetHeight + 14) + 'px');
      };
      if (window.ResizeObserver){ new ResizeObserver(apply).observe(bar); }
      apply();
      [300, 1000].forEach(function(t){ setTimeout(apply, t); });
    }

    window.addEventListener('scroll', onScroll, { passive:true });
    window.addEventListener('resize', function(){ measure(); lastY = -1; update(); }, { passive:true });
    measure(); update();
    [200, 800, 1600].forEach(function(t){ setTimeout(function(){ measure(); update(); }, t); });

    function setStrapStep(on){
      var c = document.querySelector('.container'); if (!c) return;
      if (on){
        if (typeof goToStrapStep === 'function'){ goToStrapStep(); }
        else { c.classList.add('sv-step-strap'); }
      } else {
        if (typeof goToWatchStep === 'function'){ goToWatchStep(); }
        else { c.classList.remove('sv-step-strap'); try{ window.scrollTo({top:0,behavior:'smooth'}); }catch(e){} }
      }
    }
    // Per-filter clear "×": adds a small × to each filter dropdown that clears just that filter
    // (dispatching 'change' re-runs the existing filter logic). Replaces the old Reset button.
    function setupFilterClears(){
      var ids = ['mainCategorySelect','subCategorySelect','colorFilterSelect','brandFilterSelect'];
      function updAll(){ ids.forEach(function(id){ var s=document.getElementById(id); if(s){ var b=s.closest('.filter-select-container'); if(b) b.classList.toggle('has-value', !!s.value); } }); }
      ids.forEach(function(id){
        var sel = document.getElementById(id); if (!sel) return;
        var box = sel.closest('.filter-select-container'); if (!box || box.querySelector('.filter-clear-x')) return;
        var x = document.createElement('button');
        x.type='button'; x.className='filter-clear-x'; x.setAttribute('aria-label','Clear filter'); x.textContent='×';
        box.appendChild(x);
        x.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); sel.value=''; sel.dispatchEvent(new Event('change',{bubbles:true})); setTimeout(updAll,0); });
        sel.addEventListener('change', function(){ setTimeout(updAll,0); });
      });
      updAll();
    }
    function wireStepper(){
      document.querySelectorAll('.sv-stepper .sv-step').forEach(function(btn){
        btn.addEventListener('click', function(){ setStrapStep(btn.getAttribute('data-step') === '2'); });
      });
      watchBar();
      setupFilterClears();
    }
    if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', wireStepper); }
    else { wireStepper(); }
  })();


  /************************************************************************
   * 12) CUSTOM WATCH - "photograph my own watch"
   *
   * Lets a customer shoot their own watch and drop it into the visualiser as an
   * ordinary watchList entry, so the EXISTING engine (refineWatch -> cropToContent ->
   * normalizeWatchThumbnail -> findWatchLugs/findLugInnerGap -> performCombination)
   * handles it with no compositor changes at all. The only thing the engine needs
   * that a phone photo doesn't have is a TRANSPARENT BACKGROUND, so everything
   * below exists to (a) coach the customer into a clean birds-eye shot and
   * (b) cut the watch out of that shot client-side.
   *
   * Browser notes (this runs overwhelmingly on iOS Safari / Android Chrome):
   *  - getUserMedia needs a secure context (the storefront is HTTPS) and a user
   *    gesture; the <video> needs playsinline+muted+autoplay or iOS refuses to
   *    play it inline and shows a black box.
   *  - iOS 13+ gates DeviceOrientationEvent behind requestPermission(), which must
   *    be called from the same user gesture - so the level meter is asked for on
   *    the "Open camera" tap and silently degrades to "no meter" if refused.
   *  - Inside an iframe (the theme editor preview) camera access is blocked
   *    without allow="camera"; that path falls back to the file picker.
   *  - <input type="file" accept="image/*" capture="environment"> is the universal
   *    fallback and is offered as a first-class option, not just an error path.
   *  - EXIF rotation is applied by the browser for <img>, so photos are decoded
   *    through an <img> rather than createImageBitmap (Safari only gained
   *    imageOrientation:'from-image' in 16.4).
   ************************************************************************/
  // SVC_KEY is declared at the top of this IIFE, not here - see the note there.
  const SVC_MAX_SRC  = 2400;   // cap the decoded photo (iOS canvas area limits)
  // Working size for segmentation, and therefore the resolution of the photo layer and mask
  // the cut-out is composed from. This is a real quality knob, not just a speed one: the
  // stored cut-out can never be sharper than this.
  const SVC_WORK     = 1100;
  const SVC_MAX_OUT  = 1000;   // longest side of the stored cutout
  const SVC_WIDTHS   = [14, 16, 18, 19, 20, 21, 22, 23, 24, 26];
  // Watch Stripper's segmentation service (the same rembg matte the staff tool uses).
  const SVC_REMOTE_URL = 'https://crm.strapify.com.au/api/public/watch-cutout';
  const SVC_REMOTE_TIMEOUT = 20000;

  let svcRoot    = null;   // modal element, built once on first open
  let svcStream  = null;   // live MediaStream, must be stopped or the camera LED stays on
  let svcOriHandler = null;
  let svcTilt    = null;   // degrees off level, null when unknown
  let svcSrc     = null;   // canvas: the captured photo (already guide-cropped)
  let svcCut     = null;   // canvas: what the customer sees / what gets used
  // Editing model copied from the Watch Stripper's approver editor: the PHOTO layer is kept
  // opaque and never mutated, and a separate per-pixel alpha mask is what the brush edits.
  // Restoring is then just "raise the alpha back up" and the colour is already sitting there -
  // which is the only way Restore can bring back a part the segmentation wrongly removed.
  let svcBasePhoto = null; // canvas: opaque photo, uprighted + cropped, before quarter-turns
  let svcBaseMask  = null; // Uint8Array alpha for svcBasePhoto
  let svcBaseW = 0, svcBaseH = 0;
  let svcPhoto     = null; // canvas: svcBasePhoto at the current rotation
  let svcPhotoData = null; // its pixels, cached so a brush dab doesn't re-read the canvas
  let svcMask      = null; // Uint8Array alpha at the current rotation - the brush edits THIS
  let svcW = 0, svcH = 0;
  let svcTool    = '';     // '', 'erase' or 'restore'
  let svcBrush   = 26;     // brush radius in canvas px at the working size
  let svcRot     = 0;      // manual quarter turns (auto-upright removed in 3.57.0)
  let svcFine    = 0;      // 3.57.0: single-degree straighten, -45..45, on top of the quarter turns
  let svcStrength = 0;     // background-removal strength slider, -20..+40
  let svcHistory = [];     // eraser undo stack (ImageData), capped
  let svcWarn    = '';
  let svcBadCut  = false;  // cut-out failed the quality gates: push Retake, not Continue

  function svcInjectCSS() {
    if (document.getElementById('svcStyles')) return;
    const s = document.createElement('style');
    s.id = 'svcStyles';
    s.textContent = `
/* 3.59.0: block + inline icon, not a flex row - the icon was offsetting the text block
   right of centre, so wrapped lines read as off-centre (owner report x2). */
#svcOpenBtn{display:block;width:100%;text-align:center;
  margin:0 0 10px;padding:10px 12px;border:1px dashed #b2955f;border-radius:10px;background:#fffdf8;
  color:#8a7244;font-size:13px;font-weight:700;cursor:pointer;line-height:1.35;-webkit-tap-highlight-color:transparent}
#svcOpenBtn:hover{background:#fbf6ea}
#svcOpenBtn svg{display:inline-block;vertical-align:-3px;margin-right:6px}
#svcOpenBtn span{display:inline}
/* delete button on a saved custom watch's row */
.watch-list-item .svc-del{flex:0 0 auto;margin-left:auto;align-self:center;width:30px;height:30px;
  border-radius:50%;border:1px solid #d8d2c4;background:#fff;color:#a33;font-size:15px;line-height:1;
  cursor:pointer;display:inline-flex;align-items:center;justify-content:center;
  -webkit-tap-highlight-color:transparent}
.watch-list-item .svc-del:hover{background:#fbeaea;border-color:#c66}
/* Above the support-chat launcher, which parks itself at z-index 2147483000 and otherwise
   floats over the camera view. Belt and braces: it is also hidden while the modal is open. */
#svcModal{-webkit-touch-callout:none;
  position:fixed;inset:0;z-index:2147483001;background:#111;color:#fff;display:none;
  flex-direction:column;font-family:inherit;
  padding:env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)}
#svcModal.open{display:flex}
.svc-bar{flex:0 0 auto;display:flex;align-items:center;gap:10px;padding:10px 14px;border-bottom:1px solid #2a2a2a}
.svc-bar h3{margin:0;font-size:15px;font-weight:700;flex:1 1 auto;color:#fff}
.svc-x{background:none;border:0;color:#bbb;font-size:26px;line-height:1;cursor:pointer;padding:0 4px}
.svc-body{flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:14px;
  display:flex;flex-direction:column}
/* Viewfinder step: centre it instead of stranding the preview above a tall empty gap. */
.svc-body.centre{justify-content:center}
.svc-foot{flex:0 0 auto;display:flex;gap:10px;padding:12px 14px;border-top:1px solid #2a2a2a;background:#111}
.svc-btn{flex:1 1 0;padding:13px 10px;border-radius:10px;border:0;font-size:14px;font-weight:700;
  cursor:pointer;min-height:46px;-webkit-tap-highlight-color:transparent;text-align:center}
.svc-btn.primary{background:#b2955f;color:#fff}
.svc-btn.ghost{background:#262626;color:#eee}
.svc-btn:disabled{opacity:.45;cursor:default}
.svc-step{display:none}
.svc-step.on{display:block}
.svc-lead{margin:0 0 12px;font-size:13.5px;line-height:1.5;color:#d8d8d8}
.svc-steps{margin:0 0 14px;padding:0;list-style:none;counter-reset:svc}
.svc-steps li{counter-increment:svc;position:relative;padding:0 0 12px 34px;font-size:13.5px;line-height:1.5;color:#e6e6e6}
.svc-steps li::before{content:counter(svc);position:absolute;left:0;top:0;width:23px;height:23px;border-radius:50%;
  background:#b2955f;color:#fff;font-size:12px;font-weight:700;display:flex;align-items:center;justify-content:center}
.svc-steps b{color:#fff}
.svc-diag{display:block;width:100%;max-width:340px;margin:0 auto 14px;border-radius:12px;background:#1b1b1b}
.svc-note{font-size:12px;line-height:1.5;color:#9a9a9a;margin:12px 0 0}
.svc-stage{position:relative;width:100%;max-width:520px;margin:0 auto;aspect-ratio:1/1;background:#000;
  border-radius:12px;overflow:hidden;min-height:280px}
.svc-stage video{width:100%;height:100%;object-fit:cover;display:block;background:#000}
.svc-guide{position:absolute;inset:0;pointer-events:none}
/* The capture region. Everything OUTSIDE it is dimmed by one huge spread box-shadow, clipped
   by the stage's overflow:hidden - the inside stays completely untouched so the customer can
   actually see what they are shooting. (An SVG rect with mix-blend-mode:destination-out was
   tried first and simply painted solid black in Safari, blacking out the whole viewfinder.) */
/* 3.57.0: the crop region keeps the dimming box-shadow but the visible square outline is
   gone (owner call) - the watch silhouette below is the only guide the customer sees. */
.svc-crop{position:absolute;left:16%;top:16%;width:68%;height:68%;border-radius:14px;
  border:0;box-shadow:0 0 0 9999px rgba(0,0,0,.45)}
/* 3.57.0: the guide is a standard-watch SILHOUETTE (dashed round case + four lugs + crown),
   drawn with currentColor so the whole thing flips green when the shot is level and framed. */
.svc-watchsvg{position:absolute;inset:0;width:100%;height:100%;display:block;
  color:rgba(178,149,95,.95);transition:color .25s ease}
.svc-guide.good .svc-watchsvg{color:#3ecb5f}
.svc-guide.good ~ .svc-level, .svc-guide.good .svc-tag{text-shadow:0 1px 3px rgba(0,0,0,.9)}
.svc-tag{position:absolute;left:0;right:0;text-align:center;font-size:11.5px;font-weight:700;
  color:#e2c98d;text-shadow:0 1px 3px rgba(0,0,0,.9);letter-spacing:.2px}
.svc-tag.t{top:3%}
.svc-tag.b{bottom:14%}
.svc-level{position:absolute;left:0;right:0;bottom:0;padding:8px 10px;font-size:12px;font-weight:700;
  text-align:center;background:rgba(0,0,0,.55);color:#8fe08f}
.svc-level.warn{color:#ffcf6b}
.svc-level.bad{color:#ff8f8f}
/* iOS pops a Save Image / Copy callout on a long press over a canvas, which fires mid-stroke
   whenever someone brushes slowly. Suppressed here and via a contextmenu handler. */
.svc-shot{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none;
  display:block;width:100%;height:auto;background:
  conic-gradient(#e9e9e9 0 25%,#fafafa 0 50%,#e9e9e9 0 75%,#fafafa 0) 0 0/18px 18px;
  border-radius:12px;touch-action:none;max-height:52vh;object-fit:contain;margin:0 auto}
.svc-shotwrap{position:relative}
/* 3.59.0: the reference silhouette sits BESIDE the lugs note (the 3.57.0 overlay drew it
   on top of the customer's watch - owner didn't want that). */
.svc-lugnote{display:flex;align-items:center;gap:10px}
.svc-lugnote .svc-mini{flex:0 0 auto;width:34px;height:34px;color:#bbb}
.svc-busy{position:absolute;inset:0;display:none;align-items:center;justify-content:center;gap:10px;
  background:rgba(17,17,17,.82);border-radius:12px;font-size:13px;font-weight:700;color:#e2c98d}
.svc-spin{width:16px;height:16px;border:2px solid rgba(226,201,141,.3);border-top-color:#e2c98d;
  border-radius:50%;animation:svcspin .8s linear infinite}
@keyframes svcspin{to{transform:rotate(360deg)}}
.svc-tools{display:flex;flex-wrap:wrap;gap:8px;margin:12px 0 0;align-items:center}
.svc-tool{padding:8px 11px;border-radius:8px;border:1px solid #3a3a3a;background:#1e1e1e;color:#eee;
  font-size:12.5px;font-weight:600;cursor:pointer;min-height:38px;text-align:center}
.svc-tool.on{background:#b2955f;border-color:#b2955f;color:#fff}
.svc-brush{display:flex;align-items:center;gap:8px;font-size:12.5px;color:#bbb;flex:1 1 130px}
.svc-brush input{flex:1 1 auto;min-width:80px}
.svc-slider{display:flex;align-items:center;gap:10px;margin:12px 0 0;font-size:12.5px;color:#bbb}
.svc-slider input{flex:1 1 auto;min-width:120px}
.svc-alert{margin:12px 0 0;padding:10px 12px;border-radius:8px;font-size:12.5px;line-height:1.5;
  background:#3a2a15;color:#ffcf6b;border:1px solid #5a4020}
.svc-alert.bad{background:#3d1c1c;color:#ff9f9f;border-color:#6a2c2c}
.svc-widths{display:flex;flex-wrap:wrap;gap:8px;margin:10px 0 0}
.svc-w{min-width:56px;padding:11px 8px;border-radius:9px;border:1px solid #3a3a3a;background:#1e1e1e;
  color:#eee;font-size:13.5px;font-weight:700;cursor:pointer;text-align:center}
.svc-w.on{background:#b2955f;border-color:#b2955f;color:#fff}
.svc-w.wide{flex:1 1 100%}
.svc-label{display:block;font-size:13px;font-weight:700;color:#fff;margin:16px 0 0}
.svc-name{width:100%;margin:8px 0 0;padding:11px;border-radius:9px;border:1px solid #3a3a3a;
  background:#1e1e1e;color:#fff;font-size:14px}
.svc-file{display:none}
/* Support-chat launcher/panel would otherwise float over the viewfinder and the footer
   buttons. Hidden for as long as the capture flow is open, restored on close. */
body.svc-open .scw-launcher,body.svc-open .scw-frame,body.svc-open [class^="scw-"]{
  display:none !important;visibility:hidden !important}
@media (min-width:769px){ .svc-body{padding:20px 24px} .svc-foot,.svc-bar{padding-left:24px;padding-right:24px} }`;
    document.head.appendChild(s);
  }

  /* The birds-eye guide overlay. Plain DOM rather than SVG: the dimming is one spread
     box-shadow around the capture region (see .svc-crop), which leaves the middle genuinely
     transparent in every browser. The labels sit in the dimmed margin, not over the watch. */
  /* Standard-watch silhouette: dashed round case, four flaring lugs, crown on the right.
     Shared by the camera guide (gold->green) and the review step's ghost overlay. */
  function svcWatchSVG(cls) {
    return `<svg class="${cls}" viewBox="0 0 100 100" aria-hidden="true">
      <circle cx="50" cy="50" r="21.8" fill="none" stroke="currentColor" stroke-width="2" stroke-dasharray="6 4"/>
      <path d="M41.5 30.5 41.5 24.5 M58.5 30.5 58.5 24.5 M41.5 69.5 41.5 75.5 M58.5 69.5 58.5 75.5"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      <rect x="72.6" y="46.5" width="4.2" height="7" rx="1.6" fill="none" stroke="currentColor" stroke-width="1.6"/>
    </svg>`;
  }

  function svcGuideHTML() {
    return `<div class="svc-guide" id="svcGuide">
      <div class="svc-tag t">12 o'clock up, crown to the right</div>
      <div class="svc-crop"></div>
      ${svcWatchSVG('svc-watchsvg')}
      <div class="svc-tag b">case in the circle &middot; lugs top and bottom</div>
    </div>`;
  }

  /* Small illustration of the right vs wrong camera angle - clearer than words alone. */
  function svcDiagramSVG() {
    return `<svg class="svc-diag" viewBox="0 0 320 120" role="img" aria-label="Hold the phone flat and directly above the watch">
      <rect width="320" height="120" rx="12" fill="#1b1b1b"/>
      <g transform="translate(18,0)">
        <rect x="46" y="16" width="34" height="52" rx="5" fill="#2f2f2f" stroke="#8fe08f" stroke-width="1.5"/>
        <path d="M63 70v18" stroke="#8fe08f" stroke-width="1.5" stroke-dasharray="3 3"/>
        <path d="M63 92l-4-6h8z" fill="#8fe08f"/>
        <ellipse cx="63" cy="101" rx="20" ry="6" fill="#333"/>
        <rect x="53" y="94" width="20" height="14" rx="4" fill="#555" stroke="#8fe08f" stroke-width="1.2"/>
        <text x="63" y="12" fill="#8fe08f" font-size="9" text-anchor="middle" font-weight="700">Do this</text>
      </g>
      <line x1="160" y1="14" x2="160" y2="106" stroke="#3a3a3a" stroke-width="1"/>
      <g transform="translate(180,0)">
        <g transform="rotate(-26 63 42)">
          <rect x="46" y="16" width="34" height="52" rx="5" fill="#2f2f2f" stroke="#ff8f8f" stroke-width="1.5"/>
        </g>
        <path d="M70 72l-6 16" stroke="#ff8f8f" stroke-width="1.5" stroke-dasharray="3 3"/>
        <path d="M62 92l1-7 6 4z" fill="#ff8f8f"/>
        <ellipse cx="63" cy="101" rx="20" ry="6" fill="#333"/>
        <rect x="53" y="94" width="20" height="14" rx="4" fill="#555" stroke="#ff8f8f" stroke-width="1.2"/>
        <text x="63" y="12" fill="#ff8f8f" font-size="9" text-anchor="middle" font-weight="700">Not this</text>
      </g>
    </svg>`;
  }

  function svcBuildUI() {
    if (svcRoot) return svcRoot;
    svcInjectCSS();
    const m = document.createElement('div');
    m.id = 'svcModal';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.innerHTML = `
      <div class="svc-bar"><h3 id="svcTitle">Photograph your watch</h3>
        <button type="button" class="svc-x" id="svcClose" aria-label="Close">&times;</button></div>
      <div class="svc-body">

        <section class="svc-step on" data-step="guide">
          <p class="svc-lead">A straight-down (birds-eye) photo is what makes the preview line up
            properly. It takes about 30 seconds.</p>
          ${svcDiagramSVG()}
          <ol class="svc-steps">
            <li><b>Take the strap off</b> if you can, so only the watch case and its lugs are in
              the shot. If it won't come off, tuck the strap underneath and out of view.</li>
            <li><b>Lay it face-up on a plain surface that contrasts with the watch.</b> This is
              the part that matters most. A dark watch goes on white paper; a silver, steel or
              white watch goes on something dark and matte. Avoid patterned or cluttered
              surfaces.</li>
            <li><b>Point 12 o'clock straight up</b>, with the crown on the right. The lugs (where
              the strap attaches) should sit at the top and bottom.</li>
            <li><b>Hold the phone flat and directly above the watch</b> - not leaning in from the
              side. The on-screen level turns green when you're square on.</li>
            <li><b>Centre the case in the guide circle</b> and keep both lug ends inside the box.
              Step back slightly rather than zooming in. A square watch is centred the same way.</li>
            <li><b>Even, indirect light.</b> Turn off the flash, and move so your own shadow and
              any hard glare are off the watch.</li>
          </ol>
          <p class="svc-note">Your photo is sent to us only to cut the watch out of its
            background, and is not kept afterwards. The finished cut-out is stored in this
            browser alone, so it stays on your device.</p>
        </section>

        <section class="svc-step" data-step="camera">
          <div class="svc-stage">
            <video id="svcVideo" playsinline muted autoplay></video>
            ${svcGuideHTML()}
            <div class="svc-level" id="svcLevel">Hold the phone flat above the watch</div>
          </div>
          <p class="svc-note" id="svcCamNote">Line your watch up with the outline - case in the
            circle, lugs pointing up and down. It turns <b>green</b> when you're framed and level.</p>
        </section>

        <section class="svc-step" data-step="review">
          <p class="svc-lead">Here's your watch with the background removed. Check the outline
            looks clean, then continue.</p>
          <div class="svc-shotwrap">
            <canvas class="svc-shot" id="svcCanvas"></canvas>
            <div class="svc-busy" id="svcBusy"><span class="svc-spin"></span>Removing the background…</div>
          </div>
          <div class="svc-tools">
            <button type="button" class="svc-tool" id="svcRotL">&#8634; Rotate left</button>
            <button type="button" class="svc-tool" id="svcRotR">&#8635; Rotate right</button>
            <button type="button" class="svc-tool" id="svcUndo">Undo</button>
          </div>
          <div class="svc-slider">
            <span>Straighten</span>
            <input type="range" id="svcFineRot" min="-45" max="45" step="1" value="0"
              aria-label="Straighten - rotate by single degrees">
            <span id="svcFineRotVal">0&deg;</span>
          </div>
          <div class="svc-tools">
            <button type="button" class="svc-tool" id="svcErase">&#9998; Erase</button>
            <button type="button" class="svc-tool" id="svcRestore">&#8624; Restore</button>
            <label class="svc-brush">Brush
              <input type="range" id="svcBrushSize" min="10" max="70" step="2" value="26"
                     aria-label="Brush size">
            </label>
          </div>
          <p class="svc-note" id="svcToolHint">Tap <b>Erase</b> to rub out anything left over, or
            <b>Restore</b> to paint back a part of the watch that was removed.</p>
          <div class="svc-slider">
            <span>Background removal</span>
            <input type="range" id="svcStrength" min="-20" max="40" step="2" value="0"
                   aria-label="Background removal strength">
            <span id="svcStrengthVal">normal</span>
          </div>
          <div class="svc-alert" id="svcAlert" style="display:none"></div>
          <p class="svc-note svc-lugnote">${svcWatchSVG('svc-mini')}<span>Lugs should point up and
            down, like the little watch on the left. If too much of the watch was removed,
            drag the slider left; if bits of background are left over, drag it right or use
            <b>Erase leftovers</b>.</span></p>
        </section>

        <section class="svc-step" data-step="fit">
          <p class="svc-lead">Last thing: what size straps does your watch take?</p>
          <div class="svc-widths" id="svcWidths"></div>
          <p class="svc-note">The strap width is the gap between the lugs, measured in millimetres.
            It's often printed on the back of the watch or on the buckle. If you're between sizes,
            round to the nearest even number.</p>
          <label class="svc-label" for="svcName">Name it (optional)</label>
          <input type="text" class="svc-name" id="svcName" maxlength="40"
                 placeholder="e.g. Seiko SKX007" autocomplete="off">
        </section>
      </div>
      <div class="svc-foot" id="svcFoot"></div>
      <!-- No capture attribute: capture="environment" makes iOS and Android jump STRAIGHT into
           the camera, so "Choose a photo" could never reach the photo library. Without it the
           OS shows its normal sheet, which still offers Take Photo alongside the library. -->
      <input type="file" class="svc-file" id="svcFile" accept="image/*">`;
    document.body.appendChild(m);
    svcRoot = m;

    m.querySelector('#svcClose').addEventListener('click', svcCloseModal);
    m.querySelector('#svcFile').addEventListener('change', (e) => {
      const f = e.target.files && e.target.files[0];
      e.target.value = '';                       // so re-picking the same file still fires
      if (f) svcLoadFile(f);
    });
    m.querySelector('#svcRotL').addEventListener('click', () => svcRotate(-1));
    m.querySelector('#svcRotR').addEventListener('click', () => svcRotate(1));
    // 3.57.0: single-degree straighten slider. Lightly debounced - each change rebuilds
    // the working photo+mask at the new angle, which is a few hundred ms of canvas work.
    const fine = m.querySelector('#svcFineRot');
    let fineT = null;
    fine.addEventListener('input', () => {
      m.querySelector('#svcFineRotVal').textContent = fine.value + '°';
      clearTimeout(fineT);
      fineT = setTimeout(() => {
        svcFine = parseInt(fine.value, 10) || 0;
        svcApplyRot();
      }, 90);
    });
    m.querySelector('#svcErase').addEventListener('click', () => svcSetTool('erase'));
    m.querySelector('#svcRestore').addEventListener('click', () => svcSetTool('restore'));
    m.querySelector('#svcBrushSize').addEventListener('input', (e) => {
      svcBrush = parseInt(e.target.value, 10) || 26;
    });
    m.querySelector('#svcUndo').addEventListener('click', svcUndo);
    const str = m.querySelector('#svcStrength');
    str.addEventListener('change', () => {           // 'change' not 'input': resegmenting is ~100ms
      svcStrength = parseInt(str.value, 10) || 0;
      m.querySelector('#svcStrengthVal').textContent =
        svcStrength === 0 ? 'normal' : (svcStrength > 0 ? 'more' : 'less');
      svcSegmentAndShow();
    });
    svcWireEraser(m.querySelector('#svcCanvas'));
    svcBuildWidths();
    return m;
  }

  function svcBuildWidths() {
    const box = svcRoot.querySelector('#svcWidths');
    box.innerHTML = '';
    const mk = (label, val, wide) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'svc-w' + (wide ? ' wide' : '');
      b.textContent = label;
      b.dataset.w = val;
      b.addEventListener('click', () => {
        box.querySelectorAll('.svc-w').forEach(x => x.classList.remove('on'));
        b.classList.add('on');
      });
      box.appendChild(b);
    };
    SVC_WIDTHS.forEach(w => mk(w + 'mm', String(w)));
    mk("I'm not sure - show me all standard straps", '', true);
    box.querySelector('.svc-w.wide').classList.add('on');   // "not sure" is the safe default
  }

  /* ---- step routing --------------------------------------------------- */
  function svcGo(step) {
    const m = svcRoot;
    m.querySelectorAll('.svc-step').forEach(s => s.classList.toggle('on', s.dataset.step === step));
    const bodyEl = m.querySelector('.svc-body');
    bodyEl.classList.toggle('centre', step === 'camera');
    bodyEl.scrollTop = 0;
    const foot = m.querySelector('#svcFoot');
    const title = m.querySelector('#svcTitle');
    foot.innerHTML = '';
    const btn = (label, cls, fn, id) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'svc-btn ' + cls; b.textContent = label;
      if (id) b.id = id;
      b.addEventListener('click', fn);
      foot.appendChild(b);
      return b;
    };
    if (step !== 'camera') svcStopCamera();

    if (step === 'guide') {
      title.textContent = 'Photograph your watch';
      btn('Choose a photo', 'ghost', () => svcRoot.querySelector('#svcFile').click());
      btn('Open camera', 'primary', svcStartCamera);
    } else if (step === 'camera') {
      title.textContent = 'Line it up';
      btn('Back', 'ghost', () => svcGo('guide'));
      btn('Take photo', 'primary', svcCapture);
    } else if (step === 'review') {
      title.textContent = 'Check the cut-out';
      btn('Retake', 'ghost', () => svcGo('guide'), 'svcRetake');
      btn('Looks good', 'primary', () => svcGo('fit'), 'svcAccept');
      svcSyncReviewButtons();
    } else if (step === 'fit') {
      title.textContent = 'Strap size';
      btn('Back', 'ghost', () => svcGo('review'));
      btn('Use this watch', 'primary', svcFinish);
    }
  }

  function svcOpenModal() {
    svcBuildUI();
    svcRoot.classList.add('open');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('svc-open');   // also suppresses the support-chat launcher
    svEmbedFullscreen(true);   // 3.94.0
    svcGo('guide');
  }

  function svcCloseModal() {
    svcStopCamera();
    if (svcRoot) svcRoot.classList.remove('open');
    document.body.style.overflow = '';
    document.body.classList.remove('svc-open');
    svEmbedFullscreen(false);   // 3.94.0
  }

  /* ---- camera --------------------------------------------------------- */
  async function svcStartCamera() {
    // Ask for the tilt sensor on this same gesture - iOS only grants it from a user action.
    svcRequestOrientation();

    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      svcCamFallback('This browser cannot open the camera directly.');
      return;
    }
    try {
      svcStream = await navigator.mediaDevices.getUserMedia({
        audio: false,
        video: { facingMode: { ideal: 'environment' }, width: { ideal: 2560 }, height: { ideal: 2560 } }
      });
    } catch (err) {
      // Denied, no camera, or blocked by an iframe permissions policy (theme editor preview).
      svcCamFallback(err && err.name === 'NotAllowedError'
        ? 'Camera access was blocked for this site.'
        : "We couldn't open the camera on this device.");
      return;
    }
    svcGo('camera');
    const v = svcRoot.querySelector('#svcVideo');
    v.srcObject = svcStream;
    v.setAttribute('playsinline', '');            // iOS: without this it opens fullscreen or stalls
    v.muted = true;
    try { await v.play(); } catch (e) { /* some browsers resolve late; the stream still shows */ }
    // (3.57.0: was `if (note)` on an undeclared identifier - it threw after play() and the
    // hint never updated. Also reworded: the guide square is gone, the silhouette is the guide.)
    const camNote = svcRoot.querySelector('#svcCamNote');
    if (camNote) camNote.innerHTML = 'Line your watch up with the outline - it goes green when '
      + 'you are framed and level - then tap <b>Take photo</b>.';
    svcStartFrameCheck();
  }

  /* 3.57.0: live "framed well" check - every 400ms compare the luminance of the centre
     disc (where the case should be) against the frame's outer border. A real watch on a
     contrasting surface separates cleanly; combined with the tilt sensor it drives the
     silhouette's gold->green flip. Cheap: one 48px draw + read per tick. */
  let svcFrameTimer = null;
  let svcFrameCanvas = null;
  function svcStartFrameCheck() {
    clearInterval(svcFrameTimer);
    svcFrameTimer = setInterval(() => {
      const v = svcRoot && svcRoot.querySelector('#svcVideo');
      const g = svcRoot && svcRoot.querySelector('#svcGuide');
      if (!v || !g || !v.videoWidth) return;
      let framed = false;
      try {
        const s = 48;
        if (!svcFrameCanvas) { svcFrameCanvas = document.createElement('canvas'); svcFrameCanvas.width = s; svcFrameCanvas.height = s; }
        const ctx = svcFrameCanvas.getContext('2d', { willReadFrequently: true });
        const side = Math.min(v.videoWidth, v.videoHeight);
        ctx.drawImage(v, (v.videoWidth - side) / 2, (v.videoHeight - side) / 2, side, side, 0, 0, s, s);
        const d = ctx.getImageData(0, 0, s, s).data;
        let cSum = 0, cN = 0, bSum = 0, bN = 0;
        const mid = s / 2, rCase = s * 0.20, border = s * 0.12;
        for (let y = 0; y < s; y++) for (let x = 0; x < s; x++) {
          const j = (y * s + x) * 4;
          const lum = 0.299 * d[j] + 0.587 * d[j + 1] + 0.114 * d[j + 2];
          const dist = Math.hypot(x - mid + 0.5, y - mid + 0.5);
          if (dist <= rCase) { cSum += lum; cN++; }
          else if (x < border || y < border || x >= s - border || y >= s - border) { bSum += lum; bN++; }
        }
        framed = cN > 0 && bN > 0 && Math.abs(cSum / cN - bSum / bN) > 16;
      } catch (e) { /* canvas read blocked: leave gold */ }
      const level = svcTilt == null || svcTilt <= 8;   // no sensor (desktop): tilt can't veto
      g.classList.toggle('good', framed && level);
    }, 400);
  }

  /* No camera (denied, absent, or an iframe without allow="camera"): say so on the guide
     step and point at the file picker, rather than firing a blocking alert() and then
     opening a picker the customer didn't ask for. */
  function svcCamFallback(reason) {
    svcGo('guide');
    const step = svcRoot.querySelector('.svc-step[data-step="guide"]');
    let box = step.querySelector('.svc-alert');
    if (!box) {
      box = document.createElement('div');
      box.className = 'svc-alert';
      step.insertBefore(box, step.firstChild);
    }
    box.style.display = 'block';
    box.textContent = reason + ' Take a photo with your normal camera app, then tap '
                    + '"Choose a photo" below.';
  }

  function svcStopCamera() {
    clearInterval(svcFrameTimer);
    svcFrameTimer = null;
    if (svcStream) {
      try { svcStream.getTracks().forEach(t => t.stop()); } catch (e) {}
      svcStream = null;
    }
    const v = svcRoot && svcRoot.querySelector('#svcVideo');
    if (v) { try { v.srcObject = null; } catch (e) {} }
    if (svcOriHandler) {
      window.removeEventListener('deviceorientation', svcOriHandler);
      svcOriHandler = null;
    }
  }

  function svcRequestOrientation() {
    const start = () => {
      if (svcOriHandler) return;
      svcOriHandler = (e) => {
        if (e.beta == null || e.gamma == null) return;
        // Phone lying flat, screen up / camera down => beta and gamma both ~0.
        svcTilt = Math.min(90, Math.hypot(e.beta, e.gamma));
        const el = svcRoot && svcRoot.querySelector('#svcLevel');
        if (!el) return;
        const t = Math.round(svcTilt);
        el.classList.toggle('warn', t > 7 && t <= 16);
        el.classList.toggle('bad', t > 16);
        el.textContent = t <= 7 ? '✓ Level - you are square on'
          : (t <= 16 ? 'Almost level (' + t + '° off) - flatten a little'
                     : 'Tilted ' + t + '° - hold the phone flat above the watch');
      };
      window.addEventListener('deviceorientation', svcOriHandler);
    };
    try {
      const DOE = window.DeviceOrientationEvent;
      if (DOE && typeof DOE.requestPermission === 'function') {
        DOE.requestPermission().then(r => { if (r === 'granted') start(); }).catch(() => {});
      } else if (DOE) {
        start();
      }
    } catch (e) { /* no sensor: the guide square alone still does most of the work */ }
  }

  /* Grab the guide square out of the live frame. Cropping to the guide (rather than
     keeping the whole frame) removes surrounding clutter, which is the single biggest
     help to the background cut. */
  function svcCapture() {
    const v = svcRoot.querySelector('#svcVideo');
    const vw = v.videoWidth, vh = v.videoHeight;
    if (!vw || !vh) { alert('The camera is still starting up - try again in a moment.'); return; }

    const r = v.getBoundingClientRect();
    // The preview is object-fit:cover, so work out which part of the frame is actually visible.
    const scale = Math.max(r.width / vw, r.height / vh);
    const visW = r.width / scale, visH = r.height / scale;
    const offX = (vw - visW) / 2, offY = (vh - visH) / 2;
    // Deliberately WIDER than the .svc-crop guide box (which is 16%..84%). The guide is a
    // framing aid; capturing exactly it clipped the lugs of anyone who framed tight, which is
    // precisely what "fill the box" encourages. The extra margin costs nothing - the cut-out is
    // trimmed to its own content afterwards - and it puts the background colour samples further
    // from the watch, which makes them cleaner too.
    const CAP = 0.92, CAP_OFF = (1 - CAP) / 2;
    const sx = offX + visW * CAP_OFF, sy = offY + visH * CAP_OFF;
    const sw = visW * CAP, sh = visH * CAP;

    const c = document.createElement('canvas');
    const side = Math.min(SVC_MAX_SRC, Math.round(Math.max(sw, sh)));
    c.width = side; c.height = side;
    c.getContext('2d').drawImage(v, sx, sy, sw, sh, 0, 0, side, side);
    svcSrc = c;
    svcStopCamera();
    svcAfterCapture();
  }

  function svcLoadFile(file) {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      // naturalWidth/Height are already EXIF-oriented in current Safari and Chrome.
      const long = Math.max(img.naturalWidth, img.naturalHeight) || 1;
      const k = Math.min(1, SVC_MAX_SRC / long);
      const c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(img.naturalWidth * k));
      c.height = Math.max(1, Math.round(img.naturalHeight * k));
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      svcSrc = c;
      svcAfterCapture();
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      alert("We couldn't read that image. Try a JPEG or PNG photo.");
    };
    img.src = url;
  }

  function svcAfterCapture() {
    svcRot = 0;
    svcFine = 0;
    const fr = svcRoot.querySelector('#svcFineRot');
    if (fr) { fr.value = '0'; svcRoot.querySelector('#svcFineRotVal').textContent = '0°'; }
    svcStrength = 0;
    const str = svcRoot.querySelector('#svcStrength');
    if (str) { str.value = '0'; svcRoot.querySelector('#svcStrengthVal').textContent = 'normal'; }
    svcTool = '';
    svcRoot.querySelector('#svcErase').classList.remove('on');
    svcRoot.querySelector('#svcRestore').classList.remove('on');
    svcGo('review');
    svcSegmentAndShow(true);
  }

  /* ---- background removal --------------------------------------------
     The customer has been asked for a plain light surface, so the cut is a
     border flood-fill rather than anything neural: every pixel reachable from
     the edge of the frame through background-like colour IS background, which
     means anything enclosed by the watch (dial reflections, bezel markings)
     stays solid automatically. Two refinements matter in practice:
       - the flood also accepts a pixel that merely matches its NEIGHBOUR closely,
         so a gradually-lit or vignetted sheet doesn't stop the fill halfway;
       - soft shadows are grey, dim and SMOOTH, while a real watch (even a plain
         steel one) is full of edges - so the shadow-tolerant rule is gated on a
         low local gradient. That's what stops a silver case being eaten as if it
         were paper.
  ------------------------------------------------------------------------ */
  /* Tiny k-means over RGB samples. Returns k centroids as a flat [r,g,b, r,g,b, ...]. */
  function svcKMeans(samples, k, iters) {
    const m = samples.length / 3;
    if (!m) return [];
    k = Math.min(k, m);
    const c = new Float32Array(k * 3);
    for (let i = 0; i < k; i++) {                   // deterministic spread-out seeding
      const s = Math.floor(i * m / k) * 3;
      c[i * 3] = samples[s]; c[i * 3 + 1] = samples[s + 1]; c[i * 3 + 2] = samples[s + 2];
    }
    const sum = new Float32Array(k * 3), cnt = new Float32Array(k);
    for (let it = 0; it < iters; it++) {
      sum.fill(0); cnt.fill(0);
      for (let p = 0; p < m; p++) {
        const r = samples[p * 3], g = samples[p * 3 + 1], b = samples[p * 3 + 2];
        let bi = 0, bd = Infinity;
        for (let i = 0; i < k; i++) {
          const dr = r - c[i * 3], dg = g - c[i * 3 + 1], db = b - c[i * 3 + 2];
          const d = dr * dr + dg * dg + db * db;
          if (d < bd) { bd = d; bi = i; }
        }
        sum[bi * 3] += r; sum[bi * 3 + 1] += g; sum[bi * 3 + 2] += b; cnt[bi]++;
      }
      for (let i = 0; i < k; i++) {
        if (!cnt[i]) continue;
        c[i * 3] = sum[i * 3] / cnt[i];
        c[i * 3 + 1] = sum[i * 3 + 1] / cnt[i];
        c[i * 3 + 2] = sum[i * 3 + 2] / cnt[i];
      }
    }
    return c;
  }

  /* ---- background removal ---------------------------------------------
     This does NOT assume the surface is plain. An earlier version flood-filled
     inward from the frame edge, which works on white paper and falls apart on a
     wood-grain desk: the tolerance saturates, the fill eats the whole frame, and
     the "largest blob" that survives is some random specular streak.

     Instead it uses what the guide overlay already told the customer to do - 
     centre the case in the circle. That hands us both seeds:
       - FOREGROUND samples from a disc at the centre (inside the guide circle),
       - BACKGROUND samples from the border ring of the captured square.
     A small k-means over each gives two colour models, and every pixel goes to
     whichever model it sits closer to. A textured surface is fine: its many
     shades simply become several background centroids.

     Cast shadows are handled by adding darkened copies of each background
     centroid - a shadow is the surface colour scaled down, so it lands on the
     background model instead of being kept as part of the watch.

     The kept region is then the component CONTAINING THE CENTRE, not the largest
     one, so a bright streak across a corner can never win.
  ------------------------------------------------------------------------ */
  function svcSegment(src, strength) {
    const long = Math.max(src.width, src.height) || 1;
    const k = Math.min(1, SVC_WORK / long);
    const w = Math.max(1, Math.round(src.width * k));
    const h = Math.max(1, Math.round(src.height * k));
    const work = document.createElement('canvas');
    work.width = w; work.height = h;
    const wctx = work.getContext('2d', { willReadFrequently: true });
    wctx.drawImage(src, 0, 0, w, h);
    const id = wctx.getImageData(0, 0, w, h);
    const d = id.data;
    const n = w * h;
    const cxp = (w - 1) / 2, cyp = (h - 1) / 2;
    const minSide = Math.min(w, h);

    // --- seeds -----------------------------------------------------------
    // Foreground: a disc well inside the guide circle (which is 74% of the frame),
    // so it stays on the watch even if the customer framed it a little loose.
    // Background: the outer ring, which the guide keeps clear of the watch.
    const rFg = minSide * 0.20, rFg2 = rFg * rFg;
    // Background is sampled from the CORNERS AND SIDE BANDS ONLY, never the vertical strip
    // above and below the case. A plain ring gets this badly wrong the moment the customer
    // does as instructed and fills the box: the lug tips reach further from centre than the
    // corners of the guide circle do, land in the ring, and get learned as "background" -
    // so the lugs are cut off and only the case survives.
    const bgFrom2 = (minSide * 0.42) * (minSide * 0.42);
    const lugCorridor = minSide * 0.22;
    // Fine-detail energy, the Watch Stripper's texture cue. A watch is covered in edges
    // (printing, indices, bezel knurling, bracelet links); a surface - even wood - is
    // comparatively smooth, and a cast shadow is smoother still. Measured against the
    // background's OWN texture rather than an absolute threshold, so wood grain doesn't
    // read as "detailed" just because it isn't paper.
    const L = new Float32Array(n);
    for (let i = 0; i < n; i++) {
      L[i] = 0.299 * d[i * 4] + 0.587 * d[i * 4 + 1] + 0.114 * d[i * 4 + 2];
    }
    const G = new Float32Array(n);
    for (let y = 1; y < h - 1; y++) {
      for (let x = 1; x < w - 1; x++) {
        const i = y * w + x;
        G[i] = Math.abs(L[i - 1] - L[i + 1]) + Math.abs(L[i - w] - L[i + w]);
      }
    }

    const fgS = [], bgS = [], bgG = [];
    const stride = Math.max(1, Math.round(minSide / 220));   // cap the sample count
    for (let y = 0; y < h; y += stride) {
      for (let x = 0; x < w; x += stride) {
        const p = y * w + x, i = p * 4;
        const dx = x - cxp, dy = y - cyp, dd = dx * dx + dy * dy;
        if (dd <= rFg2) { fgS.push(d[i], d[i + 1], d[i + 2]); }
        else if (dd >= bgFrom2 && Math.abs(dx) >= lugCorridor) {
          bgS.push(d[i], d[i + 1], d[i + 2]); bgG.push(G[p]);
        }
      }
    }
    bgG.sort((a, b) => a - b);
    const gQuiet = (bgG[bgG.length >> 1] || 0) * 3 + 12;   // "busier than the surface itself"
    if (!fgS.length || !bgS.length) {
      return { canvas: work, mask: new Uint8Array(n), w, h, fgFrac: 0, solidity: 0, ok: false };
    }

    // Same k for both models on purpose. An earlier version bolted two darkened copies
    // onto every background centroid to cope with shadows, which left 21 background
    // candidates against 5 foreground ones - under nearest-neighbour that alone biases
    // almost every pixel toward "background". Shadows are handled below instead, by
    // projection, which costs no extra centroids.
    const fgC = svcKMeans(Float32Array.from(fgS), 6, 8);
    const bgC = svcKMeans(Float32Array.from(bgS), 6, 8);
    const nFg = fgC.length / 3, nBg = bgC.length / 3;
    // Precompute each background centroid's squared length for the shadow projection.
    const bgLen2 = new Float32Array(nBg);
    for (let i = 0; i < nBg; i++) {
      bgLen2[i] = bgC[i * 3] * bgC[i * 3] + bgC[i * 3 + 1] * bgC[i * 3 + 1]
                + bgC[i * 3 + 2] * bgC[i * 3 + 2];
    }

    // --- classify --------------------------------------------------------
    // strength slider biases the decision: higher = more aggressive removal.
    const bias = Math.pow(1.7, strength / 30);
    // The shadow model is a whole ray rather than a point, so it explains far more colours
    // than a plain centroid does. Penalising it keeps it as a last resort: it wins only when
    // it fits genuinely well, which is what stops a silver case (a good match for "dimmed
    // white paper") from being written off as shadow.
    const SHADOW_PENALTY = 1.6;
    // Distances go through a 32x32x32 colour lookup table rather than being recomputed for
    // every pixel. Scoring all 12 centroids (plus a shadow projection each) per pixel was ~18
    // distance calculations across half a million pixels and dominated the whole run; the
    // table costs 32768 evaluations once. Quantisation error is a couple of levels per
    // channel, well inside what the despeckle and feather passes absorb.
    // 64 levels per channel, filled LAZILY from the real pixel colour that first lands in each
    // bin. A photo only touches a small fraction of the bins, so this ends up cheaper than a
    // full table AND more accurate than one keyed on bin centres - a coarser 32-level table
    // built up front shifted the decision boundary enough to shrink the cut-out noticeably.
    const LUT_N = 1 << 18;
    const LUT_F = new Float32Array(LUT_N), LUT_B = new Float32Array(LUT_N);
    const LUT_OK = new Uint8Array(LUT_N);
    const lutFill = (q, r, g, b) => {
      let dF = Infinity;
      for (let i = 0; i < nFg; i++) {
        const dr = r - fgC[i * 3], dg = g - fgC[i * 3 + 1], db = b - fgC[i * 3 + 2];
        const v = dr * dr + dg * dg + db * db;
        if (v < dF) dF = v;
      }
      let dB = Infinity;
      for (let i = 0; i < nBg; i++) {
        const cr = bgC[i * 3], cg = bgC[i * 3 + 1], cb = bgC[i * 3 + 2];
        let dr = r - cr, dg = g - cg, db = b - cb;
        let v = dr * dr + dg * dg + db * db;
        if (v < dB) dB = v;
        // Shadowed surface lies along the ray from black through the surface colour, so
        // project onto that ray and measure the miss. Continuous, unlike fixed darkened copies.
        if (bgLen2[i] > 1) {
          let f = (r * cr + g * cg + b * cb) / bgLen2[i];
          if (f > 1.04) f = 1.04; else if (f < 0.42) f = 0.42;
          dr = r - cr * f; dg = g - cg * f; db = b - cb * f;
          v = (dr * dr + dg * dg + db * db) * SHADOW_PENALTY;
          if (v < dB) dB = v;
        }
      }
      LUT_F[q] = dF; LUT_B[q] = dB; LUT_OK[q] = 1;
    };
    const lutIdx = (i) => {
      const r = d[i * 4], g = d[i * 4 + 1], b = d[i * 4 + 2];
      const q = ((r >> 2) << 12) | ((g >> 2) << 6) | (b >> 2);
      if (!LUT_OK[q]) lutFill(q, r, g, b);
      return q;
    };

    const raw = new Uint8Array(n);
    for (let p = 0; p < n; p++) {
      const q = lutIdx(p);
      // Detail that the surface itself doesn't have is evidence of the watch, so make the
      // background model work harder to claim it. This is what keeps engraved bezels and
      // bracelet links while still dropping a smooth patch of shadow.
      const dB = G[p] > gQuiet ? LUT_B[q] * 2.0 : LUT_B[q];
      raw[p] = (LUT_F[q] * bias < dB) ? 1 : 0;
    }

    // --- despeckle: two 3x3 majority passes ------------------------------
    let cur = raw, nxt = new Uint8Array(n);
    for (let pass = 0; pass < 2; pass++) {
      for (let y = 0; y < h; y++) {
        for (let x = 0; x < w; x++) {
          let s = 0, c2 = 0;
          for (let dy = -1; dy <= 1; dy++) {
            const yy = y + dy; if (yy < 0 || yy >= h) continue;
            for (let dx = -1; dx <= 1; dx++) {
              const xx = x + dx; if (xx < 0 || xx >= w) continue;
              s += cur[yy * w + xx]; c2++;
            }
          }
          nxt[y * w + x] = (s * 2 > c2) ? 1 : 0;
        }
      }
      const t = cur; cur = nxt; nxt = t;
    }
    const cls = cur;

    // --- keep the component containing the centre ------------------------
    const stack = new Int32Array(n);
    let seed = -1;
    if (cls[Math.round(cyp) * w + Math.round(cxp)]) {
      seed = Math.round(cyp) * w + Math.round(cxp);
    } else {                                   // watch slightly off-centre: nearest fg pixel
      let bd = Infinity;
      for (let y = 0; y < h; y += 2) for (let x = 0; x < w; x += 2) {
        if (!cls[y * w + x]) continue;
        const dx = x - cxp, dy = y - cyp, dd = dx * dx + dy * dy;
        if (dd < bd) { bd = dd; seed = y * w + x; }
      }
    }
    const mask = new Uint8Array(n);
    let bestSize = 0, minX = w, maxX = 0, minY = h, maxY = 0;
    if (seed >= 0) {
      let sp = 0; stack[sp++] = seed; mask[seed] = 1;
      while (sp > 0) {
        const i = stack[--sp]; bestSize++;
        const ix = i % w, iy = (i / w) | 0;
        if (ix < minX) minX = ix; if (ix > maxX) maxX = ix;
        if (iy < minY) minY = iy; if (iy > maxY) maxY = iy;
        for (let e = 0; e < 4; e++) {
          const nx = ix + (e === 0 ? -1 : e === 1 ? 1 : 0);
          const ny = iy + (e === 2 ? -1 : e === 3 ? 1 : 0);
          if (nx < 0 || ny < 0 || nx >= w || ny >= h) continue;
          const j = ny * w + nx;
          if (mask[j] || !cls[j]) continue;
          mask[j] = 1; stack[sp++] = j;
        }
      }
    }

    // --- fill holes: anything not reachable from the frame edge through
    // non-mask pixels is enclosed by the watch (dial, bezel print) and is kept.
    const outside = new Uint8Array(n);
    {
      let sp = 0;
      const push = (i) => { if (!outside[i] && !mask[i]) { outside[i] = 1; stack[sp++] = i; } };
      for (let x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
      for (let y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
      while (sp > 0) {
        const i = stack[--sp];
        const ix = i % w, iy = (i / w) | 0;
        for (let e = 0; e < 4; e++) {
          const nx = ix + (e === 0 ? -1 : e === 1 ? 1 : 0);
          const ny = iy + (e === 2 ? -1 : e === 3 ? 1 : 0);
          if (nx < 0 || ny < 0 || nx >= w || ny >= h) continue;
          push(ny * w + nx);
        }
      }
      for (let i = 0; i < n; i++) {
        if (!mask[i] && !outside[i]) {
          mask[i] = 1; bestSize++;
          const ix = i % w, iy = (i / w) | 0;
          if (ix < minX) minX = ix; if (ix > maxX) maxX = ix;
          if (iy < minY) minY = iy; if (iy > maxY) maxY = iy;
        }
      }
    }

    // --- rim peel (ported from the Watch Stripper) -----------------------
    // Segmentation leaves a band of penumbra and surface around the object: the shadow
    // gradient hugging the case, a fringe of desk still attached at the edge. Propagate
    // inward from the mask boundary, but ONLY through pixels that still look like the
    // surface and are smooth - so the front stops dead at any real edge and cannot chew
    // into a polished case or a bracelet. Distance-capped, and reverted outright if it
    // ever eats a big share of the object.
    {
      const maxPeel = Math.max(3, Math.round(minSide * 0.009));
      const dist = new Int16Array(n).fill(-1);
      // Peel a pixel only where the background explains it about as well as the watch does -
      // i.e. it is genuinely ambiguous halo. An absolute "does this look like the surface"
      // test is not safe here: a smooth polished silver case against white paper passes it
      // easily, and the peel then eats the lugs. Comparing the two models instead means a
      // pixel that is a strong match for the watch's own colours can never be peeled.
      // Memoised: every candidate is tested once as a seed and again as a neighbour, and the
      // test itself walks all 12 centroids. -1 unknown, 0 no, 1 yes.
      const peelMemo = new Int8Array(n).fill(-1);
      const surfaceLike = (i) => {
        if (peelMemo[i] !== -1) return peelMemo[i] === 1;
        const verdict = surfaceLikeCalc(i);
        peelMemo[i] = verdict ? 1 : 0;
        return verdict;
      };
      const surfaceLikeCalc = (i) => {
        if (G[i] > gQuiet) return false;         // a real edge: the front stops here
        const q = lutIdx(i);
        return LUT_B[q] < LUT_F[q] * 1.6;
      };
      const peel = new Uint8Array(n);
      const queue = stack;                 // BFS over the scratch buffer; each pixel enters once
      let sp = 0, head = 0, peeled = 0;
      // Seed with the outermost ring of the mask - the pixels most likely to be halo. A ring
      // pixel that is NOT surface-like is the object's own edge, so the front never starts there.
      for (let y = 0; y < h; y++) {
        for (let x = 0; x < w; x++) {
          const i = y * w + x;
          if (!mask[i]) continue;
          const onEdge = x === 0 || y === 0 || x === w - 1 || y === h - 1 ||
                         !mask[i - 1] || !mask[i + 1] || !mask[i - w] || !mask[i + w];
          if (!onEdge || !surfaceLike(i)) continue;
          dist[i] = 0; peel[i] = 1; peeled++; queue[sp++] = i;
        }
      }
      while (head < sp) {
        const i = queue[head++];
        const dcur = dist[i];
        if (dcur >= maxPeel) continue;
        const ix = i % w, iy = (i / w) | 0;
        for (let e = 0; e < 4; e++) {
          const nx = ix + (e === 0 ? -1 : e === 1 ? 1 : 0);
          const ny = iy + (e === 2 ? -1 : e === 3 ? 1 : 0);
          if (nx < 0 || ny < 0 || nx >= w || ny >= h) continue;
          const j = ny * w + nx;
          if (!mask[j] || dist[j] !== -1 || !surfaceLike(j)) continue;
          dist[j] = dcur + 1; peel[j] = 1; peeled++;
          if (sp < n) queue[sp++] = j;
        }
      }
      if (peeled > 0 && peeled < bestSize * 0.45) {
        for (let i = 0; i < n; i++) if (peel[i]) { mask[i] = 0; bestSize--; }
      }
    }

    // --- alpha: 1px erode, then a 3x3 blur for a soft edge ---------------
    const er = new Uint8Array(n);
    for (let y = 1; y < h - 1; y++) {
      for (let x = 1; x < w - 1; x++) {
        const i = y * w + x;
        er[i] = (mask[i] && mask[i - 1] && mask[i + 1] && mask[i - w] && mask[i + w]) ? 1 : 0;
      }
    }
    const out = wctx.createImageData(w, h);
    const o = out.data;
    const alphaOut = new Uint8Array(n);
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        const i = y * w + x;
        let s = 0, c2 = 0;
        for (let dy = -1; dy <= 1; dy++) {
          const yy = y + dy; if (yy < 0 || yy >= h) continue;
          for (let dx = -1; dx <= 1; dx++) {
            const xx = x + dx; if (xx < 0 || xx >= w) continue;
            s += er[yy * w + xx]; c2++;
          }
        }
        let a = c2 ? s / c2 : 0;
        // Defringe: a soft-edge pixel that still matches the surface is halo, not watch.
        if (a > 0 && a < 1 && LUT_B[lutIdx(i)] < 900) a *= 0.3;
        o[i * 4] = d[i * 4]; o[i * 4 + 1] = d[i * 4 + 1]; o[i * 4 + 2] = d[i * 4 + 2];
        o[i * 4 + 3] = alphaOut[i] = Math.round(Math.max(0, Math.min(1, a)) * 255);
      }
    }
    const cut = document.createElement('canvas');
    cut.width = w; cut.height = h;
    cut.getContext('2d').putImageData(out, 0, 0);

    // --- quality signals --------------------------------------------------
    // Solidity (kept pixels vs their own bounding box) is the one that catches the
    // classic garbage result: a diagonal glare streak fills barely a tenth of its
    // box, while any real watch fills well over half of its own.
    const bw = Math.max(1, maxX - minX + 1), bh = Math.max(1, maxY - minY + 1);
    const solidity = bestSize / (bw * bh);
    let edgeHits = 0, edgeTotal = 0;
    for (let x = 0; x < w; x++) { edgeTotal += 2; edgeHits += mask[x] + mask[(h - 1) * w + x]; }
    for (let y = 0; y < h; y++) { edgeTotal += 2; edgeHits += mask[y * w] + mask[y * w + w - 1]; }

    return {
      canvas: cut, mask, w, h,
      photo: work,        // the opaque photo at working size - the restore brush's colour source
      alpha: alphaOut,    // per-pixel alpha, so the brush can edit a mask rather than pixels
      fgFrac: bestSize / n,
      solidity,
      edgeFrac: edgeTotal ? edgeHits / edgeTotal : 0,
      ok: bestSize > 0
    };
  }

  function svcUprightAngle(mask, w, h) {
    let n = 0, sx = 0, sy = 0;
    for (let y = 0; y < h; y += 2) for (let x = 0; x < w; x += 2) {
      if (mask[y * w + x]) { n++; sx += x; sy += y; }
    }
    if (n < 50) return 0;
    const mx = sx / n, my = sy / n;
    let xx = 0, yy = 0, xy = 0;
    for (let y = 0; y < h; y += 2) for (let x = 0; x < w; x += 2) {
      if (!mask[y * w + x]) continue;
      const dx = x - mx, dy = y - my;
      xx += dx * dx; yy += dy * dy; xy += dx * dy;
    }
    const theta = 0.5 * Math.atan2(2 * xy, xx - yy);      // major-axis angle, radians
    let deg = theta * 180 / Math.PI;                       // 0 = horizontal, 90 = vertical
    let corr = 90 - deg;
    while (corr > 90) corr -= 180;
    while (corr < -90) corr += 180;
    // A near-circular case (dial-only, no obvious long axis) has no meaningful axis;
    // treat corrections beyond 30 degrees as untrustworthy and leave the photo as shot.
    return Math.abs(corr) <= 30 ? corr : 0;
  }

  function svcRotateCanvas(c, deg) {
    // Always hand back an independent canvas. Returning the input unchanged at 0 degrees
    // aliased the working canvas onto the base copy the rotate buttons rebuild from.
    if (!deg) return svcSnapshot(c);
    const rad = deg * Math.PI / 180;
    const s = Math.abs(Math.sin(rad)), co = Math.abs(Math.cos(rad));
    const nw = Math.ceil(c.width * co + c.height * s);
    const nh = Math.ceil(c.width * s + c.height * co);
    const out = document.createElement('canvas');
    out.width = nw; out.height = nh;
    const ctx = out.getContext('2d');
    // save/restore is essential, not tidiness: getContext returns the SAME context object
    // every time, so a transform left behind here silently displaces every later draw on
    // this canvas - which is exactly what made brush strokes vanish after a rotation.
    ctx.save();
    ctx.translate(nw / 2, nh / 2);
    ctx.rotate(rad);
    ctx.drawImage(c, -c.width / 2, -c.height / 2);
    ctx.restore();
    return out;
  }

  /* Segmenting is a second or two of synchronous work on a phone. Show a busy state and
     hand the browser a frame to paint it in before starting, or the customer taps the
     shutter and stares at an apparently frozen screen. */
  function svcSegmentAndShow(autoUpright) {
    if (!svcSrc) return;
    svcBusy(true);
    setTimeout(async () => {
      try { await svcSegmentNow(autoUpright); }
      catch (e) { /* svcSegmentNow already falls back internally */ }
      finally { svcBusy(false); }
    }, 40);
  }

  function svcBusy(on) {
    const el = svcRoot && svcRoot.querySelector('#svcBusy');
    if (el) el.style.display = on ? 'flex' : 'none';
  }

  function svcContentBox(c) {
    const w = c.width, h = c.height;
    const dd = c.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, w, h).data;
    let minX = w, maxX = -1, minY = h, maxY = -1;
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        if (dd[(y * w + x) * 4 + 3] > 0) {
          if (x < minX) minX = x; if (x > maxX) maxX = x;
          if (y < minY) minY = y; if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX < 0) return { x: 0, y: 0, w: w, h: h };
    return { x: minX, y: minY, w: maxX - minX + 1, h: maxY - minY + 1 };
  }

  function svcCropCanvas(c, box) {
    const o = document.createElement('canvas');
    o.width = box.w; o.height = box.h;
    o.getContext('2d').drawImage(c, box.x, box.y, box.w, box.h, 0, 0, box.w, box.h);
    return o;
  }

  /* Quarter-turn a flat mask array, matching svcRotateCanvas's clockwise direction. */
  function svcRotArr(a, w, h, q) {
    q = ((q % 4) + 4) % 4;
    if (!q) return a.slice();
    const out = new Uint8Array(a.length);
    if (q === 1) {
      for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) out[x * h + (h - 1 - y)] = a[y * w + x];
    } else if (q === 2) {
      for (let i = 0, n = w * h; i < n; i++) out[n - 1 - i] = a[i];
    } else {
      for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) out[(w - 1 - x) * h + y] = a[y * w + x];
    }
    return out;
  }

  /* 3.57.0: render the mask as the alpha of a white canvas so it can ride through the
     same arbitrary-angle rotation as the photo and stay pixel-aligned with it. */
  function svcMaskToCanvas(mask, w, h) {
    const c = document.createElement('canvas');
    c.width = w; c.height = h;
    const ctx = c.getContext('2d');
    const img = ctx.createImageData(w, h);
    const d = img.data;
    for (let i = 0; i < w * h; i++) {
      const j = i * 4;
      d[j] = d[j + 1] = d[j + 2] = 255; d[j + 3] = mask[i];
    }
    ctx.putImageData(img, 0, 0);
    return c;
  }

  /* Derive the working photo + mask for the current rotation from the base pair. */
  function svcApplyRot() {
    if (!svcBasePhoto) return;
    const q = ((svcRot % 4) + 4) % 4;
    if (svcFine) {
      // Arbitrary angle: rotate photo AND a mask canvas by the same total, then read the
      // alpha back. svcRotArr only quarter-turns, so it can't be used on this path.
      const deg = q * 90 + svcFine;
      svcPhoto = svcRotateCanvas(svcBasePhoto, deg);
      const mc = svcRotateCanvas(svcMaskToCanvas(svcBaseMask, svcBaseW, svcBaseH), deg);
      svcW = svcPhoto.width; svcH = svcPhoto.height;
      const md = mc.getContext('2d', { willReadFrequently: true })
                   .getImageData(0, 0, svcW, svcH).data;
      svcMask = new Uint8Array(svcW * svcH);
      for (let i = 0; i < svcMask.length; i++) svcMask[i] = md[i * 4 + 3];
    } else {
      svcPhoto = q ? svcRotateCanvas(svcBasePhoto, q * 90) : svcSnapshot(svcBasePhoto);
      svcMask = svcRotArr(svcBaseMask, svcBaseW, svcBaseH, q);
      svcW = q % 2 ? svcBaseH : svcBaseW;
      svcH = q % 2 ? svcBaseW : svcBaseH;
    }
    svcPhotoData = svcPhoto.getContext('2d', { willReadFrequently: true })
                     .getImageData(0, 0, svcW, svcH).data;
    svcHistory = [];
    svcCompose();
  }

  /* Photo colour + mask alpha -> the cut-out canvas everything downstream uses. */
  function svcCompose() {
    if (!svcPhotoData || !svcMask) return;
    const w = svcW, h = svcH, n = w * h;
    if (!svcCut || svcCut.width !== w || svcCut.height !== h) {
      svcCut = document.createElement('canvas');
      svcCut.width = w; svcCut.height = h;
    }
    const ctx = svcCut.getContext('2d');
    const img = ctx.createImageData(w, h);
    const o = img.data, p = svcPhotoData;
    for (let i = 0; i < n; i++) {
      const j = i * 4;
      o[j] = p[j]; o[j + 1] = p[j + 1]; o[j + 2] = p[j + 2]; o[j + 3] = svcMask[i];
    }
    ctx.putImageData(img, 0, 0);
    svcPaint();
  }

  /* Ask the Watch Stripper's segmentation service for a matte. It runs the same rembg model
     the staff tool uses, which is a different class of algorithm to anything that will run in
     a phone browser, so it is tried first and everything else is the fallback. Returns a
     Uint8Array alpha at the given size, or null - never throws, because "no server" has to be
     an ordinary outcome here (offline, rate limited, busy, blocked). */
  async function svcRemoteMatte(srcCanvas, w, h) {
    const blob = await new Promise(res => {
      try { srcCanvas.toBlob(b => res(b), 'image/jpeg', 0.9); } catch (e) { res(null); }
    });
    if (!blob) return null;
    const fd = new FormData();
    fd.append('file', blob, 'watch.jpg');
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), SVC_REMOTE_TIMEOUT);
    let resp;
    try {
      resp = await fetch(SVC_REMOTE_URL, { method: 'POST', body: fd, signal: ctrl.signal,
                                           mode: 'cors', cache: 'no-store' });
    } catch (e) { clearTimeout(timer); return null; }
    clearTimeout(timer);
    if (!resp || !resp.ok) return null;
    let bmpUrl = null;
    try {
      const png = await resp.blob();
      bmpUrl = URL.createObjectURL(png);
      const img = await new Promise((res, rej) => {
        const i = new Image();
        i.onload = () => res(i); i.onerror = rej; i.src = bmpUrl;
      });
      // The matte comes back at the server's own scale; resample it to our working size.
      const c = document.createElement('canvas');
      c.width = w; c.height = h;
      const cx = c.getContext('2d', { willReadFrequently: true });
      cx.imageSmoothingQuality = 'high';
      cx.drawImage(img, 0, 0, w, h);
      const d = cx.getImageData(0, 0, w, h).data;
      const a = new Uint8Array(w * h);
      for (let i = 0; i < a.length; i++) a[i] = d[i * 4];   // greyscale: any channel is the value
      return a;
    } catch (e) {
      return null;
    } finally {
      if (bmpUrl) URL.revokeObjectURL(bmpUrl);
    }
  }

  /* Wrap a server matte in the same shape svcSegment returns, so everything downstream -
     upright, crop, quality gates, the mask editor - is identical whichever produced it. */
  function svcResultFromAlpha(photoCanvas, alphaArr, w, h, strength) {
    const n = w * h;
    // The strength slider still has to mean something on a server matte: bias the cut-off.
    const thr = Math.max(8, Math.min(240, 128 + strength * 3));
    const mask = new Uint8Array(n);
    let count = 0, minX = w, maxX = -1, minY = h, maxY = -1;
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        const i = y * w + x;
        if (alphaArr[i] >= thr) {
          mask[i] = 1; count++;
          if (x < minX) minX = x; if (x > maxX) maxX = x;
          if (y < minY) minY = y; if (y > maxY) maxY = y;
        }
      }
    }
    const pctx = photoCanvas.getContext('2d', { willReadFrequently: true });
    const pd = pctx.getImageData(0, 0, w, h).data;
    const cut = document.createElement('canvas');
    cut.width = w; cut.height = h;
    const cctx = cut.getContext('2d');
    const img = cctx.createImageData(w, h);
    const o = img.data;
    const alphaOut = new Uint8Array(n);
    for (let i = 0; i < n; i++) {
      const j = i * 4;
      // Keep the matte's own soft edge rather than a hard 0/255 - it is anti-aliased already.
      const a = mask[i] ? alphaArr[i] : 0;
      o[j] = pd[j]; o[j + 1] = pd[j + 1]; o[j + 2] = pd[j + 2]; o[j + 3] = a;
      alphaOut[i] = a;
    }
    cctx.putImageData(img, 0, 0);
    const bw = Math.max(1, maxX - minX + 1), bh = Math.max(1, maxY - minY + 1);
    let edgeHits = 0, edgeTotal = 0;
    for (let x = 0; x < w; x++) { edgeTotal += 2; edgeHits += mask[x] + mask[(h - 1) * w + x]; }
    for (let y = 0; y < h; y++) { edgeTotal += 2; edgeHits += mask[y * w] + mask[y * w + w - 1]; }
    return {
      canvas: cut, mask, w, h, photo: photoCanvas, alpha: alphaOut,
      fgFrac: count / n, solidity: count / (bw * bh),
      edgeFrac: edgeTotal ? edgeHits / edgeTotal : 0,
      ok: count > 0, remote: true
    };
  }

  /* The photo at the working size - shared by the local and server paths. */
  function svcWorkCanvas(src) {
    const long = Math.max(src.width, src.height) || 1;
    const k = Math.min(1, SVC_WORK / long);
    const w = Math.max(1, Math.round(src.width * k));
    const h = Math.max(1, Math.round(src.height * k));
    const c = document.createElement('canvas');
    c.width = w; c.height = h;
    c.getContext('2d').drawImage(src, 0, 0, w, h);
    return { canvas: c, w: w, h: h };
  }

  async function svcSegmentNow(autoUpright) {
    let res = null;
    // Server matte first; local colour segmentation is the fallback, not the plan.
    try {
      const wk = svcWorkCanvas(svcSrc);
      const a = await svcRemoteMatte(svcSrc, wk.w, wk.h);
      if (a) res = svcResultFromAlpha(wk.canvas, a, wk.w, wk.h, svcStrength);
    } catch (e) { res = null; }
    try {
      if (!res) res = svcSegment(svcSrc, svcStrength);
    } catch (e) {
      svcWarn = "We couldn't process that photo on this device. Try a smaller photo.";
      svcCut = svcSrc;
      svcPaint();
      return;
    }
    // 3.57.0: NO auto-upright. svcUprightAngle guessed the case's long axis and on round
    // cases (no meaningful axis) it could tilt a perfectly straight shot up to 30 degrees
    // (owner report). The photo is kept exactly as shot; the customer straightens with the
    // quarter-turn buttons and the single-degree Straighten slider.
    const cutC = res.canvas, photoC = res.photo;
    const box = svcContentBox(cutC);
    svcBasePhoto = svcCropCanvas(photoC, box);
    svcBaseW = box.w; svcBaseH = box.h;
    {
      const cd = svcCropCanvas(cutC, box)
                   .getContext('2d', { willReadFrequently: true })
                   .getImageData(0, 0, box.w, box.h).data;
      svcBaseMask = new Uint8Array(box.w * box.h);
      for (let i = 0; i < svcBaseMask.length; i++) svcBaseMask[i] = cd[i * 4 + 3];
    }

    // Quality gates. Solidity is the important one: it is what catches a cut-out that is
    // a glare streak or a sliver of surface rather than a watch, which the old fraction-only
    // check waved straight through.
    svcWarn = '';
    svcBadCut = false;
    if (!res.ok || res.fgFrac < 0.02) {
      svcBadCut = true;
      svcWarn = "We couldn't find your watch in that photo. Make sure the case sits in the middle "
              + "of the circle and fills most of it, on a surface that contrasts with the watch.";
    } else if (res.solidity < 0.35) {
      svcBadCut = true;
      svcWarn = "That doesn't look like a watch - we've probably picked up a reflection or a bit "
              + "of the surface. Retake it with the case centred in the circle, avoiding glare "
              + "and harsh shadows.";
    } else if (res.fgFrac > 0.88 || res.edgeFrac > 0.45) {
      svcBadCut = true;
      svcWarn = "The watch and the surface look too similar, so part of the surface has been kept. "
              + "Try a surface with more contrast (dark for a silver or white watch, white paper "
              + "for a dark one), or drag the slider right.";
    }
    svcApplyRot();
  }

  function svcPaint() {
    const cv = svcRoot.querySelector('#svcCanvas');
    const src = svcCut || svcSrc;
    if (!src) return;
    cv.width = src.width; cv.height = src.height;
    const ctx = cv.getContext('2d');
    ctx.clearRect(0, 0, cv.width, cv.height);
    ctx.drawImage(src, 0, 0);
    const al = svcRoot.querySelector('#svcAlert');
    al.style.display = svcWarn ? 'block' : 'none';
    al.classList.toggle('bad', svcBadCut);
    al.textContent = svcWarn;
    svcRoot.querySelector('#svcUndo').disabled = svcHistory.length === 0;
    svcSyncReviewButtons();
  }

  /* A failed cut-out should lead with Retake, not with a confident "Looks good" - 
     accepting one produces a watch that composites as nonsense. */
  function svcSyncReviewButtons() {
    const retake = svcRoot.querySelector('#svcRetake');
    const accept = svcRoot.querySelector('#svcAccept');
    if (!retake || !accept) return;
    retake.className = 'svc-btn ' + (svcBadCut ? 'primary' : 'ghost');
    accept.className = 'svc-btn ' + (svcBadCut ? 'ghost' : 'primary');
    accept.textContent = svcBadCut ? 'Use it anyway' : 'Looks good';
  }

  function svcRotate(dir) {
    if (!svcBasePhoto) return;
    svcRot = (svcRot + dir + 4) % 4;
    svcApplyRot();
  }

  function svcUndo() {
    if (!svcHistory.length) return;
    svcMask = svcHistory.pop();
    svcCompose();
  }

  /* Two-way circular brush working on the ALPHA MASK, not on canvas pixels.
     Two things this fixes over compositing straight onto the canvas:
       - Restore can bring back parts the segmentation removed, because the photo layer
         underneath still holds their colour. Restoring from a copy of the cut-out could only
         ever undo the customer's own erasing, which is not what "restore" means to anyone.
       - No brush-shaped rings. Clipping a circle and clearing/redrawing it leaves an
         antialiased boundary that compounds with every overlapping dab; writing the mask
         with min/max is idempotent, so a stroke can pass over itself any number of times.
     Pointer Events cover Safari 13+ and every Android browser we see; touch-action:none on
     the canvas stops the page scrolling under the finger. */
  function svcWireEraser(cv) {
    let drawing = false, last = null;
    const at = (ev) => {
      const r = cv.getBoundingClientRect();
      return { x: (ev.clientX - r.left) * (cv.width / r.width),
               y: (ev.clientY - r.top) * (cv.height / r.height) };
    };
    const dab = (p) => {
      if (!svcMask) return;
      const rad = svcBrush * (Math.max(svcW, svcH) / 600);
      const restore = svcTool === 'restore';
      const feather = Math.max(1, rad * 0.18);
      const x0 = Math.max(0, Math.floor(p.x - rad)), x1 = Math.min(svcW - 1, Math.ceil(p.x + rad));
      const y0 = Math.max(0, Math.floor(p.y - rad)), y1 = Math.min(svcH - 1, Math.ceil(p.y + rad));
      for (let y = y0; y <= y1; y++) {
        for (let x = x0; x <= x1; x++) {
          const dx = x - p.x, dy = y - p.y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist > rad) continue;
          const t = dist > rad - feather ? (rad - dist) / feather : 1;   // 1 inside, 0 at the rim
          const i = y * svcW + x;
          const v = Math.round(255 * t);
          if (restore) { if (v > svcMask[i]) svcMask[i] = v; }
          else { const keep = 255 - v; if (keep < svcMask[i]) svcMask[i] = keep; }
        }
      }
    };
    // Fill the gap between pointer samples, or a quick swipe leaves a dotted trail.
    const stroke = (p) => {
      if (last) {
        const dx = p.x - last.x, dy = p.y - last.y;
        const steps = Math.ceil(Math.hypot(dx, dy) / Math.max(2, svcBrush * 0.4));
        for (let i = 1; i < steps; i++) dab({ x: last.x + dx * i / steps, y: last.y + dy * i / steps });
      }
      dab(p);
      last = p;
      svcCompose();
    };
    cv.addEventListener('pointerdown', (ev) => {
      if (!svcTool || !svcMask) return;
      ev.preventDefault();
      svcHistory.push(svcMask.slice());
      if (svcHistory.length > 12) svcHistory.shift();
      drawing = true; last = null;
      try { cv.setPointerCapture(ev.pointerId); } catch (e) {}
      stroke(at(ev));
    });
    cv.addEventListener('pointermove', (ev) => { if (drawing) { ev.preventDefault(); stroke(at(ev)); } });
    const end = () => { drawing = false; last = null; };
    cv.addEventListener('pointerup', end);
    cv.addEventListener('pointercancel', end);
    cv.addEventListener('pointerleave', end);
    // iOS pops a Save Image / Copy sheet on a long press over a canvas, which fires in the
    // middle of a slow brush stroke. Suppressed here as well as in CSS.
    cv.addEventListener('contextmenu', (ev) => ev.preventDefault());
  }

  function svcSnapshot(c) {
    const o = document.createElement('canvas');
    o.width = c.width; o.height = c.height;
    o.getContext('2d').drawImage(c, 0, 0);
    return o;
  }

  function svcSetTool(tool) {
    svcTool = (svcTool === tool) ? '' : tool;     // tapping the active tool turns it off
    svcRoot.querySelector('#svcErase').classList.toggle('on', svcTool === 'erase');
    svcRoot.querySelector('#svcRestore').classList.toggle('on', svcTool === 'restore');
    const hint = svcRoot.querySelector('#svcToolHint');
    hint.innerHTML = svcTool === 'erase'
      ? 'Drag on the picture to rub out anything that is not your watch.'
      : (svcTool === 'restore'
         ? 'Drag on the picture to paint your watch back where too much was removed.'
         : 'Tap <b>Erase</b> to rub out anything left over, or <b>Restore</b> to paint back a '
           + 'part of the watch that was removed.');
  }

  /* ---- commit --------------------------------------------------------- */
  function svcFinish() {
    const src = svcCut || svcSrc;
    if (!src) { svcCloseModal(); return; }
    const cropped = cropToContent(src);
    const long = Math.max(cropped.width, cropped.height) || 1;
    const k = Math.min(1, SVC_MAX_OUT / long);
    const out = document.createElement('canvas');
    out.width = Math.max(1, Math.round(cropped.width * k));
    out.height = Math.max(1, Math.round(cropped.height * k));
    const octx = out.getContext('2d');
    octx.imageSmoothingQuality = 'high';
    octx.drawImage(cropped, 0, 0, out.width, out.height);

    let dataUrl;
    try { dataUrl = out.toDataURL('image/png'); }
    catch (e) { alert("We couldn't save that image on this device."); return; }

    const selW = svcRoot.querySelector('#svcWidths .svc-w.on');
    const width = selW ? (selW.dataset.w || '') : '';
    const name = (svcRoot.querySelector('#svcName').value || '').trim();

    const entry = {
      brand: 'My watch',
      model: name || 'My watch',
      'lug width': width ? width + 'mm' : '',
      'watch type': 'Quick Release',   // standard spring-bar fitting: excludes Apple/QuickFit ranges
      'scaling factor': 0.8,
      link: dataUrl,
      collection_link: '',             // no collection => the strap grid stays unrestricted
      _custom: true
    };
    // The visit always gets the full-size cut-out; only what we REMEMBER may need to shrink.
    // A 1000px transparent PNG is a couple of MB once base64'd, which can exceed the quota,
    // so step down rather than silently forgetting the watch. Private mode still throws at
    // every size, and that is fine: it works for this visit and just isn't here next time.
    (function persist() {
      const sizes = [out.width >= out.height ? out.width : out.height, 700, 460];
      for (const target of sizes) {
        let url = dataUrl;
        if (target < Math.max(out.width, out.height)) {
          const s = Math.min(1, target / Math.max(out.width, out.height));
          const small = document.createElement('canvas');
          small.width = Math.max(1, Math.round(out.width * s));
          small.height = Math.max(1, Math.round(out.height * s));
          const sctx = small.getContext('2d');
          sctx.imageSmoothingQuality = 'high';
          sctx.drawImage(out, 0, 0, small.width, small.height);
          try { url = small.toDataURL('image/png'); } catch (e) { return; }
        }
        try {
          localStorage.setItem(SVC_KEY, JSON.stringify({
            model: entry.model, width: width, link: url
          }));
          return;
        } catch (e) { /* too big (or no storage at all) - try smaller */ }
      }
    })();
    svcCloseModal();
    svcAddWatch(entry, true);
  }

  /* Put the custom watch at the top of the list and select it. Re-uses the ordinary
     render path so it behaves exactly like a catalogue watch from here on. */
  function svcAddWatch(entry, select) {
    const i = watchList.findIndex(w => w._custom);
    if (i >= 0) watchList.splice(i, 1);
    watchList.unshift(entry);

    // Clear filters that would hide it (it isn't in any catalogue brand or search term).
    const brand = document.getElementById('brandFilterSelect');
    if (brand) {
      if (!Array.prototype.some.call(brand.options, o => o.value === 'My watch')) {
        const opt = document.createElement('option');
        opt.value = 'My watch'; opt.textContent = 'My watch';
        brand.insertBefore(opt, brand.options[1] || null);
      }
      if (select && brand.value) { brand.value = ''; filterState.watches.brand = ''; }
    }
    const search = document.getElementById('watchSearchInput');
    if (select && search && search.value) { search.value = ''; filterState.watches.search = ''; }

    renderWatches();
    refineWatchesBatched();
    if (typeof performOptimizedWatchFilter === 'function') performOptimizedWatchFilter();
    if (!select) return;

    // Select it directly rather than firing a synthetic click: watchSelectionSetup only
    // advances the mobile stepper for a trusted event, and we do want that advance here.
    const grid = document.getElementById('watchesGrid');
    const img = grid && grid.querySelector('img[data-custom="1"]');
    if (!img) return;
    grid.querySelectorAll('img').forEach(x => x.classList.remove('selected'));
    grid.querySelectorAll('.watch-list-item').forEach(x => x.classList.remove('selected'));
    img.classList.add('selected');
    const li = img.closest('.watch-list-item');
    if (li) li.classList.add('selected');
    svUserInteracted = true;                 // block the pending auto-select from stealing it back
    // The grid image is still a placeholder until refineWatch runs; point the compositor at the
    // real cutout immediately so the preview appears without waiting on the refine queue.
    displayWatchDetails(img);
    if (currentWatchData) currentWatchData.finalImageData = entry.link;
    if (selectedStrapProduct) showStrapDetails(selectedStrapProduct);
    combineImages();
    try { img.scrollIntoView({ block: 'nearest' }); } catch (e) {}
    goToStrapStep();
  }

  /* 3.57.0: remove the saved custom watch - forget it in storage, drop it from the list,
     and if it was the selected watch hand selection to the first catalogue row. */
  function svcDeleteWatch() {
    try { localStorage.removeItem(SVC_KEY); } catch (e) {}
    const i = watchList.findIndex(w => w._custom);
    if (i >= 0) watchList.splice(i, 1);

    const grid = document.getElementById('watchesGrid');
    const sel = grid && grid.querySelector('img.selected');
    const wasSelected = !!(sel && sel.dataset.custom === '1');

    // Drop the synthetic "My watch" brand option (and any filter stuck on it).
    const brand = document.getElementById('brandFilterSelect');
    if (brand) {
      const opt = Array.prototype.find.call(brand.options, o => o.value === 'My watch');
      if (opt) opt.remove();
      if (brand.value === 'My watch') {
        brand.value = '';
        filterState.watches.brand = '';
      }
    }

    renderWatches();
    refineWatchesBatched();
    if (typeof performOptimizedWatchFilter === 'function') performOptimizedWatchFilter();

    if (wasSelected) {
      const first = grid && grid.querySelector('img[data-model]');
      if (first) {
        grid.querySelectorAll('img').forEach(x => x.classList.remove('selected'));
        grid.querySelectorAll('.watch-list-item').forEach(x => x.classList.remove('selected'));
        first.classList.add('selected');
        const li = first.closest('.watch-list-item');
        if (li) li.classList.add('selected');
        displayWatchDetails(first);
        if (selectedStrapProduct) showStrapDetails(selectedStrapProduct);
        combineImages();
      }
    }
  }

  /* parseCSV wipes watchList on every (re)parse, so the saved watch is re-added from
     there - this runs before renderWatches on a fresh load. */
  function svcInjectCustomWatch() {
    let saved = null;
    try { saved = JSON.parse(localStorage.getItem(SVC_KEY) || 'null'); } catch (e) {}
    if (!saved || !saved.link || saved.link.indexOf('data:image') !== 0) return;
    if (watchList.some(w => w._custom)) return;
    watchList.unshift({
      brand: 'My watch',
      model: saved.model || 'My watch',
      'lug width': saved.width ? saved.width + 'mm' : '',
      'watch type': 'Quick Release',
      'scaling factor': 0.8,
      link: saved.link,
      collection_link: '',
      _custom: true
    });
  }

  function svcSetupButton() {
    svcInjectCSS();
    const host = document.querySelector('.watches-container');
    const grid = document.getElementById('watchesGrid');
    if (!host || !grid || document.getElementById('svcOpenBtn')) return;
    const b = document.createElement('button');
    b.type = 'button';
    b.id = 'svcOpenBtn';
    b.innerHTML = `<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2
        2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13"
        r="4"/></svg><span>Can't find your watch? Use a photo of your own</span>`;
    b.addEventListener('click', svcOpenModal);
    host.insertBefore(b, grid);
  }

  /************************************************************************
   * 13) ONE-SCREEN LAYOUT - 2026-08-15
   *
   * Pick the watch once, then the whole screen is the strap. Adds:
   *  - body.sv-onescreen (gates all the layout CSS in the page template)
   *  - desktop step flow: the existing mobile sv-step-strap class now runs on
   *    desktop too - the watch column collapses into the #svWatchBar chip
   *  - category chips (#svCatChips) mirroring mainCategorySelect
   *  - prev/next strap flipping: #svFlipPrev/Next, arrow keys, swipe on the
   *    preview - all route through selectStrapByImg so the engine is untouched
   *  - the buy panel (#strapDetails) docks under the canvas on desktop
   *
   * Kill switch: SV_ONESCREEN=false restores the classic 3-column layout
   * (the CSS is inert without the body class). Revert bak:
   * strap-visualiser.PRE-ONESCREEN-2026-08-15.bak
   ************************************************************************/
  (function(){
    var SV_ONESCREEN = true;
    if (!SV_ONESCREEN) return;

    /* Stale-HTML fallback (3.2.1). The one-screen markup + CSS live in the page TEMPLATE, but
       Shopify's page-HTML cache and browser caches can serve an OLD document alongside the NEW
       JS asset for a long time - observed: a user tab printing SV_BUILD 3.2.0 while showing the
       classic layout, because #svCatChips didn't exist so init backed off. So the JS now builds
       any missing piece itself and injects the layout CSS when the template didn't carry it.
       Keep this CSS in step with the "ONE-SCREEN LAYOUT - 2026-08-15" block in the template;
       it can be deleted once the template markup has been everywhere for a while. */
    var SVO_CSS = '' +
      'body.sv-onescreen #svWatchBar{display:none;align-items:center;gap:10px;width:100%;background:#fff;border:1px solid #e3ded4;border-radius:10px;padding:8px 12px;margin:0 0 10px;box-shadow:0 1px 3px rgba(29,29,29,.06);}' +
      'body.sv-onescreen .container.sv-step-strap #svWatchBar{display:flex;}' +
      '#svWatchBar .sv-wb-chip{display:flex;align-items:center;gap:9px;border:0;background:none;cursor:pointer;text-align:left;padding:2px 4px;border-radius:8px;min-width:0;}' +
      '#svWatchBar .sv-wb-chip:hover{background:#f4f1ea;}' +
      '#svWatchBar .sv-wb-name{font-weight:700;font-size:.92rem;color:#1d1d1d;white-space:normal;overflow-wrap:anywhere;max-width:190px;}' +
      '#svWatchBar .sv-wb-change{font-size:.76rem;font-weight:700;color:#b2955f;white-space:nowrap;}' +
      '#svWatchBar .sv-wb-width{margin-left:auto;font-size:.78rem;font-weight:700;color:#8a7244;background:#f4ecdd;border-radius:999px;padding:4px 11px;white-space:nowrap;font-variant-numeric:tabular-nums;}' +
      'body.sv-onescreen #svCatChips{display:flex;gap:6px;overflow-x:auto;padding:2px 2px 10px;width:100%;scrollbar-width:none;-webkit-overflow-scrolling:touch;}' +
      'body.sv-onescreen #svCatChips::-webkit-scrollbar{display:none;}' +
      '#svCatChips .sv-chip{flex:none;border:1px solid #cfc9bc;border-radius:999px;padding:5px 13px;font-size:.8rem;font-weight:600;color:#5d5a52;background:#fff;cursor:pointer;white-space:nowrap;}' +
      '#svCatChips .sv-chip[aria-pressed="true"]{background:#1d1d1d;color:#fff;border-color:#1d1d1d;}' +
      'body.sv-onescreen .straps-container .filters-container{display:none !important;}' +
      'body.sv-onescreen .preview-viewport{position:relative;}' +
      '.sv-flip{display:none;position:absolute;top:50%;transform:translateY(-50%);z-index:5;width:38px;height:38px;border-radius:50%;border:1px solid #d8d2c4;background:rgba(255,255,255,.94);cursor:pointer;box-shadow:0 2px 8px rgba(29,29,29,.12);color:#1d1d1d;font-size:0;line-height:0;padding:0;align-items:center;justify-content:center;}' +
      'body.sv-onescreen .container.sv-step-strap .sv-flip{display:inline-flex;}' +
      '.sv-flip:hover{background:#f4ecdd;}' +
      '.sv-flip svg{width:16px;height:16px;}' +
      '.sv-flip.sv-flip-prev{left:8px;}' +
      '.sv-flip.sv-flip-next{right:8px;}' +
      '.strap-row-optwrap.sv-has-swatches select.strap-colour-select{display:none !important;}' +
      '.sv-swatches{display:flex;gap:5px;align-items:center;overflow-x:auto;max-width:100%;padding:2px 0;scrollbar-width:none;-webkit-overflow-scrolling:touch;}' +
      '.sv-swatches::-webkit-scrollbar{display:none;}' +
      '.sv-swatch{flex:none;width:26px;height:26px;border-radius:50%;padding:0;cursor:pointer;border:1px solid #cfc9bc;background:#edeae3;overflow:hidden;display:inline-flex;align-items:center;justify-content:center;position:relative;}' +
      '.sv-swatch.sv-sw-oos::after{content:"";position:absolute;left:-20%;top:50%;width:140%;height:2px;background:#b3261e;transform:rotate(-45deg);box-shadow:0 0 0 1px rgba(255,255,255,.85);pointer-events:none;}' +
      '.sv-swatch img{width:100%;height:100%;object-fit:cover;display:block;pointer-events:none;}' +
      '.sv-swatch.sv-sw-zoom img{transform:scale(2.4);transform-origin:30% 50%;}' +
      'body.sv-onescreen .sv-thumbwrap{flex:0 0 auto;width:46px;height:76px;border-radius:9px;overflow:hidden;background:#efece5;position:relative;align-self:center;}' +
      // ⚠ The `.straps-grid .strap-list-item` prefix is load-bearing: without it this rule
      // (0,2,2) loses to the breakpoint rule `.straps-grid.list-view .strap-list-item img`
      // (0,3,1) that pins the thumb to 46x46 CONTAIN, top-left. See the same note in
      // templates/page.StrapVisualiser.liquid.
      'body.sv-onescreen .straps-grid .strap-list-item .sv-thumbwrap img,body.sv-onescreen .sv-thumbwrap img{width:100% !important;height:100% !important;object-fit:cover !important;aspect-ratio:auto !important;object-position:center center !important;padding:0 !important;border-width:0 !important;margin:0 !important;float:none !important;max-width:none !important;display:block;transform:none;}' +
      '.sv-swatch:hover{border-color:#b2955f;}' +
      '.sv-swatch[aria-pressed="true"]{border-color:#b2955f;box-shadow:0 0 0 2px #fff,0 0 0 3.5px #b2955f;}' +
      '@media (min-width:769px){' +
        'body.sv-onescreen .container:not(.sv-step-strap) .straps-container{display:none !important;}' +
        'body.sv-onescreen .container:not(.sv-step-strap) .watches-container{max-width:620px;}' +
        'body.sv-onescreen.sv-step-strap-on .sv-header{display:none;}' +
        'body.sv-onescreen .container.sv-step-strap{display:grid !important;grid-template-columns:minmax(330px,400px) minmax(0,1fr);grid-template-rows:auto 1fr;gap:14px 18px;align-items:start;}' +
        'body.sv-onescreen .container.sv-step-strap .watches-container{display:none !important;}' +
        'body.sv-onescreen .container.sv-step-strap > #svWatchBar{grid-column:1 / -1;grid-row:1;margin:0;}' +
        'body.sv-onescreen .container.sv-step-strap .straps-container{grid-column:1;grid-row:2;width:auto;max-width:none;}' +
        'body.sv-onescreen .container.sv-step-strap .final-image-container{grid-column:2;grid-row:2;position:sticky;top:16px !important;height:var(--sv-col-h, 700px) !important;margin-top:0 !important;width:auto;max-width:none;display:flex;flex-direction:column;align-items:center;}' +
        'body.sv-onescreen .container.sv-step-strap .preview-viewport{flex:1 1 auto;min-height:0;width:100%;display:flex;align-items:center;justify-content:center;}' +
        'body.sv-onescreen .container.sv-step-strap #finalCanvas{max-height:100%;max-width:100%;height:auto;width:auto;}' +
        'body.sv-onescreen .container.sv-step-strap .action-buttons-container{flex:0 0 auto;}' +
        'body.sv-onescreen .final-image-container .strap-details{flex:0 0 auto;width:100%;max-width:640px;margin:10px auto 0;max-height:44%;overflow-y:auto;background:#fff;border:1px solid #e3ded4;border-radius:10px;padding:12px 14px;}' +
        'body.sv-onescreen .container.sv-step-strap .straps-container .straps-grid{flex:1 1 0;}' +
      '}' +
      'body.sv-onescreen .strap-list-info{min-width:0;}' +
      '#strapDetails.sv-dedup-colour #strapColourPicker{display:none !important;}' +
      '#strapDetails .sv-hide-colour-dd{display:none !important;}' +
      '@media (max-width:768px){' +
        'body.sv-onescreen #svWatchBar{padding:6px 10px;margin-bottom:8px;gap:8px;flex-wrap:nowrap;align-items:center;}' +
        'body.sv-onescreen #svWatchBar .sv-wb-chip{flex:1 1 auto;min-width:0;gap:6px;padding:2px 4px;justify-content:space-between;}' +
        'body.sv-onescreen #svWatchBar .sv-wb-chip > span:first-child{flex:1 1 auto;min-width:0;line-height:1.2;}' +
        'body.sv-onescreen #svWatchBar .sv-wb-brand{display:inline;font-size:.6rem;margin-right:.35em;}' +
        'body.sv-onescreen #svWatchBar .sv-wb-name{max-width:none;font-size:.86rem;line-height:1.2;}' +
        'body.sv-onescreen #svWatchBar .sv-wb-change{flex:0 0 auto;font-size:.7rem;line-height:1.1;white-space:normal;max-width:4.6em;text-align:right;}' +
        'body.sv-onescreen #svWatchBar .sv-wb-width{flex:0 0 auto;margin-left:0;font-size:.68rem;line-height:1.15;padding:3px 7px;white-space:normal;max-width:5.6em;text-align:center;}' +
        '.sv-flip{width:32px;height:32px;}' +
        'body.sv-onescreen.sv-step-strap-on .sv-header{display:none;}' +
        'body.sv-onescreen .sv-stepper{display:none !important;}' +
        'body.sv-onescreen .container.sv-step-strap .final-image-container #svWatchBar{margin:0 8px 6px;width:auto;}' +
        /* ── Collapsing buy card (mobile only) ──────────────────────────────
           73% of visualiser traffic is mobile and the purchase card was eating
           ~26% of the viewport, squeezing the strap list to ~15%. Collapsed it
           is just title + price + Add to Cart; the option dropdowns appear on
           tap. Desktop is untouched - every rule here is inside this query. */
        'body.sv-onescreen #svBuyToggle{display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;flex:none;padding:0;border:1px solid #d8d2c4;border-radius:50%;background:#fff;cursor:pointer;color:#1d1d1d;}' +
        'body.sv-onescreen #svBuyToggle svg{width:13px;height:13px;transition:transform .18s ease;}' +
        'body.sv-onescreen #strapDetails.sv-buy-open #svBuyToggle svg{transform:rotate(180deg);}' +
        /* 3.41.0: collapsed card = flex; colour + width side by side; width select
           auto-sizes. Keep in sync with the template copy. */
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #strapVariants,' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #productPageLink{ display:none !important; }' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open){ display:flex !important; flex-wrap:wrap; gap:6px 8px; align-items:center; }' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) .product-title-container{ flex:1 1 100%; }' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #svBuyColour{ display:none !important; }' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #strapColourPicker{ flex:1 1 0; min-width:118px; margin:0 !important; display:flex; }' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #strapColourPicker:empty{ display:none !important; }' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #strapColourPicker label,' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #strapColourPicker .sv-variant-label{ display:block !important; font-size:.56rem !important; }' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #strapColourPicker select{ width:100% !important; font-size:12px !important; line-height:1.2; padding:6px 24px 6px 8px !important; margin:0; }' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #optionDropdownsContainer{ display:flex !important; flex-direction:row !important; flex-wrap:wrap; gap:6px; margin:0; flex:1 1 100%; width:auto !important; }' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open):has(#strapColourPicker select) #optionDropdownsContainer{ flex:0 1 auto; min-width:0; }' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #optionDropdownsContainer .sv-variant-field{ flex:1 1 0; min-width:110px; margin:0; }' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #optionDropdownsContainer .sv-variant-field:last-child{ flex:0 1 auto; min-width:0; }' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #optionDropdownsContainer .sv-variant-field:last-child select{ width:auto !important; max-width:100%; }' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #optionDropdownsContainer .sv-variant-label{ display:block !important; font-size:.56rem !important; }' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #optionDropdownsContainer select.option-select{ width:100% !important; font-size:12px !important; line-height:1.2; padding:6px 24px 6px 8px !important; margin:0; }' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #lugWidthDisclaimer{ flex:1 1 100%; }' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) .add-to-cart-btn{ flex:1 1 100%; margin:0; }' +
        /* 3.42.0 (owner): mobile goes EDGE TO EDGE - the body's own 20px side padding was the
           "container" gutter and it caught horizontal wobble while scrolling; the grey band was
           the theme body colour. Flip arrows are gone on mobile (swipe-flip is disabled there
           too, in the pointer handler) and the watch chip bar now lives at the top of the strap
           rail, above the search bar (dock() moves it). Keep in sync with the template copy. */
        'body.sv-onescreen{background:#fff !important;padding:0 !important;}' +
        /* 3.45.0 (owner): the preview/products split BREATHES - scrolling the rail
           shrinks the preview (more products on screen), picking a strap grows it back,
           and the pill handle on the divider drags it to taste (remembered). */
        'body.sv-onescreen store-header{margin-top:0 !important;}' +
        /* 3.46.0 (owner): the Zoom In button is replaced on mobile by a vertical zoom
           slider on the preview's right edge, driving the existing inlineZoom scale. */
        'body.sv-onescreen #zoomBtn{display:none !important;}' +
        'body.sv-onescreen #svZoomBar{position:absolute;right:6px;top:14%;height:64%;width:28px;display:block;z-index:6;touch-action:none;}' +
        'body.sv-onescreen #svZoomBar .svz-track{position:absolute;left:50%;top:0;bottom:0;width:4px;transform:translateX(-50%);border-radius:2px;background:#e3ddd0;}' +
        'body.sv-onescreen #svZoomBar .svz-thumb{position:absolute;left:50%;transform:translate(-50%,-50%);width:24px;height:24px;border-radius:50%;background:#fff;border:1px solid #d8d2c4;box-shadow:0 1px 4px rgba(0,0,0,.18);}' +
        'body.sv-onescreen{--sv-ph:33vh;--sv-canvas-h:calc(33vh - 6px);}' +
        // 3.49.0: the fixed preview PANEL follows --sv-ph as well - pinned at 40vh it
        // swallowed the drag and re-fitted the canvas instead (see the template note).
        'body.sv-onescreen .container.sv-step-strap .final-image-container{height:auto !important;max-height:none !important;}' +
        'body.sv-onescreen .container.sv-step-strap .straps-container > .search-row{top:calc(var(--sv-prev-bot, calc(var(--sv-prev-top,0px) + 40vh)) + 2px) !important;}' +
        'body.sv-onescreen .container.sv-step-strap .straps-grid{max-height:max(132px, calc(100dvh - var(--sv-prev-bot, 40vh) - var(--sv-bar-h,180px) - 62px)) !important;}' +
        /* 3.58.0: the fixed buy card was covering the last row - pad the scroller by its
           measured height (--sv-buy-h from dock()/ResizeObserver). Keep in sync w/ template. */
        'body.sv-onescreen .container.sv-step-strap .straps-grid{padding-bottom:calc(var(--sv-buy-h, 140px) + 14px) !important;}' +
        // A rebuilt (side-by-side) thumb is already trimmed to its content, so CONTAIN it -
        // cover would crop the outer edge off both arms.
        'body.sv-onescreen .straps-grid .strap-list-item .sv-thumbwrap img.sv-thumb2{object-fit:contain !important;}' +
        'body.sv-onescreen .container.sv-step-strap .preview-viewport{height:var(--sv-ph) !important;max-height:var(--sv-ph) !important;transition:height .18s ease;}' +
        'body.sv-onescreen .container.sv-step-strap #finalCanvas{max-height:var(--sv-canvas-h) !important;}' +
        'body.sv-onescreen.sv-ph-dragging .container.sv-step-strap .preview-viewport{transition:none !important;}' +
        'body.sv-onescreen #svPhHandle{display:flex;align-items:center;justify-content:center;position:absolute;left:50%;bottom:-4px;transform:translateX(-50%);width:56px;height:18px;border:1px solid #d8d2c4;border-radius:9px;background:#fff;box-shadow:0 1px 4px rgba(0,0,0,.12);cursor:ns-resize;touch-action:none;z-index:5;}' +
        'body.sv-onescreen #svPhHandle{width:64px;height:22px;flex-direction:column;gap:0;color:#8d8371;}' +
        'body.sv-onescreen #svPhHandle svg{width:14px;height:8px;display:block;}' +
        'body.sv-onescreen .straps-container,body.sv-onescreen .final-image-container{border-radius:0 !important;}' +
        'body.sv-onescreen .sv-flip{display:none !important;}' +
        'body.sv-onescreen .straps-container > #svWatchBar{margin:0 0 8px !important;width:100% !important;}' +
        /* 3.43.0 (owner): materials chips OFF on mobile; type + name share one line in the
           rail rows AND the buy-card title; the buy-card chevron is gone (variants already
           show collapsed, nothing extra behind it). Keep in sync with the template copy. */
        'body.sv-onescreen #svCatChips{display:none !important;}' +
        'body.sv-onescreen .strap-list-item .strap-list-info{display:block !important;}' +
        'body.sv-onescreen .strap-list-item .strap-list-category{display:inline !important;margin:0 6px 0 0;}' +
        'body.sv-onescreen .strap-list-item .strap-list-title{display:inline !important;}' +
        'body.sv-onescreen #strapTitle .sd-type{display:inline !important;margin:0 6px 0 0;}' +
        'body.sv-onescreen #strapTitle .sd-name{display:inline !important;}' +
        'body.sv-onescreen #svBuyToggle{display:none !important;}' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open){padding:8px 10px !important;}' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) .product-title-container{margin-bottom:6px !important;flex-wrap:nowrap !important;}' +
        /* 3.72.0: the buy-card title wraps; the card is measured by a ResizeObserver
           (svPublishBuyH -> --sv-buy-h) so the layout below it follows the new height. */
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #strapTitle{font-size:.94rem !important;white-space:normal;overflow:visible;text-overflow:clip;overflow-wrap:anywhere;}' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) #strapPrice{margin:0 !important;font-size:.96rem !important;white-space:nowrap;}' +
        'body.sv-onescreen #strapDetails:not(.sv-buy-open) .add-to-cart-btn{padding:9px 16px !important;}' +
        /* 3.56.0: bigger strap rows on mobile - 64x92 thumbs, larger title, larger swatch
           discs - so each strap is actually legible. Keep in sync with the template copy. */
        'body.sv-onescreen .sv-thumbwrap{width:64px !important;height:92px !important;border-radius:8px;}' +
        'body.sv-onescreen .straps-grid .strap-list-item{padding-top:10px !important;padding-bottom:10px !important;contain-intrinsic-size:0 112px !important;}' +
        'body.sv-onescreen .strap-list-item .strap-list-title{font-size:.92rem !important;}' +
        'body.sv-onescreen .strap-list-item .strap-list-category{font-size:.68rem !important;}' +
        'body.sv-onescreen .sv-swatch{width:28px;height:28px;}' +
        'body.sv-onescreen .sv-swatches{gap:6px;}' +
      '}' +
      '@media (min-width:769px){#svBuyToggle{display:none !important;}#svPhHandle{display:none !important;}}';

    function svoEnsureMarkup(){
      var strapsCol = document.querySelector('.straps-container');
      var vp = document.querySelector('.preview-viewport');
      if (!strapsCol || !vp) return false;
      var injected = false;
      if (!document.getElementById('svWatchBar')){
        var h2 = strapsCol.querySelector('h2');
        var bar = document.createElement('div');
        bar.id = 'svWatchBar';
        bar.innerHTML = '<button type="button" class="sv-wb-chip" id="svWatchChip">' +
          '<span><span class="sv-wb-brand" id="svWbBrand"></span>' +
          '<span class="sv-wb-name" id="svWbName">Your watch</span></span>' +
          '<span class="sv-wb-change">Change watch face</span></button>' +
          '<span class="sv-wb-width" id="svWbWidth"></span>';
        strapsCol.insertBefore(bar, h2 || strapsCol.firstChild);
        injected = true;
      }
      if (!document.getElementById('svCatChips')){
        var filters = strapsCol.querySelector('.filters-container');
        var chips = document.createElement('div');
        chips.id = 'svCatChips';
        chips.setAttribute('role', 'group');
        chips.setAttribute('aria-label', 'Strap category');
        if (filters) strapsCol.insertBefore(chips, filters);
        else {
          var h2b = strapsCol.querySelector('h2');
          if (h2b && h2b.nextSibling) strapsCol.insertBefore(chips, h2b.nextSibling);
          else strapsCol.appendChild(chips);
        }
        injected = true;
      }
      if (!document.getElementById('svFlipPrev')){
        var mk = function(id, cls, path, label){
          var b = document.createElement('button');
          b.type = 'button'; b.id = id; b.className = 'sv-flip ' + cls;
          b.setAttribute('aria-label', label);
          b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="' + path + '"></path></svg>';
          return b;
        };
        vp.appendChild(mk('svFlipPrev', 'sv-flip-prev', 'm14 6-6 6 6 6', 'Previous strap'));
        vp.appendChild(mk('svFlipNext', 'sv-flip-next', 'm10 6 6 6-6 6', 'Next strap'));
        injected = true;
      }
      // A page whose template already carries the markup also carries the CSS; only a stale
      // document needs the styles injected alongside the elements it was missing.
      if (injected && !document.getElementById('sv-onescreen-css')){
        var st = document.createElement('style');
        st.id = 'sv-onescreen-css';
        st.textContent = SVO_CSS;
        document.head.appendChild(st);
      }
      return true;
    }

    function svOneInit(){
      var container = document.querySelector('.container');
      var mainSel = document.getElementById('mainCategorySelect');
      var grid = document.getElementById('strapsGrid');
      // Only the standalone visualiser page has these; the PDP snippets load
      // their own code and never reach here.
      if (!container || !mainSel || !grid) return;
      if (!svoEnsureMarkup()) return;
      var chipsBox = document.getElementById('svCatChips');
      if (!chipsBox) return;
      document.body.classList.add('sv-onescreen');
      var isDesk = function(){ return window.innerWidth > 768; };
      /* 3.65.0 kill switch for the mobile flow layout (see the block near the end of this
         init). Declared up here because dock() reads it before that block runs. */
      var SV_MOBILE_FLOW = !window.SV_EMBED;   // 3.94.0: off in the PDP embed (in-flow, px-sized preview)
      document.body.classList.toggle('sv-mflow', SV_MOBILE_FLOW);

      /* --- land on the strap step once a watch is selected - BOTH breakpoints (3.3.0).
         Mobile used to start on the watch-pick step and only advance on a real tap;
         per the approved mockup the page opens straight onto the straps with the
         remembered/default watch in the chip bar, and "Change" goes back. --- */
      function autoAdvance(){
        if (svoHoldStep) return;   // mobile first-visit: stay on the watch picker
        if (!container.classList.contains('sv-step-strap') &&
            document.querySelector('#watchesGrid img.selected')){
          container.classList.add('sv-step-strap');
        }
      }
      // The default watch is auto-selected asynchronously after the feed loads,
      // so poll briefly, then rely on the click listener for manual picks.
      var svoTries = 0;
      var svoTimer = setInterval(function(){
        autoAdvance();
        if (++svoTries > 60 || container.classList.contains('sv-step-strap')) clearInterval(svoTimer);
      }, 250);
      var watchesGrid = document.getElementById('watchesGrid');
      if (watchesGrid) watchesGrid.addEventListener('click', function(){ setTimeout(autoAdvance, 0); });

      // Mirror the step onto <body> so page chrome OUTSIDE .container (the hero header)
      // can react - CSS has no previous-sibling selector.
      function syncStepClass(){
        document.body.classList.toggle('sv-step-strap-on', container.classList.contains('sv-step-strap'));
      }
      if (window.MutationObserver){
        new MutationObserver(syncStepClass).observe(container, { attributes: true, attributeFilter: ['class'] });
      }
      syncStepClass();

      /* --- watch chip bar mirrors the watch-details panel --- */
      var wbName = document.getElementById('svWbName');
      var wbWidth = document.getElementById('svWbWidth');
      function syncBar(){
        var titleEl = document.getElementById('watchTitle');
        var lugEl = document.getElementById('watchLugWidth');
        var brandEl = document.getElementById('watchBrand');
        var wbBrand = document.getElementById('svWbBrand');
        if (wbName && titleEl && titleEl.textContent.trim()) wbName.textContent = titleEl.textContent.trim();
        if (wbBrand && brandEl) wbBrand.textContent = brandEl.textContent.trim();
        if (wbWidth && lugEl){
          var w = lugEl.textContent.trim().replace(/\s*straps?$/i, '');
          // Just the width. It used to read "Select 20mm", which in a tan pill next to the
          // watch name looked like an unpressed button people were meant to click.
          wbWidth.textContent = w || '';
          // 3.75.2: an empty pill is still a pill - a small tan stub next to the watch name.
          // A watch with no width to show (see svWatchHasNoStraps) gets no pill at all.
          wbWidth.style.display = w ? '' : 'none';
        }
      }
      var wd = document.getElementById('watchDetails');
      if (wd && window.MutationObserver){
        new MutationObserver(syncBar).observe(wd, { subtree: true, childList: true, characterData: true });
      }
      syncBar();
      /* --- desktop: "Change" opens a POPUP with the watch picker (brand menu, search,
         list) - the EXISTING .watches-container is moved into the modal so all engine
         wiring keeps working; it moves home on close. Mobile keeps the step flow. --- */
      var svoWatchesHome = null;
      function svoModal(){
        var m = document.getElementById('svWatchModal');
        if (m) return m;
        m = document.createElement('div');
        m.id = 'svWatchModal';
        m.innerHTML = '<div class="sv-wm-panel" role="dialog" aria-label="Choose your watch">' +
          '<div class="sv-wm-head"><h3>Choose your watch</h3>' +
          '<button type="button" class="sv-wm-close" aria-label="Close">&times;</button></div>' +
          '<p class="sv-wm-hint">Pick a model, adjust its colour or size, then Apply.</p>' +
          '<div class="sv-wm-body"><div class="sv-wm-preview">' +
          '<img id="svWmFace" alt="Selected watch">' +
          '<div class="sv-wm-name" id="svWmName"></div>' +
          '<div class="sv-wm-width" id="svWmWidth"></div>' +
          '<button type="button" class="sv-wm-apply" id="svWmApply">Apply</button>' +
          '</div></div></div>';
        document.body.appendChild(m);
        m.addEventListener('click', function(e){ if (e.target === m) svoCloseModal(); });
        m.querySelector('.sv-wm-close').addEventListener('click', svoCloseModal);
        m.querySelector('#svWmApply').addEventListener('click', svoCloseModal);
        return m;
      }
      // Right-pane mirror of the engine's live selection (face image follows variant
      // changes because the row <img> itself is what the engine updates).
      function svoSyncWm(){
        var sel = document.querySelector('#watchesGrid img.selected');
        var face = document.getElementById('svWmFace');
        if (face && sel && sel.src && face.src !== sel.src) face.src = sel.src;
        var n = document.getElementById('svWmName');
        var w = document.getElementById('svWmWidth');
        var titleEl = document.getElementById('watchTitle');
        var lugEl = document.getElementById('watchLugWidth');
        /* ⚠ ASSIGNING textContent REPLACES THE TEXT NODE, AND WITH IT ANY SELECTION INSIDE IT.
           This runs on a 400ms interval, so double-clicking the watch name to copy it highlighted
           and then cleared within half a second (reported 2026-09-09). Write only on a real
           change - which is almost never, since this is a mirror of an element that rarely moves. */
        if (n && titleEl) { const _t = titleEl.textContent.trim(); if (n.textContent !== _t) n.textContent = _t; }
        if (w && lugEl)   { const _w = lugEl.textContent.trim();   if (w.textContent !== _w) w.textContent = _w; }
      }
      var svoWmTimer = null;
      function svoOpenModal(){
        var watchesCol = document.querySelector('.watches-container');
        if (!watchesCol) return;
        var m = svoModal();
        if (!svoWatchesHome) svoWatchesHome = { parent: watchesCol.parentElement, next: watchesCol.nextElementSibling };
        var body = m.querySelector('.sv-wm-body');
        body.insertBefore(watchesCol, body.firstChild);
        document.body.classList.add('sv-watch-modal-open');
        svEmbedFullscreen(true);   // 3.94.0
        svoSyncWm();
        // The list only becomes visible now, so refine what is on screen straight away.
        setTimeout(svRefineVisibleWatchRows, 60);
        clearInterval(svoWmTimer);
        svoWmTimer = setInterval(svoSyncWm, 400);
      }
      function svoCloseModal(){
        clearInterval(svoWmTimer); svoWmTimer = null;
        document.body.classList.remove('sv-watch-modal-open');
        svEmbedFullscreen(false);   // 3.94.0
        var m = document.getElementById('svWatchModal');
        var watchesCol = m && m.querySelector('.watches-container');
        if (watchesCol && svoWatchesHome && svoWatchesHome.parent){
          svoWatchesHome.parent.insertBefore(watchesCol, svoWatchesHome.next);
        }
      }
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape') svoCloseModal();
      });
      var svoHoldStep = false;
      if (watchesGrid) watchesGrid.addEventListener('click', function(e){
        if (e.isTrusted) svoHoldStep = false;   // a real pick releases the first-visit hold
        // Picking a model no longer closes the popup - the right pane previews it and
        // the user confirms with Apply (or Esc/scrim/X to just close; the engine has
        // already applied the selection live either way).
        if (document.body.classList.contains('sv-watch-modal-open')) setTimeout(svoSyncWm, 100);
      });
      var chip = document.getElementById('svWatchChip');
      if (chip) chip.addEventListener('click', function(){
        /* 3.56.0: BOTH breakpoints use the modal. The mobile full-page step swap
           (goToWatchStep) is retired - swapping the whole layout under a fixed
           preview + measured spacer was the source of the buggy states. */
        svoOpenModal();
      });

      /* --- first visit (no remembered watch, no ?watch= link): don't silently default
         to the first catalogue watch - put the watch choice in front of the user.
         Desktop: open the picker POPUP over the strap view once the list has loaded.
         Mobile: fall back to the watch step (its full-screen picker). --- */
      var svoHasIntent = false;
      try {
        svoHasIntent = !!((typeof SV_INITIAL_PARAMS !== 'undefined' ? SV_INITIAL_PARAMS
                              : new URLSearchParams(location.search)).get('watch')) ||
                       !!localStorage.getItem('selectedWatch');
      } catch (e) {}
      if (!svoHasIntent && !window.SV_EMBED){   // 3.94.0: the embed offers a button instead of a popup over the product page
        /* 3.56.0: mobile first-visit opens the same modal as desktop (the step-flow
           hold - svoHoldStep + removing sv-step-strap - is retired). */
        var svoIntroTries = 0;
        var svoIntroTimer = setInterval(function(){
          if (document.querySelector('#watchesGrid img')){
            clearInterval(svoIntroTimer);
            svoOpenModal();
          } else if (++svoIntroTries > 40) clearInterval(svoIntroTimer);
        }, 250);
      }

      /* --- category chips built from mainCategorySelect's options --- */
      // A dropdown filter mirroring mainCategorySelect (was a row of chip buttons;
      // owner asked for a selectable dropdown).
      function renderChips(){
        var cur = mainSel.value;
        var html = '<select class="sv-cat-select" aria-label="Filter by material">' +
          '<option value=""' + (cur === '' ? ' selected' : '') + '>All materials</option>';
        Array.prototype.forEach.call(mainSel.options, function(o){
          if (!o.value) return;
          html += '<option value="' + o.value.replace(/"/g, '&quot;') + '"' + (o.value === cur ? ' selected' : '') + '>' + o.text + '</option>';
        });
        chipsBox.innerHTML = html + '</select>';
      }
      chipsBox.addEventListener('change', function(e){
        var s = e.target.closest('.sv-cat-select'); if (!s) return;
        mainSel.value = s.value;
        mainSel.dispatchEvent(new Event('change', { bubbles: true }));
      });
      mainSel.addEventListener('change', function(e){
        if (e.target === mainSel) setTimeout(renderChips, 0);
      });
      if (window.MutationObserver){
        new MutationObserver(renderChips).observe(mainSel, { childList: true });
      }
      renderChips();

      /* --- prev/next flipping: buttons, arrow keys, swipe on the preview --- */
      function visStraps(){
        return Array.prototype.filter.call(grid.querySelectorAll('img'), function(img){
          var row = img.closest('.strap-list-item') || img;
          return row.offsetParent !== null;
        });
      }
      function flip(d){
        var list = visStraps(); if (!list.length) return;
        var cur = grid.querySelector('img.selected');
        var i = list.indexOf(cur);
        var next = list[(i + d + list.length) % list.length];
        if (typeof selectStrapByImg === 'function') selectStrapByImg(next);
        try { if (typeof svRevealRow === 'function') svRevealRow(next); } catch (e) {}
      }
      var fp = document.getElementById('svFlipPrev');
      var fn = document.getElementById('svFlipNext');
      if (fp) fp.addEventListener('click', function(){ flip(-1); });
      if (fn) fn.addEventListener('click', function(){ flip(1); });
      document.addEventListener('keydown', function(e){
        if (/^(INPUT|SELECT|TEXTAREA)$/.test((e.target && e.target.tagName) || '')) return;
        if (!container.classList.contains('sv-step-strap')) return;
        if (e.key === 'ArrowRight'){ flip(1); e.preventDefault(); }
        else if (e.key === 'ArrowLeft'){ flip(-1); e.preventDefault(); }
      });
      var vp = document.querySelector('.preview-viewport');
      var svoSx = null;
      if (vp){
        vp.addEventListener('pointerdown', function(e){
          /* 3.42.0: swipe-to-flip is DESKTOP ONLY. On a phone a vertical scroll that drifts
             44px sideways read as a swipe and changed the strap mid-scroll (owner report). */
          if (!isDesk()) return;
          if (e.target && e.target.closest && e.target.closest('.sv-flip')) return;
          svoSx = e.clientX;
        }, { passive: true });
        window.addEventListener('pointerup', function(e){
          if (svoSx === null) return;
          var dx = e.clientX - svoSx; svoSx = null;
          if (Math.abs(dx) > 44) flip(dx < 0 ? 1 : -1);
        }, { passive: true });
      }

      /* --- dock the buy panel under the canvas on desktop, back on mobile --- */
      var details = document.getElementById('strapDetails');
      var strapsCol = document.querySelector('.straps-container');
      var previewCol = document.querySelector('.final-image-container');
      /* 3.50.0: the rail's sticky search row and the strap list's height cap used to be
         written against a HARD-CODED 40vh preview. Once the panel started following the
         divider (3.49.0) that constant was wrong at every height except the default, and
         the search row detached and floated over the rows (owner report). Both are now
         keyed to this MEASURED bottom edge; the 40vh form survives only as the pre-JS
         fallback in the CSS. */
      function svPublishPrevBot(){
        if (!previewCol) return;
        var b = Math.round(previewCol.getBoundingClientRect().bottom);
        if (b > 0) document.body.style.setProperty('--sv-prev-bot', b + 'px');
      }
      /* 3.58.0: the buy card is position:fixed on mobile, so the strap grid needs its real
         height as bottom padding or the card covers the last row. Measured, not guessed -
         the card grows/shrinks per strap (colour + width selects come and go). */
      function svPublishBuyH(){
        if (!details) return;
        var h = isDesk() ? 0 : Math.ceil(details.getBoundingClientRect().height);
        document.body.style.setProperty('--sv-buy-h', h + 'px');
      }
      if (details && window.ResizeObserver){
        new ResizeObserver(svPublishBuyH).observe(details);
      }
      function dock(){
        if (!details || !strapsCol || !previewCol) return;
        var bar = document.getElementById('svWatchBar');
        if (window.SV_EMBED){
          /* 3.94.0: one column - chip bar, preview, buy card - at every width; the rail is hidden. */
          var vpE = previewCol.querySelector('.preview-viewport');
          if (bar && bar.parentElement !== previewCol) previewCol.insertBefore(bar, vpE || previewCol.firstChild);
          if (details.parentElement !== previewCol) previewCol.appendChild(details);
          var actE = previewCol.querySelector('.action-buttons-container');
          if (vpE && actE && actE.parentElement !== vpE) vpE.appendChild(actE);   // the zoom pill sits in the preview's corner
          details.classList.add('sv-buy-open');   // size/colour dropdowns always shown here
          previewCol.style.removeProperty('max-height');
          previewCol.style.removeProperty('height');
          container.style.removeProperty('padding-top');
          svPublishBuyH();
          return;
        }
        if (isDesk()){
          if (details.parentElement !== previewCol) previewCol.appendChild(details);
          // The chip bar spans the whole grid on desktop, so it must be a DIRECT
          // child of .container (a grid can only place its own children).
          if (bar && bar.parentElement !== container) container.insertBefore(bar, container.firstChild);
          // Equal vertical size with the strap rail. Inline !important because a legacy
          // base max-height:800px on this container kept capping it through the cascade.
          previewCol.style.setProperty('max-height', 'none', 'important');
          previewCol.style.setProperty('height', 'var(--sv-col-h, 760px)', 'important');
          container.style.removeProperty('padding-top');   // 3.43.2: mobile-only measured spacer
        } else {
          previewCol.style.removeProperty('max-height');
          previewCol.style.removeProperty('height');
          if (details.parentElement !== strapsCol) strapsCol.appendChild(details);
          // Mobile: the chip bar takes the stepper's slot under the sticky preview
          // (the stepper itself is hidden by the one-screen CSS).
          if (bar){
            /* 3.42.0 (owner): on mobile the chip bar sits at the TOP OF THE STRAP RAIL,
               above the search bar, filling the gap between the fixed preview and the
               rail instead of floating over the preview's bottom edge. */
            if (bar.parentElement !== strapsCol) strapsCol.insertBefore(bar, strapsCol.firstChild);
          }
          /* 3.43.2: the rail's top spacer is MEASURED from the fixed preview, replacing the
             34vh CSS guess - on taller phones the guess came up short and the chip bar (the
             rail's first child) hid underneath the preview (owner report, 4px margin here). */
          if (SV_MOBILE_FLOW) {
            // 3.65.0: the preview is in flow, so there is nothing to make room for.
            container.style.removeProperty('padding-top');
          } else {
            var svoCTop = container.getBoundingClientRect().top + window.scrollY;   // container's page-Y (padding-independent)
            var svoNeed = previewCol.getBoundingClientRect().bottom - svoCTop + 6;   // preview is FIXED, so its bottom is page-Y at scroll 0
            if (svoNeed > 100) container.style.setProperty('padding-top', Math.ceil(svoNeed) + 'px', 'important');
          }
          svPublishPrevBot();
        }
        svPublishBuyH();
      }
      /* --- progress bar while a colour/strap change composites --- */
      var svoLoadT = null;
      function svoLoadStart(){
        var vp2 = document.querySelector('.preview-viewport');
        if (vp2 && !vp2.querySelector('.sv-loadbar')){
          var lb = document.createElement('div');
          lb.className = 'sv-loadbar';
          vp2.appendChild(lb);
        }
        document.body.classList.add('sv-loading');
        clearTimeout(svoLoadT);
        svoLoadT = setTimeout(svoLoadEnd, 20000);   // failsafe (initial load can be slow)
      }
      function svoLoadEnd(){
        clearTimeout(svoLoadT); svoLoadT = null;
        document.body.classList.remove('sv-loading');
      }
      // Every recomposite funnels through combineImages; wrapping the BINDING catches
      // all callers. The canvas attribute observer ends the bar on the actual draw
      // (the promise can resolve before the debounced work finishes).
      if (typeof combineImages === 'function'){
        var _svoCombine = combineImages;
        combineImages = function(){
          svoLoadStart();
          var pr = _svoCombine.apply(this, arguments);
          if (pr && pr.finally) pr.finally(function(){ setTimeout(svoLoadEnd, 600); });
          return pr;
        };
      }
      var svoCanvas = document.getElementById('finalCanvas');
      if (svoCanvas && window.MutationObserver){
        new MutationObserver(function(){ setTimeout(svoLoadEnd, 120); })
          .observe(svoCanvas, { attributes: true, attributeFilter: ['width', 'height'] });
      }
      // INITIAL load: the feed fetch + first composite take seconds with no feedback.
      // Preview bar runs from now until the first canvas draw (observer above ends it);
      // the rail gets its own bar until the strap list renders rows.
      svoLoadStart();
      (function(){
        var rail = document.querySelector('.straps-container');
        if (!rail) return;
        if (!rail.querySelector('.sv-railload')){
          var rb = document.createElement('div');
          rb.className = 'sv-railload';
          var anchor = rail.querySelector('.search-row');
          if (anchor && anchor.nextSibling) rail.insertBefore(rb, anchor.nextSibling);
          else rail.insertBefore(rb, rail.firstChild);
        }
        function railCheck(){
          var hasRows = !!grid.querySelector('.strap-list-item, img');
          document.body.classList.toggle('sv-rail-loading', !hasRows);
          return hasRows;
        }
        if (!railCheck() && window.MutationObserver){
          var ro = new MutationObserver(function(){ if (railCheck()) ro.disconnect(); });
          ro.observe(grid, { childList: true });
          setTimeout(function(){ document.body.classList.remove('sv-rail-loading'); ro.disconnect(); }, 20000);
        }
      })();

      dock();
      setTimeout(dock, 900);   // 3.43.2: re-measure the spacer after the preview settles
      var svoRT;
      window.addEventListener('resize', function(){
        clearTimeout(svoRT); svoRT = setTimeout(dock, 150);
      }, { passive: true });

      /* ══ 3.45.0: DYNAMIC PREVIEW HEIGHT (mobile) ═══════════════════════════════
         Scrolling the product rail SHRINKS the preview so more straps fit on screen;
         selecting a strap (or a colour) GROWS it back to see the render; the pill on
         the divider drags it to any height, and that height is remembered as the
         "grown" size. Desktop is untouched (every path is gated on !isDesk()). */
      var svPhBig = 0; try { svPhBig = parseInt(localStorage.getItem('so_svPhBig2') || '0', 10) || 0; } catch (e) {}
      var svPhMode = 'big';
      function svPhClamp(px){
        return Math.max(110, Math.min(Math.round(window.innerHeight * 0.62), Math.round(px)));
      }
      // 3.66.1 (owner: "make it bigger"): flow resting height 38vh -> 46vh. Keep in step with the
      // --sv-ph rule in SVO_FLOW_CSS and the template. The stored drag height moved to a new key
      // so every phone starts from the new default once; a drag still overrides it afterwards.
      function svPhBigPx(){ return svPhClamp(svPhBig || window.innerHeight * (SV_MOBILE_FLOW ? 0.46 : 0.33)); }
      function svPhSmallPx(){ return svPhClamp(window.innerHeight * 0.16); }
      function svPhApply(px){
        document.body.style.setProperty('--sv-ph', px + 'px');
        clearTimeout(svPhApply._t);
        svPhApply._t = setTimeout(dock, 200);   // after the height transition settles
      }
      /* 3.47.0: the CANVAS renders at the BIG height and never follows the live viewport
         height - shrinking (auto or drag) only CROPS it, so nothing appears to zoom.
         ⚠ 3.49.0: it no longer re-fits when a DRAG sets a new big height either. Re-fitting
         on drag-end was the last path by which the divider changed the render's size, which
         is exactly what the divider must never do (owner, 22 Aug). The canvas size is fixed
         for the session and only re-derived on a real viewport change (rotate / resize);
         the zoom slider is the one control that scales the render. */
      function svCanvasApply(){
        document.body.style.setProperty('--sv-canvas-h', Math.max(100, svPhBigPx() - 6) + 'px');
      }
      svCanvasApply();
      window.addEventListener('orientationchange', function(){ setTimeout(svCanvasApply, 250); });
      function svPhSet(mode){
        if (isDesk()) return;
        svPhMode = mode;
        svPhApply(mode === 'small' ? svPhSmallPx() : svPhBigPx());
      }
      // scrolling the rail -> more room for products
      /* ⚠ the rail is its own scroll container on mobile (#strapsGrid overflow:auto) -
         the PAGE barely scrolls, so listen on the grid, with window as a fallback. */
      var svPhLastY = 0;
      function svPhOnScroll(y){
        if (isDesk() || SV_MOBILE_FLOW) return;   // 3.65.0: in flow mode scrolling IS the shrink
        if (y > svPhLastY + 8 && y > 40 && svPhMode !== 'small') svPhSet('small');
        svPhLastY = y;
      }
      grid.addEventListener('scroll', function(){ svPhOnScroll(grid.scrollTop); }, { passive: true });
      window.addEventListener('scroll', function(){ svPhOnScroll(window.scrollY); }, { passive: true });
      // picking a strap or a colour -> see the render (capture phase: swatch handlers
      // stopPropagation, and they are exactly the "picked a colour" case we want)
      grid.addEventListener('click', function(e){
        if (isDesk()) return;
        if (e.target && e.target.closest && e.target.closest('.strap-list-item')) svPhSet('big');
      }, true);
      // the divider handle
      (function(){
        if (!previewCol || document.getElementById('svPhHandle')) return;
        var h = document.createElement('button');
        h.type = 'button'; h.id = 'svPhHandle';
        h.setAttribute('aria-label', 'Drag to resize the preview');
        /* 3.46.0: up+down chevrons so the divider reads as adjustable */
        h.innerHTML = '<svg viewBox="0 0 14 8"><path d="M2 6l5-4 5 4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                      '<svg viewBox="0 0 14 8"><path d="M2 2l5 4 5-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        previewCol.appendChild(h);
        var dragging = false;
        h.addEventListener('pointerdown', function(e){
          if (isDesk()) return;
          dragging = true; try { h.setPointerCapture(e.pointerId); } catch (ec) {}
          document.body.classList.add('sv-ph-dragging');   // 3.47.0: no height transition mid-drag
          e.preventDefault();
        });
        /* ⚠ 3.49.0: move/up listen on DOCUMENT, not on the handle. setPointerCapture is
           wrapped in try/catch because it throws on synthetic pointers - when it threw, the
           handle stopped receiving pointermove the instant the finger left its 22px box, so
           the drag did nothing at all while drag-end still re-fitted the canvas. That pair of
           symptoms is exactly "the divider zooms but doesn't move the divider". */
        document.addEventListener('pointermove', function(e){
          if (!dragging) return;
          var vp2 = previewCol.querySelector('.preview-viewport');
          if (!vp2) return;
          var px = svPhClamp(e.clientY - vp2.getBoundingClientRect().top);
          document.body.style.setProperty('--sv-ph', px + 'px');
          svPublishPrevBot();   // the search row must follow the edge mid-drag, not at drag end
          e.preventDefault();
        }, { passive: false });
        function svPhDragEnd(){
          if (!dragging) return;
          dragging = false;
          var vp2 = previewCol.querySelector('.preview-viewport');
          var px = vp2 ? Math.round(vp2.getBoundingClientRect().height) : 0;
          document.body.classList.remove('sv-ph-dragging');
          // Remembered as the new "grown" height ONLY. No svCanvasApply() here: the render
          // must be the same size before and after a drag.
          if (px > 0){ svPhBig = px; try { localStorage.setItem('so_svPhBig2', String(px)); } catch (e2) {} svPhMode = 'big'; }
          dock();
        }
        document.addEventListener('pointerup', svPhDragEnd);
        document.addEventListener('pointercancel', svPhDragEnd);
      })();

      /* ══ 3.46.0: VERTICAL ZOOM SLIDER (mobile) ═════════════════════════════════
         Replaces the Zoom In button. Drives the existing inlineZoom scale directly;
         the thumb tracks resets (every strap change resets zoom to the mobile
         resting scale). Pan-when-zoomed is unchanged - drag the canvas itself. */
      (function(){
        var vpz = previewCol && previewCol.querySelector('.preview-viewport');
        if (!vpz || document.getElementById('svZoomBar')) return;
        var zbar = document.createElement('div');
        zbar.id = 'svZoomBar';
        zbar.innerHTML = '<div class="svz-track"></div><div class="svz-thumb"></div>';
        vpz.appendChild(zbar);
        var zthumb = zbar.querySelector('.svz-thumb');
        var ZMIN = 1.0, ZMAX = 3.2;
        function zNow(){ try { return inlineZoom.scale || 1; } catch (e) { return 1; } }
        function zPlace(){
          var f = (zNow() - ZMIN) / (ZMAX - ZMIN);
          f = Math.max(0, Math.min(1, f));
          zthumb.style.top = ((1 - f) * 100) + '%';
        }
        function zSet(f){
          var sc = ZMIN + Math.max(0, Math.min(1, f)) * (ZMAX - ZMIN);
          try {
            inlineZoom.mode = sc > inlineZoomDefault() + 0.01;
            inlineZoom.scale = sc;
            if (typeof clampInlineZoom === 'function') clampInlineZoom();
            if (typeof applyInlineZoom === 'function') applyInlineZoom();
          } catch (e) {}
          zPlace();
        }
        var zdrag = false;
        function zMove(e){
          var r = zbar.getBoundingClientRect();
          zSet(1 - (e.clientY - r.top) / r.height);
        }
        zbar.addEventListener('pointerdown', function(e){
          if (isDesk()) return;
          zdrag = true; try { zbar.setPointerCapture(e.pointerId); } catch (ec) {} zMove(e); e.preventDefault();
        });
        zbar.addEventListener('pointermove', function(e){ if (zdrag) zMove(e); });
        zbar.addEventListener('pointerup', function(){ zdrag = false; });
        zPlace();
        setInterval(zPlace, 800);   // follow the per-strap zoom resets
      })();

      var SVO_FLOW_CSS = '' +
      '#svJumpPill{display:none;}' +
      '@media (max-width:768px){' +
      'body.sv-onescreen.sv-mflow .container.sv-step-strap .final-image-container{ position:relative !important; top:auto !important; left:auto !important; right:auto !important; z-index:auto !important; transition:none !important; box-shadow:none !important; border-top:0 !important; border-left:0 !important; border-right:0 !important; padding-bottom:14px !important; }' +
      'body.sv-onescreen.sv-mflow .container.sv-step-strap{ padding-top:0 !important; padding-bottom:0 !important; }' +
      'body.sv-onescreen.sv-mflow{ --sv-ph:46vh; --sv-canvas-h:calc(46vh - 6px); }' +
      'body.sv-onescreen.sv-mflow .container.sv-step-strap .straps-grid{ max-height:none !important; min-height:0 !important; overflow:visible !important; overscroll-behavior:auto !important; }' +
      'body.sv-onescreen.sv-mflow .container.sv-step-strap .straps-container > .search-row{ position:sticky !important; top:var(--sv-prev-top,0px) !important; z-index:6 !important; background:var(--svm-surface,#fff) !important; transition:top .22s ease; }' +
      'body.sv-onescreen.sv-mflow #svJumpPill{ position:fixed; left:50%; bottom:calc(var(--sv-buy-h,140px) + 12px); transform:translate(-50%,8px); z-index:45; display:inline-flex; align-items:center; gap:7px; border:0; border-radius:999px; padding:10px 16px; background:#1d1d1d; color:#fff; font:700 12.5px/1 -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif; box-shadow:0 4px 14px rgba(0,0,0,.24); opacity:0; pointer-events:none; transition:opacity .18s ease,transform .18s ease; max-width:calc(100% - 32px); white-space:nowrap; cursor:pointer; }' +
      'body.sv-onescreen.sv-mflow #svJumpPill.sv-on{ opacity:1; pointer-events:auto; transform:translate(-50%,0); }' +
      'body.sv-onescreen.sv-mflow #svVersionTag{ left:4px; right:auto !important; bottom:calc(var(--sv-buy-h,0px) + 2px) !important; font-size:9px !important; opacity:.6; }' +
      /* 3.66.0 PEEK: fixed at the header line over the sticky search row (z 6); #svPeekPad
         holds the preview's grid cell meanwhile so the list does not jump (see svPeek). */
      'body.sv-onescreen.sv-mflow.sv-peek .container.sv-step-strap .final-image-container{ position:fixed !important; top:var(--sv-prev-top,0px) !important; left:0 !important; right:0 !important; width:auto !important; z-index:30 !important; background:var(--svm-surface,#fff) !important; box-shadow:0 8px 18px rgba(0,0,0,.16) !important; border-bottom:1px solid #e3ded4 !important; opacity:1; transition:opacity .24s ease !important; }' +
      /* 3.66.2: fade. A TRANSITION on opacity, never a keyframe (3.65.1). PEEK_FADE_MS in svPeek
         must match the .24s here. */
      'body.sv-onescreen.sv-mflow.sv-peek.sv-peek-hidden .container.sv-step-strap .final-image-container{ opacity:0 !important; }' +
      /* 3.66.3: the buy card fades with the render (sv-card-hidden is set in sync()); the pill
         drops to the bottom edge while the card is away. */
      'body.sv-onescreen.sv-mflow.sv-card-fade #strapDetails{ transition:opacity .24s ease !important; }' +
      'body.sv-onescreen.sv-mflow.sv-card-hidden #strapDetails{ opacity:0 !important; pointer-events:none !important; }' +
      'body.sv-onescreen.sv-mflow.sv-card-hidden #svJumpPill{ bottom:18px; }' +
      /* 3.94.4: the card is the selected row, continued - same beige + gold as .strap-list-item.selected.
         Mobile only (the card is fixed there). */
      '@media (max-width:768px){' +
      'body.sv-onescreen.sv-mflow .straps-container .strap-details{ background:#ece0c9 !important; border-top:2px solid #b2955f !important; box-shadow:0 -4px 16px rgba(0,0,0,.14), inset 0 1px 0 #b2955f !important; }' +
      'body.sv-onescreen.sv-mflow .straps-container .strap-details select{ background-color:#fff !important; }' +
      '}' +
      '}' +
      '@media (min-width:769px){ #svPhHandle{ display:none !important; } }';

      /* ══ 3.65.0: MOBILE FLOW LAYOUT ════════════════════════════════════════════════════
         The fixed preview + nested rail scroller left ONE strap row on screen at rest on a
         390x664 phone (preview 226 + chip 49 + search 47 + fixed buy card 123). Now the
         preview is in the document flow: scrolling the straps scrolls it away and the page is
         straps. Picking a strap (or a colour) scrolls the render back into view, and a pill
         offers "See it on your watch" while the preview is off-screen / "Back to your strap"
         after an auto-return. The auto-shrink (3.45.0) is off in this mode - scrolling IS the
         shrink - the divider handle still sets the resting height.
         Kill switch: SV_MOBILE_FLOW=false restores the 3.64.0 fixed layout. */
      /* 3.94.4 (owner): the buy card no longer fades out when the render scrolls away - a card that
         vanishes and returns as you scroll the rail was the "jumping around" that made it hard to
         tell which strap is selected. It now stays put, styled like the selected row and carrying
         its thumbnail. SV_CARD_FADE=true restores 3.66.3. */
      var SV_CARD_FADE = false;
      if (SV_MOBILE_FLOW) (function(){
        if (!document.getElementById('sv-mflow-css')){
          var fst = document.createElement('style');
          fst.id = 'sv-mflow-css';
          fst.textContent = SVO_FLOW_CSS;
          document.head.appendChild(fst);
        }
        document.body.classList.add('sv-card-fade');   // 3.66.3: arms the buy card's opacity transition
        var hdrEl = document.querySelector('.shopify-section--header');
        var pill = document.getElementById('svJumpPill');
        if (!pill){
          pill = document.createElement('button');
          pill.type = 'button'; pill.id = 'svJumpPill';
          pill.innerHTML = '<span class="sv-jp-arrow" aria-hidden="true"></span><span class="sv-jp-text"></span>';
          document.body.appendChild(pill);
        }
        var pillMode = '';
        var wantRow = false;   // set by an auto-return; cleared once the row has been on screen
        function hdrNow(){
          var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sv-prev-top'));
          return isFinite(v) ? v : (hdrEl ? hdrEl.offsetHeight : 0);
        }
        function buyH(){ return parseFloat(getComputedStyle(document.body).getPropertyValue('--sv-buy-h')) || 0; }
        function previewVisible(){
          if (!previewCol) return true;
          var r = previewCol.getBoundingClientRect();
          return r.bottom > hdrNow() + 72;   // a useful amount of the render, not a sliver
        }
        function selectedRow(){ var im = grid.querySelector('img.selected'); return im && im.closest('.strap-list-item'); }
        function rowVisible(row){
          if (!row) return true;
          var r = row.getBoundingClientRect();
          return r.top >= hdrNow() && r.bottom <= window.innerHeight - buyH();
        }
        function setPill(mode){
          if (mode === pillMode) return;
          pillMode = mode;
          var tx = pill.querySelector('.sv-jp-text'), ar = pill.querySelector('.sv-jp-arrow');
          if (mode === 'preview'){ tx.textContent = 'See it on your watch'; ar.textContent = '↑'; }
          else if (mode === 'row'){ tx.textContent = 'Back to your strap'; ar.textContent = '↓'; }
          pill.classList.toggle('sv-on', !!mode);
        }
        function toPreview(){
          var top = previewCol ? previewCol.getBoundingClientRect().top + window.scrollY - (hdrEl ? hdrEl.offsetHeight : 0) : 0;
          top = Math.max(0, Math.round(top));
          try { window.scrollTo({ top: top, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, top); }
        }
        function toRow(){
          var row = selectedRow(); if (!row) return;
          wantRow = false;
          try { row.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { row.scrollIntoView(); }
        }
        /* ══ 3.66.0 PEEK (owner: "keep it at the current location, then just show the
           visualiser part; when we scroll again, hide it again"). Picking a strap while the
           preview is off-screen no longer scrolls the page to the top. body.sv-peek makes the
           preview position:sticky at the header line, so it appears OVER the list right where
           the customer is - sticky keeps its in-flow slot, so nothing under the finger shifts.
           The next real scroll (>24px, after a 500ms grace for the address bar / the height
           transition) drops the class and the preview goes back to living at the top of the
           page, where the pill offers it again. SV_PEEK=false restores the 3.65.0 scroll. */
        var SV_PEEK = true;
        var peekY = 0, peekT = 0, peekPad = null;
        function peeking(){ return document.body.classList.contains('sv-peek'); }
        /* ⚠ position:fixed, NOT sticky: an ancestor in this theme is a scroll container
           (overflow-x hidden), so a sticky preview stayed at its in-flow slot 1300px above
           the viewport (measured on the staging theme). Fixed takes the preview out of flow,
           which would shift the list up by its height under the customer's finger - so a
           same-height pad takes its grid cell for the duration (same cell count, same gaps). */
        /* 3.66.2 (owner): the peek FADES in and out. body.sv-peek-hidden holds opacity 0; it is
           added with sv-peek and dropped a frame later (fade in, via the opacity transition on
           the preview - a transition, never a keyframe, see 3.65.1), and on dismiss it goes back
           on first and the fixed/pad teardown waits for the fade (PEEK_FADE_MS). A pick during a
           fade-out simply cancels it. */
        var PEEK_FADE_MS = 240, peekTimer = null;
        function svPeekTeardown(){
          var y = window.scrollY;
          document.body.classList.remove('sv-peek', 'sv-peek-hidden');
          if (peekPad && peekPad.parentNode) peekPad.parentNode.removeChild(peekPad);
          if (window.scrollY !== y) window.scrollTo(0, y);
          onScroll();
        }
        function svPeek(on){
          if (!SV_PEEK){ if (on) toPreview(); return; }
          // ⚠ Scroll anchoring sees the pad go in ABOVE the viewport and bumps scrollY by its
          // height, then the preview leaving the flow is not compensated - net effect on the
          // staging theme: the list jumped up 326px on every pick. The document is the same
          // height before and after, so simply pin scrollY back where it was.
          var y = window.scrollY;
          if (on){
            clearTimeout(peekTimer); peekTimer = null;
            if (peeking()){ document.body.classList.remove('sv-peek-hidden'); return; }   // cancels a fade-out
            var h = previewCol ? previewCol.getBoundingClientRect().height : 0;
            if (!peekPad){ peekPad = document.createElement('div'); peekPad.id = 'svPeekPad'; }
            peekPad.style.height = Math.round(h) + 'px';
            if (previewCol && previewCol.parentNode) previewCol.parentNode.insertBefore(peekPad, previewCol);
            peekY = y; peekT = Date.now();
            // ⚠ The hidden state must land WITHOUT a transition, or the opacity transition on
            // the peek rule animates 1 -> 0 first and the "fade in" reads as a dip. Inline
            // !important beats the stylesheet's !important; it comes off again a frame later,
            // in the same style change that drops the hidden class, so that one transitions.
            if (previewCol) previewCol.style.setProperty('transition', 'none', 'important');
            document.body.classList.add('sv-peek', 'sv-peek-hidden');
            if (previewCol) void previewCol.offsetWidth;   // commit opacity 0, no transition
            if (window.scrollY !== y) window.scrollTo(0, y);
            (typeof svRaf === 'function' ? svRaf : requestAnimationFrame)(function(){
              if (previewCol){ previewCol.style.removeProperty('transition'); void previewCol.offsetWidth; }
              document.body.classList.remove('sv-peek-hidden');
            });
          } else {
            if (!peeking() || peekTimer) return;   // not up, or already fading out
            document.body.classList.add('sv-peek-hidden');
            peekTimer = setTimeout(function(){ peekTimer = null; svPeekTeardown(); }, PEEK_FADE_MS);
          }
          onScroll();
        }
        function peekWatch(){
          if (!peeking()) return;
          if (isDesk() || !container.classList.contains('sv-step-strap') ||
              document.body.classList.contains('sv-watch-modal-open')) svPeek(false);
        }
        /* Dismissal keys off the CUSTOMER'S scroll gesture, never the scroll event: the engine
           scrolls the page itself right after a pick (svRevealRow brings the selected row into
           view, the buy card resizes), and a scrollY-delta test dismissed the peek ~1s after it
           appeared on the staging theme. A finger travelling >24px outside the preview, or a
           wheel tick, is what "scrolling again" means. Touches ON the preview (divider drag,
           pan of the zoomed render, realign) leave it alone. */
        var peekTouchY = null;
        document.addEventListener('touchstart', function(e){
          if (!peeking() || !e.touches || !e.touches[0]) return;
          peekTouchY = (previewCol && previewCol.contains(e.target)) ? null : e.touches[0].clientY;
        }, { passive: true });
        document.addEventListener('touchmove', function(e){
          if (!peeking() || peekTouchY === null || !e.touches || !e.touches[0]) return;
          if (Math.abs(e.touches[0].clientY - peekTouchY) > 24){ peekTouchY = null; svPeek(false); }
        }, { passive: true });
        document.addEventListener('wheel', function(e){
          if (!peeking() || (previewCol && previewCol.contains(e.target))) return;
          if (Math.abs(e.deltaY) > 4) svPeek(false);
        }, { passive: true });
        try { window.svPeek = svPeek; } catch (e) {}
        pill.addEventListener('click', function(){ if (pillMode === 'preview') svPeek(true); else if (pillMode === 'row') toRow(); });
        var tick = false;
        function sync(){
          tick = false;
          peekWatch();
          // 3.66.3 (owner): the buy card fades away with the render. Hidden whenever the
          // preview is off-screen (or fading out), back the moment it is on screen again -
          // at the top of the page, or peeked by a pick / the pill.
          // 3.66.4 (owner: "make the card come back when scrolling up to the preview"): the
          // card returns as soon as ANY of the preview is in the viewport (previewVisible's
          // 72px "useful amount" is the pill's threshold, too late for the card), and stays
          // while a peek is up or fading in.
          var _pr = previewCol ? previewCol.getBoundingClientRect() : null;
          var previewTouching = !_pr || (_pr.bottom > hdrNow() && _pr.top < window.innerHeight);
          var cardHide = SV_CARD_FADE && !isDesk() && container.classList.contains('sv-step-strap') &&
            !document.body.classList.contains('sv-watch-modal-open') &&
            (!previewTouching || (document.body.classList.contains('sv-peek-hidden') && peekTimer));
          document.body.classList.toggle('sv-card-hidden', cardHide);
          if (isDesk() || !container.classList.contains('sv-step-strap') ||
              document.body.classList.contains('sv-watch-modal-open')){ setPill(''); return; }
          if (!previewVisible()){ setPill('preview'); return; }
          var row = selectedRow();
          if (wantRow && row && !rowVisible(row)){ setPill('row'); return; }
          if (row && rowVisible(row)) wantRow = false;
          setPill('');
        }
        // svRaf, not bare rAF: a scroll that lands while the tab is hidden would otherwise leave
        // `tick` armed with a callback that never fires (see the svRaf note near the top).
        function onScroll(){ if (!tick){ tick = true; (typeof svRaf === 'function' ? svRaf : requestAnimationFrame)(sync); } }
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        if (window.MutationObserver){
          new MutationObserver(onScroll).observe(document.body, { attributes: true, attributeFilter: ['class'] });
        }
        // picking a strap or a colour brings the render back on screen (capture: swatch handlers
        // stopPropagation, and they are exactly the "picked a colour" case)
        grid.addEventListener('click', function(e){
          if (isDesk()) return;
          if (!(e.target && e.target.closest && e.target.closest('.strap-list-item'))) return;
          if (previewVisible()) return;
          // 3.66.0: peek the preview in place instead of scrolling to it. A peek that is
          // already up simply stays up (its grace timer is not restarted, so a scroll still
          // dismisses it); the old scroll-to-preview path lives on behind SV_PEEK=false.
          if (SV_PEEK){ svPeek(true); return; }
          wantRow = true;
          setTimeout(toPreview, 40);
          setTimeout(onScroll, 800);
        }, true);
        setTimeout(sync, 900);
      })();

      /* --- colour swatches on strap rows, thumbnails from variants / sibling products.
         The strip drives the row's existing colour <select> (value + change event), so
         every downstream path - setStrapGroupActive, the details-panel colour select,
         syncStrapThumb, the compositor - is the one that already existed. The dropdown
         is only hidden (CSS .sv-has-swatches) when a strip with >=2 DISTINCT thumbnails
         was actually built; rows whose colours all share one image keep the dropdown. --- */
      function swatchSrcsForSelect(sel, row){
        // Sibling-product group: option value = member product id, thumb = that member's cutout.
        if (!sel.classList.contains('sv-apple-colour-select')){
          var members = row._members || [];
          return Array.prototype.map.call(sel.options, function(o){
            var m = members.find(function(mm){ return String(mm.id) === String(o.value); });
            // cutout:true = tall transparent strap PNG; the swatch zooms it into the band.
            // oos: the whole sibling product is out of stock (3.94.1 - struck-through disc).
            var mv = (m && m.variants) || [];
            return { src: svProductImageSrc(m), cutout: true, oos: mv.length > 0 && !mv.some(function(v){ return v.availableForSale; }) };
          });
        }
        // Colour-as-variant: option value = colour value, thumb = that variant's visualiser image.
        // ⚠ The strap feed's processed variants carry NO selectedOptions - only a title like
        // "Black / QuickFit 20mm" - so the colour has to be parsed out of the title with the
        // slash-safe helper (a bare split(' / ') mis-splits values that contain " / ").
        var pid = sel.dataset.pid;
        var ci = parseInt(sel.dataset.ci, 10);
        var product = (typeof allStrapProducts !== 'undefined' ? allStrapProducts : [])
          .find(function(p){ return String(p.id) === String(pid); });
        if (!product || isNaN(ci)) return [];
        var pOpts = product.options || [];
        return Array.prototype.map.call(sel.options, function(o){
          var vs = (product.variants || []).filter(function(vv){
            try {
              return parseVariantOptionValues(vv.title || '', pOpts)[ci] === o.value;
            } catch (e) { return false; }
          });
          var v = vs[0];
          if (!v) return { src: '', cutout: false };
          // 3.94.1: a colour is out of stock only when NONE of its sizes can be bought.
          var oos = !vs.some(function(vv){ return vv.availableForSale; });
          // Prefer the variant's own featured image - the SAME swatch photo the product page
          // shows for that colour (per user, matching the Apple Sports Loop's PDP swatches).
          // The visualiser cutout is the fallback: on Apple products parentImages contains ONLY
          // cutouts, and a tall transparent cutout cropped into a 26px circle reads muddy.
          if (v.image) return { src: v.image, cutout: false, oos: oos };
          return {
            src: (typeof variantVisualiserSrc === 'function' ? variantVisualiserSrc(product, v) : '') || '',
            cutout: true, oos: oos
          };
        });
      }
      function syncStrip(strip, sel){
        strip.querySelectorAll('.sv-swatch').forEach(function(b){
          b.setAttribute('aria-pressed', b.dataset.v === sel.value ? 'true' : 'false');
        });
      }

      /* --- solid colour discs (3.8.0, per user: no thumbnails in the swatch).
         Products carry no hex, so the disc colour is SAMPLED from the colour's image:
         ignore transparent + near-white pixels, quantize the rest to 4-bit bins, take
         the modal bin's average. Cached per src; filled lazily as strips scroll in. --- */
      var svoColourCache = {};
      function svoDiscColour(src, cb){
        var hit = svoColourCache[src];
        if (typeof hit === 'string'){ cb(hit); return; }
        if (hit && hit.push){ hit.push(cb); return; }
        svoColourCache[src] = [cb];
        var im = new Image();
        im.crossOrigin = 'anonymous';
        var settle = function(colour){
          var subs = svoColourCache[src];
          svoColourCache[src] = colour;
          (subs || []).forEach(function(f){ try { f(colour); } catch (e) {} });
        };
        im.onload = function(){
          try {
            var cv = document.createElement('canvas');
            cv.width = 32; cv.height = 32;
            var cx = cv.getContext('2d');
            cx.drawImage(im, 0, 0, 32, 32);
            var d = cx.getImageData(0, 0, 32, 32).data;
            var bins = {}, best = null, bestN = 0;
            for (var i = 0; i < d.length; i += 4){
              var rr = d[i], gg = d[i+1], bb = d[i+2], aa = d[i+3];
              if (aa < 128) continue;
              if (rr > 242 && gg > 242 && bb > 242) continue;   // white studio background
              var k = ((rr >> 4) << 8) | ((gg >> 4) << 4) | (bb >> 4);
              var e = bins[k] || (bins[k] = { n: 0, r: 0, g: 0, b: 0 });
              e.n++; e.r += rr; e.g += gg; e.b += bb;
              if (e.n > bestN){ bestN = e.n; best = e; }
            }
            if (!best || bestN < 12){ settle('#C9C4BA'); return; }
            // Among the big clusters, prefer the most SATURATED one: on a dark strap the
            // modal bin is often a grey shadow while the true colour sits just behind it.
            var bestScore = -1;
            for (var bk in bins){
              var e2 = bins[bk];
              if (e2.n < bestN * 0.35) continue;
              var r5 = e2.r/e2.n, g5 = e2.g/e2.n, b5 = e2.b/e2.n;
              var sat5 = (Math.max(r5,g5,b5) - Math.min(r5,g5,b5)) / Math.max(1, Math.max(r5,g5,b5));
              var score = sat5 + e2.n / (bestN * 8);
              if (score > bestScore){ bestScore = score; best = e2; }
            }
            // DISPLAY remap: photo-accurate colours collapse together in the dark end
            // (navy vs black both read near-black at 24px). Lift lightness into a
            // visible band and boost saturation so the hue shows; a truly neutral
            // black stays a neutral dark grey.
            var rr2 = best.r/best.n/255, gg2 = best.g/best.n/255, bb2 = best.b/best.n/255;
            var mx = Math.max(rr2, gg2, bb2), mn = Math.min(rr2, gg2, bb2);
            var l = (mx + mn) / 2, d2 = mx - mn;
            var s2 = d2 === 0 ? 0 : d2 / (1 - Math.abs(2*l - 1));
            var hh = 0;
            if (d2 !== 0){
              if (mx === rr2) hh = ((gg2 - bb2) / d2) % 6;
              else if (mx === gg2) hh = (bb2 - rr2) / d2 + 2;
              else hh = (rr2 - gg2) / d2 + 4;
              hh = (hh * 60 + 360) % 360;
            }
            var lD = 0.18 + l * 0.72;
            var sD = Math.min(1, s2 * 1.35 + 0.04);
            var c2 = (1 - Math.abs(2*lD - 1)) * sD;
            var x2 = c2 * (1 - Math.abs((hh / 60) % 2 - 1));
            var m2 = lD - c2/2;
            var rgb = hh < 60 ? [c2,x2,0] : hh < 120 ? [x2,c2,0] : hh < 180 ? [0,c2,x2]
                    : hh < 240 ? [0,x2,c2] : hh < 300 ? [x2,0,c2] : [c2,0,x2];
            settle('rgb(' + rgb.map(function(v){ return Math.round((v + m2) * 255); }).join(',') + ')');
          } catch (e) { settle('#C9C4BA'); }   // CORS-tainted canvas etc.
        };
        im.onerror = function(){ settle('#C9C4BA'); };
        im.src = (typeof cdnSized === 'function') ? cdnSized(src, 96) : src;
      }
      /* Stitching variants: "Black | White Stitching", "Brown with Red Stitching" - 
         a dotted inner ring in the STITCH colour distinguishes them from the plain disc. */
      var SVO_STITCH_MAP = {
        white:'#ffffff', black:'#1c1b18', red:'#c0392b', orange:'#e67e22', yellow:'#f1c40f',
        blue:'#2e6bb5', navy:'#2b3a56', green:'#2e7d5b', grey:'#9a9a94', gray:'#9a9a94',
        cream:'#efe6d2', beige:'#d8c6a6', brown:'#7a4a2b', pink:'#e290b0', purple:'#8e6bb5', tan:'#b98a5a'
      };
      function svoApplyStitch(el, name){
        var m = /([a-z ]+?)\s+stitch(?:ing|ed)?\b/i.exec(name || '');
        if (!m){ el.classList.remove('sv-stitched'); return; }
        var words = m[1].trim().toLowerCase();
        if (/tone on tone|matching|self/.test(words)){ el.classList.remove('sv-stitched'); return; }
        var c = SVO_STITCH_MAP[words] || SVO_STITCH_MAP[words.split(' ').pop()];
        if (!c){ el.classList.remove('sv-stitched'); return; }
        el.classList.add('sv-stitched');
        el.style.setProperty('--sv-stitch', c);
      }
      /* Named METAL overrides (3.39.0). Image sampling reads a metal's shadows, so a Gold
         bracelet's disc came out grey-brown (worst when the sampled image is an old watch
         PHOTO rather than a cutout - QR Link Bracelet). Metals have a canonical colour a
         customer expects on the chip, so exact label matches take a fixed hex and skip
         sampling. Exact match ONLY - "Champagne Gold", "Black / Gold" etc still sample. */
      var SVO_METAL_DISC = {
        'gold': '#D4A937',
        'rose gold': '#BA9181',
        'silver': '#C9CBCD'
      };
      function svoMetalDisc(label){
        return SVO_METAL_DISC[String(label || '').trim().toLowerCase()] || null;
      }
      /* PER-PRODUCT disc exceptions (3.60.4). The named maps above are shop-wide, which is
         right when every product's photo of a finish looks the same - but the QuickFit Titanium
         Featherlight Milanese keeps its ORIGINAL pale rose gold photo (owner preferred it to the
         re-toned one), so the shop-wide #BA9181 chip read noticeably deeper than its own strap.
         The hex here is that image's measured median. Add an entry only when a product's photo
         legitimately differs from the range - not to paper over an image that should be fixed. */
      var SVO_DISC_BY_PRODUCT = {
        '8029032939594': { 'rose gold': '#F8C5AC' }   // [QuickFit] Titanium Featherlight Milanese
      };
      function svoProductDisc(pid, label){
        var m = SVO_DISC_BY_PRODUCT[String(pid || '')];
        return (m && m[String(label || '').trim().toLowerCase()]) || null;
      }
      /* Metal FINISH overrides (3.60.0) - the rest of the metal palette. Kept SEPARATE from
         SVO_METAL_DISC because these labels ("Black", "Grey", "Starlight") are also used by
         leather, silicone and nylon rows, where sampling the photo is the right answer. They
         apply only when the row is a metal one, and the row is judged by its PRODUCT TITLE:
         `visualiser_product_sub_category` would be the tidy lever but it is not populated on
         every metal product (the owner's own example, [Quick Release] Titanium Bracelet 2
         [22mm], has none), so a category test would silently skip exactly the rows reported. */
      var SVO_METAL_FINISH = {
        'black': '#2E2E30',
        'gun metal grey': '#55595E',
        'gunmetal grey': '#55595E',
        'gun metal': '#55595E',
        'dark gun metal grey': '#44474B',
        'dark grey': '#5C6064',
        'grey': '#8B8F93',
        'light grey': '#B7BBBE',
        'titanium': '#B4B7B8',
        'starlight': '#E4DFD6',
        'starlight silver': '#E4DFD6',
        'champagne gold': '#D9C089',
        'navy blue': '#2C3A55',
        'night blue': '#2C3A55',
        'white': '#EDEBE6'
      };
      /* Metal by NAME. The exclusion list runs first so "Vogue Leather Link", "Ceramic
         Bracelet" and the Acetate Bangles keep their sampled discs. */
      var SVO_METAL_TITLE_RE = /\b(bracelet|milanese|mesh|jubilee|engineer|oyster|link)\b/i;
      var SVO_NOT_METAL_RE   = /leather|nylon|silicone|rubber|fabric|nato|canvas|resin|acetate|woven|ceramic|velcro|sailcloth|elastic|perlon/i;
      function svoIsMetalRow(title){
        var t = String(title || '');
        return SVO_METAL_TITLE_RE.test(t) && !SVO_NOT_METAL_RE.test(t);
      }
      function svoMetalFinish(label){
        return SVO_METAL_FINISH[String(label || '').trim().toLowerCase()] || null;
      }
      function svoFillStrip(strip){
        if (strip.dataset.svoFilled) return;
        strip.dataset.svoFilled = '1';
        var isMetal = strip.dataset.svMetal === '1';
        var pid = strip.dataset.svPid || '';
        var pending = 0;
        var done = function(){ if (--pending <= 0) svoJudgeStrip(strip); };
        strip.querySelectorAll('.sv-swatch[data-src]').forEach(function(b){
          var fixed = svoProductDisc(pid, b.title) || svoMetalDisc(b.title) ||
            (isMetal ? svoMetalFinish(b.title) : null);
          if (fixed){ b.style.background = fixed; return; }
          pending++;
          svoDiscColour(b.dataset.src, function(colour){ b.style.background = colour; b.dataset.svSampled = '1'; done(); });
        });
        if (pending === 0) svoJudgeStrip(strip);
      }
      /* 3.94.3 (owner): "the swatch is showing grey for colours that have no match - should just be a
         dropdown". A disc can only stand in for a colour when the sampler FOUND one and it can be told
         from its neighbours. A pearl acetate is near-white all over (the sampler's white guard leaves
         a few grey pixels: three identical beige discs for Blue / Jade / White Pearl); a photo the
         sampler gave up on gets the #C9C4BA fallback. Either way the strip says nothing, so the row
         goes back to its colour dropdown, which names the colours. Judged once, after every disc has
         settled; hand-set palettes (metal finishes, product exceptions) never trip it. */
      function svoParseRgb(str){
        var m = /rgb\((\d+),\s*(\d+),\s*(\d+)/.exec(str || '');
        if (m) return [+m[1], +m[2], +m[3]];
        m = /^#([0-9a-f]{6})$/i.exec((str || '').trim());
        if (m) return [parseInt(m[1].slice(0,2),16), parseInt(m[1].slice(2,4),16), parseInt(m[1].slice(4,6),16)];
        return null;
      }
      function svoJudgeStrip(strip){
        var bs = Array.prototype.slice.call(strip.querySelectorAll('.sv-swatch[data-sv-sampled]'));
        if (!bs.length) return;
        var bad = false, why = '', cols = [];
        bs.forEach(function(b){
          var c = svoParseRgb(b.style.background);
          if (!c) { bad = true; why = 'unparsed:' + b.title; return; }
          if (c[0] === 201 && c[1] === 196 && c[2] === 186) { bad = true; why = 'fallback:' + b.title; }   // sampler gave up (#C9C4BA)
          cols.push(c);
        });
        if (!bad) {
          // Two PLAIN discs the customer could not tell apart. A stitched twin ("Black | White
          // Stitching") shares its base colour on purpose - the dotted ring is the difference.
          var plain = Array.prototype.slice.call(strip.querySelectorAll('.sv-swatch:not(.sv-stitched)'))
            .map(function(b){ return svoParseRgb(b.style.background); }).filter(Boolean);
          for (var i = 0; i < plain.length && !bad; i++) for (var j = i + 1; j < plain.length; j++) {
            var dd = Math.abs(plain[i][0]-plain[j][0]) + Math.abs(plain[i][1]-plain[j][1]) + Math.abs(plain[i][2]-plain[j][2]);
            if (dd < 24) { bad = true; why = 'twins:' + plain[i].join() + '/' + plain[j].join(); break; }
          }
        }
        if (!bad) return;
        var rowT = (strip.closest('.strap-list-item') || {}).querySelector ? (strip.closest('.strap-list-item').querySelector('.strap-list-title') || {}).textContent : '';
        window.__svTrace && window.__svTrace.push('swatch:dropdown-fallback:' + String(rowT || '').trim().slice(0, 30) + ':' + why);
        var wrap = strip.parentElement;
        if (wrap) wrap.classList.remove('sv-has-swatches');
        var row = strip.closest('.strap-list-item');
        if (row) row.classList.remove('sv-strip-2row');
        strip.remove();
      }
      var svoStripIO = window.IntersectionObserver ? new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if (en.isIntersecting){ svoFillStrip(en.target); svoStripIO.unobserve(en.target); }
        });
      }, { rootMargin: '200px' }) : null;
      var svoFillCount = 0;
      // Products whose colour dropdown is forced (style+colour composite names).
      // ⚠ Do NOT replace this with a "name contains /" heuristic: two-colour straps
      // (Sports Silicone "Black / Grey" etc., 14 rows measured 2026-08-16) genuinely
      // want swatch discs. This list is for names where the slash part is HARDWARE
      // or STYLE, which a disc cannot express (owner calls).
      var SVO_DD_PRODUCT_IDS = new Set([
        '7058233229386',   // [Apple Watch] Vogue Leather Link ("Black Alligator" vs "Black Lizard")
        // Acetate Bangles, "<colour> / Rose Gold" colour+hardware composites (owner, 2026-08-16):
        '7417186648138', '7417187926090', '7417215352906',   // [Apple Watch] Jade / Blue / White
        '7741030989898', '7741031415882', '7741034037322',   // [Quick Release] Jade / Blue / White
        // "Silver / Rose Gold" metal composite (owner, 2026-08-17). Scanned the whole feed:
        // this and the bangles are the ONLY metal/hardware-composite colour rows.
        '7406831009866',   // [Quick Release] Vintage Tapered Bracelet
        // Metal/material composites swept from the whole feed 2026-08-30 (owner call).
        // The slash separates METAL from the OTHER MATERIAL (ceramic link, acetate) or
        // from a second FINISH - one disc cannot say "silver metal + white ceramic".
        // A rail group is ONE control, so a family flips whole: the outright single
        // colours in these groups (plain Gold, Rose Gold...) go to the dropdown too.
        // ⚠ strap_type is what separates these from the 55 Militex/ElastoFlex and 9
        // silicone/nylon two-tones that KEEP their discs - NOT the slash.
        '7485867655242', '7485956948042', '6722119401546',   // Ceramic Bracelet Gold/Black, Gold/White, RoseGold/Black
        '6722120777802', '6722120253514',                    // Ceramic Bracelet Silver/Black, Silver/White
        '6585556402250', '6539850285130', '6539849564234',   // Jubilee Silver/Black, Silver/Gold, Silver/RoseGold
        '8199221280842', '8199226982474', '8199229210698',   // Steel Deployant Black/Gold, Black/RoseGold, Black/Silver
        '8199249723466', '8199248642122', '8199236878410',   // Steel Deployant RoseGold/White, Silver/Black, Silver/Gold
        '8199248478282', '8199249068106', '7451732475978',   // Steel Deployant Silver/RoseGold, Silver/White, Clasp 2 Black/Gold
        '6970988822602',   // [Quick Release] Zirconia Shimmer Bracelet ("Silver / Rose Gold" metal composite)
        '6983352909898',   // [Quick Release] Sparkle Hybrid (metal-named colours on a silicone strap, owner call)
        // Trail Loop (owner, 2026-08-30). ⚠ This REVERSES the 3.62.0 call that kept the 9
        // silicone/nylon two-tones on discs - Trail Loop is now the exception to that. Its
        // colours are woven multi-tone names ("Yellow / Beige", "Green / Orange", "Rainbow",
        // "Pastel Rainbow", "Striped Pink") that a single disc cannot express. All three rows
        // that can surface in the visualiser are listed; an id not in the feed is simply inert.
        '7211041980490',   // [Quick Release] Trail Loop  (the row reported)
        '7022349811786',   // [Apple Watch] Trail Loop    (Apple feed, same strap + swatch code)
        '8386494103626'    // [QuickFit] Trail Loop
      ]);
      /* A colour pick (swatch or dropdown) rewrites the row's img src, and rows stream in
         lazily, so the rebuild has to re-run on every src change - not just at build time. */
      (function svThumbWatch(){
        if (!grid || grid.__svThumbObs) return;
        grid.__svThumbObs = new MutationObserver(function(muts){
          muts.forEach(function(m){
            if (m.type === 'attributes' && m.target && m.target.tagName === 'IMG'){
              if (typeof svThumbSideBySide === 'function') svThumbSideBySide(m.target);
            } else if (m.type === 'childList'){
              (m.addedNodes || []).forEach(function(n){
                if (n.querySelectorAll) n.querySelectorAll('img').forEach(function(i){
                  if (typeof svThumbSideBySide === 'function') svThumbSideBySide(i);
                });
              });
            }
          });
        });
        grid.__svThumbObs.observe(grid, { subtree:true, childList:true, attributes:true, attributeFilter:['src'] });
      })();
      function buildRowSwatches(){
        grid.querySelectorAll('.strap-list-item').forEach(function(row){
          // Every row's thumbnail gets the chip treatment (wrap + zoom-crop via CSS),
          // whether or not the row earns a swatch strip below.
          var rowImg = row.querySelector(':scope > img');
          if (rowImg && !rowImg.closest('.sv-thumbwrap')){
            var tw = document.createElement('div');
            tw.className = 'sv-thumbwrap';
            row.insertBefore(tw, rowImg);
            tw.appendChild(rowImg);
          }
          if (!rowImg) rowImg = row.querySelector('.sv-thumbwrap img');
          if (rowImg && typeof svThumbSideBySide === 'function') svThumbSideBySide(rowImg);
          // Rows historically render at EXACTLY min-height and clip anything taller (the
          // blocker lives in an opaque external sheet) - an inline !important is the one
          // thing that always wins, and a 2-row wrapped swatch strip needs the room.
          row.style.setProperty('height', 'auto', 'important');
          var sel = row.querySelector('select.strap-colour-select:not(.sv-row-opt-select)');
          if (!sel) return;
          var wrap = sel.closest('.strap-row-optwrap');
          if (!wrap || wrap.querySelector('.sv-swatches')) return;
          var srcs = swatchSrcsForSelect(sel, row);
          if (!srcs.length) return;
          // The strip replaces the dropdown ONLY when EVERY colour has its own usable
          // thumbnail (a colour without one would render as a blank circle) AND at least
          // two are distinct. Anything less keeps the dropdown - per user, especially
          // on rows that already carry a second option dropdown.
          if (!srcs.every(function(s){ return !!s.src; })) return;
          var distinct = {};
          srcs.forEach(function(s){ distinct[s.src] = 1; });
          if (Object.keys(distinct).length < 2) return;
          // MANY colours (more than two wrapped rows' worth, e.g. Sports Loop's 49):
          // keep a PLAIN DROPDOWN. It used to carry a live disc of the current colour inside
          // its left edge plus colour-tinted option backgrounds; both were REMOVED at the
          // owner's request 2026-08-15. Leave the select exactly as the engine built it.
          // ⚠ svoDiscColour / svoApplyStitch are still used by the swatch STRIP below - this
          // only drops dd-mode's swatches, not the strip's.
          // Also forced for products whose colour names are STYLE+colour composites
          // ("Black Alligator" vs "Black Lizard") - near-identical discs lose the
          // style information (owner call, Vogue Leather Link 2026-08-16).
          // Colour-as-variant rows carry the product id on the select; sibling-product
          // group rows (the Acetate Bangles) carry the MEMBER product ids as option
          // values - match either shape.
          var svoForceDD = SVO_DD_PRODUCT_IDS.has(String(sel.dataset.pid || '')) ||
            Array.prototype.some.call(sel.options, function(o){
              return SVO_DD_PRODUCT_IDS.has(String(o.value));
            });
          if (sel.options.length > 16 || svoForceDD){
            return;
          }
          var strip = document.createElement('div');
          strip.className = 'sv-swatches';
          /* Metal rows take the fixed FINISH palette instead of sampled discs (3.60.0).
             Judge by the PRODUCT title, not the row's textContent - the row text also
             carries the colour VALUES, and a value like "Black Leather" would read as
             a non-metal row and put the sampled disc back. */
          /* The row's THUMBNAIL carries the product title in data-title, and it is the only
             source present for every row shape - the allStrapProducts lookup came back
             undefined for the sibling-group rows (3.60.0 shipped with the flag never set). */
          var svMetalImg = row.querySelector('img[data-title]');
          var svMetalProd = (typeof allStrapProducts !== 'undefined' ? allStrapProducts : [])
            .find(function(p){ return String(p.id) === String(sel.dataset.pid || ''); });
          var svMetalTitle = (svMetalImg && svMetalImg.getAttribute('data-title')) ||
            (svMetalProd && svMetalProd.title) ||
            ((row._members || [])[0] || {}).title || '';
          if (svoIsMetalRow(svMetalTitle)) strip.dataset.svMetal = '1';
          if (sel.dataset.pid) strip.dataset.svPid = String(sel.dataset.pid);
          Array.prototype.forEach.call(sel.options, function(o, i){
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'sv-swatch';
            b.title = o.textContent;
            b.setAttribute('aria-label', o.textContent);
            b.dataset.v = o.value;
            b.dataset.src = srcs[i].src;   // sampled into a solid disc colour by svoFillStrip
            b.setAttribute('aria-pressed', o.value === sel.value ? 'true' : 'false');
            if (srcs[i].oos) {   // 3.94.1: struck through, still selectable (the card says Out of Stock)
              b.classList.add('sv-sw-oos');
              b.title = o.textContent + ' (out of stock)';
              b.setAttribute('aria-label', b.title);
            }
            svoApplyStitch(b, o.textContent);
            b.addEventListener('click', function(e){
              e.stopPropagation();
              if (sel.value !== b.dataset.v){
                sel.value = b.dataset.v;
                sel.dispatchEvent(new Event('change'));
              } else {
                row.click();   // same colour: just select the row/strap
              }
              syncStrip(strip, sel);
            });
            strip.appendChild(b);
          });
          wrap.appendChild(strip);
          wrap.classList.add('sv-has-swatches');
          row.classList.toggle('sv-strip-2row', sel.options.length > 6);
          sel.addEventListener('change', function(){ syncStrip(strip, sel); });
          // Fill discs when the strip nears the viewport; the first few fill at once so
          // the top of the list is coloured immediately (and IO never fires in hidden tabs).
          svoFillCount++;
          if (svoFillCount <= 12 || !svoStripIO) svoFillStrip(strip);
          else svoStripIO.observe(strip);
          // EXPAND the row to its real content height (a wrapped strip needs it).
          // Measured repeatedly after layout settles - a single immediate measure ran
          // before the grid was laid out and read 0, which left rows clipped.
          [60, 400, 1500].forEach(function(t){
            setTimeout(function(){
              if (row.clientHeight > 0 && row.scrollHeight > row.clientHeight + 2){
                row.style.setProperty('min-height', (row.scrollHeight + 8) + 'px', 'important');
              }
            }, t);
          });
        });
      }
      function syncAllStrips(){
        grid.querySelectorAll('.strap-row-optwrap.sv-has-swatches').forEach(function(wrap){
          var sel = wrap.querySelector('select.strap-colour-select');
          var strip = wrap.querySelector('.sv-swatches');
          if (sel && strip) syncStrip(strip, sel);
        });
      }
      // Rows re-render on every filter pass / view switch / lazy-load - rebuild then.
      // ⚠ setTimeout, NOT requestAnimationFrame: rAF never fires in a hidden tab, so an
      // rAF-throttled rebuild silently never runs there (bit us in the hidden Browser pane).
      var svoSwTimer = null;
      if (window.MutationObserver){
        new MutationObserver(function(){
          if (svoSwTimer) return;
          svoSwTimer = setTimeout(function(){ svoSwTimer = null; buildRowSwatches(); }, 60);
        }).observe(grid, { childList: true });
      }
      // The details panel's colour select moves the row select PROGRAMMATICALLY (no change
      // event - see syncStrapThumb), so resync pressed states after any details option change.
      document.addEventListener('change', function(e){
        if (e.target && e.target.classList && e.target.classList.contains('option-select')){
          setTimeout(syncAllStrips, 0);
        }
      }, true);
      buildRowSwatches();

      /* --- the buy panel's COLOUR control duplicates the row swatches. Per user: when the
         selected strap's row has a swatch strip, hide the panel's colour dropdown(s); a row
         WITHOUT swatches keeps its dropdowns. The selects stay in the DOM (hidden) because
         the swatch clicks drive them. --- */
      function dedupDetailsColour(){
        if (!details) return;
        var selImg = grid.querySelector('img.selected');
        var row = selImg && selImg.closest('.strap-list-item');
        // Per user (2026-08-16): the buy card shows EVERY variant dropdown (colour,
        // stitching, length, ...) beside Strap Width - the earlier colour-hiding
        // dedupe is retired. The classes are cleared, never set.
        details.classList.remove('sv-dedup-colour');
        Array.prototype.forEach.call(
          details.querySelectorAll('.sv-hide-colour-dd'),
          function(el){ el.classList.remove('sv-hide-colour-dd'); });
        var has = false;
        var cardHasColourDD = !!Array.prototype.find.call(
          details.querySelectorAll('#optionDropdownsContainer select.option-select'),
          function(s){ return /colou?r/i.test(s.dataset.optionName || ''); }) ||
          !!details.querySelector('#strapColourPicker select');
        // The price lives in the title row (it replaced the View Product link) and
        // drops the engine's "Price: " prefix. Idempotent, so the observer re-running
        // over its own writes settles immediately.
        var priceEl = document.getElementById('strapPrice');
        var titleRow = details.querySelector('.product-title-container');
        if (priceEl && titleRow && priceEl.parentElement !== titleRow) titleRow.appendChild(priceEl);
        var pLink = document.getElementById('productPageLink');
        if (pLink && pLink.textContent !== '→') pLink.textContent = '→';
        // (3.94.5: the 3.94.4 card thumbnail was removed at the owner's request - "I never asked for it")
        // Collapsing buy card: the chevron lives in the title row. Injected once and
        // idempotent, so the observer re-running over its own writes settles. The card
        // starts COLLAPSED on every strap change - the dropdowns are opt-in, which is
        // what buys the strap list its space back. CSS hides the button above 768px.
        if (titleRow && !document.getElementById('svBuyToggle')){
          var svBt = document.createElement('button');
          svBt.type = 'button';
          svBt.id = 'svBuyToggle';
          svBt.setAttribute('aria-expanded', 'false');
          svBt.setAttribute('aria-label', 'Show colour and size options');
          svBt.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
            '<path d="M3 6l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2" ' +
            'stroke-linecap="round" stroke-linejoin="round"/></svg>';
          svBt.addEventListener('click', function(ev){
            ev.preventDefault();
            ev.stopPropagation();
            var open = details.classList.toggle('sv-buy-open');
            svBt.setAttribute('aria-expanded', open ? 'true' : 'false');
            svBt.setAttribute('aria-label', open
              ? 'Hide colour and size options'
              : 'Show colour and size options');
          });
          titleRow.appendChild(svBt);
        }
        // Sibling-colour products render their colour select in #strapColourPicker,
        // outside the options row - dock it into the form beside the width dropdown.
        var svoCp = document.getElementById('strapColourPicker');
        var svoForm = document.getElementById('addToCartForm');
        var svoOdc = document.getElementById('optionDropdownsContainer');
        if (svoCp && svoForm && svoOdc && svoCp.parentElement !== svoForm){
          svoForm.insertBefore(svoCp, svoOdc);
        }
        if (priceEl && /^Price:\s*/.test(priceEl.textContent)){
          priceEl.textContent = priceEl.textContent.replace(/^Price:\s*/, '');
        }
        // Colour name in the card (the dropdown is hidden when the row has swatches)
        var colourName = '';
        var rowSel = row && row.querySelector('select.strap-colour-select:not(.sv-row-opt-select)');
        if (rowSel){
          var ro = rowSel.options[rowSel.selectedIndex];
          colourName = ro ? ro.textContent : '';
        }
        var cEl = document.getElementById('svBuyColour');
        if (!cEl && titleRow){
          cEl = document.createElement('div');
          cEl.id = 'svBuyColour';
          cEl.className = 'sv-buy-colour';
          titleRow.parentElement.insertBefore(cEl, titleRow.nextSibling);
        }
        if (cEl){
          cEl.textContent = '';
          if (colourName && !cardHasColourDD){
            cEl.append('Colour: ');
            var bb = document.createElement('b');
            bb.textContent = colourName;
            cEl.append(bb);
          }
        }
      }
      // The details panel rebuilds its dropdowns on every selection - re-apply then.
      if (window.MutationObserver && details){
        var svoDedupT = null;
        new MutationObserver(function(){
          if (svoDedupT) return;
          svoDedupT = setTimeout(function(){ svoDedupT = null; dedupDetailsColour(); }, 40);
        }).observe(details, { childList: true, subtree: true });
      }
      dedupDetailsColour();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', svOneInit);
    else svOneInit();
  })();

/* =====================================================================================
     SECTION 14 - USAGE TELEMETRY (added 2.15.0)
     -------------------------------------------------------------------------------------
     Shopify Analytics can only count sessions that LAND on /pages/strapvisualiser. Anyone who
     arrives on the homepage and opens the visualiser afterwards is invisible to it, so the
     store's own number is a floor of unknown tightness. This reports the real one.

     Contract, copied from the megamenu tracker that has been live since v1.386: buffer a few
     events, flush once with sendBeacon on page hide, never block or break the page. EVERY entry
     point is wrapped - telemetry failing must not cost a shopper their preview.

     Owner exclusion: load any visualiser URL with ?sv_staff=1 to mark this browser permanently
     (?sv_staff=0 clears it). Marked events are still SENT and stored, just filtered out of the
     report - a silent drop would be unauditable.

     ⚠ Observers here are debounced with setTimeout, NOT requestAnimationFrame: rAF never fires
     in a background/hidden tab, which is exactly when we still want the flush to have happened.
     ===================================================================================== */
  (function svTelemetry() {
    const SV_TRACK = true;                       // kill switch
    const ENDPOINT = 'https://crm.strapify.com.au/api/v1/visualiser/track';
    const SURFACE = 'page';                      // this asset only runs on the standalone page
    const MAX_EVENTS = 40;                       // server caps at 40 too; stop buffering past it

    if (!SV_TRACK) return;

    let queue = [];
    let sent = false;
    let sessionId = '';
    let staff = false;

    try {
      // Session id: per page load, random, no cookie. sessionStorage so a reload starts a new
      // visit (which is what "how many visits" should mean).
      sessionId = sessionStorage.getItem('sv_tel_sid') || '';
      if (!sessionId) {
        sessionId = 'sv' + Math.random().toString(36).slice(2) + Date.now().toString(36);
        sessionStorage.setItem('sv_tel_sid', sessionId);
      }
      const q = new URLSearchParams(location.search).get('sv_staff');
      if (q === '1') localStorage.setItem('sv_staff', '1');
      if (q === '0') localStorage.removeItem('sv_staff');
      staff = localStorage.getItem('sv_staff') === '1';
    } catch (_) { /* private mode / storage disabled - carry on unsessioned */ }

    if (!sessionId) return;

    function push(event, extra) {
      try {
        if (queue.length >= MAX_EVENTS) return;
        if (event === 'render') { try { window.__svTelRenders = (window.__svTelRenders || 0) + 1; } catch (_) {} }
        queue.push(Object.assign({
          event: event,
          surface: SURFACE,
          path: location.pathname.slice(0, 200),
          vw: window.innerWidth,
          vh: window.innerHeight
        }, extra || {}));
      } catch (_) {}
    }

    function flush() {
      try {
        if (sent || !queue.length) return;
        const body = JSON.stringify({ session: sessionId, staff: staff, events: queue });
        queue = [];
        // text/plain avoids a CORS preflight on every flush (the server reads it with force=True).
        const blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, blob)) { sent = true; return; }
        // sendBeacon can refuse (queue full, or absent on old Safari) - fall back, best effort.
        fetch(ENDPOINT, { method: 'POST', body: blob, keepalive: true, mode: 'cors' })
          .then(() => { sent = true; }).catch(() => {});
      } catch (_) {}
    }

    // pagehide is the reliable one on iOS (unload does not fire there); visibilitychange covers
    // tab-switching, and 73% of this page's traffic is mobile, where that IS the exit.
    window.addEventListener('pagehide', flush);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flush();
    });
    // Backstop: a shopper who sits on the page for a minute and then loses the tab to a crash
    // still counts. After this the queue keeps filling and a later flush sends the remainder.
    setTimeout(function () { flush(); sent = false; }, 60000);

    push('view');
    try { window.__svTelPush = push; } catch (_) {}   // 3.93.2: the compositor reports what it drew

    // --- watch picks -------------------------------------------------------------------
    // Read off the rendered details panel rather than hooking the selection functions: the
    // panel is the one thing every path (auto-select, ?watch= restore, popup, size switch)
    // ends up writing to.
    try {
      const details = document.getElementById('watchDetails');
      if (details) {
        let lastWatch = '';
        let timer = null;
        const read = function () {
          try {
            const txt = function (id) {
              const el = document.getElementById(id);
              return el ? (el.textContent || '').trim().slice(0, 120) : '';
            };
            const brand = txt('watchBrand'), model = txt('watchTitle'), size = txt('watchLugWidth');
            const key = brand + '|' + model + '|' + size;
            if (!model || key === lastWatch) return;
            lastWatch = key;
            push('watch', { brand: brand, model: model, size: size });
          } catch (_) {}
        };
        new MutationObserver(function () {
          clearTimeout(timer);
          timer = setTimeout(read, 350);       // NOT rAF - see the section note
        }).observe(details, { childList: true, subtree: true, characterData: true });
        setTimeout(read, 1500);                // the first watch is auto-selected, not clicked
      }
    } catch (_) {}

    // --- strap previews ----------------------------------------------------------------
    try {
      const grid = document.getElementById('strapsGrid');
      if (grid) {
        let lastStrap = '';
        let timer = null;
        const read = function () {
          try {
            const p = selectedStrapProduct;
            if (!p || !p.handle || p.handle === lastStrap) return;
            lastStrap = p.handle;
            push('strap', {
              handle: String(p.handle).slice(0, 160),
              // strip the leading "[Quick Release] " style prefix so the report groups sanely
              title: String(p.title || '').replace(/^\s*\[[^\]]*\]\s*/, '').slice(0, 200)
            });
          } catch (_) {}
        };
        new MutationObserver(function () {
          clearTimeout(timer);
          timer = setTimeout(read, 350);
        }).observe(grid, { attributes: true, attributeFilter: ['class'], subtree: true });
      }
    } catch (_) {}

    // --- add to cart -------------------------------------------------------------------
    // Capture phase so this runs whatever the existing submit handler does; the disabled check
    // keeps out-of-stock clicks out of the funnel (they are not an add).
    try {
      const form = document.getElementById('addToCartForm');
      if (form) {
        form.addEventListener('submit', function () {
          try {
            const btn = form.querySelector('.add-to-cart-btn');
            if (btn && btn.disabled) return;
            const p = selectedStrapProduct;
            push('atc', {
              handle: p && p.handle ? String(p.handle).slice(0, 160) : null,
              title: p ? String(p.title || '').replace(/^\s*\[[^\]]*\]\s*/, '').slice(0, 200) : null
            });
            flush();                            // the cart drawer may navigate; do not risk it
            sent = false;
          } catch (_) {}
        }, true);
      }
    } catch (_) {}
  })();


  /* ══ STAFF ADJUST MODE - UI ══════════════════════════════════════════════════
     Staff-only (same localStorage 'sv_staff' flag the telemetry exclusion uses, so
     ?sv_staff=1 turns it on for this browser permanently). Customers never see it.
     Drag the preview to move an arm; the buttons scale and rotate about the lug.
     Everything is written to a localStorage draft and re-rendered live; "Copy JSON"
     produces the value to save into custom.visualiser_adjust for it to go public. */
  (function svAdjustUI(){
    function isStaff(){
      try {
        const q = new URLSearchParams(location.search).get('sv_staff');
        if (q === '1') localStorage.setItem('sv_staff', '1');
        if (q === '0') localStorage.removeItem('sv_staff');
        return localStorage.getItem('sv_staff') === '1';
      } catch (e) { return false; }
    }
    function pid(){ return (typeof selectedStrapProduct !== 'undefined' && selectedStrapProduct) ? selectedStrapProduct.id : null; }
    /* ⚠ Migrate any draft left over from the single-uniform-scale panel. Without this a stale
       draft keeps its legacy `scale`, the new Wider/Longer buttons write only the axis you
       touched, and the missing axis silently falls back to `scale` - so the width/length split
       never actually applies and the exported JSON is ambiguous exactly the way it was before.
       Rewriting it to explicit sx/sy on read makes every later nudge unambiguous. */
    function migrate(o){
      if (!o || typeof o !== 'object') return o;
      let changed = false;
      ['top','bottom'].forEach(function(k){
        const a = o[k]; if (!a || typeof a !== 'object') return;
        const legacy = parseFloat(a.scale);
        if (!isFinite(parseFloat(a.sx))) { a.sx = isFinite(legacy) ? legacy : 1; changed = true; }
        if (!isFinite(parseFloat(a.sy))) { a.sy = isFinite(legacy) ? legacy : 1; changed = true; }
        if ('scale' in a) { delete a.scale; changed = true; }
      });
      return changed ? o : o;
    }
    function read(){
      const id = pid(); if (!id) return null;
      try {
        const raw = JSON.parse(localStorage.getItem(SV_ADJ_LS + id) || 'null');
        if (!raw) return null;
        const m = migrate(raw);
        localStorage.setItem(SV_ADJ_LS + id, JSON.stringify(m));
        return m;
      } catch(e){ return null; }
    }
    function blank(){ return { top:{dx:0,dy:0,sx:1,sy:1,rot:0}, bottom:{dx:0,dy:0,sx:1,sy:1,rot:0} }; }
    function write(o){
      const id = pid(); if (!id) return;
      try { localStorage.setItem(SV_ADJ_LS + id, JSON.stringify(o)); } catch(e){}
      if (typeof combineImages === 'function') combineImages();
      paint();
    }
    let panel = null, armSel = 'top';
    /* ⚠ 3.51.0: arm-dragging is OFF by default. It used to start on ANY pointerdown in the
       preview for a staff browser - the same gesture as panning a zoomed preview - so an
       ordinary pan wrote a permanent dx/dy offset and the strap rendered detached from the
       lugs from then on. Explicit opt-in per session; nothing persists it. */
    let dragMode = false;
    function paint(){
      if (!panel) return;
      const a = read() || blank();
      const v = a[armSel] || {dx:0,dy:0,sx:1,sy:1,rot:0};
      const f = panel.querySelector('#svAdjRead');
      if (f) f.textContent = 'dx ' + (v.dx||0).toFixed(3) + '  dy ' + (v.dy||0).toFixed(3) +
                             '  width ' + (v.sx||1).toFixed(3) + '  length ' + (v.sy||1).toFixed(3) +
                             '  rot ' + (v.rot||0).toFixed(1) + '°';
      panel.querySelectorAll('[data-arm]').forEach(b => {
        b.style.background = (b.dataset.arm === armSel) ? '#b2955f' : '#fff';
        b.style.color = (b.dataset.arm === armSel) ? '#fff' : '#1d1d1d';
      });
      const db = panel.querySelector('#svAdjDragBtn');
      if (db){
        db.textContent = 'Drag: ' + (dragMode ? 'on' : 'off');
        db.style.background = dragMode ? '#b2955f' : '#fff';
        db.style.color = dragMode ? '#fff' : '#1d1d1d';
      }
    }
    /* The readout used to repaint only on a button press, so after picking a different strap
       it kept showing the PREVIOUS strap's numbers - which reads as "this strap has an offset"
       when it has none. Cheap poll: the panel only exists for staff. */
    let svAdjLastPid = null;
    setInterval(function(){
      if (!panel) return;
      const id = pid();
      if (id !== svAdjLastPid){ svAdjLastPid = id; paint(); }
    }, 400);
    function bump(field, delta){
      const a = read() || blank();
      a[armSel] = a[armSel] || {dx:0,dy:0,sx:1,sy:1,rot:0};
      const isScale = (field === 'sx' || field === 'sy');
      a[armSel][field] = (parseFloat(a[armSel][field]) || (isScale ? 1 : 0)) + delta;
      write(a);
    }
    function build(){
      if (panel || !isStaff()) return;
      const host = document.querySelector('.preview-viewport') || document.querySelector('.final-image-container');
      if (!host) return;
      panel = document.createElement('div');
      panel.id = 'svAdjPanel';
      panel.style.cssText = 'position:absolute;left:8px;bottom:8px;z-index:40;background:rgba(255,255,255,.96);' +
        'border:1px solid #d8d2c4;border-radius:10px;padding:8px 10px;font:12px/1.35 system-ui,sans-serif;' +
        'box-shadow:0 2px 10px rgba(0,0,0,.12);max-width:280px;';
      const B = 'padding:3px 7px;margin:1px;border:1px solid #d8d2c4;border-radius:6px;background:#fff;cursor:pointer;font:12px system-ui;';
      panel.innerHTML =
        '<div style="font-weight:600;margin-bottom:4px;">Adjust straps <span style="font-weight:400;color:#777;">(staff)</span></div>' +
        '<div style="margin-bottom:4px;"><button data-arm="top" style="' + B + '">Top arm</button>' +
        '<button data-arm="bottom" style="' + B + '">Bottom arm</button></div>' +
        '<div style="margin-bottom:4px;">' +
        '<button data-act="up" style="' + B + '">&uarr;</button>' +
        '<button data-act="down" style="' + B + '">&darr;</button>' +
        '<button data-act="left" style="' + B + '">&larr;</button>' +
        '<button data-act="right" style="' + B + '">&rarr;</button>' +
        '<button data-act="rotl" style="' + B + '">&#8634;</button>' +
        '<button data-act="rotr" style="' + B + '">&#8635;</button></div>' +
        '<div style="margin-bottom:4px;">' +
        '<button data-act="wider" style="' + B + '">Wider</button>' +
        '<button data-act="narrower" style="' + B + '">Narrower</button>' +
        '<button data-act="longer" style="' + B + '">Longer</button>' +
        '<button data-act="shorter" style="' + B + '">Shorter</button></div>' +
        '<div id="svAdjRead" style="font-family:ui-monospace,monospace;color:#555;margin-bottom:5px;"></div>' +
        '<div><button data-act="reset" style="' + B + '">Reset</button>' +
        '<button data-act="copy" style="' + B + 'font-weight:600;">Copy JSON</button>' +
        '<button data-act="clearall" style="' + B + '">Clear all</button></div>' +
        '<div style="margin-top:4px;"><button data-act="dragmode" id="svAdjDragBtn" style="' + B + '">Drag: off</button></div>' +
        '<div style="color:#777;margin-top:4px;">Turn Drag on to move an arm by dragging.</div>';
      host.style.position = host.style.position || 'relative';
      host.appendChild(panel);
      panel.addEventListener('click', function(ev){
        const b = ev.target.closest('button'); if (!b) return;
        ev.preventDefault(); ev.stopPropagation();
        if (b.dataset.arm) { armSel = b.dataset.arm; paint(); return; }
        const STEP = 0.01, RSTEP = 0.5, SSTEP = 0.02;
        switch (b.dataset.act) {
          case 'up': bump('dy', -STEP); break;
          case 'down': bump('dy', STEP); break;
          case 'left': bump('dx', -STEP); break;
          case 'right': bump('dx', STEP); break;
          case 'wider': bump('sx', SSTEP); break;
          case 'narrower': bump('sx', -SSTEP); break;
          case 'longer': bump('sy', SSTEP); break;
          case 'shorter': bump('sy', -SSTEP); break;
          case 'rotl': bump('rot', -RSTEP); break;
          case 'rotr': bump('rot', RSTEP); break;
          case 'reset': write(blank()); break;
          /* ⚠ Drafts are per product and survive forever in localStorage, so a stray drag on
             ONE strap silently follows staff around until they notice it on that strap again.
             "Clear all" wipes every draft in this browser; the render falls back to the saved
             custom.visualiser_adjust (or none). */
          case 'clearall': {
            try {
              Object.keys(localStorage).filter(function(k){ return k.indexOf(SV_ADJ_LS) === 0; })
                .forEach(function(k){ localStorage.removeItem(k); });
            } catch (e) {}
            if (typeof combineImages === 'function') combineImages();
            paint();
            b.textContent = 'Cleared'; setTimeout(function(){ b.textContent = 'Clear all'; }, 1200);
            break;
          }
          case 'dragmode': dragMode = !dragMode; paint(); break;
          case 'copy': {
            const out = JSON.stringify(read() || blank());
            const done = () => { b.textContent = 'Copied'; setTimeout(()=>{ b.textContent = 'Copy JSON'; }, 1200); };
            if (navigator.clipboard) navigator.clipboard.writeText(out).then(done, ()=>window.prompt('Adjustment JSON', out));
            else window.prompt('Adjustment JSON', out);
            break;
          }
        }
      });
      // Drag the preview to move the selected arm. Pointer pixels are converted to the
      // fraction unit via the canvas-to-display scale, so dragging feels 1:1 at any zoom.
      const cvs = document.getElementById('finalCanvas');
      let drag = null;
      const target = host;
      target.addEventListener('pointerdown', function(ev){
        if (!dragMode || !isStaff() || ev.target.closest('#svAdjPanel')) return;
        const g = window.__svLastAdjustGeom; if (!g || !cvs) return;
        const r = cvs.getBoundingClientRect(); if (!r.width) return;
        drag = { x: ev.clientX, y: ev.clientY, unitPx: (r.width / cvs.width) * g.unit, base: read() || blank() };
        try { target.setPointerCapture(ev.pointerId); } catch(e){}
      });
      target.addEventListener('pointermove', function(ev){
        if (!drag || !drag.unitPx) return;
        const a = JSON.parse(JSON.stringify(drag.base));
        a[armSel] = a[armSel] || {dx:0,dy:0,sx:1,sy:1,rot:0};
        a[armSel].dx = (parseFloat(drag.base[armSel] && drag.base[armSel].dx) || 0) + (ev.clientX - drag.x) / drag.unitPx;
        a[armSel].dy = (parseFloat(drag.base[armSel] && drag.base[armSel].dy) || 0) + (ev.clientY - drag.y) / drag.unitPx;
        write(a);
      });
      target.addEventListener('pointerup', function(ev){
        drag = null; try { target.releasePointerCapture(ev.pointerId); } catch(e){}
      });
      paint();
    }
    function init(){ if (isStaff()) { build(); paint(); } }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    // The one-screen layout builds the viewport late; retry briefly until the host exists.
    let tries = 0;
    const iv = setInterval(function(){ if (panel || ++tries > 40) { clearInterval(iv); return; } init(); }, 250);
    window.svAdjustPanelReady = function(){ return !!panel; };
  })();


  })(); // end scope-isolation IIFE
